import { Stack as Stack$1, Box, CircularProgress as CircularProgress$1, LinearProgress as LinearProgress$1, Tooltip, Typography as Typography$1, Badge, Avatar as Avatar$1, lighten, Dialog as Dialog$1, DialogContent, Checkbox as Checkbox$1, Paper, Chip as Chip$1, ClickAwayListener, useTheme as useTheme$2, FormControl, InputLabel, Link as Link$1, Radio as Radio$1, InputAdornment, Select as Select$1, MenuItem as MenuItem$1 } from '@mui/material';
import classNames from 'classnames';
import * as React from 'react';
import React__default, { forwardRef, useRef, useState, useEffect, useLayoutEffect, useImperativeHandle, Component, useCallback, createContext } from 'react';
import Box$1 from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import SvgIcon from '@mui/material/SvgIcon';
import Container from '@mui/material/Container';
import MUITextField from '@mui/material/TextField';
import Cookies from 'universal-cookie';
import { lighten as lighten$1, createTheme as createTheme$1, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import moment$1 from 'moment/min/moment-with-locales';
import posthog from 'posthog-js';
import PromisePool from '@supercharge/promise-pool';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDrawer from '@mui/material/Drawer';
import Button$1 from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Divider$1 from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Stack$2 from '@mui/material/Stack';
import Typography$2 from '@mui/material/Typography';
import OTPInput from 'react-otp-input';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import Collapse from '@mui/material/Collapse';
import Select from '@mui/material/Select';
import { DatePicker as DatePicker$1, TimePicker as TimePicker$1, DateTimePicker as DateTimePicker$1, MultiSectionDigitalClock, DateCalendar as DateCalendar$1, StaticDateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getNameList } from 'country-list';
import { PostHogProvider } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';
import Tooltip$1 from '@mui/material/Tooltip';
import Card from '@mui/material/Card';
import { jsx } from 'react/jsx-runtime';
import emStyled from '@emotion/styled';
import { useLocation } from 'react-router-dom';
import { HexColorPicker } from 'react-colorful';
import PlacesAutocomplete from 'react-places-autocomplete';
import { usePhoneInput, defaultCountries, FlagImage, parseCountry } from 'react-international-phone';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$y = ".actionBarContainer-component-v2 {\n  left: 0;\n  position: fixed;\n  z-index: 8999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  pointer-events: none;\n}\n.actionBarContainer-component-v2:not(.open) {\n  display: none;\n}\n.actionBarContainer-component-v2.open {\n  display: flex;\n}\n.actionBarContainer-component-v2.bottom {\n  bottom: 2rem;\n}\n.actionBarContainer-component-v2.bottom .barsContainer > * {\n  margin-top: 1rem;\n}\n.actionBarContainer-component-v2.top {\n  top: 2rem;\n}\n.actionBarContainer-component-v2.top .barsContainer > * {\n  margin-bottom: 1rem;\n}\n.actionBarContainer-component-v2 .barsContainer {\n  pointer-events: all;\n  min-width: -moz-max-content;\n  min-width: max-content;\n}\n.actionBarContainer-component-v2 .barsContainer > * {\n  max-width: unset;\n}\n.actionBarContainer-component-v2 .barsContainer > *:not(.manualContent) {\n  border-radius: 8px;\n  background-color: var(--white, #FFFFFF);\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n  padding: 1.5rem;\n  min-width: 29rem;\n  box-sizing: border-box;\n}\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .left > div:not(:first-child) {\n  margin-left: 1rem;\n}\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .middle,\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .right {\n  margin-left: 3rem;\n}\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .middle > div:first-child,\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .right > div:first-child {\n  margin-right: 0;\n}\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .middle > div:not(:first-child),\n.actionBarContainer-component-v2 .barsContainer > * .fullBar-component > .right > div:not(:first-child) {\n  margin-left: 0.75rem;\n}\n.actionBarContainer-component-v2 .barsContainer > * p,\n.actionBarContainer-component-v2 .barsContainer > * button {\n  white-space: nowrap;\n}";
styleInject(css_248z$y);

var ActionBarContainer = forwardRef(function (props, ref) {
    var refState = useRef({ open: false });
    var _a = useState(props), state = _a[0], setNewState = _a[1];
    useEffect(function () {
        refState.current = { open: state.open || false };
    }, [state.open]);
    useLayoutEffect(function () {
        if (state.open) {
            adjustDialogPosition();
        }
    });
    function isShowing() {
        return refState.current.open;
    }
    function show(cState) {
        var newState = setStateFromProps(__assign(__assign({}, cState), { open: true }));
        setNewState(newState);
    }
    function hide() {
        setNewState(setStateFromProps({ open: false }));
    }
    function setStateFromProps(cState) {
        var _a, _b, _c;
        var nextState = cState || {};
        var newState = {
            open: nextState.open || false,
            className: (_a = nextState.className) !== null && _a !== void 0 ? _a : undefined,
            adjustedPosition: (_b = nextState.adjustedPosition) !== null && _b !== void 0 ? _b : {},
            bars: (_c = nextState.bars) !== null && _c !== void 0 ? _c : []
        };
        return newState;
    }
    function adjustDialogPosition(_a) {
        var _b = {} ; _b.x; _b.y;
        var overlayRect = document.querySelector(".actionBar-component-v2.fromActionBarHandler");
        var dialogRect = document.querySelector(".actionBar-component-v2.fromActionBarHandler");
        if (overlayRect && dialogRect && state.adjustedPosition) {
            overlayRect.getBoundingClientRect();
            dialogRect.getBoundingClientRect();
            if (state.adjustedPosition.x) {
                dialogRect.style.left = state.adjustedPosition.x + "px";
            }
            if (state.adjustedPosition.y) {
                dialogRect.style.top = state.adjustedPosition.y + "px";
            }
        }
    }
    useImperativeHandle(ref, function () { return ({
        isShowing: isShowing,
        show: show,
        hide: hide
    }); });
    var mainClasses = classNames("actionBarContainer-component-v2", props.position || "bottom", state.className, {
        "open": state.open
    });
    return React__default.createElement(Stack$1, { direction: "row", className: mainClasses },
        React__default.createElement("div", { className: "barsContainer" }, Array.isArray(state.bars) ?
            state.bars.map(function (bar, index) {
                var classes = classNames("actionBar", bar.className, {
                    "manualContent": bar.manualContent
                });
                return React__default.createElement(Box, { key: index, className: classes }, bar.content);
            })
            :
                state.bars));
});

var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isLoading: props.loading || false, disabled: false };
        _this.reset = _this.reset.bind(_this);
        _this.animate = _this.animate.bind(_this);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        return _this;
    }
    Button.prototype.handleOnClick = function (event) {
        event.stopPropagation();
        if (this.props.animated) {
            this.animate();
        }
        this.props.onClick && this.props.onClick(event, this);
    };
    Button.prototype.disable = function () {
        this.setState({ disabled: true });
    };
    Button.prototype.animate = function () {
        this.setState({ isLoading: true });
    };
    Button.prototype.reset = function () {
        this.setState({ isLoading: false, disabled: false });
    };
    Button.prototype.render = function () {
        var isDisabled = typeof this.props.disabled === "boolean" ? this.props.disabled : this.state.disabled;
        var _a = this.props, className = _a.className, iconOnly = _a.iconOnly; _a.animated; var rest = __rest(_a, ["className", "iconOnly", "animated"]);
        return React__default.createElement(LoadingButton, __assign({}, rest, { className: "".concat(className, " ").concat(iconOnly ? "iconOnly" : ""), disabled: isDisabled, loading: this.state.isLoading, onClick: this.handleOnClick, color: this.props.color }), this.props.children);
    };
    return Button;
}(Component));
//@ts-ignore
Button.defaultProps = {
    variant: "contained"
};

var EOperatorTypes;
(function (EOperatorTypes) {
    EOperatorTypes["and"] = "and";
    EOperatorTypes["or"] = "or";
    EOperatorTypes["is"] = "is";
})(EOperatorTypes || (EOperatorTypes = {}));
function getTColor(name) {
    switch (name) {
        case "primary":
        case "secondary":
        case "error":
        case "info":
        case "success":
        case "warning":
        case "body1":
        case "body2":
        case "darkMatter":
        case "silver":
        case "wildSand":
        case "cloud":
        case "boulder":
        case "pebble":
        case "white":
        case "shade1000":
        case "shade950":
        case "shade900":
        case "shade850":
        case "shade800":
        case "shade750":
        case "shade700":
        case "shade650":
        case "shade600":
        case "shade550":
        case "shade500":
        case "shade450":
        case "shade400":
        case "shade350":
        case "shade300":
        case "shade250":
        case "shade200":
        case "shade150":
        case "shade100":
        case "shade50":
            return name;
        default:
            return "primary";
    }
}
function getIconSize(name) {
    var lastChars = name.substring(name.length - 2);
    switch (lastChars) {
        case "10":
        case "14":
        case "18":
        case "24":
        case "32":
        case "44":
            return lastChars;
        default:
            return "inherit";
    }
}
var EMethods;
(function (EMethods) {
    EMethods["post"] = "POST";
    EMethods["put"] = "PUT";
    EMethods["delete"] = "DELETE";
    EMethods["get"] = "GET";
    EMethods["patch"] = "PATCH";
})(EMethods || (EMethods = {}));
var EApiLanguages;
(function (EApiLanguages) {
    EApiLanguages["da"] = "da";
    EApiLanguages["da_DK"] = "da_DK";
    EApiLanguages["de"] = "de";
    EApiLanguages["de_DE"] = "de_DE";
    EApiLanguages["el"] = "el";
    EApiLanguages["el_GR"] = "el_GR";
    EApiLanguages["en"] = "en";
    EApiLanguages["en_US"] = "en_US";
    EApiLanguages["en_GB"] = "en_GB";
    EApiLanguages["en_UK"] = "en_UK";
    EApiLanguages["es"] = "es";
    EApiLanguages["es_US"] = "es_US";
    EApiLanguages["es_ES"] = "es_ES";
    EApiLanguages["et"] = "et";
    EApiLanguages["et_EE"] = "et_EE";
    EApiLanguages["fi"] = "fi";
    EApiLanguages["fi_FI"] = "fi_FI";
    EApiLanguages["fr"] = "fr";
    EApiLanguages["fr_CA"] = "fr_CA";
    EApiLanguages["fr_FR"] = "fr_FR";
    EApiLanguages["he"] = "he";
    EApiLanguages["he_IL"] = "he_IL";
    EApiLanguages["id"] = "id";
    EApiLanguages["id_ID"] = "id_ID";
    EApiLanguages["it"] = "it";
    EApiLanguages["it_IT"] = "it_IT";
    EApiLanguages["ja"] = "ja";
    EApiLanguages["ja_JP"] = "ja_JP";
    EApiLanguages["nl"] = "nl";
    EApiLanguages["nl_NL"] = "nl_NL";
    EApiLanguages["no"] = "no";
    EApiLanguages["no_NO"] = "no_NO";
    EApiLanguages["pt"] = "pt";
    EApiLanguages["pt_BR"] = "pt_BR";
    EApiLanguages["ro"] = "ro";
    EApiLanguages["ro_RO"] = "ro_RO";
    EApiLanguages["ru"] = "ru";
    EApiLanguages["ru_RU"] = "ru_RU";
    EApiLanguages["sv"] = "sv";
    EApiLanguages["sv_SE"] = "sv_SE";
    EApiLanguages["th"] = "th";
    EApiLanguages["th_TH"] = "th_TH";
    EApiLanguages["tr"] = "tr";
    EApiLanguages["tr_TR"] = "tr_TR";
    EApiLanguages["vi"] = "vi";
    EApiLanguages["vi_VN"] = "vi_VN";
    EApiLanguages["zh"] = "zh";
    EApiLanguages["zh_CN"] = "zh_CN";
    EApiLanguages["aa"] = "aa";
    EApiLanguages["ab"] = "ab";
    EApiLanguages["ae"] = "ae";
    EApiLanguages["af"] = "af";
    EApiLanguages["ak"] = "ak";
    EApiLanguages["am"] = "am";
    EApiLanguages["an"] = "an";
    EApiLanguages["ar"] = "ar";
    EApiLanguages["av"] = "av";
    EApiLanguages["ay"] = "ay";
    EApiLanguages["az"] = "az";
    EApiLanguages["ba"] = "ba";
    EApiLanguages["be"] = "be";
    EApiLanguages["bg"] = "bg";
    EApiLanguages["bh"] = "bh";
    EApiLanguages["bi"] = "bi";
    EApiLanguages["bm"] = "bm";
    EApiLanguages["bn"] = "bn";
    EApiLanguages["bo"] = "bo";
    EApiLanguages["br"] = "br";
    EApiLanguages["bs"] = "bs";
    EApiLanguages["ca"] = "ca";
    EApiLanguages["ce"] = "ce";
    EApiLanguages["ch"] = "ch";
    EApiLanguages["co"] = "co";
    EApiLanguages["cr"] = "cr";
    EApiLanguages["cs"] = "cs";
    EApiLanguages["cu"] = "cu";
    EApiLanguages["cv"] = "cv";
    EApiLanguages["cy"] = "cy";
    EApiLanguages["dv"] = "dv";
    EApiLanguages["dz"] = "dz";
    EApiLanguages["ee"] = "ee";
    EApiLanguages["eo"] = "eo";
    EApiLanguages["eu"] = "eu";
    EApiLanguages["fa"] = "fa";
    EApiLanguages["ff"] = "ff";
    EApiLanguages["fj"] = "fj";
    EApiLanguages["fo"] = "fo";
    EApiLanguages["fy"] = "fy";
    EApiLanguages["ga"] = "ga";
    EApiLanguages["gd"] = "gd";
    EApiLanguages["gl"] = "gl";
    EApiLanguages["gn"] = "gn";
    EApiLanguages["gu"] = "gu";
    EApiLanguages["gv"] = "gv";
    EApiLanguages["ha"] = "ha";
    EApiLanguages["hi"] = "hi";
    EApiLanguages["ho"] = "ho";
    EApiLanguages["hr"] = "hr";
    EApiLanguages["ht"] = "ht";
    EApiLanguages["hu"] = "hu";
    EApiLanguages["hy"] = "hy";
    EApiLanguages["hz"] = "hz";
    EApiLanguages["ia"] = "ia";
    EApiLanguages["ie"] = "ie";
    EApiLanguages["ig"] = "ig";
    EApiLanguages["ii"] = "ii";
    EApiLanguages["ik"] = "ik";
    EApiLanguages["io"] = "io";
    EApiLanguages["is_IS"] = "is_IS";
    EApiLanguages["iu"] = "iu";
    EApiLanguages["jv"] = "jv";
    EApiLanguages["ka"] = "ka";
    EApiLanguages["kg"] = "kg";
    EApiLanguages["ki"] = "ki";
    EApiLanguages["kj"] = "kj";
    EApiLanguages["kk"] = "kk";
    EApiLanguages["kl"] = "kl";
    EApiLanguages["km"] = "km";
    EApiLanguages["kn"] = "kn";
    EApiLanguages["ko"] = "ko";
    EApiLanguages["kr"] = "kr";
    EApiLanguages["ks"] = "ks";
    EApiLanguages["ku"] = "ku";
    EApiLanguages["kv"] = "kv";
    EApiLanguages["kw"] = "kw";
    EApiLanguages["ky"] = "ky";
    EApiLanguages["la"] = "la";
    EApiLanguages["lb"] = "lb";
    EApiLanguages["lg"] = "lg";
    EApiLanguages["li"] = "li";
    EApiLanguages["ln"] = "ln";
    EApiLanguages["lo"] = "lo";
    EApiLanguages["lt"] = "lt";
    EApiLanguages["lu"] = "lu";
    EApiLanguages["lv"] = "lv";
    EApiLanguages["mg"] = "mg";
    EApiLanguages["mh"] = "mh";
    EApiLanguages["mi"] = "mi";
    EApiLanguages["mk"] = "mk";
    EApiLanguages["ml"] = "ml";
    EApiLanguages["mn"] = "mn";
    EApiLanguages["mr"] = "mr";
    EApiLanguages["ms"] = "ms";
    EApiLanguages["mt"] = "mt";
    EApiLanguages["my"] = "my";
    EApiLanguages["na"] = "na";
    EApiLanguages["nb"] = "nb";
    EApiLanguages["nd"] = "nd";
    EApiLanguages["ne"] = "ne";
    EApiLanguages["ng"] = "ng";
    EApiLanguages["nn"] = "nn";
    EApiLanguages["nr"] = "nr";
    EApiLanguages["nv"] = "nv";
    EApiLanguages["ny"] = "ny";
    EApiLanguages["oc"] = "oc";
    EApiLanguages["oj"] = "oj";
    EApiLanguages["om"] = "om";
    EApiLanguages["os"] = "os";
    EApiLanguages["pa"] = "pa";
    EApiLanguages["pi"] = "pi";
    EApiLanguages["pl"] = "pl";
    EApiLanguages["ps"] = "ps";
    EApiLanguages["qu"] = "qu";
    EApiLanguages["rm"] = "rm";
    EApiLanguages["rn"] = "rn";
    EApiLanguages["rw"] = "rw";
    EApiLanguages["sa"] = "sa";
    EApiLanguages["sc"] = "sc";
    EApiLanguages["sd"] = "sd";
    EApiLanguages["se"] = "se";
    EApiLanguages["sg"] = "sg";
    EApiLanguages["si"] = "si";
    EApiLanguages["sk"] = "sk";
    EApiLanguages["sl"] = "sl";
    EApiLanguages["sm"] = "sm";
    EApiLanguages["sn"] = "sn";
    EApiLanguages["so"] = "so";
    EApiLanguages["sq"] = "sq";
    EApiLanguages["sr"] = "sr";
    EApiLanguages["ss"] = "ss";
    EApiLanguages["st"] = "st";
    EApiLanguages["su"] = "su";
    EApiLanguages["sw"] = "sw";
    EApiLanguages["ta"] = "ta";
    EApiLanguages["te"] = "te";
    EApiLanguages["tg"] = "tg";
    EApiLanguages["ti"] = "ti";
    EApiLanguages["tk"] = "tk";
    EApiLanguages["tl"] = "tl";
    EApiLanguages["tn"] = "tn";
    EApiLanguages["to"] = "to";
    EApiLanguages["ts"] = "ts";
    EApiLanguages["tt"] = "tt";
    EApiLanguages["tw"] = "tw";
    EApiLanguages["ty"] = "ty";
    EApiLanguages["ug"] = "ug";
    EApiLanguages["uk"] = "uk";
    EApiLanguages["ur"] = "ur";
    EApiLanguages["uz"] = "uz";
    EApiLanguages["ve"] = "ve";
    EApiLanguages["vo"] = "vo";
    EApiLanguages["wa"] = "wa";
    EApiLanguages["wo"] = "wo";
    EApiLanguages["xh"] = "xh";
    EApiLanguages["yi"] = "yi";
    EApiLanguages["yo"] = "yo";
    EApiLanguages["za"] = "za";
    EApiLanguages["zu"] = "zu";
})(EApiLanguages || (EApiLanguages = {}));

function Add10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("rect", { x: "4.125", width: "2", height: "10", rx: "1" }),
        React__default.createElement("rect", { x: "0.125", y: "6", width: "2", height: "10", rx: "1", transform: "rotate(-90 0.125 6)" }));
}

function ArrowDown10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { d: "M4.99997 0.00012207C4.44769 0.000121812 3.99997 0.447837 3.99997 1.00012L3.99997 6.62165L1.70869 4.33037C1.31817 3.93984 0.685004 3.93984 0.29448 4.33037C-0.0960445 4.72089 -0.0960439 5.35406 0.29448 5.74458L4.2926 9.7427C4.68312 10.1332 5.31629 10.1332 5.70681 9.7427L5.71087 9.73862L9.70415 5.74534C10.0947 5.35482 10.0947 4.72165 9.70415 4.33113C9.31362 3.94061 8.68046 3.94061 8.28993 4.33113L5.99997 6.62109L5.99997 1.00012C5.99997 0.447837 5.55226 0.000121649 4.99997 0.00012207Z" }));
}

function ArrowUp10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { d: "M4.99869 10.0355C5.55097 10.0355 5.99869 9.58775 5.99869 9.03546L5.99869 3.41394L8.28996 5.70521C8.68049 6.09574 9.31365 6.09574 9.70418 5.70521C10.0947 5.31469 10.0947 4.68152 9.70418 4.291L5.70606 0.292882C5.31553 -0.0976424 4.68237 -0.0976424 4.29185 0.292881L4.28779 0.296962L0.294509 4.29024C-0.0960155 4.68076 -0.0960146 5.31393 0.294509 5.70445C0.685033 6.09498 1.3182 6.09498 1.70872 5.70445L3.99869 3.41449L3.99869 9.03546C3.99869 9.58775 4.4464 10.0355 4.99869 10.0355Z" }));
}

function Checkmark10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.53 0.152013C9.99834 0.444724 10.1407 1.06167 9.848 1.53001L4.848 9.53001C4.68648 9.78843 4.41594 9.9591 4.11316 9.99359C3.81037 10.0281 3.50838 9.92261 3.29289 9.70712L0.292893 6.70712C-0.0976311 6.31659 -0.0976311 5.68343 0.292893 5.29291C0.683417 4.90238 1.31658 4.90238 1.70711 5.29291L3.81824 7.40404L8.152 0.470013C8.44471 0.00167632 9.06166 -0.140697 9.53 0.152013Z" }));
}

function Chevron10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.292893 2.29289C0.683417 1.90237 1.31658 1.90237 1.70711 2.29289L5 5.58579L8.29289 2.29289C8.68342 1.90237 9.31658 1.90237 9.70711 2.29289C10.0976 2.68342 10.0976 3.31658 9.70711 3.70711L5.70711 7.70711C5.31658 8.09763 4.68342 8.09763 4.29289 7.70711L0.292893 3.70711C-0.0976311 3.31658 -0.0976311 2.68342 0.292893 2.29289Z" }));
}

function Dash10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { fillRule: "evenodd", d: "M1 4.5h8c0.55 0 1 0.45 1 1s-0.45 1-1 1H1c-0.55 0-1-0.45-1-1s0.45-1 1-1z" }));
}

function Link10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { d: "M2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1V7C0 8.65685 1.34315 10 3 10H9C9.55229 10 10 9.55229 10 9C10 8.44771 9.55228 8 9 8H3C2.44772 8 2 7.55229 2 7V1Z" }),
        React__default.createElement("path", { d: "M3.99998 1C3.99998 0.447715 4.44769 0 4.99998 0H8.83331C9.47765 0 9.99998 0.522334 9.99998 1.16667V5C9.99998 5.55228 9.55226 6 8.99998 6C8.44769 6 7.99998 5.55228 7.99998 5V3.40053L4.91706 6.48344C4.55003 6.85048 3.95494 6.85048 3.5879 6.48344C3.22086 6.11641 3.22086 5.52132 3.5879 5.15428L6.74218 2H4.99998C4.44769 2 3.99998 1.55228 3.99998 1Z" }));
}

function Search10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.03189 7.44622C5.4364 7.79809 4.74178 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 4.74184 7.79805 5.43651 7.44614 6.03204L9.70707 8.29291C10.0976 8.68343 10.0976 9.31659 9.70708 9.70712C9.31656 10.0976 8.6834 10.0977 8.29287 9.70714L6.03189 7.44622ZM6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4Z" }));
}

function Union10(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "10", height: "10", viewBox: "0 0 10 10" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4V3C2 1.34315 3.34315 0 5 0C6.65685 0 8 1.34315 8 3V4H9C9.55228 4 10 4.44772 10 5V9C10 9.55228 9.55229 10 9 10H1C0.447716 10 0 9.55228 0 9V5C0 4.44772 0.447715 4 1 4H2ZM6 3V4H4V3C4 2.44772 4.44772 2 5 2C5.55228 2 6 2.44772 6 3ZM8 6H2V8H8V6Z" }));
}

function BarChart14(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "14", height: "14", viewBox: "0 0 14 14" }),
        React__default.createElement("rect", { id: "Rectangle 261", x: "4", y: "10", width: "6", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 262", x: "4", y: "2", width: "10", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 264", width: "2", height: "14" }),
        React__default.createElement("rect", { id: "Rectangle 263", x: "4", y: "6", width: "8", height: "2" }));
}

function Checkmark14(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "14", height: "15", viewBox: "0 0 14 15" }),
        React__default.createElement("path", { d: "M6.76967 8.29363L5.70711 7.23106C5.31658 6.84054 4.68342 6.84054 4.29289 7.23106C3.90237 7.62159 3.90237 8.25475 4.29289 8.64528L6.29289 10.6453C6.76268 11.1151 7.55151 11.0046 7.87416 10.4238L13.8742 2.42381C14.1424 1.94103 13.9684 1.33223 13.4856 1.06401C13.0029 0.7958 12.3941 0.969744 12.1258 1.45253L6.76967 8.29363Z" }),
        React__default.createElement("path", { d: "M7 1C7.90412 1 8.7682 1.17141 9.56152 1.48349L8.25072 3.15771C7.85098 3.05476 7.43188 3 7 3C4.32871 3 2.1467 5.09482 2.0071 7.73132C2.00175 7.80912 1.99943 7.88709 2.00012 7.96504L2 8C2 10.7614 4.23858 13 7 13C9.67245 13 11.8552 10.9034 11.9931 8.26524L13.705 5.98274C13.8969 6.62152 14 7.29871 14 8C14 11.866 10.866 15 7 15C3.13401 15 0 11.866 0 8C0 4.13401 3.13401 1 7 1Z" }));
}

function Copy14(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "15", height: "14", viewBox: "0 0 15 14" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.59131 0C1.93445 0 0.591309 1.34315 0.591309 3V7C0.591309 8.65685 1.93445 10 3.59131 10H4.59131V11C4.59131 12.6569 5.93445 14 7.59131 14H11.5913C13.2482 14 14.5913 12.6569 14.5913 11V7C14.5913 5.34315 13.2482 4 11.5913 4H10.5913V3C10.5913 1.34315 9.24816 0 7.59131 0H3.59131ZM10.5913 6V7C10.5913 8.65685 9.24816 10 7.59131 10H6.59131V11C6.59131 11.5523 7.03902 12 7.59131 12H11.5913C12.1436 12 12.5913 11.5523 12.5913 11V7C12.5913 6.44772 12.1436 6 11.5913 6H10.5913ZM2.59131 3C2.59131 2.44772 3.03902 2 3.59131 2H7.59131C8.14359 2 8.59131 2.44772 8.59131 3V7C8.59131 7.55228 8.14359 8 7.59131 8H3.59131C3.03902 8 2.59131 7.55228 2.59131 7V3Z" }));
}

function Filter14(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "14", height: "14", viewBox: "0 0 14 14" }),
        React__default.createElement("path", { d: "M0 1C0 0.447715 0.447715 0 1 0H13C13.5523 0 14 0.447715 14 1C14 1.55228 13.5523 2 13 2H1C0.447716 2 0 1.55228 0 1Z" }),
        React__default.createElement("path", { d: "M2 7C2 6.44771 2.44772 6 3 6H11C11.5523 6 12 6.44771 12 7C12 7.55228 11.5523 8 11 8H3C2.44772 8 2 7.55228 2 7Z" }),
        React__default.createElement("path", { d: "M5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14H9C9.55229 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12H5Z" }));
}

function Remove14(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "14", height: "14", viewBox: "0 0 14 14" }),
        React__default.createElement("rect", { x: "12.6553", y: "11.2412", width: "2", height: "13.9959", rx: "1", transform: "rotate(135 12.6553 11.2412)" }),
        React__default.createElement("rect", { x: "2.75867", y: "12.6554", width: "2", height: "13.9959", rx: "1", transform: "rotate(-135 2.75867 12.6554)" }));
}

function X14(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "14", height: "14", viewBox: "0 0 14 14" }),
        React__default.createElement("rect", { id: "Rectangle 153", x: "12.6553", y: "11.2412", width: "2", height: "13.9959", rx: "1", transform: "rotate(135 12.6553 11.2412)" }),
        React__default.createElement("rect", { id: "Rectangle 153_2", x: "2.75867", y: "12.6554", width: "2", height: "13.9959", rx: "1", transform: "rotate(-135 2.75867 12.6554)" }));
}

function AccountProfile18$1(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("rect", { x: "4", y: "4", width: "3", height: "3", rx: "1.5" }),
        React__default.createElement("rect", { x: "4", y: "12", width: "5", height: "2", rx: "1" }),
        React__default.createElement("rect", { x: "4", y: "9", width: "10", height: "2", rx: "1" }),
        React__default.createElement("rect", { className: 'noFill', x: "1", y: "1", width: "16", height: "16", rx: "5", strokeWidth: "2" }));
}

function Activity18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { className: 'noFill', id: "Rectangle 253", d: "M1 11.9999V12.9999C1 15.209 2.79086 16.9999 5 16.9999H13C15.2091 16.9999 17 15.209 17 12.9999V11.9999", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Rectangle 253_2", d: "M17 5.99988L17 4.99988C17 2.79074 15.2091 0.999878 13 0.999877L5 0.999877C2.79086 0.999876 1 2.79074 1 4.99988L1 5.99988", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector 152", d: "M1 8.99988H5V6.99988C5 5.89531 5.89543 4.99988 7 4.99988V4.99988C8.10457 4.99988 9 5.89531 9 6.99988V10.4999C9 11.6044 9.89543 12.4999 11 12.4999V12.4999C12.1046 12.4999 13 11.6044 13 10.4999V8.99988H17", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}

function Add18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M10 1C10 0.447715 9.55229 0 9 0C8.44771 0 8 0.447715 8 1V8H1C0.447715 8 0 8.44771 0 9C0 9.55229 0.447715 10 1 10H8V17C8 17.5523 8.44772 18 9 18C9.55229 18 10 17.5523 10 17V10H17C17.5523 10 18 9.55228 18 9C18 8.44771 17.5523 8 17 8H10V1Z" }));
}

function AddTags18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("rect", { x: "4", y: "4", width: "3", height: "3", rx: "1.5" }),
        React__default.createElement("rect", { x: "4", y: "12", width: "5", height: "2", rx: "1" }),
        React__default.createElement("rect", { x: "4", y: "9", width: "10", height: "2", rx: "1" }),
        React__default.createElement("rect", { className: 'noFill', x: "1", y: "1", width: "16", height: "16", rx: "5", strokeWidth: "2" }));
}

function Arrow18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.7071 3.70711C8.09762 3.31658 8.09762 2.68342 7.7071 2.29289C7.31657 1.90237 6.68341 1.90237 6.29288 2.29289L0.292892 8.2929C0.0976302 8.48817 -4.19999e-07 8.74409 0 9.00001C4.30001e-07 9.25593 0.0976319 9.51186 0.292894 9.70712L6.2929 15.7071C6.68343 16.0976 7.31659 16.0976 7.70712 15.7071C8.09764 15.3166 8.09764 14.6834 7.70712 14.2929L3.41422 10L16.9807 9.99998C17.5447 9.99998 18 9.55226 18 8.99998C18 8.46385 17.5465 7.99998 16.9872 7.99998L3.41421 8.00001L7.7071 3.70711Z" }));
}

function Attribute18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.28 1.84813C6.74834 1.55542 6.89071 0.938471 6.598 0.470135C6.30529 0.00179839 5.68834 -0.140575 5.22 0.152136L2.63 1.77088C1.46048 2.50184 0.75 3.78372 0.75 5.16288V14.0001C0.75 16.2093 2.54086 18.0002 4.75 18.0002C6.72261 18.0002 8.36172 16.5723 8.6901 14.6938C9.37917 14.4728 10.1208 14.4728 10.8099 14.6938C11.1383 16.5723 12.7774 18.0002 14.75 18.0002C16.9506 18.0002 18.7361 16.2232 18.7499 14.0259C18.7501 14.0173 18.7502 14.0087 18.7502 14.0001V5.16288C18.7502 3.78372 18.0398 2.50184 16.8702 1.77088L14.2802 0.152136C13.8119 -0.140575 13.195 0.00179839 12.9022 0.470135C12.6095 0.938471 12.7519 1.55542 13.2202 1.84813L15.8102 3.46688C16.395 3.83236 16.7502 4.4733 16.7502 5.16288V10.5355C16.1618 10.1951 15.4787 10.0002 14.75 10.0002C13.0082 10.0002 11.5264 11.1136 10.9774 12.6675C10.1699 12.4816 9.33009 12.4816 8.52258 12.6674C7.97362 11.1136 6.49182 10.0002 4.75 10.0002C4.02143 10.0002 3.33835 10.195 2.75 10.5354V5.16288C2.75 4.4733 3.10524 3.83236 3.69 3.46688L6.28 1.84813ZM6.74992 13.9827C6.74049 12.8862 5.8487 12.0002 4.75 12.0002C3.64543 12.0002 2.75 12.8957 2.75 14.0002C2.75 15.1048 3.64543 16.0002 4.75 16.0002C5.84837 16.0002 6.73994 15.1148 6.74992 14.0188C6.7497 14.0068 6.7497 13.9947 6.74992 13.9827ZM12.7501 14.0169C12.7502 14.0061 12.7502 13.9954 12.7501 13.9846C12.7585 12.8872 13.6506 12.0002 14.75 12.0002C15.8546 12.0002 16.75 12.8957 16.75 14.0002C16.75 15.1048 15.8546 16.0002 14.75 16.0002C13.651 16.0002 12.759 15.1138 12.7501 14.0169Z" }));
}

function Book18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("rect", { className: 'noFill', id: "Rectangle 213", x: "1.25", y: "1", width: "16", height: "14", rx: "4", strokeWidth: "2" }),
        React__default.createElement("path", { id: "Vector 154", d: "M8.54289 17.2928L7.25 15.9999H11.25L9.95711 17.2928C9.56658 17.6833 8.93342 17.6833 8.54289 17.2928Z" }),
        React__default.createElement("rect", { id: "Rectangle 442", x: "3.25", y: "3.99988", width: "4", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 442_2", x: "11.25", y: "3.99988", width: "4", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 443", x: "3.25", y: "9.99988", width: "4", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 443_2", x: "11.25", y: "9.99988", width: "4", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 443_3", x: "3.25", y: "6.99988", width: "4", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 443_4", x: "11.25", y: "6.99988", width: "4", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 457", x: "8.25", y: "1.99988", width: "2", height: "14" }));
}

function Bounce18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M0 11C0 9.89543 0.895432 9 2 9H5.04148L6.99955 12H10.9999L12.9992 9H16C17.1046 9 18 9.89543 18 11V16C18 17.1046 17.1046 18 16 18H2C0.895431 18 0 17.1046 0 16V11ZM2 11H3.99922L5.40676 13.1099C5.77775 13.666 6.40204 14 7.07052 14H10.9292C11.5979 14 12.2224 13.6657 12.5934 13.1092L13.9992 11H16V16H2V11Z" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 158", d: "M1 1L9 9L17 1", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 159", d: "M13 1H17V5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}

function Branded18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0V11C0 12.1046 0.89543 13 2 13H6V16C6 17.1046 6.89543 18 8 18H10C11.1046 18 12 17.1046 12 16V13H16C17.1046 13 18 12.1046 18 11V0H0ZM4 2H2L2 7H16V2H14V5H12V2H10V5H8V2H6V5H4V2ZM2 9H16V11H10V16H8V11H2L2 9Z" }));
}

function Campaigns18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { className: "noFill", d: "M7 1L17 11", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M8 2L1.34324 12.6508C0.849647 13.4406 0.966488 14.4665 1.62502 15.125L2.88855 16.3885C3.54085 17.0408 4.55467 17.1624 5.34266 16.6827L15.5 10.5", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M12.875 12.6568V14.6753C12.875 15.031 12.6861 15.3599 12.3789 15.5391L10.3065 16.748C10.0348 16.9065 9.70445 16.9279 9.41458 16.8058L7.5 15.9997", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M16 2L14.5 3.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M17 5.5L16.5 6", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M12.5 1L12 1.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}

function Clicks18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Vector", d: "M3.37444 1.78352L1.78345 3.37451L4.50006 6.09113L6.09105 4.50014L3.37444 1.78352Z" }),
        React__default.createElement("path", { id: "Vector_2", d: "M14.6248 1.77997L11.9082 4.49658L13.4992 6.08757L16.2158 3.37096L14.6248 1.77997Z" }),
        React__default.createElement("path", { id: "Vector_3", d: "M4.50177 11.9074L1.78516 14.624L3.37615 16.215L6.09276 13.4984L4.50177 11.9074Z" }),
        React__default.createElement("path", { id: "Vector_4", d: "M4 8H0V10H4V8Z" }),
        React__default.createElement("path", { id: "Vector_5", d: "M10 0H8V4H10V0Z" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector 104", d: "M9.54552 16.2983C9.67291 16.7059 10.0451 16.9877 10.4721 16.9996C10.899 17.0115 11.2864 16.751 11.4363 16.3511L12.7767 12.7767L16.3511 11.4363C16.751 11.2864 17.0115 10.899 16.9996 10.4721C16.9877 10.0451 16.7059 9.67291 16.2983 9.54552L8.29828 7.04552C7.94322 6.93457 7.55593 7.02986 7.29289 7.29289C7.02986 7.55593 6.93457 7.94322 7.04552 8.29827L9.54552 16.2983Z", strokeWidth: "2", strokeLinejoin: "round" }),
        React__default.createElement("path", { id: "Vector 105", d: "M16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L16.2929 17.7071ZM12.2929 13.7071L16.2929 17.7071L17.7071 16.2929L13.7071 12.2929L12.2929 13.7071Z" }));
}

function Code18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Rectangle 455 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M0 5C0 2.23858 2.23858 0 5 0H13C15.7614 0 18 2.23858 18 5V13C18 15.7614 15.7614 18 13 18H5C2.23858 18 0 15.7614 0 13V5ZM5 2C3.34315 2 2 3.34315 2 5V13C2 14.6569 3.34315 16 5 16H13C14.6569 16 16 14.6569 16 13V5C16 3.34315 14.6569 2 13 2H5Z" }),
        React__default.createElement("rect", { id: "Rectangle 456", x: "10", y: "11", width: "3", height: "2", rx: "1" }),
        React__default.createElement("path", { id: "Vector 153 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L7.58579 9L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" }));
}

function Collapse18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M13 9C13 8.44772 12.5523 8 12 8L6 8C5.44772 8 5 8.44771 5 9C5 9.55228 5.44772 10 6 10H12C12.5523 10 13 9.55229 13 9Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z" }));
}

function Copy18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3C0 1.34315 1.34315 0 3 0H10C11.6569 0 13 1.34315 13 3V10C13 11.6569 11.6569 13 10 13H3C1.34315 13 0 11.6569 0 10V3ZM3 2H10C10.5523 2 11 2.44772 11 3V10C11 10.5523 10.5523 11 10 11H3C2.44772 11 2 10.5523 2 10V3C2 2.44772 2.44772 2 3 2Z" }),
        React__default.createElement("path", { d: "M6 15H8C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15V9C16 8.44772 15.5523 8 15 8V6C16.6569 6 18 7.34315 18 9V15C18 16.6569 16.6569 18 15 18H9C7.34315 18 6 16.6568 6 15Z" }));
}

function AccountProfile18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "10", viewBox: "0 0 18 10" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L9 7.58579L16.2929 0.292893C16.6834 -0.0976311 17.3166 -0.0976311 17.7071 0.292893C18.0976 0.683418 18.0976 1.31658 17.7071 1.70711L9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z" }));
}

function Dashboard18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.4 0H6.6C7.3732 0 8 0.626801 8 1.4V6.6C8 7.3732 7.3732 8 6.6 8H1.4C0.626801 8 0 7.3732 0 6.6V1.4C0 0.626801 0.626801 0 1.4 0ZM2 2V6H6V2H2Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.4 10H6.6C7.3732 10 8 10.6268 8 11.4V16.6C8 17.3732 7.3732 18 6.6 18H1.4C0.626801 18 0 17.3732 0 16.6V11.4C0 10.6268 0.626801 10 1.4 10ZM2 12V16H6V12H2Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6 0H11.4C10.6268 0 10 0.626801 10 1.4V6.6C10 7.3732 10.6268 8 11.4 8H16.6C17.3732 8 18 7.3732 18 6.6V1.4C18 0.626801 17.3732 0 16.6 0ZM12 6V2H16V6H12Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4 10H16.6C17.3732 10 18 10.6268 18 11.4V16.6C18 17.3732 17.3732 18 16.6 18H11.4C10.6268 18 10 17.3732 10 16.6V11.4C10 10.6268 10.6268 10 11.4 10ZM12 12V16H16V12H12Z" }));
}

function Delete18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M13 2C13 0.895431 12.1046 0 11 0H7C5.89543 0 5 0.895431 5 2H1C0.447715 2 0 2.44772 0 3C0 3.55228 0.447716 4 1 4H17C17.5523 4 18 3.55228 18 3C18 2.44772 17.5523 2 17 2H13Z" }),
        React__default.createElement("path", { d: "M8.00001 7C8.00001 6.44772 7.55229 6 7 6C6.44772 6 6 6.44772 6 7V13C6 13.5523 6.44772 14 7 14C7.55229 14 8.00001 13.5523 8.00001 13V7Z" }),
        React__default.createElement("path", { d: "M12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7V13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13V7Z" }),
        React__default.createElement("path", { d: "M3 6C2.44772 6 2 6.44772 2 7V13C2 15.7614 4.23858 18 7 18H11C13.7614 18 16 15.7614 16 13V7.5C16 6.94772 15.5523 6.5 15 6.5C14.4477 6.5 14 6.94772 14 7.5V13C14 14.6569 12.6569 16 11 16H7C5.34315 16 4 14.6569 4 13V7C4 6.44772 3.55228 6 3 6Z" }));
}

function Desktop18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 16V14H16C17.1046 14 18 13.1046 18 12V2C18 0.89543 17.1046 0 16 0H2C0.89543 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H7V16H6C5.44772 16 5 16.4477 5 17C5 17.5523 5.44772 18 6 18H12C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16H11ZM16 2H2V12H16V2Z" }));
}

function Document18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("rect", { className: 'noFill', id: "Rectangle 213", x: "1", y: "1", width: "16", height: "16", rx: "4", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector 142", d: "M17 11.9999L14 11.9999C12.8954 11.9999 12 12.8953 12 13.9999L12 16.9999", strokeWidth: "2" }),
        React__default.createElement("rect", { id: "Rectangle 442", x: "5", y: "4.99988", width: "8", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 443", x: "5", y: "10.9999", width: "5", height: "2", rx: "1" }),
        React__default.createElement("rect", { id: "Rectangle 443_2", x: "5", y: "7.99988", width: "8", height: "2", rx: "1" }));
}

function Domainauthenticated18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M12.8638 5.50387C13.1421 5.02681 12.981 4.4145 12.5039 4.13622C12.0269 3.85794 11.4145 4.01907 11.1363 4.49612L8.22003 9.49537L6.62473 8.21913C6.19347 7.87412 5.56418 7.94404 5.21917 8.3753C4.87416 8.80656 4.94408 9.43585 5.37534 9.78086L7.87534 11.7809C8.10236 11.9625 8.39717 12.0363 8.68299 11.9831C8.96881 11.9299 9.21733 11.755 9.36382 11.5039L12.8638 5.50387Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 0C1.34315 0 0 1.34315 0 3V11.6133C0 13.151 0.881404 14.5525 2.26729 15.2186L7.23127 17.6043C8.32117 18.1281 9.58953 18.1308 10.6816 17.6115L15.7176 15.217C17.1117 14.5542 18 13.1482 18 11.6046V3C18 1.34315 16.6569 0 15 0H3ZM2 3C2 2.44772 2.44772 2 3 2H15C15.5523 2 16 2.44772 16 3V11.6046C16 12.3764 15.5559 13.0794 14.8588 13.4108L9.82279 15.8053C9.27675 16.0649 8.64258 16.0636 8.09763 15.8017L3.13365 13.416C2.4407 13.0829 2 12.3822 2 11.6133V3Z" }));
}

function Domainblocked18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M9.016 4C8.45526 4 8 4.45526 8 5.016V8.984C8 9.54474 8.45526 10 9.016 10C9.57675 10 10.032 9.54474 10.032 8.984V5.016C10.032 4.45526 9.57675 4 9.016 4Z" }),
        React__default.createElement("path", { d: "M9 11C8.44809 11 8 11.4481 8 12C8 12.5519 8.44809 13 9 13H9.032C9.58392 13 10.032 12.5519 10.032 12C10.032 11.4481 9.58392 11 9.032 11H9Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 0C1.34315 0 0 1.34315 0 3V11.6133C0 13.151 0.881404 14.5525 2.26729 15.2186L7.23127 17.6043C8.32117 18.1281 9.58953 18.1308 10.6816 17.6115L15.7176 15.217C17.1117 14.5542 18 13.1482 18 11.6046V3C18 1.34315 16.6569 0 15 0H3ZM2 3C2 2.44772 2.44772 2 3 2H15C15.5523 2 16 2.44772 16 3V11.6046C16 12.3764 15.5559 13.0794 14.8588 13.4108L9.82279 15.8053C9.27675 16.0649 8.64258 16.0636 8.09763 15.8017L3.13365 13.416C2.4407 13.0829 2 12.3822 2 11.6133V3Z" }));
}

function Domainunauthenticated18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M7.62122 5.70725C7.23096 5.31699 6.59727 5.31698 6.20701 5.70725C5.81674 6.09751 5.81674 6.7312 6.207 7.12146L7.62121 8.53568L6.207 9.94989C5.81674 10.3402 5.81674 10.9738 6.207 11.3641C6.59727 11.7544 7.23095 11.7544 7.62122 11.3641L9.03543 9.94989L10.4496 11.3641C10.8399 11.7544 11.4736 11.7544 11.8638 11.3641C12.2541 10.9739 12.2541 10.3402 11.8639 9.9499L10.4496 8.53568L11.8639 7.12146C12.2541 6.7312 12.2541 6.09751 11.8639 5.70725C11.4736 5.31699 10.8399 5.31699 10.4496 5.70725L9.03543 7.12146L7.62122 5.70725Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 0C1.34315 0 0 1.34315 0 3V11.6133C0 13.151 0.881404 14.5525 2.26729 15.2186L7.23127 17.6043C8.32117 18.1281 9.58953 18.1308 10.6816 17.6115L15.7176 15.217C17.1117 14.5542 18 13.1482 18 11.6046V3C18 1.34315 16.6569 0 15 0H3ZM2 3C2 2.44772 2.44772 2 3 2H15C15.5523 2 16 2.44772 16 3V11.6046C16 12.3764 15.5559 13.0794 14.8588 13.4108L9.82279 15.8053C9.27675 16.0649 8.64258 16.0636 8.09763 15.8017L3.13365 13.416C2.4407 13.0829 2 12.3822 2 11.6133V3Z" }));
}

function Edit18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M12.8776 0.878823C14.0491 -0.292826 15.9487 -0.292865 17.1203 0.87874C18.2918 2.05028 18.2919 3.94971 17.1204 5.1213L15.7422 6.4996L16.5961 7.35356C17.3772 8.13461 17.3772 9.40094 16.5961 10.182L13.4748 13.3033C13.0843 13.6938 12.4511 13.6938 12.0606 13.3033C11.6701 12.9128 11.6701 12.2796 12.0606 11.8891L15.1819 8.76777L14.328 7.91387L4.53556 17.7071C4.34802 17.8946 4.09366 18 3.82843 18H1C0.447715 18 0 17.5523 0 17V14.1716C0 13.9064 0.105347 13.652 0.292867 13.4645L12.8776 0.878823ZM15.7061 2.29295C15.3155 1.90242 14.6824 1.90243 14.2918 2.29298L12.8744 3.7104L14.2887 5.12462L15.7061 3.70714C16.0966 3.31661 16.0966 2.68347 15.7061 2.29295ZM2 14.5858L11.4603 5.12467L12.8745 6.53889L3.41419 16L2 16L2 14.5858Z" }));
}

function EmailAddress18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9V12C18 13.6569 16.6569 15 15 15C13.6548 15 12.5164 14.1146 12.1357 12.8948C11.2781 13.5861 10.1874 14 9 14C6.23858 14 4 11.7614 4 9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9V12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12V9C16 5.13401 12.866 2 9.00002 2C5.13403 2 2.00002 5.13401 2.00002 9C2.00002 12.866 5.13402 16 9 16H10C10.5523 16 11 16.4477 11 17C11 17.5523 10.5523 18 10 18H9ZM12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9Z" }));
}

function Expand18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M8 6C8 5.44772 8.44771 5 9 5C9.55228 5 10 5.44772 10 6V8H12C12.5523 8 13 8.44772 13 9C13 9.55229 12.5523 10 12 10H10V12C10 12.5523 9.55228 13 9 13C8.44771 13 8 12.5523 8 12V10H6C5.44772 10 5 9.55228 5 9C5 8.44771 5.44772 8 6 8H8V6Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z" }));
}

function Export18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M18 17C18 17.5523 17.5523 18 17 18L1 18C0.447716 18 3.91405e-08 17.5523 8.74228e-08 17C1.35705e-07 16.4477 0.44974 16 1.00202 16C7.09192 16 10.9081 16 16.998 16C17.5503 16 18 16.4477 18 17Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2929 5.7071C12.6834 6.09762 13.3166 6.09762 13.7071 5.7071C14.0976 5.31657 14.0976 4.68341 13.7071 4.29288L9.7071 0.292892C9.51183 0.09763 9.25591 -6.27369e-07 8.99999 -2.18556e-07C8.74407 2.00257e-07 8.48814 0.0976316 8.29288 0.292894L4.29289 4.2929C3.90237 4.68343 3.90237 5.31659 4.29289 5.70712C4.68342 6.09764 5.31658 6.09764 5.70711 5.70711L7.99999 3.41421L8.00002 12.9807C8.00002 13.5447 8.44774 14 9.00002 14C9.53615 14 10 13.5465 10 12.9872L9.99999 3.41421L12.2929 5.7071Z" }));
}

function Field18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 1C2 0.447715 2.44772 0 3 0H5C5.76836 0 6.46925 0.288855 7 0.763896C7.53076 0.288855 8.23165 0 9 0H11C11.5523 0 12 0.447716 12 1C12 1.55228 11.5523 2 11 2L9 2C8.44772 2 8 2.44771 8 3V4H14C16.2091 4 18 5.79086 18 8V10C18 12.2091 16.2091 14 14 14H8V15C8 15.5523 8.44772 16 9 16H11C11.5523 16 12 16.4477 12 17C12 17.5523 11.5523 18 11 18H9C8.23164 18 7.53076 17.7111 7 17.2361C6.46925 17.7111 5.76836 18 5 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H5C5.55229 16 6 15.5523 6 15V14H4C1.79086 14 0 12.2091 0 10V8C0 5.79086 1.79086 4 4 4H6V3C6 2.44772 5.55228 2 5 2H3C2.44772 2 2 1.55228 2 1ZM6 6H4C2.89543 6 2 6.89543 2 8V10C2 11.1046 2.89543 12 4 12H6V6ZM8 12H14C15.1046 12 16 11.1046 16 10V8C16 6.89543 15.1046 6 14 6H8V12Z" }));
}

function Flow18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.87398 5C7.42994 6.72523 5.86384 8 4 8C3.3733 8 2.78027 7.85588 2.25223 7.59897C2.08916 8.03499 2 8.50708 2 9C2 9.49292 2.08916 9.96501 2.25223 10.401C2.78027 10.1441 3.3733 10 4 10C5.86384 10 7.42994 11.2748 7.87398 13H13V13.0069H14.5965L12.9479 11.3543C12.5586 10.9644 12.5586 10.3322 12.9479 9.94233C13.3372 9.55243 13.9684 9.55243 14.3577 9.94233L17.708 13.2993C18.0973 13.6892 18.0973 14.3214 17.708 14.7113L14.7226 17.7028C14.3333 18.0927 13.7021 18.0927 13.3128 17.7028C12.9235 17.3129 12.9235 16.6808 13.3128 16.2909L14.5965 15.0037H10.08L10.08 15H7.87398C7.42994 16.7252 5.86384 18 4 18C1.79086 18 0 16.2091 0 14C0 13.1753 0.249601 12.4088 0.677384 11.7721C0.244657 10.9429 0 10 0 9C0 7.99996 0.244658 7.05706 0.677384 6.2279C0.249601 5.59118 0 4.82474 0 4C0 1.79086 1.79086 0 4 0C5.86384 0 7.42994 1.27477 7.87398 3H10.126C10.5701 1.27477 12.1362 0 14 0C16.2091 0 18 1.79086 18 4C18 6.20914 16.2091 8 14 8C12.1362 8 10.5701 6.72523 10.126 5L7.87398 5ZM4 6C5.10458 6 6 5.10449 6 4C6 2.89551 5.10458 2 4 2C2.89542 2 2 2.89551 2 4C2 5.10449 2.89542 6 4 6ZM14 6C15.1046 6 16 5.10449 16 4C16 2.89551 15.1046 2 14 2C12.8954 2 12 2.89551 12 4C12 5.10449 12.8954 6 14 6ZM6 14C6 15.1045 5.10458 16 4 16C2.89542 16 2 15.1045 2 14C2 12.8955 2.89542 12 4 12C5.10458 12 6 12.8955 6 14Z" }));
}

function Globe18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 0.00012207C13.9706 0.00012207 18 4.02956 18 9.00012C17.9999 13.9706 13.9705 18.0001 9 18.0001C4.02948 18.0001 6.5973e-05 13.9706 0 9.00012C0 4.02956 4.02944 0.00012207 9 0.00012207ZM2.07227 10.0001C2.44075 12.5754 4.20976 14.6982 6.58398 15.5714C5.50391 13.8629 4.88717 11.9468 4.72949 10.0001H2.07227ZM13.2695 10.0001C13.1118 11.9469 12.4953 13.8629 11.415 15.5714C13.7897 14.6984 15.5592 12.5757 15.9277 10.0001H13.2695ZM6.73438 10.0001C6.92498 11.9685 7.6799 13.8926 8.99902 15.5099C10.3186 13.8925 11.0749 11.9688 11.2656 10.0001H6.73438ZM6.58398 2.42786C4.20956 3.301 2.44068 5.42466 2.07227 8.00012H4.73047C4.88821 6.05325 5.50366 4.1365 6.58398 2.42786ZM9 2.4884C7.68007 4.10602 6.92508 6.03112 6.73438 8.00012H11.2656C11.075 6.03108 10.3199 4.10605 9 2.4884ZM11.415 2.42786C12.4955 4.13666 13.1128 6.05303 13.2705 8.00012H15.9277C15.5593 5.42435 13.7899 3.30081 11.415 2.42786Z" }));
}

function Google18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M9.18359 7.36353V10.849H14.1261C13.909 11.9699 13.2578 12.919 12.281 13.5572L15.2615 15.8235C16.998 14.2527 17.9999 11.9454 17.9999 9.20451C17.9999 8.56635 17.9415 7.95266 17.8329 7.36362L9.18359 7.36353Z", fill: "#4285F4" }),
        React__default.createElement("path", { d: "M4.03653 10.7131L3.36431 11.2174L0.984863 13.0337C2.49599 15.971 5.59317 18.0001 9.18313 18.0001C11.6627 18.0001 13.7415 17.1983 15.261 15.8238L12.2805 13.5574C11.4623 14.0974 10.4187 14.4247 9.18313 14.4247C6.79538 14.4247 4.76668 12.8456 4.04028 10.7183L4.03653 10.7131Z", fill: "#34A853" }),
        React__default.createElement("path", { d: "M0.985087 4.96631C0.358961 6.17716 0 7.54354 0 8.99987C0 10.4562 0.358961 11.8226 0.985087 13.0334C0.985087 13.0416 4.0408 10.7098 4.0408 10.7098C3.85713 10.1698 3.74856 9.59712 3.74856 8.99977C3.74856 8.40243 3.85713 7.82974 4.0408 7.28974L0.985087 4.96631Z", fill: "#FBBC05" }),
        React__default.createElement("path", { d: "M9.18332 3.58361C10.5358 3.58361 11.7381 4.04178 12.6982 4.92543L15.328 2.3482C13.7334 0.891869 11.6629 0 9.18332 0C5.59336 0 2.49599 2.02089 0.984863 4.96634L4.04048 7.28997C4.76679 5.16268 6.79557 3.58361 9.18332 3.58361Z", fill: "#EA4335" }));
}

function Heart18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.98783 7.93833C3.00127 7.95363 3.01447 7.96913 3.02743 7.98484C3.62606 8.71006 5.48652 10.874 7.21987 12.8823C7.85912 13.623 8.47727 14.338 9.00204 14.9446C9.52682 14.3381 10.145 13.623 10.7842 12.8823C12.5176 10.874 14.3781 8.71014 14.9768 7.98484C14.9898 7.96913 15.003 7.95362 15.0164 7.93831C16.3568 6.41195 16.2963 4.28001 15.0584 2.95629C14.4632 2.31964 13.7102 2 12.9282 2C12.1462 2 11.3934 2.31947 10.7982 2.95612L10.7967 2.95765L10.4617 3.31529C10.0835 3.71889 9.55518 3.9479 9.00213 3.9479C8.44908 3.9479 7.92072 3.71889 7.5426 3.31529L7.20609 2.95612C6.61089 2.31947 5.85801 2 5.07604 2C4.29407 2 3.54119 2.31947 2.94598 2.95612C1.70811 4.27993 1.64746 6.41195 2.98783 7.93833ZM9.00201 18C9.00201 18 8.46731 17.3833 7.67926 16.4725C5.76567 14.261 2.3582 10.3158 1.48502 9.25801C-0.497825 7 -0.492184 3.70472 1.48502 1.59026C2.44361 0.564922 3.71898 0 5.07604 0C6.09569 0 7.06922 0.318926 7.89691 0.912447C8.1708 1.10885 8.42872 1.33532 8.66706 1.59026L9.00213 1.9479L9.33719 1.59026C9.57553 1.33532 9.83346 1.10885 10.1073 0.912447C10.935 0.318926 11.9086 0 12.9282 0C14.2853 0 15.5606 0.564922 16.5192 1.59026C18.4964 3.70464 18.5021 7 16.5192 9.25801C15.6459 10.316 12.2384 14.261 10.3248 16.4725C9.53673 17.3833 9.00201 18 9.00201 18Z" }));
}

function Home18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.00333 0.152003C9.34655 -0.0625069 9.78522 -0.0489805 10.1146 0.186267L17.5812 5.5196C17.844 5.70731 18 6.01038 18 6.33333V17C18 17.5523 17.5523 18 17 18H11.6667C11.1144 18 10.6667 17.5523 10.6667 17V12.5556C10.6667 11.6351 9.92048 10.8889 9 10.8889C8.07952 10.8889 7.33333 11.6351 7.33333 12.5556V17C7.33333 17.5523 6.88562 18 6.33333 18H1C0.447715 18 0 17.5523 0 17V6.33333C0 5.98854 0.17762 5.66807 0.470001 5.48534L9.00333 0.152003ZM9 8.88889C11.025 8.88889 12.6667 10.5305 12.6667 12.5556V16H16V6.84795L9.49626 2.20242L2 6.88758V16H5.33333V12.5556C5.33333 10.5305 6.97496 8.88889 9 8.88889Z" }));
}

function Image18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M9 6C9 7.10457 8.10457 8 7 8C5.89543 8 5 7.10457 5 6C5 4.89543 5.89543 4 7 4C8.10457 4 9 4.89543 9 6Z" }),
        React__default.createElement("path", { d: "M10.2426 8.05169C10.5956 7.46295 11.4113 7.50408 11.7111 8.12575L13.9042 12.6738C14.196 13.2788 13.7859 14 13.15 14H4.84987C4.2268 14 3.81606 13.305 4.08267 12.7019L5.35045 9.83399C5.63648 9.18693 6.47622 9.13143 6.83437 9.73591L7.31399 10.5454C7.64631 11.1063 8.40983 11.1085 8.74497 10.5495L10.2426 8.05169Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2ZM2 3C2 2.44772 2.44772 2 3 2H15C15.5523 2 16 2.44772 16 3V15C16 15.5523 15.5523 16 15 16H3C2.44772 16 2 15.5523 2 15V3Z" }));
}

function Info18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M8 7V5H10V7H8Z" }),
        React__default.createElement("path", { d: "M8 13V8H10V13H8Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z" }));
}

function Integrations18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M10.9395 13.4985C10.9129 13.6619 10.8984 13.8296 10.8984 14.0005C10.8984 14.5608 11.0497 15.085 11.3096 15.5386C10.5985 15.8354 9.81866 16.0005 9 16.0005C8.18103 16.0005 7.4007 15.8357 6.68945 15.5386C6.94947 15.0849 7.10156 14.5609 7.10156 14.0005C7.10156 13.8295 7.08618 13.662 7.05957 13.4985C7.63432 13.818 8.29577 14.0005 9 14.0005C9.70392 14.0005 10.3649 13.8178 10.9395 13.4985ZM5.87891 4.87549C6.06574 5.54333 6.46192 6.12251 6.99121 6.5415C5.80065 7.23441 5.00001 8.5237 5 10.0005C5 10.3912 5.05671 10.7686 5.16113 11.1255C4.80235 10.9804 4.41077 10.8989 4 10.8989C3.68366 10.8989 3.37833 10.9466 3.09082 11.0347C3.03242 10.6986 3 10.3533 3 10.0005C3.00001 7.83007 4.15258 5.92906 5.87891 4.87549ZM12.1201 4.87549C13.8468 5.92897 15 7.82978 15 10.0005C15 10.3533 14.9666 10.6986 14.9082 11.0347C14.6209 10.9468 14.316 10.8989 14 10.8989C13.5889 10.8989 13.1969 10.9802 12.8379 11.1255C12.9424 10.7685 13 10.3913 13 10.0005C13 8.5234 12.1988 7.2343 11.0078 6.5415C11.5373 6.12253 11.9332 5.54346 12.1201 4.87549Z" }),
        React__default.createElement("path", { d: "M4 10.0005C6.20914 10.0005 8 11.7913 8 14.0005C8 16.2096 6.20914 18.0005 4 18.0005C1.79086 18.0005 0 16.2096 0 14.0005C0 11.7913 1.79086 10.0005 4 10.0005ZM14 10.0005C16.2091 10.0005 18 11.7913 18 14.0005C18 16.2096 16.2091 18.0005 14 18.0005C11.7909 18.0005 10 16.2096 10 14.0005C10 11.7913 11.7909 10.0005 14 10.0005ZM4 12.0005C2.89543 12.0005 2 12.8959 2 14.0005C2 15.1051 2.89543 16.0005 4 16.0005C5.10457 16.0005 6 15.1051 6 14.0005C6 12.8959 5.10457 12.0005 4 12.0005ZM14 12.0005C12.8954 12.0005 12 12.8959 12 14.0005C12 15.1051 12.8954 16.0005 14 16.0005C15.1046 16.0005 16 15.1051 16 14.0005C16 12.8959 15.1046 12.0005 14 12.0005ZM9 0.000488281C11.2091 0.000488281 13 1.79135 13 4.00049C13 6.20963 11.2091 8.00049 9 8.00049C6.79086 8.00049 5 6.20963 5 4.00049C5 1.79135 6.79086 0.000488281 9 0.000488281ZM9 2.00049C7.89543 2.00049 7 2.89592 7 4.00049C7 5.10506 7.89543 6.00049 9 6.00049C10.1046 6.00049 11 5.10506 11 4.00049C11 2.89592 10.1046 2.00049 9 2.00049Z" }));
}

function Kb18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M14 10.0001C14.5523 10.0001 15 10.4478 15 11.0001C14.9999 11.5524 14.5522 12.0001 14 12.0001H12C11.4478 12.0001 11.0001 11.5524 11 11.0001C11 10.4478 11.4477 10.0001 12 10.0001H14Z" }),
        React__default.createElement("path", { d: "M14 7.00012C14.5523 7.00012 15 7.44784 15 8.00012C14.9999 8.55235 14.5522 9.00012 14 9.00012H12C11.4478 9.00012 11.0001 8.55235 11 8.00012C11 7.44784 11.4477 7.00012 12 7.00012H14Z" }),
        React__default.createElement("path", { d: "M14 4.00012C14.5523 4.00012 15 4.44784 15 5.00012C14.9999 5.55235 14.5522 6.00012 14 6.00012H12C11.4478 6.00012 11.0001 5.55235 11 5.00012C11 4.44784 11.4477 4.00012 12 4.00012H14Z" }),
        React__default.createElement("path", { d: "M6 10.0001C6.55228 10.0001 7 10.4478 7 11.0001C6.99993 11.5524 6.55224 12.0001 6 12.0001H4C3.44776 12.0001 3.00007 11.5524 3 11.0001C3 10.4478 3.44772 10.0001 4 10.0001H6Z" }),
        React__default.createElement("path", { d: "M6 7.00012C6.55228 7.00012 7 7.44784 7 8.00012C6.99993 8.55235 6.55224 9.00012 6 9.00012H4C3.44776 9.00012 3.00007 8.55235 3 8.00012C3 7.44784 3.44772 7.00012 4 7.00012H6Z" }),
        React__default.createElement("path", { d: "M6 4.00012C6.55228 4.00012 7 4.44784 7 5.00012C6.99993 5.55235 6.55224 6.00012 6 6.00012H4C3.44776 6.00012 3.00007 5.55235 3 5.00012C3 4.44784 3.44772 4.00012 4 4.00012H6Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 0.00012207C15.7614 0.00012207 18 2.2387 18 5.00012V11.0001C18 13.7615 15.7614 16.0001 13 16.0001H11L9.70703 17.2931C9.31654 17.6834 8.68346 17.6834 8.29297 17.2931L7 16.0001H5C2.23858 16.0001 0 13.7615 0 11.0001V5.00012C0 2.2387 2.23858 0.00012207 5 0.00012207H13ZM10 14.0001H13C14.6569 14.0001 16 12.657 16 11.0001V5.00012C16 3.34327 14.6569 2.00012 13 2.00012H10V14.0001ZM5 2.00012C3.34315 2.00012 2 3.34327 2 5.00012V11.0001C2 12.657 3.34315 14.0001 5 14.0001H8V2.00012H5Z" }));
}

function LineChart18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Union", d: "M18 16H0V18H18V16Z" }),
        React__default.createElement("path", { id: "Union_2", d: "M2 0H0V18H2V0Z" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector 90", d: "M5 5.99988L9 2.99988L13 5.99988L17 2.99988", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("rect", { id: "Rectangle 245", x: "4", y: "10", width: "2", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 246", x: "8", y: "10", width: "2", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 247", x: "12", y: "10", width: "2", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 248", x: "16", y: "10", width: "2", height: "2" }));
}

function LinkArrow18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M18 9C18 4.02944 13.9706 -6.10673e-07 9 -3.93402e-07C4.02944 -1.76132e-07 -6.10673e-07 4.02944 -3.93402e-07 9C-1.76132e-07 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9ZM16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9Z" }),
        React__default.createElement("path", { id: "Union_2", fillRule: "evenodd", clipRule: "evenodd", d: "M11.2929 8.7071C11.6834 9.09762 12.3166 9.09762 12.7071 8.7071C13.0976 8.31657 13.0976 7.68341 12.7071 7.29288L9.7071 4.29289C9.51183 4.09763 9.25591 4 8.99999 4C8.74407 4 8.48814 4.09763 8.29288 4.29289L5.29289 7.29291C4.90237 7.68343 4.90237 8.3166 5.29289 8.70712C5.68342 9.09764 6.31658 9.09764 6.70711 8.70712L7.99999 7.41422L8.00002 12.9807C8.00002 13.5447 8.44774 14 9.00002 14C9.53615 14 10 13.5465 10 12.9872L9.99999 7.41421L11.2929 8.7071Z" }));
}

function Mobile18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12H7Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0H14C15.1038 0 16 0.89617 16 2V16C16 17.1038 15.1038 18 14 18H4C2.89617 18 2 17.1038 2 16V2C2 0.89617 2.89617 0 4 0ZM5 2H13C13.5519 2 14 2.44809 14 3V15C14 15.5519 13.5519 16 13 16H5C4.44809 16 4 15.5519 4 15V3C4 2.44809 4.44809 2 5 2Z" }));
}

function Money18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { className: 'noFill', d: "M14 6V6C14 4.89543 13.1046 4 12 4H6.5C5.11929 4 4 5.11929 4 6.5V6.5C4 7.88071 5.11929 9 6.5 9H11.5C12.8807 9 14 10.1193 14 11.5V11.5C14 12.8807 12.8807 14 11.5 14H6C4.89543 14 4 13.1046 4 12V12", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: 'noFill', d: "M9 1V3", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: 'noFill', d: "M9 15V17", strokeWidth: "2", strokeLinecap: "round" }));
}

function Organization18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 8V1C10 0.447716 9.55229 0 9 0H1C0.447715 0 0 0.447716 0 1V17C0 17.5523 0.447715 18 1 18H17C17.5523 18 18 17.5523 18 17V13C18 12.4477 17.5523 12 17 12H14V9C14 8.44771 13.5523 8 13 8H10ZM10 16H12V14H10V16ZM10 12H12V10H10V12ZM8 10H6V12H8V10ZM8 14H6V16H8V14ZM4 6H2V8H4V6ZM6 6H8V8H6V6ZM4 10H2V12H4V10ZM2 14H4V16H2V14ZM16 14V16H14V14H16ZM15 6C16.6569 6 18 4.65685 18 3C18 1.34315 16.6569 0 15 0C13.3431 0 12 1.34315 12 3C12 4.65685 13.3431 6 15 6ZM15 4C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2C14.4477 2 14 2.44772 14 3C14 3.55228 14.4477 4 15 4ZM4 2H2V4H4V2ZM8 2H6V4H8V2Z" }));
}

function Partner18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M4 2C2.89543 2 2 2.89543 2 4V11L3.53157e-09 13.5V4C3.53157e-09 1.79086 1.79086 0 4 0H14C16.2091 0 18 1.79086 18 4V11H16V4C16 2.89543 15.1046 2 14 2H4Z" }),
        React__default.createElement("path", { d: "M4 4H9V6H4V4Z" }),
        React__default.createElement("path", { d: "M7 7H4V9H7V7Z" }),
        React__default.createElement("path", { d: "M6.43675 12.3364C6.3339 12.285 6.20918 12.3111 6.13557 12.3994L1.76825 17.6402C1.41468 18.0645 0.784118 18.1218 0.359841 17.7682C-0.0644363 17.4147 -0.12176 16.7841 0.231804 16.3598L4.59913 11.119C5.2669 10.3177 6.39821 10.0811 7.33118 10.5476C8.44154 11.1027 8.8916 12.4529 8.33642 13.5633L7.44396 15.3482C7.38747 15.4612 7.43327 15.5986 7.54626 15.6551C7.64378 15.7039 7.76217 15.677 7.82911 15.5909L10.0922 12.6812C10.7445 11.8426 11.898 11.581 12.8482 12.0561C13.9492 12.6065 14.3954 13.9453 13.8449 15.0462L13.7846 15.1669C13.7081 15.32 13.8194 15.5 13.9905 15.5C14.0515 15.5 14.1101 15.4758 14.1532 15.4326L15.7929 13.7929C16.1834 13.4024 16.8166 13.4024 17.2071 13.7929C17.5977 14.1834 17.5977 14.8166 17.2071 15.2071L15.5674 16.8468C15.1492 17.265 14.582 17.5 13.9905 17.5C12.3326 17.5 11.2543 15.7553 11.9958 14.2725L12.0561 14.1518C12.1126 14.0388 12.0668 13.9014 11.9538 13.8449C11.8563 13.7962 11.7379 13.823 11.6709 13.9091L9.40782 16.8188C8.75557 17.6574 7.60207 17.9191 6.65183 17.4439C5.55088 16.8935 5.10463 15.5547 5.65511 14.4538L6.54757 12.6689C6.60877 12.5465 6.55915 12.3976 6.43675 12.3364Z" }),
        React__default.createElement("path", { d: "M12.5 7C13.3284 7 14 6.32843 14 5.5C14 4.67157 13.3284 4 12.5 4C11.6716 4 11 4.67157 11 5.5C11 6.32843 11.6716 7 12.5 7Z" }));
}

function Preview18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M0 1C0 0.447754 0.447693 0 1 0H3C3.55231 0 4 0.447754 4 1C4 1.55225 3.55231 2 3 2H2V3C2 3.55225 1.55231 4 1 4C0.447693 4 0 3.55225 0 3V1Z" }),
        React__default.createElement("path", { d: "M17 0C17.5523 0 18 0.447754 18 1V3C18 3.55225 17.5523 4 17 4C16.4477 4 16 3.55225 16 3V2H15C14.4477 2 14 1.55225 14 1C14 0.447754 14.4477 0 15 0H17Z" }),
        React__default.createElement("path", { d: "M16 15C16 14.4478 16.4477 14 17 14C17.5523 14 18 14.4478 18 15V17C18 17.5522 17.5523 18 17 18H15C14.4477 18 14 17.5522 14 17C14 16.4478 14.4477 16 15 16H16V15Z" }),
        React__default.createElement("path", { d: "M0 15C0 14.4478 0.447693 14 1 14C1.55231 14 2 14.4478 2 15V16H3C3.55231 16 4 16.4478 4 17C4 17.5522 3.55231 18 3 18H1C0.447693 18 0 17.5522 0 17V15Z" }),
        React__default.createElement("path", { d: "M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1881 10.0657C17.7045 9.43868 17.7045 8.56132 17.1881 7.93429C15.768 6.21014 12.6358 3 9.00005 3C5.36432 3 2.23211 6.21014 0.812023 7.93429C0.29557 8.56132 0.295569 9.43868 0.812022 10.0657C2.23211 11.7899 5.36432 15 9.00005 15C12.6358 15 15.768 11.7899 17.1881 10.0657ZM15.4722 9C14.8215 8.23357 13.877 7.24995 12.7569 6.44407C11.5179 5.55266 10.2338 5 9.00005 5C7.76632 5 6.48221 5.55266 5.2432 6.44407C4.12309 7.24995 3.17858 8.23357 2.52791 9C3.17858 9.76643 4.12309 10.7501 5.2432 11.5559C6.48221 12.4473 7.76632 13 9.00005 13C10.2338 13 11.5179 12.4473 12.7569 11.5559C13.877 10.7501 14.8215 9.76643 15.4722 9Z" }));
}

function Publish18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M14.123 6.23012C13.4259 6.92721 12.3341 6.96561 11.6844 6.31589C11.0346 5.66618 11.073 4.57436 11.7701 3.87727C12.4672 3.18017 13.559 3.14179 14.2087 3.7915C14.8585 4.44122 14.8201 5.53303 14.123 6.23012Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0919 16.9917C11.3246 17.0671 11.5899 16.9982 11.7735 16.8146L15.0989 13.4892C15.2249 13.3632 15.2993 13.1958 15.3057 13.0241L15.4316 9.62139C17.7681 7.14263 18.4762 3.73286 17.5049 0.863304C17.4458 0.688745 17.3114 0.554341 17.1369 0.495261C14.2673 -0.475963 10.8576 0.232164 8.37889 2.5687L4.97623 2.69462C4.8044 2.70097 4.63708 2.77533 4.51109 2.90133L1.18566 6.22675C1.00209 6.41032 0.933169 6.67565 1.00853 6.90836C1.084 7.14098 1.29034 7.29924 1.53848 7.31497L5.62516 7.57339C5.57319 7.85653 5.53544 8.14085 5.51196 8.42518C5.41911 9.54951 5.54939 10.674 5.90566 11.7266C5.96471 11.9012 6.09912 12.0356 6.2737 12.0947C7.3262 12.4509 8.45062 12.5812 9.57486 12.4883C9.85927 12.4649 10.1437 12.4271 10.4269 12.3751L10.6853 16.4618C10.701 16.7099 10.8592 16.9162 11.0919 16.9917ZM5.36283 4.40243L9.00209 4.26776L9.51475 3.7845C11.351 2.05362 13.8303 1.44476 16.0066 1.99359C16.5555 4.16995 15.9467 6.64928 14.2158 8.48554L13.7325 8.9982L13.5979 12.6374L12.2643 13.9709L12.0352 10.3476L10.2321 10.6786C9.28158 10.8531 8.3155 10.8261 7.40399 10.5963C7.17417 9.6848 7.14717 8.71871 7.32165 7.76812L7.65261 5.96509L4.0293 5.73597L5.36283 4.40243Z" }),
        React__default.createElement("path", { id: "Vector 155", d: "M0.292893 16.2929C-0.0976311 16.6834 -0.0976311 17.3166 0.292893 17.7071C0.683417 18.0976 1.31658 18.0976 1.70711 17.7071L0.292893 16.2929ZM3.29289 13.2929L0.292893 16.2929L1.70711 17.7071L4.70711 14.7071L3.29289 13.2929Z" }),
        React__default.createElement("path", { id: "Vector 155_2", d: "M5.29289 16.2929C4.90237 16.6834 4.90237 17.3166 5.29289 17.7071C5.68342 18.0976 6.31658 18.0976 6.70711 17.7071L5.29289 16.2929ZM7.79289 13.7929L5.29289 16.2929L6.70711 17.7071L9.20711 15.2071L7.79289 13.7929Z" }),
        React__default.createElement("path", { id: "Vector 155_3", d: "M0.292893 11.2929C-0.0976311 11.6834 -0.0976311 12.3166 0.292893 12.7071C0.683417 13.0976 1.31658 13.0976 1.70711 12.7071L0.292893 11.2929ZM2.79289 8.79289L0.292893 11.2929L1.70711 12.7071L4.20711 10.2071L2.79289 8.79289Z" }));
}

function Redirection18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H13V16H15C15.5523 16 16 15.5523 16 15V6H2V9H0V3ZM16 3V4H2V3C2 2.44772 2.44772 2 3 2H15C15.5523 2 16 2.44772 16 3Z" }),
        React__default.createElement("path", { d: "M1 13.364C0.447715 13.364 0 12.9163 0 12.364C0 11.8117 0.447715 11.364 1 11.364H8.58582L6.92896 9.70703C6.53845 9.31665 6.53845 8.68335 6.92896 8.29297C7.31946 7.90234 7.95264 7.90234 8.34314 8.29297L11.7072 11.6567C12.0977 12.0474 12.0977 12.6807 11.7072 13.071L8.34314 16.4351C7.95264 16.8254 7.31946 16.8254 6.92896 16.4351C6.53845 16.0444 6.53845 15.4114 6.92896 15.0208L8.58582 13.364H1Z" }));
}

function Refresh18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M9 16C12.866 16 16 12.866 16 9C16 8.44771 16.4477 8 17 8C17.5523 8 18 8.44771 18 9C18 13.9706 13.9706 18 9 18C4.36744 18 0.552372 14.4999 0.0549278 10C0.0519905 9.97343 0.0491714 9.94683 0.0464668 9.9202C0.0157413 9.61764 0 9.31066 0 9C0 4.02944 4.02944 0 9 0C11.3051 0 13.4077 0.86656 15 2.29168V1C15 0.447715 15.4477 0 16 0C16.5523 0 17 0.447715 17 1L17 5C17 5.55228 16.5523 6 16 6L12 6C11.4477 6 11 5.55228 11 5C11 4.44771 11.4477 4 12 4L13.899 4C12.6364 2.76281 10.9073 2 9 2C8.75838 2 8.51961 2.01224 8.28429 2.03614C4.7545 2.39461 2 5.37563 2 9C2 9.33952 2.02417 9.6734 2.07089 10C2.55612 13.3923 5.47353 16 9 16Z" }));
}

function Search18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0491 13.4633C10.7873 14.4274 9.21054 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.21054 14.4274 10.7873 13.4633 12.0491L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L12.0491 13.4633ZM13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5Z" }));
}

function Sends18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.7071 0.292893C17.8771 0.462914 17.9731 0.678925 17.9951 0.900882C18.0027 0.97666 18.0016 1.05358 17.9915 1.13015C17.9833 1.19338 17.969 1.25598 17.9487 1.317L12.9545 17.2982C12.8358 17.6779 12.5034 17.9511 12.1079 17.9941C11.7125 18.037 11.3292 17.8414 11.1318 17.496L7.26709 10.733L0.503883 6.86827C0.158492 6.6709 -0.0370687 6.28759 0.00586237 5.89211C0.0487934 5.49663 0.322051 5.1642 0.701747 5.04555L16.6803 0.0522551C17.0289 -0.0650577 17.4294 0.0151551 17.7071 0.292893ZM3.48828 6.27014L13.419 3.16679L7.83297 8.75282L3.48828 6.27014ZM14.8333 4.58092L9.2472 10.167L11.7299 14.5117L14.8333 4.58092Z" }),
        React__default.createElement("path", { d: "M5.70711 13.7071C6.09763 13.3166 6.09763 12.6834 5.70711 12.2929C5.31658 11.9024 4.68342 11.9024 4.29289 12.2929L0.292893 16.2929C-0.0976311 16.6834 -0.0976311 17.3166 0.292893 17.7071C0.683417 18.0976 1.31658 18.0976 1.70711 17.7071L5.70711 13.7071Z" }),
        React__default.createElement("path", { d: "M3.20711 10.2929C3.59763 10.6834 3.59763 11.3166 3.20711 11.7071L1.70711 13.2071C1.31658 13.5976 0.683417 13.5976 0.292893 13.2071C-0.0976311 12.8166 -0.0976311 12.1834 0.292893 11.7929L1.79289 10.2929C2.18342 9.90237 2.81658 9.90237 3.20711 10.2929Z" }),
        React__default.createElement("path", { d: "M7.70711 16.2071C8.09763 15.8166 8.09763 15.1834 7.70711 14.7929C7.31658 14.4024 6.68342 14.4024 6.29289 14.7929L4.79289 16.2929C4.40237 16.6834 4.40237 17.3166 4.79289 17.7071C5.18342 18.0976 5.81658 18.0976 6.20711 17.7071L7.70711 16.2071Z" }));
}

function Settings18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.99994 11.8421C10.5696 11.8421 11.842 10.5697 11.842 9C11.842 7.43035 10.5696 6.15789 8.99994 6.15789C7.43029 6.15789 6.15784 7.43035 6.15784 9C6.15784 10.5697 7.43029 11.8421 8.99994 11.8421ZM8.99994 9.94737C9.52316 9.94737 9.94731 9.52322 9.94731 9C9.94731 8.47678 9.52316 8.05263 8.99994 8.05263C8.47673 8.05263 8.05257 8.47678 8.05257 9C8.05257 9.52322 8.47673 9.94737 8.99994 9.94737Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.86871 0C10.7634 0 11.5266 0.623709 11.7178 1.48074C11.99 1.57917 12.2554 1.69192 12.5129 1.81809C13.2488 1.3743 14.2074 1.47943 14.8298 2.10183L15.8983 3.17037C16.5207 3.79279 16.6258 4.75139 16.182 5.48732C16.3081 5.74476 16.4208 6.01002 16.5192 6.28219C17.3763 6.47333 18 7.23654 18 8.13125V9.86858C18 10.7633 17.3763 11.5265 16.5193 11.7176C16.4209 11.9899 16.3081 12.2553 16.1819 12.5129C16.6257 13.2488 16.5206 14.2074 15.8982 14.8298L14.8296 15.8983C14.2072 16.5207 13.2486 16.6258 12.5127 16.182C12.2552 16.3081 11.99 16.4209 11.7178 16.5193C11.5266 17.3763 10.7634 18 9.86871 18H8.13138C7.23668 18 6.47348 17.3763 6.28233 16.5193C6.01011 16.4209 5.7448 16.3081 5.48732 16.182C4.75138 16.6258 3.79279 16.5207 3.17038 15.8983L2.10185 14.8298C1.47945 14.2074 1.37431 13.2488 1.81809 12.5129C1.6919 12.2553 1.57913 11.9899 1.4807 11.7176C0.623684 11.5265 0 10.7633 0 9.86858V8.13125C0 7.23654 0.623715 6.47333 1.48076 6.28219C1.57915 6.01002 1.69187 5.74476 1.81799 5.48732C1.37417 4.75138 1.4793 3.79279 2.10171 3.17038L3.17024 2.10185C3.79264 1.47945 4.75119 1.37431 5.48712 1.81809C5.74466 1.69191 6.01004 1.57914 6.28233 1.48071C6.47348 0.623693 7.23668 0 8.13138 0H9.86871ZM6.96224 3.36159L7.99524 2.98818L8.21565 2H9.78443L10.0048 2.98819L11.0378 3.36162C11.2415 3.43525 11.4401 3.51963 11.6329 3.61411L12.612 4.0938L13.4737 3.57419L14.4259 4.52644L13.9063 5.38811L14.386 6.36722C14.4804 6.56001 14.5648 6.75854 14.6384 6.96214L15.0118 7.99514L16 8.21553V9.78431L15.0118 10.0047L14.6384 11.0377C14.5648 11.2414 14.4804 11.4401 14.3859 11.6329L13.9062 12.612L14.4258 13.4737L13.4736 14.4259L12.6119 13.9063L11.6328 14.386C11.44 14.4804 11.2414 14.5648 11.0378 14.6384L10.0048 15.0118L9.78443 16H8.21565L7.99524 15.0118L6.96223 14.6384C6.75859 14.5648 6.56003 14.4804 6.36721 14.386L5.38811 13.9063L4.52645 14.4259L3.5742 13.4737L4.0938 12.612L3.61411 11.6329C3.51962 11.4401 3.43522 11.2414 3.36158 11.0377L2.98817 10.0047L2 9.78431V8.21553L2.98819 7.99514L3.36163 6.96214C3.43523 6.75853 3.51959 6.56 3.61404 6.36722L4.09371 5.38812L3.57407 4.52645L4.52632 3.5742L5.38799 4.0938L6.36707 3.61411C6.55992 3.51962 6.75854 3.43523 6.96224 3.36159Z" }));
}

function Sparkle18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector", d: "M13.7928 10.5C11.5851 12.011 9.67707 13.9191 8.16602 16.1268C6.65496 13.9191 4.74689 12.011 2.53925 10.5C4.74689 8.98893 6.65496 7.08086 8.16601 4.87322C9.67707 7.08086 11.5851 8.98893 13.7928 10.5Z", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector_2", d: "M16.9194 2.99988C16.4625 3.37657 16.0427 3.79632 15.666 4.2533C15.2893 3.79632 14.8696 3.37657 14.4126 2.99988C14.8696 2.62319 15.2893 2.20344 15.666 1.74645C16.0427 2.20344 16.4625 2.62319 16.9194 2.99988Z", strokeWidth: "2" }));
}

function Stripe18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0H18V18H0V0Z", fill: "#635BFF" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.29833 6.9973C8.29833 6.5743 8.64483 6.4078 9.22083 6.4078C10.0488 6.4078 11.0928 6.6598 11.9208 7.1053V4.5493C11.0163 4.1893 10.1253 4.0498 9.22533 4.0498C7.01583 4.0498 5.54883 5.2018 5.54883 7.1278C5.54883 10.1293 9.68433 9.6523 9.68433 10.9483C9.68433 11.4478 9.24783 11.6098 8.64033 11.6098C7.73583 11.6098 6.58383 11.2408 5.67033 10.7413V13.3288C6.68283 13.7653 7.70433 13.9498 8.64033 13.9498C10.9038 13.9498 12.4608 12.8293 12.4608 10.8808C12.4428 7.6408 8.29833 8.2168 8.29833 6.9973Z", fill: "white" }));
}

function Subscription18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { id: "Vector 157 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M17.0812 0.686344C17.5307 1.00735 17.6347 1.6319 17.3137 2.08132L9.81373 12.5813C9.64288 12.8205 9.37543 12.9724 9.08248 12.9967C8.78953 13.0209 8.50075 12.915 8.29289 12.7072L5.29289 9.70718C4.90237 9.31666 4.90237 8.68349 5.29289 8.29297C5.68342 7.90245 6.31658 7.90245 6.70711 8.29297L8.8724 10.4583L15.6863 0.918839C16.0073 0.469427 16.6318 0.365335 17.0812 0.686344Z" }),
        React__default.createElement("path", { id: "Vector 157 (Stroke)_2", fillRule: "evenodd", clipRule: "evenodd", d: "M17.0812 0.686344C17.5307 1.00735 17.6347 1.6319 17.3137 2.08132L9.81373 12.5813C9.64288 12.8205 9.37543 12.9724 9.08248 12.9967C8.78953 13.0209 8.50075 12.915 8.29289 12.7072L5.29289 9.70718C4.90237 9.31666 4.90237 8.68349 5.29289 8.29297C5.68342 7.90245 6.31658 7.90245 6.70711 8.29297L8.8724 10.4583L15.6863 0.918839C16.0073 0.469427 16.6318 0.365335 17.0812 0.686344Z" }),
        React__default.createElement("path", { id: "Subtract", d: "M11.9813 2.66478C11.0768 2.23839 10.0662 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 8.50886 15.9494 8.02953 15.8532 7.56694L17.3072 5.53127C17.7535 6.59879 18 7.77061 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C10.5003 0 11.9148 0.367101 13.1587 1.01638L11.9813 2.66478Z" }));
}

function Suppressed18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM13.1921 14.6064C12.0235 15.4816 10.5723 16 9 16C5.13401 16 2 12.866 2 9C2 7.4277 2.51838 5.97648 3.39355 4.80792L13.1921 14.6064ZM14.6063 13.1923L4.80774 3.39368C5.97634 2.51843 7.42763 2 9 2C12.866 2 16 5.13401 16 9C16 10.5724 15.4816 12.0237 14.6063 13.1923ZM4.07039 4.0302C4.05694 4.04354 4.04354 4.05694 4.0302 4.07039L4.07039 4.0302Z" }));
}

function Tag18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.92971 18L18 7.92971L9.94835 -2.17428e-07L1 -2.18557e-08C0.447715 -9.78513e-09 9.7851e-09 0.447714 2.18557e-08 0.999999L2.17428e-07 9.94835L7.92971 18ZM7.94054 15.1607L15.1607 7.94054L9.12885 2L2 2L2 9.12885L7.94054 15.1607Z" }),
        React__default.createElement("circle", { cx: "5.5", cy: "5.5", r: "1.5" }));
}

function Templates18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M2 2.00049H12V5.81823L14 7.00049V2.00049C14 0.895919 13.1046 0.000488281 12 0.000488281H2C0.895431 0.000488281 0 0.895919 0 2.00049V15.0005C0 16.1051 0.89543 17.0005 2 17.0005H8V15.0005H2L2 2.00049Z" }),
        React__default.createElement("path", { d: "M10.3171 16.3207L10 7.00049L18 11.9322L14.8416 13.1029L17.0595 16.9034L15.1388 18.0005L12.9209 14.2L10.3171 16.3207Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 14.0005V3.00049H8V14.0005H3ZM5 5.00049H6V12.0005H5V5.00049Z" }));
}

function TrayOpen18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M14 0C16.2091 0 18 1.79086 18 4V14C18 16.2091 16.2091 18 14 18H4C1.79086 18 1.61066e-08 16.2091 0 14V4C0 1.79086 1.79086 1.61064e-08 4 0H14ZM4 2C2.89543 2 2 2.89543 2 4V14C2 15.1046 2.89543 16 4 16H14C15.1046 16 16 15.1046 16 14V4C16 2.89543 15.1046 2 14 2H4Z" }),
        React__default.createElement("path", { d: "M3 4C3 3.44772 3.44772 3 4 3H5C5.55228 3 6 3.44772 6 4V14C6 14.5523 5.55228 15 5 15H4C3.44772 15 3 14.5523 3 14V4Z" }));
}

function TrayToggle18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M14 0C16.2091 0 18 1.79086 18 4V14C18 16.2091 16.2091 18 14 18H4C1.79086 18 1.61066e-08 16.2091 0 14V4C0 1.79086 1.79086 1.61064e-08 4 0H14ZM4 2C2.89543 2 2 2.89543 2 4V14C2 15.1046 2.89543 16 4 16H14C15.1046 16 16 15.1046 16 14V4C16 2.89543 15.1046 2 14 2H4Z", fillOpacity: "0.5737" }),
        React__default.createElement("path", { d: "M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4V14C9 14.5523 8.55228 15 8 15H4C3.44772 15 3 14.5523 3 14V4Z", fillOpacity: "0.5737" }));
}

function UnBranded18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M18 11C18 12.1046 17.1046 13 16 13H12V16C12 17.1046 11.1046 18 10 18H8C6.89543 18 6 17.1046 6 16V15.1543L8 13.209V16H10V11.2646L10.2734 11H16V9H12.3301L14.3877 7H16V5.43164L18 3.4873V11Z" }),
        React__default.createElement("path", { d: "M16.3047 0.282227C16.7014 -0.102033 17.3335 -0.0919732 17.7178 0.304688C18.102 0.701362 18.092 1.3335 17.6953 1.71777L1.69531 17.2178C1.29864 17.602 0.666499 17.592 0.282227 17.1953C-0.102028 16.7986 -0.0919778 16.1665 0.304688 15.7822L16.3047 0.282227Z" }),
        React__default.createElement("path", { d: "M12 2.34473V2H10V4.29004L9.26953 5H8V2H6V5H4V2H2V7H7.21289L5.15527 9H2V11H3.09863L1.20898 12.8359C0.498127 12.5293 0 11.8234 0 11V0H14.4131L12 2.34473Z" }));
}

function User18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.60003 4.96399C4.28098 2.32458 6.34137 0.00012207 9 0.00012207C11.6586 0.00012207 13.719 2.32458 13.4 4.96399L13.1274 7.21889C13.092 7.51163 13.0204 7.79723 12.9154 8.06951C15.7946 8.51027 18 10.9976 18 14.0001V17.0001C18 17.5524 17.5523 18.0001 17 18.0001H1C0.447715 18.0001 0 17.5524 0 17.0001V14.0001C0 10.9977 2.20538 8.51027 5.0846 8.06951C4.97955 7.79723 4.90798 7.51163 4.8726 7.21889L4.60003 4.96399ZM11.4144 4.72398L11.1419 6.97888C11.1056 7.27852 10.9824 7.56099 10.7875 7.7914L10.334 8.3273C9.63598 9.15226 8.36402 9.15226 7.66597 8.3273L7.21253 7.7914C7.01756 7.56099 6.89436 7.27852 6.85814 6.97888L6.58557 4.72398C6.4105 3.27564 7.54111 2.00012 9 2.00012C10.4589 2.00012 11.5895 3.27564 11.4144 4.72398ZM6.50995 10.0001H6C3.79086 10.0001 2 11.791 2 14.0001V16.0001H4V14.0001C4 13.4478 4.44772 13.0001 5 13.0001C5.55228 13.0001 6 13.4478 6 14.0001V16.0001H12V14.0001C12 13.4478 12.4477 13.0001 13 13.0001C13.5523 13.0001 14 13.4478 14 14.0001V16.0001H16V14.0001C16 11.791 14.2091 10.0001 12 10.0001H11.49C10.077 11.2613 7.92304 11.2613 6.50995 10.0001Z" }));
}

function X18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M2.70698 1.2928C2.31646 0.902277 1.6833 0.902277 1.29277 1.2928C0.902247 1.68333 0.902247 2.31649 1.29277 2.70702L7.08576 8.5L1.56494 14.0208C1.17442 14.4113 1.17442 15.0445 1.56494 15.435C1.95547 15.8256 2.58863 15.8256 2.97916 15.435L8.49997 9.91422L14.0207 15.4349C14.4112 15.8255 15.0444 15.8255 15.4349 15.4349C15.8254 15.0444 15.8254 14.4112 15.4349 14.0207L9.91418 8.5L15.7071 2.70711C16.0976 2.31658 16.0976 1.68342 15.7071 1.29289C15.3166 0.90237 14.6834 0.90237 14.2929 1.29289L8.49997 7.08579L2.70698 1.2928Z" }));
}

function ZoomReset18(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18" }),
        React__default.createElement("path", { d: "M9.32484 15.8908C10.6591 15.6684 11.8817 15.1158 12.9056 14.3199L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L14.3199 12.9056C15.3729 11.551 16 9.84871 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 11.3747 2.0896 14.2614 5.04553 15.4367L4.53625 13.6108L5.3491 13.3841C3.36494 12.4054 2 10.3621 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.0482 11.7269 13.5655 8.78334 13.9493L9.32484 15.8908Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.71912 11.4194C5.61843 11.075 5.3409 10.8109 4.99189 10.7274C4.64287 10.6439 4.27589 10.7539 4.03026 11.0155L1.27099 13.9544C1.02699 14.2142 0.939781 14.5844 1.04209 14.9258C1.1444 15.2673 1.42075 15.5285 1.76745 15.6114L5.65777 16.5417C6.00446 16.6246 6.36907 16.5167 6.61479 16.2584C6.86051 16.0002 6.95019 15.6307 6.85017 15.2885L5.71912 11.4194Z" }));
}

function ColorWheel20(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "20", height: "20", viewBox: "0 0 20 20" }),
        React__default.createElement("mask", { id: "mask0_4139_390", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "20", height: "20" },
            React__default.createElement("path", { d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z", fill: "#C4C4C4" })),
        React__default.createElement("g", { mask: "url(#mask0_4139_390)" },
            React__default.createElement("path", { d: "M20 0H10V20H20V0Z", fill: "#3A8BBB" }),
            React__default.createElement("path", { d: "M20 4L10 -3V10L20 4Z", fill: "#00B6E3" }),
            React__default.createElement("path", { d: "M20 16L10 24V10L20 16Z", fill: "#C142A0" }),
            React__default.createElement("path", { d: "M0 0H10V10L0 16V0Z", fill: "#FCC870" }),
            React__default.createElement("path", { d: "M-7 0H10V10L-7 0Z", fill: "#EF875B" }),
            React__default.createElement("path", { d: "M0 16L10 24V10L0 16Z", fill: "#FF5555" })),
        React__default.createElement("path", { d: "M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z", fill: "#F5F6F7" }));
}

function NewSubscriber24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0.00012207C9.00106 0.00012207 6.67693 2.54842 7.03682 5.44202L7.34428 7.91407C7.43803 8.66784 7.75691 9.37841 8.26152 9.95801L8.77301 10.5455C8.91723 10.7112 9.07157 10.8627 9.2343 11H6C2.68629 11 0 13.6863 0 17V24H13V22H7V17H5V22H2V17C2 14.7909 3.79086 13 6 13H22.4722C21.3736 11.7725 19.777 11 18 11H14.7657C14.9284 10.8627 15.0828 10.7112 15.227 10.5455L15.7385 9.95801C16.2431 9.37841 16.562 8.66784 16.6557 7.91407L16.9632 5.44202C17.3231 2.54843 14.9989 0.00012207 12 0.00012207ZM9.02153 5.19517C8.8179 3.55797 10.1391 2.00012 12 2.00012C13.8609 2.00012 15.1821 3.55797 14.9785 5.19517L14.671 7.66722C14.627 8.02113 14.4766 8.36155 14.2301 8.64475L13.7186 9.23225C12.8272 10.2561 11.1728 10.2561 10.2814 9.23225L9.76995 8.64475C9.52339 8.36155 9.37301 8.02113 9.32899 7.66722L9.02153 5.19517Z" }),
        React__default.createElement("path", { d: "M23 19H21V17C21 16.4477 20.5523 16 20 16C19.4477 16 19 16.4477 19 17V19H17C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21H19V23C19 23.5523 19.4477 24 20 24C20.5523 24 21 23.5523 21 23V21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19Z" }));
}

function Bounce24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M3.85984 0.231804C4.28412 -0.12176 4.91468 -0.0644363 5.26825 0.359841L12.0672 8.51861L17.5858 3H14C13.4477 3 13 2.55228 13 2C13 1.44772 13.4477 1 14 1H20C20.5523 1 21 1.44772 21 2V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V4.41426L12.7071 10.7071C12.5085 10.9058 12.2354 11.0117 11.9547 10.999C11.674 10.9863 11.4117 10.856 11.2318 10.6402L3.7318 1.64021C3.37824 1.21593 3.43556 0.585368 3.85984 0.231804Z" }),
        React__default.createElement("path", { d: "M9 18C8.44771 18 8 18.4477 8 19C8 19.5523 8.44771 20 9 20H15C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18H9Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 11C1.34315 11 0 12.3431 0 14V21C0 22.6569 1.34314 24 3 24H21C22.6569 24 24 22.6569 24 21V14C24 12.3431 22.6569 11 21 11H18.2326C16.8246 11 15.5362 11.7922 14.9007 13.0487C14.6056 13.6322 14.0074 14 13.3536 14H10.6464C9.99259 14 9.39435 13.6322 9.09926 13.0487C8.46378 11.7922 7.17544 11 5.76735 11H3ZM2 14C2 13.4477 2.44772 13 3 13H5.76735C6.4212 13 7.01944 13.3678 7.31453 13.9513C7.95002 15.2078 9.23835 16 10.6464 16H13.3536C14.7616 16 16.05 15.2078 16.6855 13.9513C16.9806 13.3678 17.5788 13 18.2326 13H21C21.5523 13 22 13.4477 22 14V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V14Z" }));
}

function Calendar24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("rect", { className: "noFill", x: "1", y: "1.00012", width: "22", height: "22", rx: "3", strokeWidth: "2" }),
        React__default.createElement("rect", { y: "6.00012", width: "24", height: "2" }),
        React__default.createElement("rect", { className: "noFill", x: "11.5", y: "11.5001", width: "1", height: "7", rx: "0.5" }),
        React__default.createElement("rect", { className: "noFill", x: "10.5", y: "11.5001", width: "2", height: "1", rx: "0.5" }),
        React__default.createElement("rect", { className: "noFill", x: "10.5", y: "17.5001", width: "3", height: "1", rx: "0.5" }));
}

function Campaign24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 106", d: "M9 0.999878L23 14.9999", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 107", d: "M10 2.49988L1.26479 17.6716C0.813566 18.4553 0.944369 19.4442 1.58382 20.0837L3.91618 22.4161C4.55563 23.0555 5.54461 23.1863 6.32832 22.7351L21.5 13.9999", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 108", d: "M15 17.9999L16 20.9999L12 22.9999L9.5 20.9999", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 109", d: "M22 1.99988L18 5.99988", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 110", d: "M23 6.99988L21 8.49988", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", id: "Vector 111", d: "M17 0.999878L15.5 2.99988", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}

function Clicks24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("g", { clipPath: "url(#clip0_265_197)" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.99998 3.00012C5.99998 1.34327 7.34312 0.00012207 8.99998 0.00012207C10.6568 0.00012207 12 1.34327 12 3.00012V6.50855L20.6576 7.95148C22.5863 8.27294 24 9.9417 24 11.8971V21.0001C24 22.657 22.6568 24.0001 21 24.0001H4.63958C3.20954 24.0001 1.9783 22.9907 1.69784 21.5885L0.36565 14.9275C0.0689324 13.4439 0.92338 11.9716 2.35871 11.4931L5.99998 10.2794V3.00012ZM5.99998 12.3875L2.99116 13.3905C2.51272 13.55 2.22791 14.0408 2.32681 14.5353L3.659 21.1962C3.75249 21.6637 4.1629 22.0001 4.63958 22.0001H21C21.5523 22.0001 22 21.5524 22 21.0001V11.8971C22 10.9194 21.2931 10.085 20.3288 9.92427L20 9.86948V16.0001H18V9.53614L16 9.20281V15.0001H14V8.86948L12 8.53614V15.0001H9.99998V3.00012C9.99998 2.44784 9.55226 2.00012 8.99998 2.00012C8.44769 2.00012 7.99998 2.44784 7.99998 3.00012V18.0001H5.99998V12.3875Z" })),
        React__default.createElement("defs", null,
            React__default.createElement("clipPath", { id: "clip0_265_197" },
                React__default.createElement("rect", { width: "24", height: "24" }))));
}

function Completed24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { id: "Vector 12 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M20.8811 0.163495C21.3432 0.466029 21.4725 1.08585 21.1699 1.5479L11.3128 16.5479C11.1496 16.7972 10.8837 16.9607 10.5876 16.9939C10.2914 17.0271 9.99594 16.9265 9.78158 16.7195L4.63872 11.7195C4.24141 11.3359 4.2303 10.7028 4.61391 10.3055C4.99753 9.90821 5.63059 9.8971 6.02791 10.2807L10.3015 14.4414L19.4967 0.452328C19.7992 -0.0097236 20.419 -0.139038 20.8811 0.163495Z" }),
        React__default.createElement("path", { id: "Rectangle 89", d: "M0.333313 22H24.3333V24H0.333313V22Z" }));
}

function Customize24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.874 5C10.4299 6.72523 8.86384 8 7 8C5.13616 8 3.57006 6.72523 3.12602 5H1C0.447716 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H3.12602C3.57006 1.27477 5.13616 0 7 0C8.86384 0 10.4299 1.27477 10.874 3H23C23.5523 3 24 3.44772 24 4C24 4.55228 23.5523 5 23 5H10.874ZM9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4C5 2.89543 5.89543 2 7 2C8.10457 2 9 2.89543 9 4Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.874 5C10.4299 6.72523 8.86384 8 7 8C5.13616 8 3.57006 6.72523 3.12602 5H1C0.447716 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H3.12602C3.57006 1.27477 5.13616 0 7 0C8.86384 0 10.4299 1.27477 10.874 3H23C23.5523 3 24 3.44772 24 4C24 4.55228 23.5523 5 23 5H10.874ZM9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4C5 2.89543 5.89543 2 7 2C8.10457 2 9 2.89543 9 4Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.874 5C10.4299 6.72523 8.86384 8 7 8C5.13616 8 3.57006 6.72523 3.12602 5H1C0.447716 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H3.12602C3.57006 1.27477 5.13616 0 7 0C8.86384 0 10.4299 1.27477 10.874 3H23C23.5523 3 24 3.44772 24 4C24 4.55228 23.5523 5 23 5H10.874ZM9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4C5 2.89543 5.89543 2 7 2C8.10457 2 9 2.89543 9 4Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.874 13C20.4299 14.7252 18.8638 16 17 16C15.1362 16 13.5701 14.7252 13.126 13H1C0.447716 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H13.126C13.5701 9.27477 15.1362 8 17 8C18.8638 8 20.4299 9.27477 20.874 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H20.874ZM19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.874 13C20.4299 14.7252 18.8638 16 17 16C15.1362 16 13.5701 14.7252 13.126 13H1C0.447716 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H13.126C13.5701 9.27477 15.1362 8 17 8C18.8638 8 20.4299 9.27477 20.874 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H20.874ZM19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.874 13C20.4299 14.7252 18.8638 16 17 16C15.1362 16 13.5701 14.7252 13.126 13H1C0.447716 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11H13.126C13.5701 9.27477 15.1362 8 17 8C18.8638 8 20.4299 9.27477 20.874 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H20.874ZM19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 24C8.86384 24 10.4299 22.7252 10.874 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19H10.874C10.4299 17.2748 8.86384 16 7 16C5.13616 16 3.57006 17.2748 3.12602 19H1C0.447715 19 0 19.4477 0 20C0 20.5523 0.447716 21 1 21H3.12602C3.57006 22.7252 5.13616 24 7 24ZM7 22C8.10457 22 9 21.1046 9 20C9 18.8954 8.10457 18 7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 24C8.86384 24 10.4299 22.7252 10.874 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19H10.874C10.4299 17.2748 8.86384 16 7 16C5.13616 16 3.57006 17.2748 3.12602 19H1C0.447715 19 0 19.4477 0 20C0 20.5523 0.447716 21 1 21H3.12602C3.57006 22.7252 5.13616 24 7 24ZM7 22C8.10457 22 9 21.1046 9 20C9 18.8954 8.10457 18 7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 24C8.86384 24 10.4299 22.7252 10.874 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19H10.874C10.4299 17.2748 8.86384 16 7 16C5.13616 16 3.57006 17.2748 3.12602 19H1C0.447715 19 0 19.4477 0 20C0 20.5523 0.447716 21 1 21H3.12602C3.57006 22.7252 5.13616 24 7 24ZM7 22C8.10457 22 9 21.1046 9 20C9 18.8954 8.10457 18 7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22Z", fillOpacity: "0.01" }));
}

function Domainauthenticated24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V14.6735C24 17.3964 22.4211 19.8722 19.9522 21.0205L14.9573 23.3439C13.0864 24.2141 10.9269 24.2146 9.05566 23.3452L4.05063 21.0199C1.58023 19.8722 0 17.3956 0 14.6716V4ZM4 2C2.89543 2 2 2.89543 2 4V14.6716C2 16.6173 3.12874 18.3863 4.89331 19.2061L9.89833 21.5314C11.2349 22.1524 12.7774 22.152 14.1138 21.5305L19.1087 19.2071C20.8722 18.3868 22 16.6184 22 14.6735V4C22 2.89543 21.1046 2 20 2H4Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.4903 6.12848C16.9717 6.39924 17.1424 7.00896 16.8717 7.49032L12.3717 15.4903C12.2324 15.7378 11.9946 15.9144 11.7174 15.9762C11.4402 16.0379 11.1499 15.9788 10.9188 15.8138L7.41884 13.3138C6.96943 12.9928 6.86534 12.3682 7.18634 11.9188C7.50735 11.4694 8.1319 11.3653 8.58132 11.6863L11.1747 13.5387L15.1285 6.50979C15.3993 6.02844 16.009 5.85772 16.4903 6.12848Z" }));
}

function Domainblocked24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M7.75742 6.75742C8.14768 6.36716 8.78137 6.36716 9.17163 6.75742L12.0001 9.58587L14.8284 6.75752C15.2187 6.36726 15.8524 6.36726 16.2426 6.75752C16.6329 7.14779 16.6329 7.78147 16.2426 8.17174L13.4143 11.0001L16.2427 13.8285C16.6329 14.2188 16.6329 14.8525 16.2427 15.2427C15.8524 15.633 15.2187 15.633 14.8285 15.2427L12.0001 12.4143L9.17156 15.2428C8.7813 15.6331 8.14761 15.6331 7.75735 15.2428C7.36708 14.8525 7.36708 14.2189 7.75735 13.8286L10.5859 11.0001L7.75742 8.17163C7.36716 7.78137 7.36716 7.14768 7.75742 6.75742Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V14.6735C24 17.3964 22.4211 19.8722 19.9522 21.0205L14.9573 23.3439C13.0864 24.2141 10.9269 24.2146 9.05566 23.3452L4.05063 21.0199C1.58023 19.8722 0 17.3956 0 14.6716V4ZM4 2C2.89543 2 2 2.89543 2 4V14.6716C2 16.6173 3.12874 18.3863 4.89331 19.2061L9.89833 21.5314C11.2349 22.1524 12.7774 22.152 14.1138 21.5305L19.1087 19.2071C20.8722 18.3868 22 16.6184 22 14.6735V4C22 2.89543 21.1046 2 20 2H4Z" }));
}

function Domainunauthenticated24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M12 6.00012C11.4481 6.00012 11 6.44821 11 7.00012V12.0001C11 12.552 11.4481 13.0001 12 13.0001C12.5519 13.0001 13 12.552 13 12.0001V7.00012C13 6.44821 12.5519 6.00012 12 6.00012Z" }),
        React__default.createElement("path", { d: "M12 15.0001C11.4481 15.0001 11 15.4482 11 16.0001C11 16.552 11.4481 17.0001 12 17.0001C12.5519 17.0001 13 16.552 13 16.0001C13 15.4482 12.5519 15.0001 12 15.0001Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0C1.79086 0 0 1.79086 0 4V14.6716C0 17.3956 1.58023 19.8722 4.05063 21.0199L9.05566 23.3452C10.9269 24.2146 13.0864 24.2141 14.9573 23.3439L19.9522 21.0205C22.4211 19.8722 24 17.3964 24 14.6735V4C24 1.79086 22.2091 0 20 0H4ZM2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V14.6735C22 16.6184 20.8722 18.3868 19.1087 19.2071L14.1138 21.5305C12.7774 22.152 11.2349 22.1524 9.89833 21.5314L4.89331 19.2061C3.12874 18.3863 2 16.6173 2 14.6716V4Z" }));
}

function Draft24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M16 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H16C17.1046 22 18 21.1046 18 20V16.8284L20 14.8284V20C20 22.2091 18.2091 24 16 24H4C1.79086 24 0 22.2091 0 20V4C0 1.79086 1.79086 0 4 0H16C17.4043 0 18.6395 0.723633 19.3532 1.81835L17.8734 3.29817C17.5892 2.5398 16.8576 2 16 2Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2916 19.0001L24 8.29167L19.7084 4.00012L9 14.7086V19.0001H13.2916ZM20.4853 8.92905L19.0711 7.51484L10.5147 16.0712L11.9289 17.4854L20.4853 8.92905Z" }),
        React__default.createElement("path", { d: "M14 5.8802V5.00012H5V7.00012H12.8801L14 5.8802Z" }),
        React__default.createElement("path", { d: "M10.8801 9.00012H5V11.0001H8.88008L10.8801 9.00012Z" }),
        React__default.createElement("path", { d: "M7 15.0001V13.0001H5V15.0001H7Z" }),
        React__default.createElement("path", { d: "M7 17.0001V19.0001H5V17.0001H7Z" }));
}

function Facebook24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "25", height: "16", viewBox: "0 0 25 16" }),
        React__default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.563 0.0587325C15.6362 0.203737 14.1108 1.13605 13.4943 1.93447C13.4594 1.97949 13.2586 2.21555 13.048 2.45894C12.7008 2.86043 12.3563 3.31151 12.3563 3.36487C12.3563 3.37638 12.5542 3.65627 12.7958 3.98674C12.9964 4.26015 13.1954 4.53476 13.3927 4.81055C13.5828 5.08033 13.5443 5.08211 13.7444 4.79409C13.8823 4.59176 14.025 4.39281 14.1725 4.19741C14.2647 4.07383 14.3399 3.96433 14.3399 3.95401C14.3399 3.9187 14.9933 3.19924 15.2286 2.97568C15.4631 2.75272 15.9711 2.41114 16.1907 2.32862C16.8982 2.06301 17.5066 2.08126 18.2263 2.38971C18.3076 2.42443 18.3836 2.4522 18.3949 2.45121C18.4062 2.45021 18.4246 2.4635 18.4357 2.48076C18.4468 2.49782 18.5081 2.53849 18.5718 2.57102C19.6136 3.10244 20.7933 5.00574 21.2658 6.91817C21.4024 7.46358 21.5126 8.01529 21.5959 8.57134C21.9279 10.7696 21.6594 12.5113 20.905 13.051C20.8542 13.0873 20.7919 13.1367 20.7667 13.1607C20.5507 13.3662 19.6226 13.3975 19.2582 13.2115C19.2084 13.1861 19.1604 13.1653 19.1514 13.1653C19.1425 13.1651 19.0957 13.1282 19.0471 13.0831C18.9985 13.0383 18.94 13.0014 18.9168 13.0014C18.8938 13.0014 18.8698 12.9889 18.8638 12.9738C18.8577 12.9586 18.7757 12.878 18.6815 12.7951C18.5875 12.712 18.5175 12.637 18.526 12.6283C18.5347 12.6198 18.4816 12.565 18.408 12.5067C18.3344 12.4484 18.2743 12.3879 18.2743 12.372C18.2743 12.3561 18.2407 12.3067 18.1999 12.2621C18.0916 12.1443 18.0412 12.0794 18.0426 12.0596C18.0462 12.0104 17.9289 11.8773 17.8819 11.8769C17.8406 11.8765 17.8381 11.8697 17.871 11.8491C17.9027 11.8289 17.8831 11.7981 17.7966 11.7321C17.7319 11.6829 17.6792 11.6226 17.6792 11.5982C17.6792 11.5738 17.6552 11.5446 17.626 11.5335C17.5969 11.5222 17.581 11.4923 17.5907 11.4669C17.6157 11.4018 17.504 11.3052 17.4576 11.3516C17.4322 11.377 17.4148 11.3754 17.3967 11.3461C17.3794 11.3183 17.385 11.3135 17.4138 11.3314C17.4423 11.349 17.4509 11.3425 17.4396 11.3117C17.4304 11.2864 17.4082 11.2687 17.3904 11.2725C17.3725 11.276 17.362 11.2427 17.3668 11.1981C17.3717 11.1535 17.3624 11.117 17.3459 11.117C17.3297 11.117 17.3182 11.1505 17.3207 11.1913C17.3233 11.2322 17.2951 11.355 17.2582 11.4641C17.2214 11.5732 17.1815 11.7283 17.1694 11.8086C17.1248 12.1074 16.6144 13.0566 16.3771 13.2825C16.3198 13.337 16.2299 13.4394 16.1776 13.51C16.125 13.5806 16.0397 13.6626 15.9881 13.6919C15.8766 13.7552 15.8705 13.781 15.9609 13.8048C15.9978 13.8143 16.0258 13.8347 16.023 13.8498C16.0099 13.925 16.0318 13.9526 16.0923 13.9367C16.1361 13.9252 16.1583 13.9357 16.1583 13.9678C16.1583 14.0551 16.2654 14.2329 16.3277 14.2493C16.3614 14.2581 16.3809 14.2785 16.371 14.2945C16.3608 14.3106 16.3686 14.3239 16.3878 14.3239C16.4071 14.3239 16.4227 14.3465 16.4227 14.3741C16.4227 14.4019 16.46 14.4413 16.5055 14.4622C16.5509 14.4828 16.5882 14.5173 16.5882 14.5387C16.5882 14.5752 16.929 14.9063 16.9405 14.8809C16.9434 14.8746 16.978 14.9103 17.0172 14.9603C17.0567 15.0102 17.1073 15.0511 17.1299 15.0511C17.1523 15.0511 17.2144 15.0967 17.2678 15.1525C17.413 15.3038 17.8966 15.5823 18.3735 15.789C18.5147 15.8503 18.8285 15.9311 19.0511 15.9636C19.2693 15.9953 20.5396 16.0001 20.6876 15.9695C20.7512 15.9564 20.848 15.937 20.9026 15.9265C21.247 15.8596 21.9353 15.5613 22.0422 15.4326C22.0654 15.4046 22.0995 15.3818 22.1182 15.3818C22.3171 15.3818 23.0646 14.5274 23.3907 13.9272C23.5293 13.6717 23.8449 12.8415 23.8146 12.8114C23.8053 12.8021 23.8106 12.7703 23.8263 12.7408C23.8658 12.667 24.0175 11.8261 24.0568 11.4641C24.1371 10.7236 24.0425 8.44479 23.9122 7.97625C23.9044 7.94887 23.889 7.84473 23.8775 7.74476C23.8642 7.63377 23.8459 7.52344 23.8227 7.41408C23.8042 7.33186 23.7877 7.24918 23.7733 7.16613C23.6995 6.70275 23.1346 4.95675 23.0031 4.78576C22.989 4.7677 22.9473 4.6709 22.9102 4.57093C22.6841 3.95996 21.9214 2.71265 21.4447 2.17409C19.9463 0.481249 18.3328 -0.217787 16.563 0.0587325ZM10.7025 5.73632C10.6642 5.82479 10.6817 5.79761 10.2239 6.48693C10.0239 6.78824 9.80808 7.1211 9.7446 7.22663C9.68093 7.33236 9.47364 7.65192 9.2842 7.93717C8.9811 8.39301 8.58278 9.02203 8.47447 9.21603C8.45424 9.25233 8.31499 9.46557 8.16542 9.68992C8.01566 9.91447 7.89307 10.1019 7.89307 10.1069C7.89307 10.1313 7.44953 10.7851 7.12183 11.2435C6.97073 11.4546 6.8199 11.6658 6.66936 11.8773C6.62413 11.941 6.57871 12.0005 6.56839 12.0096C6.55808 12.0187 6.44719 12.1451 6.32222 12.2907C5.21634 13.5771 3.92419 13.7203 3.15414 12.6418C3.05159 12.498 2.89587 12.201 2.905 12.1663C2.90619 12.1619 2.88417 12.0989 2.8564 12.0261C2.80582 11.8947 2.72131 11.5006 2.68263 11.2161C2.65823 11.0382 2.65863 9.72483 2.68303 9.60065C2.69235 9.55265 2.70901 9.40943 2.71992 9.28208C2.73545 9.08848 2.75775 8.89549 2.78677 8.70345C2.79372 8.65803 2.80899 8.52413 2.82069 8.40591C2.8324 8.28768 2.8558 8.17402 2.87266 8.15319C2.88953 8.13236 2.90103 8.10261 2.89825 8.08713C2.89535 8.07227 2.8959 8.05693 2.89984 8.0423C2.90341 8.03318 2.91273 7.98855 2.92027 7.94312C2.94626 7.78741 2.95856 7.72829 2.9653 7.72829C2.97542 7.72829 2.99744 7.60828 3.00636 7.50513C3.01073 7.45514 3.02461 7.41408 3.03711 7.41408C3.0498 7.41408 3.05179 7.38215 3.04147 7.34287C3.02997 7.29923 3.03572 7.27959 3.05635 7.29229C3.07698 7.30518 3.08353 7.27999 3.07321 7.22643C3.06052 7.15998 3.06746 7.1453 3.10277 7.16375C3.12816 7.17684 3.1228 7.16633 3.09106 7.14014C3.03394 7.09333 3.00854 7.03144 3.05952 7.06298C3.074 7.0719 3.10753 7.06397 3.13391 7.04513C3.17319 7.01755 3.1712 7.01458 3.12419 7.02985C3.09225 7.03997 3.06627 7.03461 3.06627 7.01795C3.06627 6.98046 2.93574 6.95904 2.57373 6.93741C2.2252 6.91659 1.28555 6.77079 0.927702 6.68212C0.662886 6.61646 0.497053 6.62201 0.542082 6.69481C0.556761 6.71862 0.544264 6.72338 0.505583 6.7085C0.45857 6.69045 0.450041 6.69918 0.463529 6.75095C0.472853 6.78666 0.469084 6.82038 0.455397 6.82573C0.441511 6.83109 0.419096 6.87096 0.405805 6.91421C0.390135 6.96439 0.393308 6.98522 0.414732 6.97193C0.434965 6.95943 0.441511 6.97748 0.431196 7.01696C0.421675 7.05326 0.403822 7.07667 0.391523 7.06893C0.379423 7.06139 0.365934 7.08758 0.361967 7.12725C0.353636 7.20897 0.329832 7.33156 0.322294 7.33156C0.317335 7.33156 0.305235 7.37996 0.272703 7.52993C0.264768 7.56623 0.250486 7.64795 0.240965 7.71163C0.231443 7.7753 0.201292 7.94649 0.173917 8.09189C0.0977455 8.49596 0.0931831 8.53207 0.0721565 8.86889C0.0614448 9.04166 0.045774 9.22019 0.0376411 9.26562C-0.00401542 9.49532 -0.0143304 10.9664 0.0231605 11.3484C0.0965553 12.0985 0.094175 12.0824 0.204267 12.5487C0.618055 14.2999 1.71759 15.5022 3.28308 15.9152C3.59392 15.9971 4.84024 16.0302 5.21515 15.9664C6.25835 15.789 7.28845 15.0696 8.25687 13.8413C8.4715 13.5693 8.88489 12.9969 8.88489 12.9719C8.88489 12.9548 8.89739 12.9358 8.91246 12.9298C8.94817 12.9155 9.54624 12.0108 9.54624 11.9711C9.54624 11.9542 9.56151 11.9227 9.58016 11.9007C9.5988 11.8789 9.65593 11.794 9.70711 11.712C9.75829 11.6301 9.86203 11.4667 9.93781 11.3486C10.0134 11.2306 10.0751 11.1166 10.0751 11.0951C10.0751 11.0739 10.088 11.0513 10.1036 11.0453C10.1191 11.0392 10.1844 10.9376 10.2483 10.8194C10.4407 10.4633 10.6394 10.1106 10.8443 9.76153C10.9243 9.62505 10.9997 9.49116 11.012 9.46398C11.0377 9.4131 11.0658 9.36345 11.0963 9.31521C11.1639 9.2065 11.6951 8.26705 11.6951 8.25594C11.6951 8.25217 11.777 8.11272 11.877 7.9461C12.1176 7.545 12.1765 7.71222 11.3555 6.46372C10.8328 5.66868 10.7646 5.5927 10.7025 5.73632ZM16.1179 13.8556C16.1413 13.9256 16.0768 13.8935 16.0105 13.802L15.9453 13.7122L16.0252 13.7647C16.0691 13.7935 16.1109 13.8343 16.1179 13.8556Z", fill: "#0479F2" }),
        React__default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.15743 0.0580333C5.48021 0.150074 4.56813 0.54839 3.94249 1.02526C3.31486 1.50371 2.31967 2.57389 2.05426 3.05572C2.03085 3.09817 1.90192 3.31895 1.76762 3.54607C1.51729 3.96978 1.32666 4.33318 1.24711 4.53789C1.22232 4.60157 1.19316 4.66108 1.18205 4.6702C1.11639 4.72396 0.446119 6.64651 0.476072 6.69491C0.484601 6.70879 0.506422 6.7199 0.524473 6.7199C0.542722 6.7199 0.54907 6.70622 0.538557 6.68935C0.4969 6.62171 0.671262 6.61854 0.927747 6.68221C1.2856 6.77088 2.22525 6.91668 2.57378 6.93751C3.01811 6.96409 3.07306 6.97738 3.04925 7.05236C3.03795 7.08767 3.0437 7.11663 3.06175 7.11663C3.08318 7.11663 3.08397 7.15412 3.06393 7.22395C3.04707 7.28286 3.03319 7.34495 3.03319 7.36161C3.03319 7.40228 3.07703 7.35705 3.08734 7.30587C3.11452 7.17118 3.13138 7.11207 3.1526 7.07795C3.16887 7.05137 3.15677 7.04621 3.11313 7.06149C3.05164 7.08311 3.05183 7.08231 3.11392 7.03411C3.14923 7.00674 3.16609 6.98452 3.15141 6.98452C3.13673 6.98452 3.14923 6.94723 3.17899 6.9018C3.20874 6.85638 3.22163 6.81889 3.20755 6.81869C3.19347 6.81829 3.19862 6.80718 3.21886 6.79389C3.27698 6.75561 3.31546 6.60703 3.25992 6.6356C3.23532 6.64829 3.24087 6.63758 3.27241 6.61179C3.30395 6.58581 3.3351 6.53642 3.34164 6.5019C3.35513 6.44653 3.37304 6.39234 3.3952 6.33984C3.41801 6.28529 3.44003 6.22578 3.4444 6.20753C3.4561 6.15734 3.53029 5.98794 3.5892 5.87685C3.61816 5.8223 3.63701 5.77767 3.63106 5.77767C3.61162 5.77767 3.99347 4.96101 4.02521 4.93462C4.03612 4.9255 4.09384 4.83068 4.15335 4.72376C4.21306 4.61684 4.29042 4.49882 4.32533 4.46133C4.36024 4.42383 4.38881 4.37444 4.38881 4.35163C4.38881 4.32862 4.40825 4.29787 4.43225 4.28339C4.45625 4.26891 4.55861 4.14533 4.65978 4.00905C4.88155 3.71012 5.30188 3.28165 5.37329 3.28165C5.384 3.28165 5.46077 3.22532 5.54369 3.15649C6.01758 2.76353 6.80866 2.58916 7.4458 2.73734C7.54637 2.76075 7.6287 2.77186 7.6287 2.76214C7.6287 2.75242 7.64734 2.75936 7.66996 2.77741C7.69277 2.79546 7.77092 2.82879 7.84352 2.8516C7.91632 2.87441 8.02423 2.92202 8.08335 2.95772C8.14246 2.99343 8.19066 3.01327 8.19066 3.00196C8.19066 2.99085 8.22319 3.01188 8.26306 3.04897C8.30294 3.08607 8.34995 3.11642 8.3676 3.11642C8.41819 3.11642 8.8651 3.46256 9.10592 3.6883C9.4231 3.98545 9.48281 4.04655 9.6292 4.22468C9.7018 4.31295 9.7873 4.41213 9.81923 4.44526C9.87458 4.50259 9.92536 4.56626 10.3643 5.12882C10.4691 5.26272 10.5861 5.42637 10.6246 5.49242C10.6631 5.55848 10.7271 5.62731 10.7668 5.64556C10.8894 5.7017 12.0588 7.50701 12.0588 7.64031C12.0588 7.67959 12.0736 7.71172 12.0919 7.71172C12.1101 7.71172 12.125 7.73037 12.125 7.75318C12.125 7.7758 12.1996 7.90612 12.2909 8.0424C12.3819 8.17887 12.4888 8.3572 12.5281 8.43913C12.5676 8.52105 12.6098 8.59544 12.6223 8.60436C12.6346 8.61349 12.6709 8.673 12.7029 8.73667C12.735 8.80035 12.7796 8.87473 12.8024 8.90191C12.825 8.92929 12.8808 9.01855 12.9262 9.10028C13.0095 9.24524 13.0956 9.38856 13.1845 9.53013C13.3527 9.79911 13.508 10.0665 13.5782 10.2079C13.5965 10.2442 13.66 10.352 13.7195 10.4472C13.779 10.5424 14.0129 10.9292 14.2394 11.3067C14.6216 11.9436 15.1112 12.6986 15.1669 12.7371C15.1802 12.746 15.2407 12.8353 15.3014 12.9355C15.4651 13.2046 15.6315 13.4314 15.6656 13.4314C15.6821 13.4314 15.6922 13.4425 15.688 13.4562C15.6841 13.4696 15.7263 13.543 15.7821 13.6192L15.8836 13.7575L15.984 13.6964C16.0393 13.6629 16.127 13.5782 16.1788 13.5085C16.2306 13.4387 16.3198 13.3371 16.3772 13.2826C16.6144 13.0567 17.1248 12.1075 17.1694 11.8087C17.1815 11.7284 17.2214 11.5733 17.2583 11.4642C17.2952 11.3551 17.3234 11.2323 17.3208 11.1914C17.3182 11.1506 17.3297 11.117 17.346 11.117C17.3624 11.117 17.3718 11.1535 17.3668 11.1982C17.362 11.2428 17.3726 11.2761 17.3904 11.2726C17.4083 11.2688 17.4305 11.2864 17.4396 11.3118C17.4509 11.3426 17.4424 11.3491 17.4138 11.3315C17.3854 11.3138 17.3795 11.3184 17.396 11.345C17.4132 11.3729 17.4329 11.3745 17.462 11.3503C17.4848 11.3315 17.513 11.3255 17.5247 11.3372C17.5364 11.3489 17.5201 11.3781 17.4886 11.4021C17.4567 11.4263 17.4487 11.4459 17.4705 11.4465C17.4824 11.4462 17.494 11.4431 17.5045 11.4374C17.5149 11.4318 17.5239 11.4237 17.5306 11.414C17.5365 11.405 17.5457 11.3988 17.5562 11.3966C17.5667 11.3944 17.5776 11.3964 17.5866 11.4023C17.6356 11.4324 17.3678 11.0419 17.3025 10.9877C17.2732 10.9635 17.2494 10.9296 17.2494 10.9123C17.2494 10.8951 17.2047 10.8161 17.1502 10.7368C17.0956 10.6576 17.051 10.5775 17.051 10.559C17.051 10.5404 17.0324 10.5134 17.0097 10.4987C16.9869 10.4843 16.9342 10.4041 16.8923 10.3208C16.8505 10.2375 16.7733 10.1222 16.7205 10.0647C16.668 10.007 16.6327 9.95999 16.6418 9.95999C16.6511 9.95999 16.6281 9.91674 16.5904 9.86398C16.5527 9.81101 16.522 9.7523 16.522 9.73326C16.522 9.71421 16.5027 9.68684 16.4789 9.67236C16.4551 9.65768 16.4069 9.58865 16.3714 9.51863C16.2512 9.28079 16.2419 9.26571 16.2167 9.26571C16.2028 9.26571 16.1915 9.2433 16.1915 9.21612C16.1915 9.18875 16.1756 9.16653 16.1564 9.16653C16.1371 9.16653 16.1296 9.15304 16.1397 9.13677C16.1498 9.12051 16.1213 9.07211 16.0762 9.02926C16.031 8.98661 15.9939 8.92889 15.9937 8.90132C15.9933 8.87354 15.941 8.77178 15.8773 8.67518C15.8136 8.57858 15.7616 8.48673 15.7616 8.47086C15.7616 8.45519 15.7422 8.4306 15.7186 8.41592C15.6948 8.40144 15.6496 8.33737 15.6178 8.27389C15.5315 8.10091 15.3619 7.83035 15.3252 7.80734C15.3076 7.79623 15.2981 7.78135 15.304 7.77421C15.3102 7.76707 15.2788 7.70181 15.2344 7.6292C15.1901 7.55641 15.1529 7.48936 15.1515 7.48043C15.1501 7.47131 15.1346 7.44155 15.117 7.41418C15.0991 7.387 15.0622 7.3263 15.0346 7.27949C15.0073 7.23248 14.8984 7.05395 14.7928 6.88276C14.7151 6.75718 14.638 6.63128 14.5613 6.50507C14.5397 6.46877 14.5127 6.43148 14.5016 6.42236C14.4903 6.41323 14.4316 6.31663 14.3711 6.20753C14.3104 6.09843 14.2426 5.99786 14.2203 5.98417C14.1979 5.97028 14.1626 5.9072 14.1416 5.84353C14.1206 5.78005 14.0898 5.72808 14.073 5.72808C14.0563 5.72808 14.0422 5.70963 14.042 5.68682C14.0418 5.66401 14.0123 5.60827 13.9764 5.56284C13.8129 5.35535 13.6155 5.0227 13.636 4.98878C13.6485 4.96775 13.635 4.97013 13.6054 4.99413C13.5592 5.03162 13.5318 5.00822 13.394 4.81243C13.1964 4.53597 12.997 4.26077 12.7959 3.98684C12.5543 3.65636 12.3563 3.36358 12.3563 3.3362C12.3563 3.30883 12.3379 3.26678 12.3151 3.24277C12.2701 3.19131 12.2271 3.13811 12.1863 3.08329C12.1022 2.9779 12.0139 2.87586 11.9217 2.77741C11.8166 2.66422 11.7135 2.54921 11.6124 2.43245C11.3766 2.15613 10.6514 1.46067 10.3893 1.25972C10.3348 1.21767 10.2852 1.17205 10.279 1.15796C10.2729 1.14388 10.2542 1.14071 10.2376 1.15102C10.2211 1.16134 10.2074 1.15598 10.2074 1.13932C10.2074 1.11254 9.86744 0.868153 9.83014 0.868153C9.82201 0.868153 9.72402 0.807454 9.61234 0.733266C9.4225 0.607304 8.90537 0.348439 8.78833 0.321064C8.75977 0.31432 8.63956 0.272664 8.52133 0.228428C8.16408 0.0951274 7.80147 0.0449413 7.06673 0.0270885C6.68706 0.0179637 6.37444 0.0286754 6.15743 0.0580333ZM2.84772 8.18879C2.8378 8.21478 2.83522 8.27052 2.84196 8.31277C2.85109 8.3693 2.85863 8.3568 2.87093 8.26556C2.88838 8.13722 2.87926 8.10687 2.84772 8.18879ZM17.58 11.4818C17.58 11.5005 17.6023 11.5245 17.6296 11.5348C17.6568 11.5453 17.6792 11.5723 17.6792 11.5949C17.6792 11.6397 17.7836 11.7453 17.828 11.7453C17.8435 11.7453 17.8254 11.7117 17.7883 11.6709C17.7477 11.6253 17.7121 11.5754 17.6822 11.5221C17.6427 11.4457 17.58 11.4209 17.58 11.4818ZM18.509 12.646C18.5167 12.6506 18.5899 12.7139 18.6714 12.7867L18.8198 12.9188L18.6891 12.7783C18.6171 12.701 18.5441 12.6379 18.5264 12.6379C18.509 12.6379 18.501 12.6415 18.509 12.646ZM15.9745 13.7587C15.9868 13.7787 15.9802 13.795 15.96 13.795C15.9398 13.795 15.9322 13.8098 15.9435 13.8281C15.9733 13.8763 16.0338 13.8686 16.009 13.8198C15.9975 13.7969 16.0114 13.8071 16.0399 13.8422C16.0683 13.8771 16.1006 13.8967 16.1117 13.8856C16.1403 13.8571 16.1002 13.8015 16.0203 13.7589C15.9709 13.7323 15.9582 13.7323 15.9745 13.7587ZM16.0592 13.9602C16.0592 13.9785 16.0717 13.9933 16.087 13.9933C16.1022 13.9933 16.1326 14.0324 16.1542 14.0802C16.176 14.128 16.2036 14.1576 16.2153 14.1459C16.227 14.1342 16.2191 14.1068 16.1974 14.0854C16.1736 14.0579 16.1599 14.0231 16.1584 13.9868C16.1584 13.9541 16.1359 13.9273 16.1088 13.9273C16.0814 13.9273 16.0592 13.9422 16.0592 13.9602Z", fill: "#0564DC" }));
}

function Flag24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M24.3335 2H4.3335V16H24.3335V2ZM22.3335 4H6.3335V14H22.3335V4Z" }),
        React__default.createElement("path", { id: "Vector_2", d: "M2.3335 0H0.333496V24H2.3335V0Z" }));
}

function Globe24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { className: 'noFill', id: "Ellipse 74", d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1Z", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Ellipse 75", d: "M12 22.6666C17.891 16.7755 17.891 7.22428 12 1.33325", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Ellipse 76", d: "M12 1.33319C6.10897 7.22422 6.10897 16.7755 12 22.6665", strokeWidth: "2" }),
        React__default.createElement("rect", { id: "Rectangle 403", x: "1", y: "11", width: "22", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 404", x: "2", y: "6", width: "20", height: "2" }),
        React__default.createElement("rect", { id: "Rectangle 405", x: "2", y: "16", width: "20", height: "2" }));
}

function Inbox24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M9 18.0001C8.44771 18.0001 8 18.4478 8 19.0001C8 19.5524 8.44771 20.0001 9 20.0001H15C15.5523 20.0001 16 19.5524 16 19.0001C16 18.4478 15.5523 18.0001 15 18.0001H9Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 11.0001C1.34315 11.0001 0 12.3433 0 14.0001V21.0001C0 22.657 1.34314 24.0001 3 24.0001H21C22.6569 24.0001 24 22.657 24 21.0001V14.0001C24 12.3433 22.6569 11.0001 21 11.0001H18.2326C16.8246 11.0001 15.5362 11.7923 14.9007 13.0488C14.6056 13.6323 14.0074 14.0001 13.3536 14.0001H10.6464C9.99259 14.0001 9.39435 13.6323 9.09926 13.0488C8.46378 11.7923 7.17544 11.0001 5.76735 11.0001H3ZM2 14.0001C2 13.4478 2.44772 13.0001 3 13.0001H5.76735C6.4212 13.0001 7.01944 13.368 7.31453 13.9514C7.95002 15.208 9.23835 16.0001 10.6464 16.0001H13.3536C14.7616 16.0001 16.05 15.208 16.6855 13.9514C16.9806 13.368 17.5788 13.0001 18.2326 13.0001H21C21.5523 13.0001 22 13.4478 22 14.0001V21.0001C22 21.5524 21.5523 22.0001 21 22.0001H3C2.44772 22.0001 2 21.5524 2 21.0001V14.0001Z" }),
        React__default.createElement("path", { d: "M16.3053 7.69486C16.6897 7.31038 16.6919 6.68769 16.3102 6.3005C15.9227 5.90748 15.2885 5.90748 14.901 6.3005L12.986 8.24276V0.986107C12.986 0.441563 12.5445 0.00012207 12 0.00012207C11.4555 0.00012207 11.014 0.441562 11.014 0.986107V8.24276L9.09897 6.3005C8.71146 5.90748 8.07733 5.90748 7.68982 6.3005C7.30806 6.68769 7.31025 7.31038 7.69474 7.69486L11.2929 11.293C11.6834 11.6835 12.3166 11.6835 12.7071 11.293L16.3053 7.69486Z" }));
}

function Kb24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M4 6V4H9V6H4Z" }),
        React__default.createElement("path", { d: "M4 6V4H9V6H4Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M4 6V4H9V6H4Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M9 8.00001V10H4V8.00001H9Z" }),
        React__default.createElement("path", { d: "M9 8.00001V10H4V8.00001H9Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M9 8.00001V10H4V8.00001H9Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M9 12V14H4V12H9Z" }),
        React__default.createElement("path", { d: "M9 12V14H4V12H9Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M9 12V14H4V12H9Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M4 16V18H9V16H4Z" }),
        React__default.createElement("path", { d: "M4 16V18H9V16H4Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M4 16V18H9V16H4Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M15 6V4H20V6H15Z" }),
        React__default.createElement("path", { d: "M15 6V4H20V6H15Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M15 6V4H20V6H15Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M15 8V10H20V8.00001L15 8Z" }),
        React__default.createElement("path", { d: "M15 8V10H20V8.00001L15 8Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M15 8V10H20V8.00001L15 8Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M15 12V14H20V12L15 12Z" }),
        React__default.createElement("path", { d: "M15 12V14H20V12L15 12Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M15 12V14H20V12L15 12Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { d: "M15 16V18H20V16H15Z" }),
        React__default.createElement("path", { d: "M15 16V18H20V16H15Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { d: "M15 16V18H20V16H15Z", fillOpacity: "0.01" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0H9C9.7874 0 10.522 0.228008 11.1412 0.621545C11.649 0.944259 12.351 0.944258 12.8588 0.621544C13.478 0.228008 14.2126 0 15 0H20C22.2091 0 24 1.79086 24 4V18C24 20.2091 22.2091 22 20 22H15.7706C15.2747 22 14.7964 22.1843 14.4286 22.5171L13.3637 23.4808C12.6092 24.1637 11.4623 24.1711 10.699 23.4981L9.56691 22.4999C9.20158 22.1777 8.73125 22 8.24418 22H4C1.79086 22 0 20.2091 0 18V4C0 1.79086 1.79086 0 4 0ZM11 18V4C11 2.89543 10.1046 2 9 2H4C2.89543 2 2 2.89543 2 4V18C2 19.1046 2.89543 20 4 20H9C10.1046 20 11 19.1046 11 18ZM13 18.0062C13.0034 19.1079 13.8975 20 15 20H20C21.1046 20 22 19.1046 22 18V4C22 2.89543 21.1046 2 20 2H15C13.8971 2 13.0027 2.89268 13 3.9949L13 18.0062Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0H9C9.7874 0 10.522 0.228008 11.1412 0.621545C11.649 0.944259 12.351 0.944258 12.8588 0.621544C13.478 0.228008 14.2126 0 15 0H20C22.2091 0 24 1.79086 24 4V18C24 20.2091 22.2091 22 20 22H15.7706C15.2747 22 14.7964 22.1843 14.4286 22.5171L13.3637 23.4808C12.6092 24.1637 11.4623 24.1711 10.699 23.4981L9.56691 22.4999C9.20158 22.1777 8.73125 22 8.24418 22H4C1.79086 22 0 20.2091 0 18V4C0 1.79086 1.79086 0 4 0ZM11 18V4C11 2.89543 10.1046 2 9 2H4C2.89543 2 2 2.89543 2 4V18C2 19.1046 2.89543 20 4 20H9C10.1046 20 11 19.1046 11 18ZM13 18.0062C13.0034 19.1079 13.8975 20 15 20H20C21.1046 20 22 19.1046 22 18V4C22 2.89543 21.1046 2 20 2H15C13.8971 2 13.0027 2.89268 13 3.9949L13 18.0062Z", fillOpacity: "0.1" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0H9C9.7874 0 10.522 0.228008 11.1412 0.621545C11.649 0.944259 12.351 0.944258 12.8588 0.621544C13.478 0.228008 14.2126 0 15 0H20C22.2091 0 24 1.79086 24 4V18C24 20.2091 22.2091 22 20 22H15.7706C15.2747 22 14.7964 22.1843 14.4286 22.5171L13.3637 23.4808C12.6092 24.1637 11.4623 24.1711 10.699 23.4981L9.56691 22.4999C9.20158 22.1777 8.73125 22 8.24418 22H4C1.79086 22 0 20.2091 0 18V4C0 1.79086 1.79086 0 4 0ZM11 18V4C11 2.89543 10.1046 2 9 2H4C2.89543 2 2 2.89543 2 4V18C2 19.1046 2.89543 20 4 20H9C10.1046 20 11 19.1046 11 18ZM13 18.0062C13.0034 19.1079 13.8975 20 15 20H20C21.1046 20 22 19.1046 22 18V4C22 2.89543 21.1046 2 20 2H15C13.8971 2 13.0027 2.89268 13 3.9949L13 18.0062Z", fillOpacity: "0.01" }));
}

function Opens24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.9545 1.86864C13.2784 0.617384 10.9774 0.530465 9.23954 1.75949C6.73457 3.53099 3.74047 5.7809 1.95922 7.13278C0.718433 8.07448 0 9.54078 0 11.0917V19.0001C0 21.7615 2.23858 24.0001 5 24.0001H19C21.7614 24.0001 24 21.7615 24 19.0001V11.1282C24 9.55053 23.2553 8.06536 21.9911 7.12155L14.9545 1.86864ZM10.3943 3.39241C11.3948 2.68488 12.7466 2.71622 13.7581 3.47132L20.7946 8.72423C20.9602 8.84783 21.1109 8.9869 21.2454 9.13864L13.8529 15.1581C12.7456 16.0597 11.1563 16.0559 10.0533 15.149L2.7339 9.13086C2.86352 8.98287 3.00876 8.84701 3.16833 8.72591C4.94662 7.37627 7.91838 5.1434 10.3943 3.39241ZM2 11.1167V19.0001C2 20.657 3.34314 22.0001 5 22.0001H19C20.6569 22.0001 22 20.657 22 19.0001V11.1282C22 11.12 22 11.1117 21.9999 11.1034L15.1157 16.709C13.2703 18.2117 10.6214 18.2054 8.78314 16.6939L2 11.1167Z" }));
}

function Organization24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("rect", { className: 'noFill', x: "1", y: "0.999878", width: "22", height: "22", rx: "3", fill: 'none', strokeWidth: "2" }),
        React__default.createElement("rect", { className: 'noFill', x: "6", y: "5.99988", width: "4", height: "4", rx: "2", strokeWidth: "2", fill: 'none' }),
        React__default.createElement("rect", { className: 'noFill', x: "5.5", y: "17.4999", width: "13", height: "1" }),
        React__default.createElement("rect", { className: 'noFill', x: "5.5", y: "13.4999", width: "13", height: "1" }));
}

function Sends24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.9126 0.902922C23.9226 0.962922 23.9226 1.01292 23.9226 1.06292C23.9226 1.13292 23.9026 1.19292 23.8826 1.25292L23.8526 1.37292L16.0726 20.4729C15.9326 20.8229 15.6026 21.0629 15.2226 21.0929H15.1426C14.7926 21.0929 14.4626 20.9029 14.2826 20.6029L10.1726 13.7429L3.31263 9.63292C2.99263 9.44292 2.80263 9.08292 2.83263 8.70292C2.86263 8.32292 3.10263 7.99292 3.45263 7.85292L22.5426 0.0729221C22.5826 0.0529221 22.6326 0.0529221 22.6726 0.0429221C22.7226 0.0229221 22.7826 0.00292206 22.8426 0.00292206C22.8783 -0.00302285 22.9104 0.00163482 22.9432 0.00639012C22.9656 0.00963337 22.9883 0.0129221 23.0126 0.0129221C23.0726 0.0129221 23.1226 0.0129221 23.1826 0.0329221C23.2326 0.0429221 23.2926 0.0729221 23.3426 0.102922C23.3926 0.122922 23.4326 0.132922 23.4726 0.162922L23.4926 0.182922C23.5426 0.212922 23.5826 0.262922 23.6226 0.302922C23.6626 0.342922 23.7126 0.372922 23.7426 0.422922L23.7626 0.442922C23.7926 0.482922 23.8026 0.532922 23.8226 0.572922C23.8426 0.622922 23.8726 0.672922 23.8926 0.732922C23.9126 0.782922 23.9126 0.842922 23.9126 0.902922ZM10.7526 11.7629L18.7226 3.79292H18.7126L6.06263 8.95292L10.7526 11.7629ZM12.1726 13.1729L16.1526 9.19292L20.1326 5.21292L14.9767 17.853L12.1726 13.1729ZM1.7125 17.9729L5.25263 14.4329C5.64263 14.0429 5.64263 13.4129 5.25263 13.0229C4.86263 12.6329 4.23263 12.6329 3.84263 13.0229L0.292504 16.5529C-0.0974957 16.9429 -0.0974957 17.5729 0.292504 17.9629C0.492504 18.1629 0.742504 18.2529 1.0025 18.2529C1.2625 18.2529 1.5125 18.1529 1.7125 17.9629V17.9729ZM7.37263 15.1429C7.76263 14.7529 8.39262 14.7529 8.78262 15.1429L8.79262 15.1329C9.18262 15.5229 9.18262 16.1529 8.79262 16.5429L2.4225 22.9129C2.2225 23.1029 1.9725 23.2029 1.7125 23.2029C1.4525 23.2029 1.2025 23.1129 1.0025 22.9129C0.612504 22.5229 0.612504 21.8929 1.0025 21.5029L7.37263 15.1429ZM5.9525 22.2129L9.49262 18.6729H9.50262C9.89262 18.2829 10.5226 18.2829 10.9126 18.6729C11.3026 19.0629 11.3026 19.6929 10.9126 20.0829L7.3725 23.6229C7.1725 23.8129 6.9225 23.9129 6.6625 23.9129C6.4025 23.9129 6.1525 23.8229 5.9525 23.6229C5.5625 23.2329 5.5625 22.6029 5.9525 22.2129Z" }));
}

function SignIn24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M9 1.00012C9 1.55241 9.44772 2.00012 10 2.00012H20C21.1046 2.00012 22 2.89555 22 4.00012V20.0001C22 21.1047 21.1046 22.0001 20 22.0001H10C9.44772 22.0001 9 22.4478 9 23.0001C9 23.5524 9.44772 24.0001 10 24.0001H20C22.2091 24.0001 24 22.2093 24 20.0001V4.00012C24 1.79098 22.2091 0.000122019 20 0.00012207L10 0.000122303C9.44772 0.000122316 9 0.447837 9 1.00012Z" }),
        React__default.createElement("path", { d: "M11.2929 16.7072C10.9024 16.3167 10.9024 15.6835 11.2929 15.293L13.5858 13.0001L1.01285 13.0001C0.45347 13.0001 0 12.5363 0 12.0001C0 11.4479 0.455304 11.0001 1.0193 11.0001L13.5858 11.0001L11.2929 8.70723C10.9024 8.31671 10.9024 7.68354 11.2929 7.29302C11.6834 6.90249 12.3166 6.90249 12.7071 7.29301L16.7071 11.293C16.9024 11.4883 17 11.7442 17 12.0001C17 12.256 16.9024 12.512 16.7071 12.7072L12.7071 16.7072C12.3166 17.0978 11.6834 17.0978 11.2929 16.7072Z" }));
}

function Stats24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M9.33301 8H0.333008V24H9.33301V8ZM7.33301 10H2.33301V22H7.33301V10Z" }),
        React__default.createElement("path", { id: "Vector_2", fillRule: "evenodd", clipRule: "evenodd", d: "M16.333 5H7.33301V24H16.333V5ZM14.333 7H9.33301V22H14.333V7Z" }),
        React__default.createElement("path", { id: "Vector_3", fillRule: "evenodd", clipRule: "evenodd", d: "M24.333 0H14.333V24H24.333V0ZM22.1108 2H16.5552V22H22.1108V2Z" }));
}

function Subscriptions24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M12 22.0001C17.5228 22.0001 22 17.523 22 12.0001H24C24 18.6275 18.6274 24.0001 12 24.0001C5.37258 24.0001 0 18.6275 0 12.0001C0 5.3727 5.37258 0.00012207 12 0.00012207V2.00012C6.47715 2.00012 2 6.47727 2 12.0001C2 17.523 6.47715 22.0001 12 22.0001Z" }),
        React__default.createElement("path", { d: "M21.7926 3.60988C22.1294 3.17213 22.0475 2.54428 21.6097 2.20755C21.172 1.87081 20.5441 1.95271 20.2074 2.39046L10.9018 14.4877L7.70711 11.2931C7.31658 10.9025 6.68342 10.9025 6.29289 11.2931C5.90237 11.6836 5.90237 12.3168 6.29289 12.7073L10.2929 16.7073C10.4964 16.9108 10.7776 17.0167 11.0648 16.9981C11.352 16.9794 11.6172 16.838 11.7926 16.6099L21.7926 3.60988Z" }));
}

function Success24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.5 12C24.5 5.37702 19.123 0 12.5 0C5.87702 0 0.5 5.37702 0.5 12C0.5 18.623 5.87702 24 12.5 24C19.123 24 24.5 18.623 24.5 12ZM22.5 12C22.5 6.48085 18.0191 2 12.5 2C6.98087 2 2.50004 6.48085 2.50004 12C2.50004 17.5191 6.98087 22 12.5 22C18.0191 22 22.5 17.5191 22.5 12Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.0478 7.1635C17.5098 7.46603 17.6392 8.08585 17.3366 8.5479L11.4795 16.5479C11.3163 16.7972 11.0504 16.9607 10.7542 16.9939C10.4581 17.0271 10.1626 16.9265 9.94826 16.7195L6.80541 13.7195C6.40809 13.3359 6.39699 12.7028 6.7806 12.3055C7.16421 11.9082 7.79728 11.8971 8.1946 12.2807L10.4682 14.4414L15.6634 7.45233C15.9659 6.99028 16.5857 6.86096 17.0478 7.1635Z" }));
}

function Unsubscribes24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.03682 5.44202C6.67693 2.54842 9.00106 0.00012207 12 0.00012207C14.9989 0.00012207 17.3231 2.54843 16.9632 5.44202L16.6557 7.91407C16.562 8.66784 16.2431 9.37841 15.7385 9.95801L15.227 10.5455C15.0828 10.7112 14.9284 10.8627 14.7657 11H18C19.777 11 21.3736 11.7725 22.4722 13H6C3.79086 13 2 14.7909 2 17V22H5V17H7V22H13V24H0V17C0 13.6863 2.68629 11 6 11H9.2343C9.07157 10.8627 8.91723 10.7112 8.77301 10.5455L8.26152 9.95801C7.75691 9.37841 7.43803 8.66784 7.34428 7.91407L7.03682 5.44202ZM12 2.00012C10.1391 2.00012 8.8179 3.55797 9.02153 5.19517L9.32899 7.66722C9.37301 8.02113 9.52339 8.36155 9.76995 8.64475L10.2814 9.23225C11.1728 10.2561 12.8272 10.2561 13.7186 9.23225L14.2301 8.64475C14.4766 8.36155 14.627 8.02113 14.671 7.66722L14.9785 5.19517C15.1821 3.55797 13.8609 2.00012 12 2.00012Z" }),
        React__default.createElement("path", { d: "M17 19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19Z" }));
}

function User24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0.00012207C9.00106 0.00012207 6.67693 2.54842 7.03682 5.44202L7.34428 7.91407C7.43803 8.66784 7.75691 9.37841 8.26152 9.95801L8.77301 10.5455C8.91723 10.7112 9.07157 10.8627 9.2343 11H6C2.68629 11 0 13.6863 0 17V24H24V17C24 13.6863 21.3137 11 18 11H14.7657C14.9284 10.8627 15.0828 10.7112 15.227 10.5455L15.7385 9.95801C16.2431 9.37841 16.562 8.66784 16.6557 7.91407L16.9632 5.44202C17.3231 2.54843 14.9989 0.00012207 12 0.00012207ZM9.02153 5.19517C8.8179 3.55797 10.1391 2.00012 12 2.00012C13.8609 2.00012 15.1821 3.55797 14.9785 5.19517L14.671 7.66722C14.627 8.02113 14.4766 8.36155 14.2301 8.64475L13.7186 9.23225C12.8272 10.2561 11.1728 10.2561 10.2814 9.23225L9.76995 8.64475C9.52339 8.36155 9.37301 8.02113 9.32899 7.66722L9.02153 5.19517ZM6 13C3.79086 13 2 14.7909 2 17V22H5V17H7V22H17V17H19V22H22V17C22 14.7909 20.2091 13 18 13H6Z" }));
}

function Warning24(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24" }),
        React__default.createElement("path", { d: "M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V7Z" }),
        React__default.createElement("path", { d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 12C24 5.37702 18.623 0 12 0C5.37702 0 0 5.37702 0 12C0 18.623 5.37702 24 12 24C18.623 24 24 18.623 24 12ZM22 12C22 6.48085 17.5191 2 12 2C6.48087 2 2.00004 6.48085 2.00004 12C2.00004 17.5191 6.48087 22 12 22C17.5191 22 22 17.5191 22 12Z" }));
}

function HumanSupport32(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2.34668C7.34315 2.34668 6 3.68983 6 5.34668V30.2203L9.88794 24.5155C10.199 24.0592 10.8211 23.9413 11.2775 24.2524C11.7338 24.5634 11.8517 25.1855 11.5406 25.6419L7.65268 31.3467C6.54421 32.9732 4 32.1886 4 30.2203V18.1396C1.6915 17.4867 0 15.3642 0 12.8467C0 10.3291 1.6915 8.20664 4 7.55371L4 5.34668C4 2.58526 6.23858 0.34668 9 0.34668H23C25.7614 0.34668 28 2.58526 28 5.34668V7.55371C30.3085 8.20664 32 10.3291 32 12.8467C32 15.3642 30.3085 17.4867 28 18.1396V18.9621C28 21.7235 25.7614 23.9621 23 23.9621H18.9035C18.644 24.7655 17.8899 25.3467 17 25.3467H15C13.8954 25.3467 13 24.4512 13 23.3467V22.3467C13 21.2421 13.8954 20.3467 15 20.3467H17C17.973 20.3467 18.7837 21.0415 18.9631 21.9621H23C24.6569 21.9621 26 20.6189 26 18.9621V5.34668C26 3.68983 24.6569 2.34668 23 2.34668H9ZM4 9.6835C2.81753 10.2452 2 11.4505 2 12.8467C2 14.2429 2.81753 15.4481 4 16.0099L4 9.6835ZM30 12.8467C30 14.2429 29.1825 15.4481 28 16.0099V9.6835C29.1825 10.2452 30 11.4505 30 12.8467ZM17 22.3467H15V23.3467H17V22.3467Z" }),
        React__default.createElement("path", { d: "M12 11.3467C13.1046 11.3467 14 10.4512 14 9.34668C14 8.24211 13.1046 7.34668 12 7.34668C10.8954 7.34668 10 8.24211 10 9.34668C10 10.4512 10.8954 11.3467 12 11.3467Z" }),
        React__default.createElement("path", { d: "M22 9.34668C22 10.4512 21.1046 11.3467 20 11.3467C18.8954 11.3467 18 10.4512 18 9.34668C18 8.24211 18.8954 7.34668 20 7.34668C21.1046 7.34668 22 8.24211 22 9.34668Z" }),
        React__default.createElement("path", { d: "M20.7072 15.0539C21.0977 14.6634 21.0977 14.0302 20.7072 13.6397C20.3167 13.2492 19.6835 13.2492 19.293 13.6397C17.4744 15.4583 14.5258 15.4583 12.7072 13.6397C12.3167 13.2492 11.6835 13.2492 11.293 13.6397C10.9024 14.0302 10.9024 14.6634 11.293 15.0539C13.8926 17.6536 18.1075 17.6536 20.7072 15.0539Z" }));
}

function NonProfits32(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2275 0.357344C21.2724 0.43126 22.3264 0.892027 23.325 1.84791C25.8519 4.25694 25.3376 7.89916 23.0148 10.4259L23.003 10.4385L16.7243 17.0361C16.5356 17.2344 16.2737 17.3467 15.9999 17.3467C15.7261 17.3467 15.4643 17.2344 15.2755 17.0361L8.99684 10.4385L8.98506 10.4259C6.66224 7.89917 6.14792 4.25697 8.67477 1.84794C9.67346 0.892035 10.7274 0.43126 11.7723 0.357344C12.7994 0.284684 13.7133 0.592949 14.4411 0.988794C15.0816 1.33714 15.6118 1.77119 15.9999 2.13921C16.388 1.77119 16.9182 1.33714 17.5587 0.988794C18.2865 0.592949 19.2004 0.284684 20.2275 0.357344ZM10.0571 3.29334C10.7657 2.6149 11.3945 2.38907 11.9134 2.35236C12.4504 2.31437 12.9816 2.47167 13.4856 2.74574C13.9906 3.02041 14.4241 3.38912 14.7382 3.70164C14.8929 3.85558 15.013 3.99022 15.0925 4.08387C15.1321 4.13055 15.1612 4.16662 15.1792 4.18931L15.1976 4.21281L15.2002 4.21614C15.389 4.46772 15.6852 4.61583 15.9999 4.61583C16.3146 4.61583 16.6109 4.4677 16.7997 4.21611L16.8009 4.21449L16.8022 4.21281L16.8206 4.18931C16.8386 4.16662 16.8678 4.13055 16.9074 4.08387C16.9868 3.99022 17.1069 3.85558 17.2616 3.70164C17.5757 3.38912 18.0093 3.02041 18.5143 2.74574C19.0182 2.47167 19.5494 2.31437 20.0864 2.35236C20.6053 2.38907 21.2342 2.6149 21.9427 3.29334L21.9444 3.29496C23.4349 4.71536 23.3815 7.06709 21.548 9.06617L15.9999 14.8961L10.4518 9.06617C8.61833 7.06708 8.56497 4.71536 10.0554 3.29496L10.0571 3.29334Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.00854763 14.1322C-0.0980493 12.6708 0.805705 11.6126 1.97433 11.3893C3.14062 11.1666 4.37984 11.8165 4.80081 13.2162L4.80342 13.225C4.82342 13.2938 4.9039 13.4907 5.06486 13.8316C5.2146 14.1487 5.40461 14.5302 5.60836 14.9357L5.68511 15.0883C5.7807 15.0109 5.8807 14.9416 5.98374 14.8805C6.79344 14.3924 8.18826 14.2791 8.97732 15.4694L8.98512 15.4812L8.99259 15.4932C9.49102 16.2933 10.2251 17.1417 11.0022 18.0397C11.9005 19.0627 12.8039 20.2201 13.3408 21.1544C13.99 22.2727 14.717 24.7318 14.876 27.2237L14.8767 27.235C14.9196 28.0526 14.9479 28.957 14.9711 29.6993C14.9812 30.0217 14.9903 30.3135 14.9993 30.5543L14.9999 30.5729V30.5914C14.9999 31.4662 14.33 32.3467 13.2985 32.3467H8.7234C7.74518 32.3467 7.02194 31.5544 7.02194 30.623V29.2811C5.36478 28.0854 3.78298 26.6543 2.86715 25.5743L2.8614 25.5674C2.27833 24.8672 1.83998 23.8951 1.50028 22.8867C1.15445 21.8601 0.883092 20.7101 0.672204 19.59C0.252707 17.362 0.0573262 15.1699 0.00854763 14.1322ZM3.97515 16.1395L3.82129 15.8337C3.61779 15.4287 3.41772 15.0273 3.25633 14.6855C3.10735 14.37 2.95685 14.0347 2.88467 13.7893C2.81214 13.5503 2.70143 13.448 2.62689 13.4026C2.54404 13.3521 2.4461 13.3354 2.34957 13.3538C2.25358 13.3722 2.16803 13.4235 2.10783 13.5036C2.0527 13.577 1.98263 13.7232 2.00376 13.9935L2.005 14.0094L2.00573 14.0253C2.04963 14.9762 2.23564 17.0847 2.63767 19.22C2.83854 20.2869 3.0895 21.3395 3.39562 22.2482C3.70707 23.1727 4.04933 23.8671 4.39561 24.2844C5.18217 25.211 6.63274 26.5342 8.19353 27.6602C8.75031 28.0336 9.02194 28.6818 9.02194 29.27V30.3467H12.9907C12.9843 30.1561 12.9779 29.9492 12.971 29.731C12.9482 28.999 12.9213 28.1402 12.8797 27.3454C12.7329 25.0582 12.0583 22.9277 11.6104 22.1574L11.6077 22.1527C11.1692 21.3889 10.3661 20.3462 9.49703 19.3566L9.49226 19.3512L9.43156 19.281C8.70383 18.4403 7.88759 17.4974 7.30554 16.5675C7.29009 16.5458 7.28039 16.5403 7.2793 16.5397C7.27712 16.5384 7.26865 16.5336 7.24797 16.5311C7.19771 16.5251 7.10705 16.5382 7.01584 16.5936L7.00458 16.6003C6.89792 16.6632 6.80224 16.7716 6.76147 16.934C6.72163 17.0928 6.71057 17.4035 6.96156 17.8979L6.96229 17.8993C7.09467 18.1611 7.3354 18.5019 7.68764 18.9342C7.98514 19.2992 8.32884 19.6899 8.7043 20.1167L8.98417 20.4352L9.00381 20.4756L9.01443 20.4865L9.01083 20.49L9.04312 20.5564C9.03048 20.5304 9.01821 20.5091 9.00798 20.4928L7.57833 21.8785L7.57083 21.871C7.53883 21.8389 7.43371 21.7338 7.33773 21.5913L7.20671 21.4424C6.83324 21.0179 6.46072 20.5946 6.13725 20.1976C5.76531 19.7412 5.41145 19.2642 5.17787 18.8026L4.83982 17.9124C4.64685 17.4739 4.31881 16.8222 3.97515 16.1395Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.9913 14.1322C32.0979 12.6708 31.1942 11.6126 30.0256 11.3893C28.8593 11.1666 27.6201 11.8165 27.1991 13.2162L27.1965 13.225C27.1765 13.2938 27.096 13.4907 26.935 13.8316C26.7853 14.1487 26.5953 14.5302 26.3915 14.9357L26.3148 15.0883C26.2192 15.0109 26.1192 14.9416 26.0162 14.8805C25.2065 14.3924 23.8116 14.2791 23.0226 15.4694L23.0148 15.4812L23.0073 15.4932C22.5089 16.2933 21.7748 17.1417 20.9977 18.0397C20.0994 19.0627 19.196 20.2201 18.6591 21.1544C18.0099 22.2727 17.2828 24.7318 17.1239 27.2237L17.1232 27.235C17.0803 28.0526 17.052 28.9569 17.0288 29.6992C17.0187 30.0216 17.0096 30.3135 17.0006 30.5543L16.9999 30.5729V30.5914C16.9999 31.4662 17.6699 32.3467 18.7014 32.3467H23.2765C24.2547 32.3467 24.978 31.5544 24.978 30.623V29.2811C26.6351 28.0854 28.2169 26.6543 29.1327 25.5743L29.1385 25.5674C29.7216 24.8672 30.1599 23.8951 30.4996 22.8867C30.8454 21.8601 31.1168 20.7101 31.3277 19.59C31.7472 17.362 31.9426 15.1699 31.9913 14.1322ZM28.0247 16.1396L28.1786 15.8337C28.3821 15.4287 28.5822 15.0273 28.7436 14.6855C28.8925 14.37 29.043 14.0347 29.1152 13.7893C29.1878 13.5503 29.2985 13.448 29.373 13.4026C29.4559 13.3521 29.5538 13.3354 29.6503 13.3538C29.7463 13.3722 29.8319 13.4235 29.8921 13.5036C29.9472 13.577 30.0173 13.7232 29.9961 13.9935L29.9949 14.0094L29.9942 14.0253C29.9503 14.9762 29.7643 17.0847 29.3622 19.22C29.1614 20.2869 28.9104 21.3395 28.6043 22.2482C28.2928 23.1727 27.9506 23.8671 27.6043 24.2844C26.8177 25.211 25.3672 26.5342 23.8064 27.6602C23.2496 28.0336 22.978 28.6818 22.978 29.27V30.3467H19.0092C19.0156 30.1561 19.022 29.9492 19.0289 29.731C19.0517 28.9991 19.0786 28.1401 19.1202 27.3454C19.267 25.0582 19.9416 22.9277 20.3895 22.1574L20.3922 22.1527C20.8307 21.3889 21.6338 20.3462 22.5029 19.3566L22.5076 19.3512L22.5683 19.281C23.2961 18.4403 24.1123 17.4974 24.6944 16.5675C24.7098 16.5458 24.7195 16.5403 24.7206 16.5397C24.7228 16.5384 24.7312 16.5336 24.7519 16.5311C24.8022 16.5251 24.8928 16.5382 24.9841 16.5936L24.9953 16.6003C25.102 16.6632 25.1977 16.7716 25.2384 16.934C25.2783 17.0928 25.2893 17.4035 25.0383 17.8979L25.0376 17.8993C24.9052 18.1611 24.6645 18.5019 24.3123 18.9342C24.0148 19.2992 23.6711 19.6899 23.2956 20.1167L23.0157 20.4352L22.9961 20.4756L22.9855 20.4865L22.9891 20.49L22.9568 20.5564C22.9694 20.5304 22.9817 20.5091 22.9919 20.4928L24.4216 21.8785L24.4291 21.871C24.4611 21.8389 24.5662 21.7338 24.6622 21.5913L24.7932 21.4424C25.1667 21.0179 25.5392 20.5946 25.8626 20.1976C26.2346 19.7412 26.5884 19.2642 26.822 18.8026L27.1601 17.9124C27.353 17.4739 27.6811 16.8222 28.0247 16.1396Z" }));
}

function Sent32(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5566 0.790407C32.8406 1.07446 32.9271 1.50093 32.7762 1.87322L22.1696 28.0362C22.0258 28.391 21.6919 28.6326 21.3098 28.6582C20.9278 28.6839 20.5646 28.4891 20.3746 28.1566L14.8531 18.4939L5.19039 12.9724C4.85792 12.7824 4.66314 12.4192 4.68877 12.0372C4.7144 11.6551 4.95596 11.3212 5.31082 11.1774L31.4738 0.570774C31.8461 0.419847 32.2725 0.506349 32.5566 0.790407ZM7.97023 12.2573L27.6562 4.27653L15.419 16.5138L7.97023 12.2573ZM21.0896 25.3768L16.8332 17.928L29.0705 5.6907L21.0896 25.3768Z" }),
        React__default.createElement("path", { d: "M12.7576 20.5893C12.367 20.1988 11.7339 20.1988 11.3434 20.5893L2.15096 29.7817C1.76044 30.1723 1.76044 30.8054 2.15096 31.1959C2.54149 31.5865 3.17465 31.5865 3.56518 31.1959L12.7576 22.0036C13.1481 21.613 13.1481 20.9799 12.7576 20.5893Z" }),
        React__default.createElement("path", { d: "M13.4647 25.5391C13.8552 25.1486 14.4884 25.1486 14.8789 25.5391C15.2694 25.9296 15.2694 26.5628 14.8789 26.9533L9.22203 32.6102C8.8315 33.0007 8.19834 33.0007 7.80782 32.6102C7.41729 32.2196 7.4173 31.5865 7.80782 31.1959L13.4647 25.5391Z" }),
        React__default.createElement("path", { d: "M7.80782 18.468C7.41729 18.0775 6.78413 18.0775 6.3936 18.468L0.736748 24.1249C0.346225 24.5154 0.346224 25.1486 0.736748 25.5391C1.12727 25.9296 1.76044 25.9296 2.15096 25.5391L7.80782 19.8822C8.19834 19.4917 8.19834 18.8586 7.80782 18.468Z" }));
}

function Uptime32(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32" }),
        React__default.createElement("path", { id: "Union", d: "M12.71 2.22636L13.7028 2.34668V2.34668L12.71 2.22636ZM19.2861 2.22636L18.2933 2.34668L18.2933 2.34668L19.2861 2.22636ZM19.4782 3.81165L18.4855 3.93196L18.566 4.59655L19.2111 4.77533L19.4782 3.81165ZM22.5997 5.13884L22.0912 5.99994L22.6839 6.3499L23.2225 5.92122L22.5997 5.13884ZM23.7956 4.18686L23.1728 3.40447V3.40447L23.7956 4.18686ZM25.1253 4.26218L25.8325 3.55512L25.8325 3.55512L25.1253 4.26218ZM28.0808 7.21802L27.3737 7.92508L27.3737 7.92508L28.0808 7.21802ZM28.1561 8.54796L28.9386 9.17066L28.1561 8.54796ZM27.2043 9.74402L26.4218 9.12132L25.9933 9.65977L26.3431 10.2524L27.2043 9.74402ZM28.5314 12.8661L27.5677 13.1331L27.7464 13.7782L28.411 13.8588L28.5314 12.8661ZM30.1164 13.0582L30.2368 12.0655H30.2368L30.1164 13.0582ZM30.1164 19.6351L30.2368 20.6279H30.2368L30.1164 19.6351ZM28.5315 19.8273L28.4111 18.8346L27.7465 18.9151L27.5678 19.5603L28.5315 19.8273ZM27.2044 22.9494L26.3433 22.4411L25.9935 23.0337L26.422 23.5721L27.2044 22.9494ZM28.1562 24.1454L28.9386 23.5227L28.1562 24.1454ZM28.0809 25.4753L27.3737 24.7683L27.3737 24.7683L28.0809 25.4753ZM25.1254 28.4312L25.8326 29.1382L25.8326 29.1382L25.1254 28.4312ZM23.7956 28.5065L23.1728 29.2889L23.7956 28.5065ZM22.5999 27.5547L23.2227 26.7723L22.6842 26.3436L22.0915 26.6936L22.5999 27.5547ZM19.4782 28.8821L19.2111 27.9184L18.566 28.0971L18.4854 28.7617L19.4782 28.8821ZM19.2861 30.467L20.2788 30.5873L19.2861 30.467ZM12.71 30.467L11.7173 30.5873L12.71 30.467ZM12.518 28.8822L13.5107 28.7619L13.4301 28.0973L12.785 27.9185L12.518 28.8822ZM9.39579 27.5548L9.90424 26.6937L9.31153 26.3437L8.773 26.7724L9.39579 27.5548ZM8.20013 28.5065L7.57733 27.7242H7.57733L8.20013 28.5065ZM6.87036 28.4312L6.16321 29.1383V29.1383L6.87036 28.4312ZM3.91491 25.4754L3.20775 26.1824H3.20775L3.91491 25.4754ZM3.83959 24.1454L3.05713 23.5227L3.83959 24.1454ZM4.79126 22.9496L5.57373 23.5723L6.00223 23.0339L5.65242 22.4413L4.79126 22.9496ZM3.46409 19.8272L4.4278 19.5603L4.24907 18.9151L3.58444 18.8345L3.46409 19.8272ZM1.87965 19.6351L2 18.6424L2 18.6424L1.87965 19.6351ZM1.87965 13.0582L1.75931 12.0655H1.75931L1.87965 13.0582ZM3.46418 12.8661L3.58453 13.8589L4.24915 13.7783L4.42789 13.1331L3.46418 12.8661ZM4.79141 9.74384L5.65255 10.2522L6.00238 9.6596L5.57387 9.12115L4.79141 9.74384ZM3.83965 8.54789L3.05719 9.17059V9.17059L3.83965 8.54789ZM3.91496 7.21795L3.20781 6.51089L3.91496 7.21795ZM6.87042 4.26211L7.57758 4.96917V4.96917L6.87042 4.26211ZM8.20019 4.18679L7.57739 4.96917L7.57739 4.96917L8.20019 4.18679ZM9.39608 5.13874L8.77329 5.92113L9.31181 6.3498L9.90451 5.99985L9.39608 5.13874ZM12.5179 3.8115L12.7849 4.77519L13.4301 4.59643L13.5107 3.93181L12.5179 3.8115ZM13.7028 0.34668C12.6913 0.34668 11.839 1.10189 11.7173 2.10605L13.7028 2.34668L13.7028 2.34668V0.34668ZM18.2933 0.34668H13.7028V2.34668H18.2933V0.34668ZM20.2788 2.10605C20.1571 1.10189 19.3048 0.34668 18.2933 0.34668V2.34668L18.2933 2.34668L20.2788 2.10605ZM20.4709 3.69133L20.2788 2.10605L18.2933 2.34668L18.4855 3.93196L20.4709 3.69133ZM19.2111 4.77533C20.2321 5.05824 21.1985 5.47284 22.0912 5.99994L23.1081 4.27774C22.0665 3.66272 20.938 3.17849 19.7453 2.84796L19.2111 4.77533ZM23.1728 3.40447L21.9769 4.35645L23.2225 5.92122L24.4184 4.96924L23.1728 3.40447ZM25.8325 3.55512C25.1133 2.83578 23.9687 2.77093 23.1728 3.40447L24.4184 4.96924L24.4182 4.96924L25.8325 3.55512ZM28.788 6.51096L25.8325 3.55512L24.4182 4.96924L27.3737 7.92508L28.788 6.51096ZM28.9386 9.17066C29.572 8.37478 29.5072 7.23025 28.788 6.51096L27.3737 7.92508L27.3737 7.92527L28.9386 9.17066ZM27.9867 10.3667L28.9386 9.17066L27.3737 7.92527L26.4218 9.12132L27.9867 10.3667ZM26.3431 10.2524C26.8702 11.1452 27.2848 12.1119 27.5677 13.1331L29.4951 12.5991C29.1646 11.4062 28.6804 10.2775 28.0654 9.23567L26.3431 10.2524ZM30.2368 12.0655L28.6517 11.8733L28.411 13.8588L29.9961 14.051L30.2368 12.0655ZM31.9961 14.051C31.9961 13.0395 31.2409 12.1872 30.2368 12.0655L29.9961 14.051H31.9961ZM31.9961 18.6424V14.051H29.9961V18.6424H31.9961ZM30.2368 20.6279C31.2409 20.5061 31.9961 19.6539 31.9961 18.6424H29.9961L29.9961 18.6424L30.2368 20.6279ZM28.6518 20.82L30.2368 20.6279L29.9961 18.6424L28.4111 18.8346L28.6518 20.82ZM27.5678 19.5603C27.2849 20.5815 26.8703 21.5482 26.3433 22.4411L28.0656 23.4578C28.6806 22.4159 29.1647 21.2872 29.4952 20.0942L27.5678 19.5603ZM28.9386 23.5227L27.9869 22.3267L26.422 23.5721L27.3737 24.7681L28.9386 23.5227ZM28.788 26.1824C29.5072 25.4631 29.572 24.3186 28.9386 23.5227L27.3737 24.7681L27.3737 24.7683L28.788 26.1824ZM25.8326 29.1382L28.788 26.1824L27.3737 24.7683L24.4183 27.7241L25.8326 29.1382ZM23.1728 29.2889C23.9687 29.9224 25.1133 29.8576 25.8326 29.1382L24.4183 27.7241H24.4184L23.1728 29.2889ZM21.9771 28.3371L23.1728 29.2889L24.4184 27.7241L23.2227 26.7723L21.9771 28.3371ZM22.0915 26.6936C21.1987 27.2208 20.2321 27.6354 19.2111 27.9184L19.7452 29.8457C20.938 29.5152 22.0667 29.0309 23.1084 28.4158L22.0915 26.6936ZM20.2788 30.5873L20.4709 29.0024L18.4854 28.7617L18.2933 30.3467L20.2788 30.5873ZM18.2933 32.3467C19.3048 32.3467 20.1571 31.5915 20.2788 30.5873L18.2933 30.3467V30.3467V32.3467ZM13.7028 32.3467H18.2933V30.3467H13.7028V32.3467ZM11.7173 30.5873C11.839 31.5915 12.6913 32.3467 13.7028 32.3467V30.3467H13.7028L11.7173 30.5873ZM11.5252 29.0025L11.7173 30.5873L13.7028 30.3467L13.5107 28.7619L11.5252 29.0025ZM12.785 27.9185C11.7638 27.6356 10.7971 27.2209 9.90424 26.6937L8.88734 28.4159C9.92917 29.031 11.058 29.5154 12.2509 29.8459L12.785 27.9185ZM8.82292 29.2889L10.0186 28.3372L8.773 26.7724L7.57733 27.7242L8.82292 29.2889ZM6.16321 29.1383C6.88246 29.8576 8.02705 29.9225 8.82293 29.2889L7.57733 27.7242L7.57752 27.7242L6.16321 29.1383ZM3.20775 26.1824L6.16321 29.1383L7.57752 27.7242L4.62206 24.7683L3.20775 26.1824ZM3.05713 23.5227C2.42376 24.3186 2.48856 25.4632 3.20775 26.1824L4.62206 24.7683L4.62206 24.7681L3.05713 23.5227ZM4.0088 22.3269L3.05713 23.5227L4.62206 24.7681L5.57373 23.5723L4.0088 22.3269ZM5.65242 22.4413C5.12529 21.5483 4.71069 20.5815 4.4278 19.5603L2.50038 20.0942C2.83086 21.2872 3.31507 22.4161 3.93011 23.4579L5.65242 22.4413ZM1.75931 20.6279L3.34374 20.8199L3.58444 18.8345L2 18.6424L1.75931 20.6279ZM0 18.6424C0 19.6539 0.755178 20.5061 1.75931 20.6279L2 18.6424L2 18.6424H0ZM0 14.051V18.6424H2V14.051H0ZM1.75931 12.0655C0.755179 12.1872 0 13.0395 0 14.051H2L2 14.051L1.75931 12.0655ZM3.34384 11.8734L1.75931 12.0655L2 14.051L3.58453 13.8589L3.34384 11.8734ZM4.42789 13.1331C4.7108 12.1119 5.12542 11.1451 5.65255 10.2522L3.93026 9.23548C3.31522 10.2773 2.83098 11.4062 2.50048 12.5992L4.42789 13.1331ZM3.05719 9.17059L4.00894 10.3665L5.57387 9.12115L4.62212 7.9252L3.05719 9.17059ZM3.20781 6.51089C2.48862 7.23018 2.42382 8.37471 3.05719 9.17059L4.62212 7.9252L4.62212 7.92501L3.20781 6.51089ZM6.16327 3.55505L3.20781 6.51089L4.62212 7.92501L7.57758 4.96917L6.16327 3.55505ZM8.82298 3.4044C8.02711 2.77087 6.88251 2.83571 6.16327 3.55505L7.57758 4.96917L7.57739 4.96917L8.82298 3.4044ZM10.0189 4.35636L8.82298 3.4044L7.57739 4.96917L8.77329 5.92113L10.0189 4.35636ZM9.90451 5.99985C10.7973 5.47271 11.7639 5.05809 12.7849 4.77519L12.2509 2.84781C11.0581 3.17831 9.92938 3.66257 8.88765 4.27764L9.90451 5.99985ZM11.7173 2.10605L11.5252 3.69118L13.5107 3.93181L13.7028 2.34668L11.7173 2.10605Z" }),
        React__default.createElement("path", { className: 'noFill', id: "Ellipse 37", d: "M24 16.3466C24 20.7657 20.4182 24.3478 16 24.3478C11.5818 24.3478 8 20.7657 8 16.3466C8 11.9276 11.5818 8.34546 16 8.34546C20.4182 8.34546 24 11.9276 24 16.3466Z", strokeWidth: "2" }),
        React__default.createElement("path", { className: 'noFill', id: "Vector 119", d: "M13.2842 17.391L15.2591 19.0621L18.7153 13.631", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}

function CreateForm44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "44", viewBox: "0 0 44 44" }),
        React__default.createElement("path", { d: "M39 0C41.7614 0 44 2.23858 44 5V31.5459H42V5C42 3.34315 40.6569 2 39 2H5C3.34315 2 2 3.34315 2 5V39C2 40.6568 3.34315 42 5 42H30.5908V44H5C2.23858 44 0 41.7614 0 39V5C0 2.23858 2.23858 0 5 0H39Z" }),
        React__default.createElement("path", { d: "M36.8359 30C37.3881 30.0001 37.8359 30.4478 37.8359 31V36H42.8359C43.3881 36.0001 43.8359 36.4478 43.8359 37C43.8359 37.5522 43.3881 37.9999 42.8359 38H37.8359V43C37.8359 43.5522 37.3881 43.9999 36.8359 44C36.2837 44 35.8359 43.5523 35.8359 43V38H30.8359C30.2837 38 29.8359 37.5523 29.8359 37C29.8359 36.4477 30.2837 36 30.8359 36H35.8359V31C35.8359 30.4477 36.2837 30 36.8359 30Z" }),
        React__default.createElement("path", { d: "M19 12C20.195 12 21.267 12.5246 22 13.3555C22.733 12.5246 23.805 12 25 12H28C28.5523 12 29 12.4477 29 13C29 13.5523 28.5523 14 28 14H25C23.8954 14 23 14.8954 23 16V27C23 28.1046 23.8954 29 25 29H28C28.5523 29 29 29.4477 29 30C29 30.5523 28.5523 31 28 31H25C23.8047 31 22.733 30.4747 22 29.6436C21.267 30.4747 20.1953 31 19 31H16C15.4477 31 15 30.5523 15 30C15 29.4477 15.4477 29 16 29H19C20.1046 29 21 28.1046 21 27V16C21 14.8954 20.1046 14 19 14H16C15.4477 14 15 13.5523 15 13C15 12.4477 15.4477 12 16 12H19Z" }));
}

function CreateWidget44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "45", viewBox: "0 0 44 45" }),
        React__default.createElement("rect", { className: 'noFill', id: "Rectangle 221", x: "1", y: "1", width: "18", height: "18", rx: "2", strokeWidth: "2" }),
        React__default.createElement("rect", { className: 'noFill', id: "Rectangle 223", x: "1", y: "25", width: "18", height: "18", rx: "2", strokeWidth: "2" }),
        React__default.createElement("rect", { className: 'noFill', id: "Rectangle 224", x: "25", y: "25", width: "18", height: "18", rx: "2", strokeWidth: "2" }),
        React__default.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M28.2916 20L44 4.29155L39.7084 0L24 15.7084V20H28.2916ZM40.4853 4.92893L39.0711 3.51472L25.5147 17.0711L26.9289 18.4853L40.4853 4.92893Z" }));
}

function EmptyABTest44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "44", viewBox: "0 0 44 44" }),
        React__default.createElement("path", { className: 'noFill', d: "M22 7H7C3.68629 7 1 9.68629 1 13V31C1 34.3137 3.68629 37 7 37H22V7Z", strokeWidth: "2" }),
        React__default.createElement("path", { d: "M16.1025 30.0046C16.6066 30.056 16.9999 30.4822 17 30.9998C17 31.5174 16.6067 31.9435 16.1025 31.9949L16 31.9998H7C6.44772 31.9998 6 31.552 6 30.9998C6.00012 30.4476 6.44779 29.9998 7 29.9998H16L16.1025 30.0046ZM16.1025 25.0046C16.6066 25.056 16.9999 25.4822 17 25.9998C17 26.5174 16.6067 26.9435 16.1025 26.9949L16 26.9998H7C6.44772 26.9998 6 26.552 6 25.9998C6.00012 25.4476 6.44779 24.9998 7 24.9998H16L16.1025 25.0046ZM14.1562 13.4626C14.4528 12.997 15.0713 12.8596 15.5371 13.156C16.0029 13.4525 16.1401 14.071 15.8438 14.5369L12.0254 20.5369C11.8703 20.7804 11.6174 20.9446 11.332 20.988C11.0467 21.0314 10.7565 20.9498 10.5361 20.7634L8.35449 18.9167C7.93301 18.56 7.8797 17.9291 8.23633 17.5076C8.59301 17.0862 9.22394 17.0339 9.64551 17.3904L10.9521 18.4958L14.1562 13.4626Z" }),
        React__default.createElement("path", { d: "M26 36.7998C26.5522 36.7998 26.9999 37.2476 27 37.7998V43C26.9999 43.5522 26.5522 44 26 44C25.4478 44 25.0001 43.5522 25 43V37.7998C25.0001 37.2476 25.4478 36.7998 26 36.7998ZM37 6C40.866 6 44 9.13401 44 13V31C44 34.866 40.866 38 37 38H29V36H37C39.7614 36 42 33.7614 42 31V13C42 10.2386 39.7614 8 37 8H29V6H37ZM26 27.6006C26.5523 27.6006 27 28.0483 27 28.6006V33.8008C26.9996 34.3528 26.5521 34.8008 26 34.8008C25.4479 34.8008 25.0004 34.3528 25 33.8008V28.6006C25 28.0483 25.4477 27.6006 26 27.6006ZM37 30C37.5523 30 38 30.4477 38 31C38 31.5523 37.5523 32 37 32H31C30.4477 32 30 31.5523 30 31C30 30.4477 30.4477 30 31 30H37ZM37 25C37.5523 25 38 25.4477 38 26C38 26.5523 37.5523 27 37 27H31C30.4477 27 30 26.5523 30 26C30 25.4477 30.4477 25 31 25H37ZM26 18.4004C26.5523 18.4004 27 18.8481 27 19.4004V24.6006C26.9996 25.1526 26.5521 25.6006 26 25.6006C25.4479 25.6006 25.0004 25.1526 25 24.6006V19.4004C25 18.8481 25.4477 18.4004 26 18.4004ZM36.293 13.293C36.6835 12.9024 37.3165 12.9024 37.707 13.293C38.0976 13.6835 38.0976 14.3165 37.707 14.707L35.4141 17L37.707 19.293C38.0976 19.6835 38.0976 20.3165 37.707 20.707C37.3165 21.0976 36.6835 21.0976 36.293 20.707L34 18.4141L31.707 20.707C31.3165 21.0976 30.6835 21.0976 30.293 20.707C29.9024 20.3165 29.9024 19.6835 30.293 19.293L32.5859 17L30.293 14.707C29.9024 14.3165 29.9024 13.6835 30.293 13.293C30.6835 12.9024 31.3165 12.9024 31.707 13.293L34 15.5859L36.293 13.293ZM26 9.2002C26.5523 9.2002 27 9.64791 27 10.2002V15.4004C26.9998 15.9525 26.5521 16.4004 26 16.4004C25.4479 16.4004 25.0002 15.9525 25 15.4004V10.2002C25 9.64791 25.4477 9.2002 26 9.2002ZM26 0C26.5523 0 27 0.447715 27 1V6.2002C26.9999 6.75239 26.5522 7.2002 26 7.2002C25.4478 7.2002 25.0001 6.75239 25 6.2002V1C25 0.447715 25.4477 0 26 0Z" }));
}

function EmptyDraft44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "44", viewBox: "0 0 44 44" }),
        React__default.createElement("path", { d: "M0.615234 22.0774C0.987691 21.9221 1.41737 22.0054 1.7041 22.2893L12.2402 32.7249C12.2798 32.7641 12.315 32.8061 12.3467 32.8499C12.9849 32.3154 13.6176 31.7852 14.2334 31.2717C16.753 29.1708 20.3803 29.1594 22.9404 31.1848L25.7822 33.4329L30.3232 29.2639C30.7299 28.8905 31.3627 28.917 31.7363 29.3235C32.1097 29.7302 32.0832 30.363 31.6768 30.7366L27.3701 34.6897L34.6318 40.4348C35.4791 39.539 36 38.3311 36 37.0002V28.0002C36 27.448 36.4477 27.0002 37 27.0002C37.5523 27.0002 38 27.448 38 28.0002V37.0002C37.9999 40.8657 34.8684 44.0002 31.002 44.0002H6.99805C3.13165 44.0002 5.4212e-05 40.8658 0 37.0002V23.0002L0.0107422 22.8508C0.0623218 22.5088 0.289394 22.2133 0.615234 22.0774ZM21.6992 32.7532C19.8688 31.3052 17.2948 31.3236 15.5146 32.8079C13.0006 34.9041 10.1579 37.3046 7.88477 39.1731C6.74818 40.1073 5.74212 40.9185 4.98242 41.4983C4.96077 41.5148 4.93833 41.5299 4.91699 41.5461C5.55068 41.8368 6.25511 42.0002 6.99805 42.0002H31.002C31.678 42.0002 32.3221 41.8646 32.9102 41.6213L21.6992 32.7532ZM2 37.0002C2.00002 38.2642 2.4693 39.4179 3.24219 40.2981C3.39408 40.1886 3.57058 40.0595 3.76855 39.9084C4.49799 39.3518 5.48117 38.5595 6.61426 37.6282C7.88973 36.5798 9.34121 35.3665 10.8174 34.1301L2 25.3987V37.0002ZM38.4541 11.0002C39.2354 10.2189 40.5024 10.2195 41.2832 11.0002C41.8843 11.6013 42.3989 12.116 43 12.717C43.7808 13.4978 43.7813 14.7648 43 15.5461L34.7021 23.844C34.4332 24.1128 34.0928 24.2996 33.7217 24.3821L30.2168 25.1604C29.8994 25.2309 29.5677 25.1429 29.3271 24.9241C29.0867 24.7053 28.9676 24.3834 29.0078 24.0608L29.4385 20.6116C29.4936 20.1704 29.6945 19.76 30.0088 19.4456L38.4541 11.0002ZM31.4238 20.8596L31.168 22.9006L33.2881 22.4299L41.5859 14.1321C40.9757 13.5219 40.4794 13.0245 39.8691 12.4143H39.8682L31.4238 20.8596Z" }),
        React__default.createElement("path", { d: "M25 24C25.5521 24.0002 26 24.4478 26 25C26 25.5522 25.5521 25.9998 25 26H13C12.4479 25.9998 12 25.5522 12 25C12 24.4478 12.4479 24.0002 13 24H25ZM25 20C25.5521 20.0002 26 20.4478 26 21C26 21.5522 25.5521 21.9998 25 22H13C12.4479 21.9998 12 21.5522 12 21C12 20.4478 12.4479 20.0002 13 20H25ZM25 7C26.1044 7.0002 27 7.89555 27 9V15C27 16.1044 26.1044 16.9998 25 17H13C11.8956 16.9998 11 16.1044 11 15V9C11 7.89555 11.8956 7.0002 13 7H25ZM13 15H25V9H13V15Z" }),
        React__default.createElement("path", { className: "noFill", d: "M4 12.5V18.5", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M22 1L16 1", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M4 7V5C4 2.79086 5.79086 1 8 1H10", strokeWidth: "2", strokeLinecap: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M34 7V5C34 2.79086 32.2091 1 30 1H28", strokeWidth: "2", strokeLinecap: "round" }));
}

function EmptyFolder(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "45", viewBox: "0 0 44 45" }),
        React__default.createElement("path", { d: "M23.9837 2.75812C23.9946 2.67362 24.0002 2.58747 24.0002 2.5C24.0002 1.39543 23.1048 0.5 22.0002 0.5C20.8957 0.5 20.0002 1.39543 20.0002 2.5H19.0002C17.8957 2.5 17.0002 3.39543 17.0002 4.5C17.0002 5.60457 17.8957 6.5 19.0002 6.5H20.0002C20.0002 7.60457 20.8957 8.5 22.0002 8.5C23.1048 8.5 24.0002 7.60457 24.0002 6.5C24.0002 6.41253 23.9946 6.32638 23.9837 6.24188C24.5906 5.89848 25.0002 5.24708 25.0002 4.5C25.0002 3.75292 24.5906 3.10152 23.9837 2.75812Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.0002 14.5C39.5525 14.5 40.0002 14.9477 40.0002 15.5V21.5H4.00024V10.5C4.00024 9.94772 4.44796 9.5 5.00024 9.5H10.9691C11.378 9.5 11.7458 9.74895 11.8976 10.1286L12.8918 12.6142C13.3474 13.7531 14.4506 14.5 15.6773 14.5H25.0002V12.5H15.6773C15.2684 12.5 14.9007 12.251 14.7488 11.8714L13.7546 9.38583C13.299 8.24685 12.1959 7.5 10.9691 7.5H5.00024C3.34339 7.5 2.00024 8.84315 2.00024 10.5V21.6916C0.72268 22.1731 -0.122639 23.4989 0.0918251 24.9412L2.61965 41.9412C2.83827 43.4115 4.10059 44.5 5.58703 44.5H38.4132C39.8997 44.5 41.162 43.4115 41.3806 41.9412L43.9084 24.9412C44.1228 23.499 43.2776 22.1733 42.0002 21.6917V15.5C42.0002 13.8431 40.6571 12.5 39.0002 12.5H33.0002V14.5H39.0002ZM2.07007 24.6471C1.98023 24.0429 2.44835 23.5 3.0592 23.5H40.941C41.5518 23.5 42.02 24.0429 41.9301 24.6471L39.4023 41.6471C39.3295 42.1372 38.9087 42.5 38.4132 42.5H5.58703C5.09155 42.5 4.67077 42.1372 4.5979 41.6471L2.07007 24.6471Z" }),
        React__default.createElement("path", { d: "M30.0002 9.5H32.0002V11.5H30.0002V9.5Z" }),
        React__default.createElement("path", { d: "M30.0002 6.5H28.0002V8.5H30.0002V6.5Z" }),
        React__default.createElement("path", { d: "M26.0002 3.5H28.0002V5.5H26.0002V3.5Z" }),
        React__default.createElement("path", { d: "M30.0002 12.5H28.0002V14.5H30.0002V12.5Z" }),
        React__default.createElement("path", { d: "M26.0002 15.5H28.0002V17.5H26.0002V15.5Z" }),
        React__default.createElement("path", { d: "M26.0002 20.5V18.5H24.0002V20.5H26.0002Z" }));
}

function EmptyList44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "46", height: "44", viewBox: "0 0 46 44" }),
        React__default.createElement("path", { className: "noFill", d: "M42.2808 30C43.2976 27.5343 43.8584 24.8327 43.8584 22C43.8584 10.402 34.4564 1 22.8584 1C11.2604 1 1.8584 10.402 1.8584 22C1.8584 33.598 11.2604 43 22.8584 43C25.6182 43 28.2536 42.4676 30.6677 41.5", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React__default.createElement("path", { className: "noFill", d: "M7.8584 7L32.8584 32", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React__default.createElement("path", { className: "noFill", d: "M37.8584 31V43M43.8584 37H31.8584", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" }));
}

function EmptyOutbox44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "44", viewBox: "0 0 44 44" }),
        React__default.createElement("path", { className: 'noFill', d: "M23.8413 28.7159L43.0123 20.8586L35.155 40.0296L32.3266 31.5443L23.8413 28.7159Z", strokeWidth: "2", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: 'noFill', d: "M28.5 35.5L22 42", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: 'noFill', d: "M30 39L26 43", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: 'noFill', d: "M25 34L21 38", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: 'noFill', d: "M32.5 31.5C37.1863 26.8137 38.3137 25.6863 43 21", strokeWidth: "2", strokeLinejoin: "round" }),
        React__default.createElement("path", { d: "M31 0C34.866 3.86566e-07 38 3.13401 38 7V19H36V7C36 4.23858 33.7614 2 31 2H7C4.23858 2 2 4.23858 2 7V32C2 34.7614 4.23858 37 7 37H17V39H7C3.13401 39 0 35.866 0 32V7C4.50994e-07 3.13401 3.13401 9.66385e-08 7 0H31Z" }),
        React__default.createElement("circle", { cx: "21.8357", cy: "16", r: "2" }),
        React__default.createElement("circle", { cx: "15", cy: "22", r: "2" }),
        React__default.createElement("circle", { cx: "8", cy: "28", r: "2" }),
        React__default.createElement("circle", { cx: "28.8357", cy: "16", r: "2" }),
        React__default.createElement("circle", { cx: "22", cy: "22", r: "2" }),
        React__default.createElement("circle", { cx: "15", cy: "28", r: "2" }),
        React__default.createElement("path", { className: 'noFill', d: "M1 8H37", strokeWidth: "2" }));
}

function EmptySent44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "44", viewBox: "0 0 44 44" }),
        React__default.createElement("path", { className: "noFill", d: "M1 29V39C1 41.2091 2.79086 43 5 43H22M43 29V39C43 41.2091 41.2091 43 39 43H22M22 29V43M33 35V43M11 35V43", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M1 21L12.4545 11.4762L22 21L43 1", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { className: "noFill", d: "M33 1H43V11", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
}

function Stats44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "44", viewBox: "0 0 44 44" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 28.5H2V42.5H14V28.5H16V42.5H28V28.5H30V42.5H42V28.5H44V42.5V44.5H42H30H28H16H14H2H0V42.5V28.5Z" }),
        React__default.createElement("rect", { x: "34", y: "0.5", width: "4", height: "2" }),
        React__default.createElement("rect", { y: "14.5", width: "2", height: "3" }),
        React__default.createElement("rect", { y: "21.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "14", y: "21.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "28", y: "21.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "42", y: "21.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "14", y: "14.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "28", y: "14.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "42", y: "14.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "28", y: "7.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "42", y: "7.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "14", y: "7.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "28", y: "0.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "42", y: "0.5", width: "2", height: "3" }),
        React__default.createElement("rect", { x: "20", y: "7.5", width: "4", height: "2" }),
        React__default.createElement("rect", { x: "6", y: "14.5", width: "4", height: "2" }));
}

function Upload44(props) {
    return React__default.createElement(SvgIcon, __assign({}, props, { width: "44", height: "45", viewBox: "0 0 44 45" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.364 44C21.9163 44 22.364 43.5523 22.364 43L22.364 20.4142L26.0208 24.071C26.4114 24.4615 27.0444 24.4615 27.4351 24.071C27.8254 23.6805 27.8254 23.0474 27.4351 22.6569L22.071 17.2928C21.6807 16.9023 21.0474 16.9023 20.6567 17.2928L15.293 22.6569C14.9023 23.0474 14.9023 23.6805 15.293 24.071C15.6833 24.4615 16.3166 24.4615 16.707 24.071L20.364 20.4142L20.364 43C20.364 43.5523 20.8117 44 21.364 44Z" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.9455 14.1032L36.817 15.3969L37.9471 16.0396C40.3719 17.4183 42 20.0203 42 23C42 27.4183 38.4183 31 34 31H27V33H34C39.5228 33 44 28.5228 44 23C44 19.2721 41.9601 16.0207 38.9357 14.301C38.9782 13.8731 39 13.4391 39 13C39 5.8203 33.1797 0 26 0C20.9109 0 16.5048 2.92423 14.3703 7.18407C13.7656 7.06333 13.1402 7 12.5 7C7.25329 7 3 11.2533 3 16.5C3 16.986 3.03649 17.4634 3.10688 17.9297C1.20992 19.4886 0 21.853 0 24.5C0 29.0266 3.53831 32.7267 8 32.9855V33H16V31H8.30726L8.11582 30.9889C4.70574 30.7911 2 27.9608 2 24.5C2 22.4766 2.92218 20.6702 4.37669 19.4749L5.25394 18.754L5.08448 17.6312C5.02895 17.2634 5 16.8857 5 16.5C5 12.3579 8.35786 9 12.5 9C13.008 9 13.5023 9.05022 13.9788 9.14536L15.4749 9.44408L16.1584 8.08002C17.967 4.47067 21.6968 2 26 2C32.0751 2 37 6.92487 37 13C37 13.3729 36.9815 13.7409 36.9455 14.1032Z" }));
}

function Icon(_a) {
    var name = _a.name, _b = _a.actionIcon, actionIcon = _b === void 0 ? false : _b, sx = _a.sx, iconProps = __rest(_a, ["name", "actionIcon", "sx"]);
    var components = {
        Add10: Add10,
        ArrowDown10: ArrowDown10,
        ArrowUp10: ArrowUp10,
        Checkmark10: Checkmark10,
        Chevron10: Chevron10,
        Dash10: Dash10,
        Link10: Link10,
        Search10: Search10,
        Union10: Union10,
        BarChart14: BarChart14,
        Checkmark14: Checkmark14,
        Copy14: Copy14,
        Filter14: Filter14,
        Remove14: Remove14,
        X14: X14,
        Activity18: Activity18,
        Add18: Add18,
        AddTags18: AddTags18,
        AccountProfile18: AccountProfile18$1,
        Attribute18: Attribute18,
        Integrations18: Integrations18,
        Arrow18: Arrow18,
        Book18: Book18,
        Bounce18: Bounce18,
        Branded18: Branded18,
        Campaigns18: Campaigns18,
        Collapse18: Collapse18,
        Clicks18: Clicks18,
        Chevron18: AccountProfile18,
        Copy18: Copy18,
        Code18: Code18,
        Dashboard18: Dashboard18,
        Document18: Document18,
        Delete18: Delete18,
        Desktop18: Desktop18,
        Domainauthenticated18: Domainauthenticated18,
        Domainblocked18: Domainblocked18,
        Domainunauthenticated18: Domainunauthenticated18,
        Edit18: Edit18,
        Expand18: Expand18,
        Export18: Export18,
        EmailAddress18: EmailAddress18,
        Flow18: Flow18,
        Field18: Field18,
        Google18: Google18,
        Globe18: Globe18,
        Heart18: Heart18,
        Kb18: Kb18,
        Home18: Home18,
        Image18: Image18,
        Info18: Info18,
        LinkArrow18: LinkArrow18,
        LineChart18: LineChart18,
        Mobile18: Mobile18,
        Money18: Money18,
        Organization18: Organization18,
        Partner18: Partner18,
        Preview18: Preview18,
        Publish18: Publish18,
        Redirection18: Redirection18,
        Refresh18: Refresh18,
        Search18: Search18,
        Settings18: Settings18,
        Sends18: Sends18,
        Sparkle18: Sparkle18,
        Stripe18: Stripe18,
        Subscription18: Subscription18,
        Suppressed18: Suppressed18,
        Tag18: Tag18,
        Templates18: Templates18,
        TrayOpen18: TrayOpen18,
        TrayToggle18: TrayToggle18,
        X18: X18,
        User18: User18,
        UnBranded18: UnBranded18,
        ZoomReset18: ZoomReset18,
        ColorWheel20: ColorWheel20,
        Bounce24: Bounce24,
        Calendar24: Calendar24,
        Campaign24: Campaign24,
        Clicks24: Clicks24,
        Completed24: Completed24,
        Customize24: Customize24,
        Domainauthenticated24: Domainauthenticated24,
        Domainblocked24: Domainblocked24,
        Domainunauthenticated24: Domainunauthenticated24,
        Draft24: Draft24,
        Facebook24: Facebook24,
        Flag24: Flag24,
        Globe24: Globe24,
        Inbox24: Inbox24,
        Kb24: Kb24,
        Organization24: Organization24,
        Opens24: Opens24,
        Sends24: Sends24,
        SignIn24: SignIn24,
        Subscriptions24: Subscriptions24,
        Success24: Success24,
        Stats24: Stats24,
        User24: User24,
        NewSubscriber24: NewSubscriber24,
        Unsubscribes24: Unsubscribes24,
        Warning24: Warning24,
        HumanSupport32: HumanSupport32,
        NonProfits32: NonProfits32,
        Sent32: Sent32,
        Uptime32: Uptime32,
        CreateWidget44: CreateWidget44,
        EmptyABTest44: EmptyABTest44,
        EmptyFolder44: EmptyFolder,
        EmptyDraft44: EmptyDraft44,
        EmptyList44: EmptyList44,
        EmptySent44: EmptySent44,
        CreateForm44: CreateForm44,
        EmptyOutbox44: EmptyOutbox44,
        Stats44: Stats44,
        Upload44: Upload44,
    };
    var Component = components[name];
    if (!Component) {
        console.warn("Icon : " + name + ", doesn't exist.");
    }
    var fontSize = getIconSize(name);
    var csx = actionIcon ? { cursor: "pointer", "&:hover": { opacity: "0.65" } } : {};
    return React__default.createElement(React__default.Fragment, null, Component ? React__default.createElement(SvgIcon, __assign({ fontSize: fontSize, sx: __assign(__assign({}, sx), csx) }, iconProps, { component: Component })) : "");
}

var css_248z$x = ".circulatProgress-component-v2.content {\n  flex: 1;\n}\n.circulatProgress-component-v2.container {\n  position: absolute;\n}\n.circulatProgress-component-v2.page {\n  position: fixed;\n}\n.circulatProgress-component-v2.page, .circulatProgress-component-v2.container {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.circulatProgress-component-v2.content, .circulatProgress-component-v2.container, .circulatProgress-component-v2.page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}";
styleInject(css_248z$x);

function CircularProgress(_a) {
    var color = _a.color, _b = _a.location, location = _b === void 0 ? "default" : _b, props = __rest(_a, ["color", "location"]);
    return React__default.createElement(Box, { className: "circulatProgress-component-v2 ".concat(location) },
        React__default.createElement(CircularProgress$1, __assign({}, props, { color: color })));
}

function LinearProgress(_a) {
    var color = _a.color, _b = _a.size, size = _b === void 0 ? "small" : _b, props = __rest(_a, ["color", "size"]);
    var classes = classNames("linear-progress-component-v2", size);
    return React__default.createElement(LinearProgress$1, __assign({}, props, { color: color, className: classes }));
}

var css_248z$w = ".loadingContainer-component-v2.keepChildren {\n  position: relative;\n}\n.loadingContainer-component-v2.keepChildren .hiddenChildren {\n  visibility: hidden;\n}\n.loadingContainer-component-v2.keepChildren .circulatProgress-component-v2,\n.loadingContainer-component-v2.keepChildren .MuiLinearProgress-root {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}";
styleInject(css_248z$w);

function LoadingContainer(_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b, children = _a.children, _c = _a.variant, variant = _c === void 0 ? "circular" : _c, width = _a.width, _d = _a.className, className = _d === void 0 ? "" : _d, keepChildren = _a.keepChildren, // Works with contenet not in iframes
    showChildren = _a.showChildren // To use in tendem with keepChildren to show children when loading is true
    ;
    var linearStyle = width ? { height: width } : undefined;
    var loader = variant === "circular" ? React__default.createElement(CircularProgress, { thickness: width }) : React__default.createElement(LinearProgress, { sx: linearStyle });
    return React__default.createElement(React__default.Fragment, null,
        !loading &&
            children,
        loading &&
            React__default.createElement(React__default.Fragment, null,
                children &&
                    React__default.createElement(Container, { className: "loadingContainer-component-v2 ".concat(keepChildren ? "keepChildren" : "", " ").concat(className), sx: { display: "flex", alignItems: "center", justifyContent: "center", height: "inherit", width: "100%", flex: 1 } },
                        keepChildren && React__default.createElement(Box, { className: showChildren ? "showChildren loading" : "hiddenChildren" },
                            " ",
                            children),
                        loader),
                !children &&
                    React__default.createElement(Container, { className: "loadingContainer-component-v2 ".concat(className), sx: { display: "flex", alignItems: "center", justifyContent: "center", width: "100%" } }, loader)));
}

var css_248z$v = ".textfield-component-v2 {\n  position: relative;\n}\n.textfield-component-v2.disabled {\n  opacity: 0.65;\n  pointer-events: none;\n}\n.textfield-component-v2 .MuiSvgIcon-root ~ .MuiFormControl-root .MuiInputBase-input {\n  padding-left: 42px;\n}\n.textfield-component-v2 .MuiSvgIcon-root {\n  position: absolute;\n  left: 1rem;\n  top: 1.65rem;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.locationTextField-component-v2 {\n  position: relative;\n}\n.locationTextField-component-v2 .autocomplete-dropdown-container {\n  position: absolute;\n  width: 100%;\n  z-index: 10000;\n}\n\n.phoneTextField-component-v2 .MuiInputAdornment-root .MuiSelect-select {\n  padding-right: 1.75rem !important;\n}\n.phoneTextField-component-v2 .MuiInputAdornment-root .MuiSelect-icon {\n  display: inline-block;\n  right: 0.5rem;\n}\n\n.react-international-phone-flag-emoji {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.colorTextField-component-v2 {\n  position: relative;\n}\n.colorTextField-component-v2 .boxedColor {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  left: 1rem;\n  top: 1.65rem;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n.colorTextField-component-v2 .boxedColor .MuiSvgIcon-root {\n  width: unset;\n  height: unset;\n}\n.colorTextField-component-v2 .boxedColor::after {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  content: \"\";\n  background-color: var(--white, #FFFFFF);\n  border-radius: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.colorTextField-component-v2 .boxedColor ~ .textfield-component-v2 .MuiInputBase-input {\n  padding-left: 44px;\n}\n.colorTextField-component-v2.bottom .react-colorful {\n  top: 3.5rem;\n}\n.colorTextField-component-v2.top .react-colorful {\n  bottom: 4rem;\n}\n.colorTextField-component-v2 .react-colorful {\n  width: 100%;\n  position: absolute;\n}";
styleInject(css_248z$v);

var TextField = forwardRef(function (_a, ref) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, label = _a.label, timeout = _a.timeout, labelTooltipText = _a.labelTooltipText, disabled = _a.disabled; _a.useBareBoneInput; var onChange = _a.onChange, multiline = _a.multiline, inputProps = _a.inputProps, iconName = _a.iconName, onKeyDown = _a.onKeyDown, props = __rest(_a, ["className", "label", "timeout", "labelTooltipText", "disabled", "useBareBoneInput", "onChange", "multiline", "inputProps", "iconName", "onKeyDown"]);
    var cLabel = label;
    var timeoutRef = useRef(undefined);
    function onChangeHandler(e) {
        // Convert value to proper type based on input type
        var convertedValue = e.target.value;
        if (props.type === 'number' && e.target.value !== '') {
            var numValue = Number(e.target.value);
            if (!isNaN(numValue)) {
                convertedValue = numValue;
            }
        }
        var modifiedEvent = __assign(__assign({}, e), { target: {
                name: props.name,
                value: convertedValue
            }, currentTarget: {
                name: props.name,
                value: convertedValue
            } });
        onChange && onChange(modifiedEvent);
        if (timeout) {
            var callback_1 = timeout.callback ? timeout.callback : function () { };
            var time = timeout.time ? timeout.time : 800;
            clearInterval(timeoutRef.current);
            timeoutRef.current = setTimeout(function () {
                callback_1(modifiedEvent);
            }, time);
        }
    }
    if (cLabel && labelTooltipText) {
        cLabel = React__default.createElement(Tooltip, { arrow: true, placement: "top", title: labelTooltipText },
            React__default.createElement("div", null,
                cLabel,
                " ",
                React__default.createElement(Icon, { name: "Info18" })));
    }
    function handleKeyDown(event) {
        if (event.key === 'Escape') {
            //@ts-ignore
            onChange && onChange({
                target: { value: "", name: props.name },
                currentTarget: { value: "", name: props.name }
            });
        }
        onKeyDown && onKeyDown(event);
    }
    inputProps = __assign({ maxLength: 256 }, inputProps);
    return React__default.createElement(Box$1, { className: "textfield-component-v2 ".concat(className, " ").concat(disabled ? "disabled" : "", " ") },
        iconName && React__default.createElement(Icon, { name: iconName }),
        React__default.createElement(MUITextField, __assign({}, props, { inputProps: inputProps, onChange: onChangeHandler, label: cLabel, disabled: disabled, onKeyDown: handleKeyDown, multiline: multiline, inputRef: ref })));
});

var css_248z$u = ".assetmanager-component-v2 {\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n  background: var(--background-color-1, var(--white, #FFFFFF));\n  min-width: 25rem;\n  width: 100%;\n}\n.assetmanager-component-v2 .loadingContainer-component-v2 {\n  padding: 3rem;\n}\n.assetmanager-component-v2 .container {\n  padding: 0.75rem;\n}\n.assetmanager-component-v2 .container > div.textInputContainer {\n  display: flex;\n  border: solid 1px var(--wild-sand, #dddddd);\n  border-radius: 6px;\n  justify-content: flex-start;\n  align-items: center;\n}\n.assetmanager-component-v2 .container > div.textInputContainer > div .MuiSvgIcon-root {\n  display: block;\n  cursor: pointer;\n}\n.assetmanager-component-v2 .container > div.textInputContainer > div:first-child {\n  padding: 0 0.75rem 0 0.75rem;\n  height: 100%;\n}\n.assetmanager-component-v2 .container > div.textInputContainer > div:last-child:not(.textfield-component-v2) {\n  padding: 0 0.875rem;\n  height: 100%;\n}\n.assetmanager-component-v2 .container > div.textInputContainer .textfield-component-v2 {\n  width: 100%;\n}\n.assetmanager-component-v2 .container > div.textInputContainer .textfield-component-v2 fieldset {\n  outline: none !important;\n  border: none !important;\n}\n.assetmanager-component-v2 .container > div.textInputContainer .textfield-component-v2 input {\n  padding: 0.5rem 0 !important;\n}\n.assetmanager-component-v2 .container .optionsListingContainer {\n  padding: 0 1.25rem 0.5rem 1.25rem;\n  margin: 1.25rem 0 0.5rem 0;\n  max-height: 20rem;\n  overflow-y: auto;\n}\n.assetmanager-component-v2 .container .optionsListingContainer button {\n  text-transform: capitalize;\n}\n.assetmanager-component-v2 .container .optionsListingContainer::-webkit-scrollbar {\n  display: block;\n}\n.assetmanager-component-v2 .container .optionsListingContainer::-webkit-scrollbar-track:horizontal {\n  position: absolute;\n  bottom: -20px;\n}\n.assetmanager-component-v2 .container .optionsListingContainer::-webkit-scrollbar-track:vertical {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n.assetmanager-component-v2 .container .optionsListingContainer::-webkit-scrollbar-track {\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 2rem;\n  background-clip: content-box;\n  border-bottom-left-radius: 8px;\n}\n.assetmanager-component-v2 .container .optionsListingContainer::-webkit-scrollbar-thumb {\n  background: var(--body-font-color-2, var(--silver, #9B9B9B));\n  border-radius: 24px;\n  border-top: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-bottom: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-right: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-left: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n}\n.assetmanager-component-v2 .container .optionsListingContainer > div:first-child:not(.listItem) {\n  padding-bottom: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}\n.assetmanager-component-v2 .container .optionsListingContainer > p.h8 {\n  margin-bottom: 1rem;\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}\n.assetmanager-component-v2 .container .optionsListingContainer p.h8 {\n  flex: 1;\n  font-family: proxima-nova, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Geneva, Verdana, sans-serif;\n  text-transform: uppercase;\n  font-weight: 700;\n  line-height: 1rem;\n  font-size: 0.75rem;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 2rem;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem p.h8 {\n  color: var(--body-font-color-2, var(--silver, #9B9B9B));\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem > .MuiSvgIcon-root {\n  margin-right: 1rem;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem.selected p.h8 {\n  color: var(--secondary-brand-color, var(--teal, #0ABDAE));\n  padding-right: 1rem;\n  max-width: 100%;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem.selected .MuiSvgIcon-root span svg path {\n  fill: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem .buttonContainer {\n  margin-left: 1rem;\n  visibility: hidden;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem .buttonContainer button:nth-child(2) {\n  margin-left: 0.5rem;\n}\n.assetmanager-component-v2 .container .optionsListingContainer .listItem:hover .buttonContainer {\n  visibility: visible;\n}\n.assetmanager-component-v2 > button:last-child {\n  width: 100%;\n  text-transform: uppercase;\n  font-family: proxima-nova, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Geneva, Verdana, sans-serif;\n  height: 3rem;\n  border-top: 1px solid var(--wild-sand, #dddddd) !important;\n  outline: none;\n  border-radius: 0;\n  font-weight: 700;\n}";
styleInject(css_248z$u);

var EAssetManagerMatchType;
(function (EAssetManagerMatchType) {
    EAssetManagerMatchType["full"] = "full";
    EAssetManagerMatchType["partial"] = "partial";
})(EAssetManagerMatchType || (EAssetManagerMatchType = {}));

function AssetManager(_a) {
    var className = _a.className, options = _a.options, textFieldProps = _a.textFieldProps, manageBtn = _a.manageBtn, listMainBtn = _a.listMainBtn, listSecondaryBtn = _a.listSecondaryBtn, createBtnProps = _a.createBtnProps, clearSelection = _a.clearSelection, noAssetTitle = _a.noAssetTitle, chooseAssetTitle = _a.chooseAssetTitle;
    useEffect(function () {
        document.addEventListener("keydown", onKeyDown, false);
        return function () {
            document.removeEventListener("keydown", onKeyDown, false);
        };
    }, []);
    function onKeyDown(e) {
        if (e.key === 'Enter') {
            var btn = document.querySelector(".assetmanager-component-v2 .createAssetBtn");
            if (btn) {
                btn.click();
            }
        }
        else if (e.key === 'Escape' && clearSelection) {
            clearSelection();
        }
    }
    function renderListItem(option) {
        var mainBtn = listMainBtn ? React__default.createElement(Button, { color: "secondary", size: "small", variant: "outlined", onClick: function (event, btnRef) { listMainBtn.onClick(event, btnRef, option); }, animated: true }, listMainBtn.text) : "";
        var secondaryBtn = listSecondaryBtn ? React__default.createElement(Button, { color: "silver", size: "small", variant: "outlined", onClick: function (event, btnRef) { listSecondaryBtn.onClick(event, btnRef, option); }, animated: true }, listSecondaryBtn.text) : "";
        var isFullMatch = option.matchType === EAssetManagerMatchType.full;
        var isPartialMatch = option.matchType === EAssetManagerMatchType.partial;
        var isNew = option.new === true;
        var noMatch = !option.matchType && !option.new;
        return (React__default.createElement("div", { className: " listItem ".concat(isFullMatch || isPartialMatch || isNew ? "selected" : ""), key: option.value },
            isFullMatch && React__default.createElement(Icon, { name: "Checkmark10", color: "secondary" }),
            isPartialMatch && React__default.createElement(Icon, { name: "Dash10", color: "secondary" }),
            React__default.createElement("p", { className: "h8" },
                " ",
                option.new ? "\"".concat(option.text, "\"") : option.text,
                " "),
            (option.new && createBtnProps) ?
                React__default.createElement(Button, { color: "secondary", size: "small", variant: "outlined", onClick: function (event, button) { createBtnProps === null || createBtnProps === void 0 ? void 0 : createBtnProps.onClick(event, button, option); }, animated: true, className: "createAssetBtn" }, createBtnProps.text)
                :
                    React__default.createElement("div", { className: "buttonContainer" },
                        isFullMatch && secondaryBtn,
                        isPartialMatch && React__default.createElement(React__default.Fragment, null,
                            mainBtn,
                            secondaryBtn),
                        noMatch && mainBtn)));
    }
    function sortArray(a, b) {
        return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
    }
    var fullMatchOptions = (options === null || options === void 0 ? void 0 : options.filter(function (opt) { return opt.matchType === EAssetManagerMatchType.full; })) || [];
    fullMatchOptions.sort(sortArray);
    var partialMatchOptions = (options === null || options === void 0 ? void 0 : options.filter(function (opt) { return opt.matchType === EAssetManagerMatchType.partial; })) || [];
    partialMatchOptions.sort(sortArray);
    var noMatch = (options === null || options === void 0 ? void 0 : options.filter(function (opt) { return !opt.matchType; })) || [];
    noMatch.sort(sortArray);
    var showCreateOption = !(options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value === (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.value) || ""; }));
    var mainClasses = classNames("assetmanager-component-v2", className, {});
    return React__default.createElement(Box$1, { className: mainClasses },
        React__default.createElement(Box$1, { className: "container" },
            textFieldProps &&
                React__default.createElement("div", { className: "textInputContainer" },
                    React__default.createElement("div", null,
                        React__default.createElement(Icon, { name: "Tag18", color: "body1" })),
                    React__default.createElement(TextField, { placeholder: textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.placeholder, value: textFieldProps.value, onChange: function (e) { return textFieldProps.onChange(e); }, timeout: textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.timeout }),
                    ((textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.value) && clearSelection) &&
                        React__default.createElement("div", null,
                            React__default.createElement(Icon, { color: "body1", name: "X18", onClick: function (e) {
                                    e.stopPropagation();
                                    clearSelection();
                                } }))),
            React__default.createElement(LoadingContainer, { loading: !options }, options &&
                React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Stack$1, { className: "optionsListingContainer" },
                        showCreateOption && !(textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.value) && options.length === 0 ?
                            React__default.createElement(React__default.Fragment, null, noAssetTitle && React__default.createElement(Typography$1, { variant: "body1", className: "title bold" }, noAssetTitle))
                            :
                                React__default.createElement(React__default.Fragment, null, chooseAssetTitle && React__default.createElement(Typography$1, { variant: "body1", className: "title bold" }, chooseAssetTitle)),
                        (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.value) && showCreateOption && renderListItem({
                            value: textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.value,
                            text: textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.value,
                            new: true
                        }),
                        fullMatchOptions.map(function (option) {
                            return renderListItem(option);
                        }),
                        partialMatchOptions.map(function (option) {
                            return renderListItem(option);
                        }),
                        noMatch.map(function (option) {
                            return renderListItem(option);
                        }))))),
        manageBtn && React__default.createElement(Button, { color: "secondary", variant: 'outlined', onClick: manageBtn.onClick }, manageBtn.text));
}

function getUrlQueryParam(name) {
    return (new URLSearchParams(window.location.search).get(name) ||
        new URLSearchParams(getHashQueryWithoutHistory()).get(name) ||
        null);
}
function getHashQueryWithoutHistory(returnObj) {
    var _a, _b;
    if (returnObj === void 0) { returnObj = false; }
    var reactHistory = {};
    var manualQueryParam = null;
    if (returnObj) {
        manualQueryParam = (_b = (_a = window.location.hash.split("?")) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split("&");
        if ((manualQueryParam === null || manualQueryParam === void 0 ? void 0 : manualQueryParam.length) > 0) {
            manualQueryParam.forEach(function (param) {
                var queryParam = param.split("=");
                reactHistory[queryParam === null || queryParam === void 0 ? void 0 : queryParam[0]] = queryParam === null || queryParam === void 0 ? void 0 : queryParam[1];
            });
        }
        return reactHistory;
    }
    return "?" + window.location.hash.split("?")[1];
}
function updateAndClearUrlParams(params) {
    var searchParams = new URLSearchParams(window.location.search);
    params.forEach(function (param) {
        searchParams.delete(param);
    });
    var newUrl = "".concat(window.location.pathname, "?").concat(searchParams.toString()).concat(window.location.hash);
    window.history.replaceState(null, '', newUrl);
}
function fetchRoute(_a) {
    var route = _a.route, routes = _a.routes, params = _a.params, externalRoute = _a.externalRoute;
    if (routes && !Object.keys(routes).includes(route)) {
        console.error("Route : ".concat(route, " doesn't exist"));
        return "";
    }
    var r = replaceParams(route, params);
    return externalRoute ? "/#" + r : r;
}
function replaceParams(route, params) {
    if (!params)
        return route;
    Object.keys(params).forEach(function (param, index) {
        if (!params[param]) {
            console.error("Route param : ".concat(param, ", doesn't exist on route : ").concat(route, " "));
        }
        else {
            //route = route.replace(new RegExp(`:${param}\\((.)+?\\)`), params[param])
            route = route.replace(new RegExp(":".concat(param)), params[param]);
        }
    });
    return route;
}
function removeQueryParams(url) {
    var urlWithoutQuery = url.split('?')[0];
    return urlWithoutQuery;
}
function removeTrailingChar(url, char) {
    if (url.endsWith(char)) {
        return url.slice(0, -1);
    }
    return url;
}
function getUtmCookies() {
    var cookies = new Cookies();
    return {
        utm_campaign: cookies.get("utm_campaign"),
        utm_medium: cookies.get("utm_medium"),
        utm_source: cookies.get("utm_source"),
        utm_content: cookies.get("utm_content"),
    };
}
// @ts-ignore
function MD5(s) { function L(k, d) { return (k << d) | (k >>> (32 - d)); } function K(G, k) { var I, d, F, H, x; F = (G & 2147483648); H = (k & 2147483648); I = (G & 1073741824); d = (k & 1073741824); x = (G & 1073741823) + (k & 1073741823); if (I & d) {
    return (x ^ 2147483648 ^ F ^ H);
} if (I | d) {
    if (x & 1073741824) {
        return (x ^ 3221225472 ^ F ^ H);
    }
    else {
        return (x ^ 1073741824 ^ F ^ H);
    }
}
else {
    return (x ^ F ^ H);
} } function r(d, F, k) { return (d & F) | ((~d) & k); } function q(d, F, k) { return (d & k) | (F & (~k)); } function p(d, F, k) { return (d ^ F ^ k); } function n(d, F, k) { return (F ^ (d | (~k))); } function u(G, F, aa, Z, k, H, I) { G = K(G, K(K(r(F, aa, Z), k), I)); return K(L(G, H), F); } function f(G, F, aa, Z, k, H, I) { G = K(G, K(K(q(F, aa, Z), k), I)); return K(L(G, H), F); } function D(G, F, aa, Z, k, H, I) { G = K(G, K(K(p(F, aa, Z), k), I)); return K(L(G, H), F); } function t(G, F, aa, Z, k, H, I) { G = K(G, K(K(n(F, aa, Z), k), I)); return K(L(G, H), F); } function e(G) { var Z; var F = G.length; var x = F + 8; var k = (x - (x % 64)) / 64; var I = (k + 1) * 16; var aa = Array(I - 1); var d = 0; var H = 0; while (H < F) {
    Z = (H - (H % 4)) / 4;
    d = (H % 4) * 8;
    aa[Z] = (aa[Z] | (G.charCodeAt(H) << d));
    H++;
} Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = aa[Z] | (128 << d); aa[I - 2] = F << 3; aa[I - 1] = F >>> 29; return aa; } function B(x) { var k = "", F = "", G, d; for (d = 0; d <= 3; d++) {
    G = (x >>> (d * 8)) & 255;
    F = "0" + G.toString(16);
    k = k + F.substr(F.length - 2, 2);
} return k; } function J(k) { k = k.replace(/rn/g, "n"); var d = ""; for (var F = 0; F < k.length; F++) {
    var x = k.charCodeAt(F);
    if (x < 128) {
        d += String.fromCharCode(x);
    }
    else {
        if ((x > 127) && (x < 2048)) {
            d += String.fromCharCode((x >> 6) | 192);
            d += String.fromCharCode((x & 63) | 128);
        }
        else {
            d += String.fromCharCode((x >> 12) | 224);
            d += String.fromCharCode(((x >> 6) & 63) | 128);
            d += String.fromCharCode((x & 63) | 128);
        }
    }
} return d; } var C = Array(); var P, h, E, v, g, Y, X, W, V; var S = 7, Q = 12, N = 17, M = 22; var A = 5, z = 9, y = 14, w = 20; var o = 4, m = 11, l = 16, j = 23; var U = 6, T = 10, R = 15, O = 21; s = J(s); C = e(s); Y = 1732584193; X = 4023233417; W = 2562383102; V = 271733878; for (P = 0; P < C.length; P += 16) {
    h = Y;
    E = X;
    v = W;
    g = V;
    Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
    V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
    W = u(W, V, Y, X, C[P + 2], N, 606105819);
    X = u(X, W, V, Y, C[P + 3], M, 3250441966);
    Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
    V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
    W = u(W, V, Y, X, C[P + 6], N, 2821735955);
    X = u(X, W, V, Y, C[P + 7], M, 4249261313);
    Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
    V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
    W = u(W, V, Y, X, C[P + 10], N, 4294925233);
    X = u(X, W, V, Y, C[P + 11], M, 2304563134);
    Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
    V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
    W = u(W, V, Y, X, C[P + 14], N, 2792965006);
    X = u(X, W, V, Y, C[P + 15], M, 1236535329);
    Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
    V = f(V, Y, X, W, C[P + 6], z, 3225465664);
    W = f(W, V, Y, X, C[P + 11], y, 643717713);
    X = f(X, W, V, Y, C[P + 0], w, 3921069994);
    Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
    V = f(V, Y, X, W, C[P + 10], z, 38016083);
    W = f(W, V, Y, X, C[P + 15], y, 3634488961);
    X = f(X, W, V, Y, C[P + 4], w, 3889429448);
    Y = f(Y, X, W, V, C[P + 9], A, 568446438);
    V = f(V, Y, X, W, C[P + 14], z, 3275163606);
    W = f(W, V, Y, X, C[P + 3], y, 4107603335);
    X = f(X, W, V, Y, C[P + 8], w, 1163531501);
    Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
    V = f(V, Y, X, W, C[P + 2], z, 4243563512);
    W = f(W, V, Y, X, C[P + 7], y, 1735328473);
    X = f(X, W, V, Y, C[P + 12], w, 2368359562);
    Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
    V = D(V, Y, X, W, C[P + 8], m, 2272392833);
    W = D(W, V, Y, X, C[P + 11], l, 1839030562);
    X = D(X, W, V, Y, C[P + 14], j, 4259657740);
    Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
    V = D(V, Y, X, W, C[P + 4], m, 1272893353);
    W = D(W, V, Y, X, C[P + 7], l, 4139469664);
    X = D(X, W, V, Y, C[P + 10], j, 3200236656);
    Y = D(Y, X, W, V, C[P + 13], o, 681279174);
    V = D(V, Y, X, W, C[P + 0], m, 3936430074);
    W = D(W, V, Y, X, C[P + 3], l, 3572445317);
    X = D(X, W, V, Y, C[P + 6], j, 76029189);
    Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
    V = D(V, Y, X, W, C[P + 12], m, 3873151461);
    W = D(W, V, Y, X, C[P + 15], l, 530742520);
    X = D(X, W, V, Y, C[P + 2], j, 3299628645);
    Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
    V = t(V, Y, X, W, C[P + 7], T, 1126891415);
    W = t(W, V, Y, X, C[P + 14], R, 2878612391);
    X = t(X, W, V, Y, C[P + 5], O, 4237533241);
    Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
    V = t(V, Y, X, W, C[P + 3], T, 2399980690);
    W = t(W, V, Y, X, C[P + 10], R, 4293915773);
    X = t(X, W, V, Y, C[P + 1], O, 2240044497);
    Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
    V = t(V, Y, X, W, C[P + 15], T, 4264355552);
    W = t(W, V, Y, X, C[P + 6], R, 2734768916);
    X = t(X, W, V, Y, C[P + 13], O, 1309151649);
    Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
    V = t(V, Y, X, W, C[P + 11], T, 3174756917);
    W = t(W, V, Y, X, C[P + 2], R, 718787259);
    X = t(X, W, V, Y, C[P + 9], O, 3951481745);
    Y = K(Y, h);
    X = K(X, E);
    W = K(W, v);
    V = K(V, g);
} var i = B(Y) + B(X) + B(W) + B(V); return i.toLowerCase(); }

function Avatar(_a) {
    var _b = _a.sizes, sizes = _b === void 0 ? 32 : _b, _c = _a.variant, variant = _c === void 0 ? "rounded" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.email, email = _e === void 0 ? "" : _e, _f = _a.firstName, firstName = _f === void 0 ? "" : _f, _g = _a.lastName, lastName = _g === void 0 ? "" : _g, _h = _a.showBadge, showBadge = _h === void 0 ? false : _h, _j = _a.badgeOrigin, badgeOrigin = _j === void 0 ? {
        horizontal: 'right',
        vertical: 'bottom'
    } : _j, _k = _a.badgeColor, badgeColor = _k === void 0 ? "secondary" : _k, _l = _a.sx, sx = _l === void 0 ? {} : _l;
    firstName = firstName ? firstName : "";
    lastName = lastName ? lastName : "";
    return React__default.createElement(Badge, { overlap: "circular", anchorOrigin: badgeOrigin, color: badgeColor, className: "avatar-component-v2 " + className, variant: showBadge ? "dot" : undefined, sx: sx },
        React__default.createElement(Avatar$1, { variant: variant, sx: {
                width: sizes,
                height: sizes
            }, alt: firstName + " " + lastName, src: email ? "https://www.gravatar.com/avatar/" + MD5(email) + ".jpg?s=" + sizes + "&d=404" : "" }, firstName[0] ? firstName[0] : "" + " " + lastName[0] ? lastName[0] : ""));
}

var whiteLabelBrand = {
    client_config: {
        brand_repo: {
            url: "",
            accountId: "",
            brandId: ""
        },
        support: {
            email: "",
            phone: ""
        },
        segment_config: {
            disabled_event: [],
            enabled: false,
            id: "",
            server: ""
        },
        zendesk_config: {
            enabled: false,
            return_to: ""
        }
    },
    page_customization: {
        sign_in: {
            sign_up_link_disabled: false,
            sign_up_link_redirection: ""
        },
        sign_up: {
            disabled: false,
            sign_in_link_disabled: false,
            sign_in_link_redirection: ""
        }
    },
    images: {
        "ill-empty-automations": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-automations.png",
        "ill-empty-ab-test-drafts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-ab-test-drafts.png",
        "ill-empty-ab-test-outbox": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-ab-test-outbox.png",
        "ill-empty-ab-test-complete": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-ab-test-complete.png",
        favicon: "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-empty-forms": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-forms.png",
        "ill-empty-campaigns-drafts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-drafts.png",
        "favicon-mstile": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-add-contacts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-add-contacts.png",
        "favicon-32": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "favicon-android-chrome-512": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-create-email": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-create-email.png",
        "ill-empty-campaigns-outbox": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-outbox.png",
        "ill-empty-contacts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-contacts.png",
        "favicon-16": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        logo: "https://app-brand-assets.s3.amazonaws.com/default/default-logo.svg",
        injected_logo: "https://app-brand-assets.s3.amazonaws.com/default/default-logo.svg",
        "favicon-android-chrome-192": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-empty-campaigns-sent": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-sent.png",
        "favicon-apple-touch": "https://app-brand-assets.s3.amazonaws.com/cakemail/favicon/apple-touch-icon.png",
        "ill-empty-campaigns-templates": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-templates.png",
        "ill-empty-listing": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-listing.png",
        "ill-workflow": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-workflow.png"
    },
    theme: {
        base: {
            "background-color-2": "#F8F8F8",
            "body-font-color": "#444444",
            "error-brand-color": "#FF1E61",
            "primary-brand-color-darken": "#444444",
            "error-brand-color-darken": "#FD2E61",
            "heading-font": "aller, Lucida Grande,Lucida Sans Unicode,Lucida Sans,Geneva,Verdana,sans-serif",
            "primary-brand-color": "#000000",
            "secondary-brand-color-darken": "#1866CC",
            "text-font": "proxima-nova, Lucida Grande,Lucida Sans Unicode,Lucida Sans,Geneva,Verdana,sans-serif",
            "body-font-color-2": "#888888",
            "warning-brand-color": "#FF971E",
            "success-brand-color": "#09D266",
            "secondary-brand-color": "#1E7FFF",
            "background-color-1": "#FFFFFF"
        },
        advance: {
            Spinner: {
                "spinner-stroke-outer": "#1E7FFF"
            }
        }
    },
    url: {
        privacy_url: {
            en: ""
        },
        email_designer_help: {
            en: ""
        },
        schedule_help_url: {
            en: ""
        },
        anti_spam_url: {
            en: ""
        },
        protect_account_kb_url: {
            en: ""
        },
        unusubcribe_mergetag_kb_url: {
            en: ""
        },
        kb_boost_1: {
            en: ""
        },
        kb_boost_segment: {
            en: ""
        },
        kb_choose_sender_email: {
            en: ""
        },
        terms_url: {
            en: ""
        },
        address_mergetag_kb_url: {
            en: ""
        },
        help_url: {
            en: ""
        }
    },
    list_redirection: {
        logo: {
            id: null,
            width: null,
            type: ""
        },
        styles: {
            "title-color": "#444444",
            "text-color": "#444444",
            "background-color": "#F8F8F8",
            "background-ele-color": "#ffffff"
        }
    },
    name: "",
    config: {}
};

var ActionBarContainerHandler = {
    actionBarContainer: undefined,
    register: function (actionBarContainer) {
        this.actionBarContainer = actionBarContainer;
    },
    unregister: function () {
        if (ActionBarContainerHandler.actionBarContainer) {
            ActionBarContainerHandler.actionBarContainer = undefined;
        }
    },
    isShowing: function () {
        if (ActionBarContainerHandler.actionBarContainer) {
            return ActionBarContainerHandler.actionBarContainer.isShowing();
        }
        return false;
    },
    show: function (newState) {
        setTimeout(function () {
            newState.className = newState.className + " fromActionBarContainerHandler";
            if (!ActionBarContainerHandler.actionBarContainer) {
                return;
            }
            ActionBarContainerHandler.actionBarContainer.show(newState);
        }, 0);
    },
    hide: function () {
        setTimeout(function () {
            if (!ActionBarContainerHandler.actionBarContainer) {
                return;
            }
            ActionBarContainerHandler.actionBarContainer.hide();
        }, 0);
    }
};

var DialogHandler = {
    queuedDialog: [],
    dialog: undefined,
    register: function (dialog) {
        this.dialog = dialog;
    },
    unregister: function () {
        if (DialogHandler.dialog) {
            DialogHandler.dialog = undefined;
        }
    },
    isShowing: function () {
        if (DialogHandler.dialog) {
            return DialogHandler.dialog.isShowing();
        }
        return false;
    },
    queued: function () {
        return DialogHandler.queuedDialog.length;
    },
    clearQueue: function () {
        DialogHandler.queuedDialog = [];
    },
    show: function (newState, skipCheck) {
        if (newState === void 0) { newState = {}; }
        if (skipCheck === void 0) { skipCheck = false; }
        setTimeout(function () {
            newState.className = newState.className + " fromDialogHandler";
            if (!DialogHandler.dialog) {
                return;
            }
            if (!skipCheck && DialogHandler.isShowing()) {
                if (newState.hasOwnProperty("isExpress") && newState.isExpress) {
                    DialogHandler.dialog.show(newState);
                }
                else if (newState.hasOwnProperty("isPriority") && newState.isPriority) {
                    DialogHandler.queuedDialog.unshift(newState);
                }
                else {
                    DialogHandler.queuedDialog.push(newState);
                }
            }
            else {
                DialogHandler.dialog.show(newState);
            }
        }, 0);
    },
    hide: function () {
        setTimeout(function () {
            if (!DialogHandler.dialog) {
                return;
            }
            DialogHandler.dialog.hide();
            if (DialogHandler.queuedDialog.length > 0) {
                DialogHandler.show(DialogHandler.queuedDialog[0], true);
                DialogHandler.queuedDialog.shift();
            }
        }, 0);
    }
};

var DrawerHandler = {
    drawer: undefined,
    register: function (drawer) {
        this.drawer = drawer;
    },
    unregister: function () {
        if (DrawerHandler.drawer) {
            DrawerHandler.drawer = undefined;
        }
    },
    isShowing: function () {
        if (DrawerHandler.drawer) {
            return DrawerHandler.drawer.isShowing();
        }
        return false;
    },
    show: function (newState) {
        if (!DrawerHandler.drawer) {
            return;
        }
        DrawerHandler.drawer.show(newState);
    },
    hide: function () {
        if (!DrawerHandler.drawer) {
            return;
        }
        DrawerHandler.drawer.hide();
    }
};

var ModalHandler = {
    modal: undefined,
    register: function (modal) {
        this.modal = modal;
    },
    unregister: function () {
        if (ModalHandler.modal) {
            ModalHandler.modal = undefined;
        }
    },
    isShowing: function () {
        if (ModalHandler.modal) {
            return ModalHandler.modal.isShowing();
        }
        return false;
    },
    show: function (newState) {
        if (!ModalHandler.modal) {
            return;
        }
        ModalHandler.modal.show(newState);
    },
    hide: function () {
        if (!ModalHandler.modal) {
            return;
        }
        ModalHandler.modal.hide();
    }
};

var OverlayHandler = {
    overlay: undefined,
    register: function (modal) {
        this.overlay = modal;
    },
    unregister: function () {
        if (OverlayHandler.overlay) {
            OverlayHandler.overlay = undefined;
        }
    },
    isShowing: function () {
        if (OverlayHandler.overlay) {
            return OverlayHandler.overlay.isShowing();
        }
        return false;
    },
    show: function (newState) {
        if (!OverlayHandler.overlay) {
            return;
        }
        OverlayHandler.overlay.show(newState);
    },
    hide: function () {
        if (!OverlayHandler.overlay) {
            return;
        }
        OverlayHandler.overlay.hide();
    }
};

var uiKitConfig = {
    GATEWAY_PROXY: window.location.origin + "/api",
    ERROR_HANDLER: undefined,
    SUPPORTED_LANGUAGES: [
        "en-US",
        "fr-CA",
        "nl-NL",
        "es-ES",
        "pt-BR",
        "es-US",
        "fi",
        "sv",
        "it",
    ]
};

var EPartialInfoPool;
(function (EPartialInfoPool) {
    EPartialInfoPool["partialSenders"] = "partialSenders";
    EPartialInfoPool["partialTemplates"] = "partialTemplates";
    EPartialInfoPool["partialEmailActivity"] = "partialEmailActivity";
    EPartialInfoPool["partialAccountReport"] = "partialAccountReport";
    EPartialInfoPool["partialAutomationReport"] = "partialAutomationReport";
    EPartialInfoPool["partialUsers"] = "partialUsers";
    EPartialInfoPool["partialLists"] = "partialLists";
    EPartialInfoPool["partialListReports"] = "partialListReports";
    EPartialInfoPool["partialCampaignReports"] = "partialCampaignReports";
})(EPartialInfoPool || (EPartialInfoPool = {}));

// Storage
var EStorageType;
(function (EStorageType) {
    EStorageType["local"] = "local";
    EStorageType["session"] = "session";
})(EStorageType || (EStorageType = {}));

function wait(delay) {
    return new Promise(function (resolve) { return setTimeout(resolve, delay); });
}
//TODO partial success
function fetchRetry(_a) {
    var url = _a.url, _b = _a.delay, delay = _b === void 0 ? 500 : _b, _c = _a.tries, tries = _c === void 0 ? 2 : _c, _d = _a.fetchOptions, fetchOptions = _d === void 0 ? {} : _d;
    var triesLeft = tries - 1;
    function onError(err) {
        if (!triesLeft || (err === null || err === void 0 ? void 0 : err.skipRetry)) {
            if (err.response) {
                throw err;
            }
            throw { response: err, body: {} };
        }
        return wait(delay).then(function () { return fetchRetry({ url: url, delay: delay, tries: triesLeft, fetchOptions: fetchOptions }); });
    }
    return fetch(url, fetchOptions).then(function (response) {
        var _a, _b;
        var responseData;
        if ((_b = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type")) === null || _b === void 0 ? void 0 : _b.includes("application/json")) {
            responseData = response.json();
        }
        else {
            responseData = response.text();
        }
        if (response != null && response.status >= 200 && response.status < 400) {
            return responseData;
        }
        else {
            return responseData.then(function (res) {
                throw { response: response, body: res, skipRetry: true };
            });
        }
    }).catch(function (e) {
        onError(e);
    });
}

function getStorage(_a) {
    var key = _a.key, _b = _a.type, type = _b === void 0 ? EStorageType.local : _b;
    try {
        var item = null;
        if (type === EStorageType.local) {
            item = window.localStorage.getItem(key);
        }
        else {
            item = window.sessionStorage.getItem(key);
        }
        if (item) {
            return JSON.parse(item);
        }
        return null;
    }
    catch (e) {
        console.warn(e);
        return null;
    }
}
function setStorage(_a) {
    var key = _a.key, data = _a.data, _b = _a.type, type = _b === void 0 ? EStorageType.local : _b;
    try {
        if (type === EStorageType.local) {
            window.localStorage.setItem(key, JSON.stringify(data));
        }
        else {
            window.sessionStorage.setItem(key, JSON.stringify(data));
        }
    }
    catch (e) {
        console.warn(e);
    }
}
function clearStorage(type) {
    if (type === void 0) { type = EStorageType.local; }
    if (type === EStorageType.local)
        window.localStorage.clear();
    else
        window.localStorage.clear();
}
function deleteStorageItem(_a) {
    var key = _a.key, _b = _a.type, type = _b === void 0 ? EStorageType.local : _b;
    if (type === EStorageType.local)
        window.localStorage.removeItem(key);
    else
        window.sessionStorage.removeItem(key);
}

var impersonificationKey = "impersonificationTree";
function callApi(_a) {
    var url = _a.url, delay = _a.delay, tries = _a.tries, _b = _a.fetchOptions, fetchOptions = _b === void 0 ? {} : _b, _c = _a.query, query = _c === void 0 ? {} : _c, _d = _a.errorHandler, errorHandler = _d === void 0 ? uiKitConfig.ERROR_HANDLER : _d, _e = _a.useImpersonationTree, useImpersonationTree = _e === void 0 ? true : _e;
    //Prepare data
    if (fetchOptions.body) {
        fetchOptions.body = JSON.stringify(fetchOptions.body);
    }
    if (!fetchOptions.redirect) {
        fetchOptions.redirect = "follow";
    }
    fetchOptions.credentials = "same-origin";
    var impersonationTree = getStorage({ key: impersonificationKey, type: EStorageType.session });
    if (useImpersonationTree && impersonationTree && Array.isArray(impersonationTree) && (impersonationTree === null || impersonationTree === void 0 ? void 0 : impersonationTree.length) > 0) {
        var urlPathname = new URL(url).pathname;
        var impersonationIndex = impersonationTree[impersonationTree.length - 1];
        if (urlPathname === "/api/accounts") {
            query.partner_account_id = impersonationIndex;
        }
        else if (urlPathname.includes("/api/workflows") || urlPathname.includes("/api/automations") || urlPathname.includes("/api/customevents") || urlPathname.includes("/api/domains")) {
            query.accountId = impersonationIndex;
        }
        else {
            query.account_id = impersonationIndex;
        }
    }
    //Prepare Headers
    var _headers = new Headers();
    _headers.set("content-type", "application/json");
    fetchOptions.headers = _headers;
    //Extend URL
    var queryExtention = "";
    var updatedUrl = url;
    var initQueryChar = updatedUrl.includes("?") ? "&" : "?";
    for (var key in query) {
        if (![null, undefined].includes(query[key])) {
            var data = typeof query[key] === "object"
                ? JSON.stringify(query[key])
                : query[key];
            queryExtention += "&".concat(key, "=").concat(encodeURIComponent(data));
        }
    }
    if (queryExtention) {
        queryExtention = initQueryChar + queryExtention.slice(1);
    }
    updatedUrl += queryExtention;
    return fetchRetry({ url: updatedUrl, delay: delay, tries: tries, fetchOptions: fetchOptions })
        .then(function (res) {
        return res;
    })
        .catch(function (errorResponse) {
        if (errorHandler) {
            throw errorHandler({ errorResponse: errorResponse });
        }
        else {
            throw errorResponse;
        }
    });
}
function addToImpersonificationTree(id) {
    var impersonationTree = getStorage({ key: impersonificationKey, type: EStorageType.session }) || [];
    impersonationTree.push(id);
    setStorage({ key: impersonificationKey, data: impersonationTree, type: EStorageType.session });
}
function popImpersonificationTree() {
    var impersonationTree = getStorage({ key: impersonificationKey, type: EStorageType.session }) || [];
    impersonationTree.pop();
    setStorage({ key: impersonificationKey, data: impersonationTree, type: EStorageType.session });
}
function amIImpersonating(returnId) {
    var impersonationTree = getStorage({ key: impersonificationKey, type: EStorageType.session }) || [];
    if (returnId === true) {
        var latestImpersonation = impersonationTree[impersonationTree.length - 1];
        // Assuming impersonationTree contains either a string/number or is empty
        return (latestImpersonation !== undefined ? latestImpersonation : 0);
    }
    return impersonationTree.length > 0;
}
function clearImpersonificationTree() {
    deleteStorageItem({ key: impersonificationKey, type: EStorageType.session });
}

function camelToSnakeCase(str) {
    return str.replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); });
}
function truncateText(input, maxLength) {
    if (input.length <= maxLength) {
        return input;
    }
    else {
        return input.substring(0, maxLength - 3) + '...';
    }
}
function capitalizeFirstLetter(str) {
    if (!str) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function isValidEmail(email) {
    if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))(\(@\d+\)|@)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
        return true;
    }
    return false;
}
function isValidUrl(url) {
    if (/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(url)) {
        return true;
    }
    return false;
}
function isValidString(string) {
    if (string)
        return !/^ *$/.test(string);
    return false;
}

function descendingComparator(a, b, orderBy) {
    var _a, _b;
    //@ts-ignore
    var curA = isSimpleType(a[orderBy]) ? a[orderBy] : ((_a = a[orderBy]) === null || _a === void 0 ? void 0 : _a.id) || "";
    //@ts-ignore
    var curB = isSimpleType(b[orderBy]) ? b[orderBy] : ((_b = b[orderBy]) === null || _b === void 0 ? void 0 : _b.id) || "";
    if (curB < curA) {
        return -1;
    }
    if (curB > curA) {
        return 1;
    }
    return 0;
}
function getComparator(order, orderBy) {
    return order === 'desc'
        ? function (a, b) { return descendingComparator(a, b, orderBy); }
        : function (a, b) { return -descendingComparator(a, b, orderBy); };
}
function stableSort(array, order, orderBy) {
    var comparator = getComparator(order, orderBy);
    //comparator: (a: T, b: T) => number
    var stabilizedThis = array.map(function (el, index) { return [el, index]; });
    stabilizedThis.sort(function (a, b) {
        //@ts-ignore
        var order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) { return el[0]; });
}
function isSimpleType(data) {
    return ["number", "string"].includes(typeof data);
}
function camelCase(options) {
    if (options === void 0) { options = {}; }
    var out = {};
    for (var key in options) {
        out[camelToSnakeCase(key)] = options[key];
    }
    return out;
}
function splitObject(data, splitIndex) {
    if (splitIndex === void 0) { splitIndex = 5; }
    var keys = Object.keys(Object(data));
    var cData = data;
    var firstObject = {};
    var secondObject = {};
    keys.forEach(function (key, index) {
        var targetObject = index < splitIndex ? firstObject : secondObject;
        targetObject[key] = cData[key];
    });
    return { firstObject: firstObject, secondObject: secondObject };
}
function splitArray(originalArray, splitIndex) {
    if (originalArray === void 0) { originalArray = []; }
    if (splitIndex === void 0) { splitIndex = 5; }
    var firstArray = originalArray.slice(0, splitIndex);
    var secondArray = originalArray.slice(splitIndex);
    return { firstArray: firstArray, secondArray: secondArray };
}
function getPropertyValue(obj, key) {
    if (obj && obj[key])
        return obj[key];
    else {
        return 0;
    }
}
function googlePlacesMapper(placesResult, _a) {
    var address = {
        address: "",
        country: "",
        state: "",
        city: "",
        postal: "",
        countryCode: ""
    };
    var streetNb = "", route = "";
    var fallback = __assign({}, address);
    placesResult.address_components.forEach(function (el) {
        var _a, _b, _c, _d, _e, _f;
        if (el.types.indexOf("country") !== -1) {
            address.country = (_a = el.long_name) !== null && _a !== void 0 ? _a : el.short_name;
            address.countryCode = el.short_name;
        }
        else if (el.types.indexOf("administrative_area_level_1") !== -1) {
            address.state = el.long_name || el.short_name;
        }
        else if (el.types.indexOf("locality") !== -1) {
            address.city = el.short_name;
        }
        else if (el.types.indexOf("route") !== -1) {
            route = el.short_name;
        }
        else if (el.types.indexOf("postal_code") !== -1) {
            address.postal = el.short_name;
        }
        else if (el.types.indexOf("street_number") !== -1) {
            streetNb = el.short_name;
        }
        if (((_b = el.types) === null || _b === void 0 ? void 0 : _b.length) === 1 && ((_c = el.types) === null || _c === void 0 ? void 0 : _c.includes("political"))) {
            fallback.address = el.short_name;
        }
        if (el.types.includes("administrative_area_level_2")) {
            fallback.state = el.short_name;
        }
        else if (el.types.includes("administrative_area_level_3")) {
            fallback.state = el.short_name;
        }
        if ((_d = el.types) === null || _d === void 0 ? void 0 : _d.includes("sublocality")) {
            fallback.city = el.short_name;
        }
        else if ((_e = el.types) === null || _e === void 0 ? void 0 : _e.includes("sublocality_level_1")) {
            fallback.city = el.short_name;
        }
        else if ((_f = el.types) === null || _f === void 0 ? void 0 : _f.includes("sublocality_level_2")) {
            fallback.city = el.short_name;
        }
    });
    address.address = (streetNb + " " + route).trim();
    address.address = address.address ? address.address : fallback.address;
    address.state = address.state ? address.state : fallback.state;
    address.city = address.city ? address.city : fallback.city;
    return address;
}
function areAllPropertiesEmpty(obj, treatStringHasEmtpy) {
    if (treatStringHasEmtpy === void 0) { treatStringHasEmtpy = false; }
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] === 'object') {
                if (!areAllPropertiesEmpty(obj[key], treatStringHasEmtpy)) {
                    return false;
                }
            }
            else {
                if (treatStringHasEmtpy) {
                    if (obj[key]) {
                        return false;
                    }
                }
                else {
                    if (obj[key] !== null && obj[key] !== undefined) {
                        return false;
                    }
                }
            }
        }
    }
    return true;
}
function removeEmptyProperties(obj, treatStringHasEmtpy) {
    if (treatStringHasEmtpy === void 0) { treatStringHasEmtpy = false; }
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] === 'object') {
                removeEmptyProperties(obj[key]);
                if (areAllPropertiesEmpty(obj[key], treatStringHasEmtpy)) {
                    delete obj[key];
                }
            }
            else {
                if (treatStringHasEmtpy) {
                    if (!obj[key]) {
                        delete obj[key];
                    }
                }
                else {
                    if (obj[key] === null || obj[key] === undefined) {
                        delete obj[key];
                    }
                }
            }
        }
    }
    return obj;
}
function getNestedProperty(obj, path) {
    // Split the path into an array of properties
    var properties = path.split('.');
    // Traverse the object
    var current = obj;
    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
        var prop = properties_1[_i];
        // Check if the property exists
        if (current && prop in current) {
            current = current[prop];
        }
        else {
            // Property not found, return undefined
            return undefined;
        }
    }
    // Return the final value
    return current;
}
function findNestedProperty(obj, key) {
    if (obj === null || typeof obj !== 'object') {
        return undefined;
    }
    if (obj.hasOwnProperty(key)) {
        return obj[key];
    }
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
            var result = findNestedProperty(obj[k], key);
            if (result !== undefined) {
                return result;
            }
        }
    }
    return undefined;
}
function deepMergeObject(source, target) {
    // Loop through each property in the source object
    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            // Check if the property is an object and also exists in the target as an object
            if (typeof source[key] === 'object' &&
                source[key] !== null &&
                !Array.isArray(source[key]) &&
                typeof target[key] === 'object' &&
                target[key] !== null &&
                !Array.isArray(target[key])) {
                // Recursively merge objects
                target[key] = deepMergeObject(target[key], source[key]);
            }
            else {
                // Otherwise, assign the property directly
                target[key] = source[key];
            }
        }
    }
    return target;
}
function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function (err) {
            fallbackCopyToClipboard(text);
        });
    }
    else {
        fallbackCopyToClipboard(text);
    }
}
function fallbackCopyToClipboard(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.top = '-1000px';
    textarea.style.left = '-1000px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand('copy');
    }
    catch (err) {
        console.error('Failed to copy text');
    }
    document.body.removeChild(textarea);
}

function setBrandHeadElements(brand, locale) {
    var link = document.getElementById("favicon");
    if (link)
        link.href = getBrandUrl({ elKey: "favicon", brand: brand, locale: locale });
    link = document.getElementById("favicon-apple-touch");
    if (link)
        link.href = getBrandUrl({ elKey: "faviconAppleTouch", brand: brand, locale: locale });
    link = document.getElementById("favicon-16");
    if (link)
        link.href = getBrandUrl({ elKey: "favicon16", brand: brand, locale: locale });
    link = document.getElementById("favicon-32");
    if (link)
        link.href = getBrandUrl({ elKey: "favicon32", brand: brand, locale: locale });
    link = document.getElementById("favicon-512");
    if (link)
        link.href = getBrandUrl({ elKey: "favicon512", brand: brand, locale: locale });
    link = document.getElementById("favicon-mstile");
    if (link)
        link.href = getBrandUrl({ elKey: "faviconMstile", brand: brand, locale: locale });
    document.title = brand.name;
}
function getBrandUrl(_a) {
    var _b;
    var mainKey = _a.mainKey, elKey = _a.elKey, brand = _a.brand, locale = _a.locale;
    if (!elKey || !brand)
        return "";
    var brandImages = mainKey && (brand === null || brand === void 0 ? void 0 : brand[mainKey]) ? brand === null || brand === void 0 ? void 0 : brand[mainKey] : brand === null || brand === void 0 ? void 0 : brand.images;
    if (!brandImages)
        return "";
    var cLocale = ((_b = locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) === null || _b === void 0 ? void 0 : _b.replace("-", "_")) || undefined;
    var localedImgViaUnderscore = brandImages === null || brandImages === void 0 ? void 0 : brandImages[elKey + "_" + cLocale];
    var defaultImg = getNestedProperty(brandImages, elKey);
    if (localedImgViaUnderscore) {
        return getBrandUrlFromProperty(localedImgViaUnderscore) || undefined;
    }
    else if (defaultImg) {
        if (typeof defaultImg === "string") {
            return defaultImg;
        }
        else {
            if (cLocale) {
                var isoLang = cLocale === null || cLocale === void 0 ? void 0 : cLocale.substring(0, 2);
                return getBrandUrlFromProperty(defaultImg === null || defaultImg === void 0 ? void 0 : defaultImg[cLocale]) ||
                    getBrandUrlFromProperty(defaultImg === null || defaultImg === void 0 ? void 0 : defaultImg[isoLang]) ||
                    getBrandUrlFromProperty(defaultImg === null || defaultImg === void 0 ? void 0 : defaultImg.en) ||
                    getBrandUrlFromProperty(defaultImg) || undefined;
            }
            return getBrandUrlFromProperty(defaultImg === null || defaultImg === void 0 ? void 0 : defaultImg.en) ||
                getBrandUrlFromProperty(defaultImg) || undefined;
        }
    }
    else {
        return "";
    }
}
function getBrandUrlFromProperty(element) {
    return typeof element === "string" ? element : (element === null || element === void 0 ? void 0 : element.url) || null;
}
function getBrandService(_a) {
    var url = _a.url;
    return fetchRetry({ url: url, fetchOptions: { method: EMethods.get } })
        .then(function (res) {
        return res;
    })
        .catch(function (err) { throw err; });
}

function isColorLight(hex, brightnessLimit) {
    if (brightnessLimit === void 0) { brightnessLimit = 155; }
    // Remove the '#' if present
    hex = hex.replace('#', '');
    // Parse the hex color code into its RGB components
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    // Calculate the brightness using the YIQ formula
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= brightnessLimit ? true : false; //default 128 for half half
}

function ElementContains(element, target) {
    if (element && element.contains(target)) {
        return true;
    }
    return false;
}
function modelToJson(model, exclude) {
    if (exclude === void 0) { exclude = []; }
    var obj = {};
    Object.keys(model).forEach(function (key) {
        var _a;
        var value = model[key];
        if (exclude.includes(key)) {
            return;
        }
        if (value != null && typeof value === "object") {
            if (((_a = Object.keys(value)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                obj[key] = value;
            }
        }
        else if (value != null) {
            obj[key] = value;
        }
    });
    return obj;
}
function modelSet(model, property, value) {
    if (model.hasOwnProperty(property)) {
        //@ts-ignore
        model[property] = value;
    }
    else {
        throw new Error("Property '".concat(String(property), "' does not exist in the ").concat(model.constructor.name, "."));
    }
}

function getUnixTime(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.diff, diff = _c === void 0 ? 0 : _c, time = _b.time;
    var timeToAdd = 0;
    if (typeof diff === "string") {
        var lastChar = diff.slice(-1);
        var numericValue = parseInt(diff.slice(0, -1));
        var timestamp = 0;
        switch (lastChar) {
            case 's':
                timestamp = numericValue; // seconds
                break;
            case 'm':
                timestamp = numericValue * 60; // minutes to seconds
                break;
            case 'h':
                timestamp = numericValue * 60 * 60; // hours to seconds
                break;
            case 'd':
                timestamp = numericValue * 24 * 60 * 60; // days to seconds
                break;
            case 'w':
                timestamp = numericValue * 7 * 24 * 60 * 60; // weeks to seconds
                break;
            default:
                timestamp = parseInt(diff);
                break;
        }
        timeToAdd += timestamp;
    }
    else {
        timeToAdd = diff;
    }
    var timeStamp = time !== undefined ? time : miliToSecond(Date.now());
    if (timeToAdd)
        timeStamp += timeToAdd;
    return timeStamp;
}
function miliToSecond(miliseconds) {
    return Math.floor(miliseconds / 1000);
}
//Implementation
function getDate(_a) {
    var _b = _a === void 0 ? {} : _a, format = _b.format, add = _b.add, addFormat = _b.addFormat, inUtc = _b.inUtc, date = _b.date;
    var returnDate = date && !Number.isNaN(date) ? moment.unix(Number(date)) : moment(date);
    if (inUtc) {
        returnDate = returnDate.utc();
    }
    if (add) {
        returnDate = returnDate.add(add, addFormat || "days");
    }
    if (format === "unix") {
        return returnDate.unix();
    }
    else if (format) {
        return returnDate.format(format);
    }
    return returnDate;
}
function getStartOfDate(_a) {
    var _b = _a === void 0 ? {} : _a, add = _b.add, addFormat = _b.addFormat, inUtc = _b.inUtc, date = _b.date, inMiliseconds = _b.inMiliseconds;
    var returnDate = getDate({
        add: add,
        addFormat: addFormat,
        inUtc: inUtc === undefined ? true : inUtc,
        date: date
    });
    returnDate = returnDate.startOf("day");
    if (inMiliseconds) {
        return returnDate.unix() * 1000;
    }
    return returnDate.unix();
}
function getEndOfDate(_a) {
    var _b = _a === void 0 ? {} : _a, add = _b.add, addFormat = _b.addFormat, inUtc = _b.inUtc, date = _b.date, inMiliseconds = _b.inMiliseconds;
    var returnDate = getDate({
        add: add,
        addFormat: addFormat,
        inUtc: inUtc === undefined ? true : inUtc,
        date: date
    });
    returnDate = returnDate.endOf("day");
    if (inMiliseconds) {
        return returnDate.unix() * 1000;
    }
    return returnDate.unix();
}
function getAdjustedBillingCycle(startDate) {
    var now = moment();
    var start = moment(startDate);
    // Set the billing date to the same day in the current month
    var adjustedStart = now.clone().date(start.date());
    // If it's in the future, move back one month
    if (adjustedStart.isAfter(now)) {
        adjustedStart.subtract(1, "month");
    }
    // The end date is exactly one month after the start
    var adjustedEnd = adjustedStart.clone().add(1, "month");
    return { start: adjustedStart, end: adjustedEnd };
}

function getDomainsFromEmails(emails) {
    var domainsList = [];
    emails.forEach(function (email) {
        var domain = getDomainFromEmail(typeof email === 'string' ? email : email === null || email === void 0 ? void 0 : email.email);
        if (domainsList.filter(function (d) { return d === domain; }).length == 0) {
            domainsList.push(domain);
        }
    });
    return domainsList;
}
function getDomainFromEmail(email) {
    if (!email) {
        return "";
    }
    var atIndex = email.indexOf("@");
    var domain = email.substring(atIndex + 1);
    return domain;
}
function truncateEmail(email, length) {
    if (length === void 0) { length = 55; }
    if (email.length > length) {
        var _a = email.split('@'), localPart = _a[0], domainPart = _a[1];
        var domainParts = domainPart.split('.');
        // Get the first group of characters before any special characters in the local part
        var firstGroup = localPart.split(/[\.\+\_\-]/)[0];
        var lastTwoDomainParts = domainParts.slice(-2).join('.');
        return "".concat(firstGroup, "...@").concat(domainParts.length > 2 ? "..." : "").concat(lastTwoDomainParts);
    }
    return email;
}

// Post a message to the parent window
// example: used in iframe components
function postMessage(data) {
    var type = data.type, message = data.message;
    window.parent.postMessage({ type: type, message: message }, '*');
}

function getBestLocalMatch(locale, languageList) {
    var lookupLanguages = (languageList === null || languageList === void 0 ? void 0 : languageList.map(function (l) { return l.replace("_", "-"); })) || uiKitConfig.SUPPORTED_LANGUAGES;
    if (locale) {
        var foundLocale = lookupLanguages.find(function (lLang) {
            if (locale.toLowerCase() == lLang.toLowerCase())
                return true;
            else if (locale.substring(0, 2) === lLang)
                return true;
            return false;
        });
        // best match otherwise leave it to the rest
        if (!foundLocale) {
            foundLocale = lookupLanguages.find(function (lLang) { return lLang.includes(locale.substring(0, 2)); });
        }
        if (foundLocale)
            return foundLocale;
    }
    //@ts-ignore
    var browserFallBackLang = navigator.language || (navigator === null || navigator === void 0 ? void 0 : navigator.userLanguage);
    if (browserFallBackLang && lookupLanguages.includes(browserFallBackLang)) {
        return browserFallBackLang;
    }
    else {
        return "en-US";
    }
}

const isString = obj => typeof obj === 'string';
const defer = () => {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
};
const makeString = object => {
  if (object == null) return '';
  return '' + object;
};
const copy$1 = (a, s, t) => {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
};
const lastOfPathSeparatorRegExp = /###/g;
const cleanKey = key => key && key.indexOf('###') > -1 ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
const canNotTraverseDeeper = object => !object || isString(object);
const getLastOfPath = (object, path, Empty) => {
  const stack = !isString(path) ? path : path.split('.');
  let stackIndex = 0;
  while (stackIndex < stack.length - 1) {
    if (canNotTraverseDeeper(object)) return {};
    const key = cleanKey(stack[stackIndex]);
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
    ++stackIndex;
  }
  if (canNotTraverseDeeper(object)) return {};
  return {
    obj: object,
    k: cleanKey(stack[stackIndex])
  };
};
const setPath = (object, path, newValue) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  if (obj !== undefined || path.length === 1) {
    obj[k] = newValue;
    return;
  }
  let e = path[path.length - 1];
  let p = path.slice(0, path.length - 1);
  let last = getLastOfPath(object, p, Object);
  while (last.obj === undefined && p.length) {
    e = `${p[p.length - 1]}.${e}`;
    p = p.slice(0, p.length - 1);
    last = getLastOfPath(object, p, Object);
    if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') {
      last.obj = undefined;
    }
  }
  last.obj[`${last.k}.${e}`] = newValue;
};
const pushPath = (object, path, newValue, concat) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  obj[k].push(newValue);
};
const getPath$1 = (object, path) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
  return obj[k];
};
const getPathWithDefaults = (data, defaultData, key) => {
  const value = getPath$1(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath$1(defaultData, key);
};
const deepExtend = (target, source, overwrite) => {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
};
const regexEscape = str => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
const escape = data => {
  if (isString(data)) {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
};
class RegExpCache {
  constructor(capacity) {
    this.capacity = capacity;
    this.regExpMap = new Map();
    this.regExpQueue = [];
  }
  getRegExp(pattern) {
    const regExpFromCache = this.regExpMap.get(pattern);
    if (regExpFromCache !== undefined) {
      return regExpFromCache;
    }
    const regExpNew = new RegExp(pattern);
    if (this.regExpQueue.length === this.capacity) {
      this.regExpMap.delete(this.regExpQueue.shift());
    }
    this.regExpMap.set(pattern, regExpNew);
    this.regExpQueue.push(pattern);
    return regExpNew;
  }
}
const chars = [' ', ',', '?', '!', ';'];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
const looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
};
const deepFind = (obj, path, keySeparator = '.') => {
  if (!obj) return undefined;
  if (obj[path]) {
    if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
    return obj[path];
  }
  const tokens = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < tokens.length;) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }
    let next;
    let nextPath = '';
    for (let j = i; j < tokens.length; ++j) {
      if (j !== i) {
        nextPath += keySeparator;
      }
      nextPath += tokens[j];
      next = current[nextPath];
      if (next !== undefined) {
        if (['string', 'number', 'boolean'].indexOf(typeof next) > -1 && j < tokens.length - 1) {
          continue;
        }
        i += j - i + 1;
        break;
      }
    }
    current = next;
  }
  return current;
};
const getCleanedCode = code => code?.replace('_', '-');

const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    console?.[type]?.apply?.(console, args);
  }
};
class Logger {
  constructor(concreteLogger, options = {}) {
    this.init(concreteLogger, options);
  }
  init(concreteLogger, options = {}) {
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log(...args) {
    return this.forward(args, 'log', '', true);
  }
  warn(...args) {
    return this.forward(args, 'warn', '', true);
  }
  error(...args) {
    return this.forward(args, 'error', '');
  }
  deprecate(...args) {
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      if (!this.observers[event]) this.observers[event] = new Map();
      const numListeners = this.observers[event].get(listener) || 0;
      this.observers[event].set(listener, numListeners + 1);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event].delete(listener);
  }
  emit(event, ...args) {
    if (this.observers[event]) {
      const cloned = Array.from(this.observers[event].entries());
      cloned.forEach(([observer, numTimesAdded]) => {
        for (let i = 0; i < numTimesAdded; i++) {
          observer(...args);
        }
      });
    }
    if (this.observers['*']) {
      const cloned = Array.from(this.observers['*'].entries());
      cloned.forEach(([observer, numTimesAdded]) => {
        for (let i = 0; i < numTimesAdded; i++) {
          observer.apply(observer, [event, ...args]);
        }
      });
    }
  }
}

class ResourceStore extends EventEmitter {
  constructor(data, options = {
    ns: ['translation'],
    defaultNS: 'translation'
  }) {
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key, options = {}) {
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path;
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    } else {
      path = [lng, ns];
      if (key) {
        if (Array.isArray(key)) {
          path.push(...key);
        } else if (isString(key) && keySeparator) {
          path.push(...key.split(keySeparator));
        } else {
          path.push(key);
        }
      }
    }
    const result = getPath$1(this.data, path);
    if (!result && !ns && !key && lng.indexOf('.') > -1) {
      lng = path[0];
      ns = path[1];
      key = path.slice(2).join('.');
    }
    if (result || !ignoreJSONStructure || !isString(key)) return result;
    return deepFind(this.data?.[lng]?.[ns], key, keySeparator);
  }
  addResource(lng, ns, key, value, options = {
    silent: false
  }) {
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources, options = {
    silent: false
  }) {
    for (const m in resources) {
      if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite, options = {
    silent: false,
    skipCopy: false
  }) {
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath$1(this.data, path) || {};
    if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      value = this.processors[processor]?.process(value, key, options, translator) ?? value;
    });
    return value;
  }
};

const checkedLoadedFor = {};
const shouldHandleAsObject = res => !isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class Translator extends EventEmitter {
  constructor(services, options = {}) {
    super();
    copy$1(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key, o = {
    interpolation: {}
  }) {
    const opt = {
      ...o
    };
    if (key == null) return false;
    const resolved = this.resolve(key, opt);
    return resolved?.res !== undefined;
  }
  extractFromKey(key, opt) {
    let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
    let namespaces = opt.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces: isString(namespaces) ? [namespaces] : namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    return {
      key,
      namespaces: isString(namespaces) ? [namespaces] : namespaces
    };
  }
  translate(keys, o, lastKey) {
    let opt = typeof o === 'object' ? {
      ...o
    } : o;
    if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) {
      opt = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === 'object') opt = {
      ...opt
    };
    if (!opt) opt = {};
    if (keys == null) return '';
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
    const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], opt);
    const namespace = namespaces[namespaces.length - 1];
    let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const lng = opt.lng || this.language;
    const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng?.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(opt)
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace,
          usedParams: this.getUsedParamsDetails(opt)
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, opt);
    let res = resolved?.res;
    const resUsedKey = resolved?.usedKey || key;
    const resExactUsedKey = resolved?.exactUsedKey || key;
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const needsPluralHandling = opt.count !== undefined && !isString(opt.count);
    const hasDefaultValue = Translator.hasDefaultValue(opt);
    const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
    const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
      ordinal: false
    }) : '';
    const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
    const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
    let resForObjHndl = res;
    if (handleAsObjectInI18nFormat && !res && hasDefaultValue) {
      resForObjHndl = defaultValue;
    }
    const handleAsObject = shouldHandleAsObject(resForObjHndl);
    const resType = Object.prototype.toString.apply(resForObjHndl);
    if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(resForObjHndl))) {
      if (!opt.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
          ...opt,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          resolved.usedParams = this.getUsedParamsDetails(opt);
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = Array.isArray(resForObjHndl);
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in resForObjHndl) {
          if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            if (hasDefaultValue && !res) {
              copy[m] = this.translate(deepKey, {
                ...opt,
                defaultValue: shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
            } else {
              copy[m] = this.translate(deepKey, {
                ...opt,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
            }
            if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, opt, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...opt,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
        } else {
          lngs.push(opt.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
          } else if (this.backendConnector?.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              const suffixes = this.pluralResolver.getSuffixes(language, opt);
              if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                suffixes.push(`${this.options.pluralSeparator}zero`);
              }
              suffixes.forEach(suffix => {
                send([language], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, opt, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) {
        res = `${namespace}${nsSeparator}${key}`;
      }
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
      }
    }
    if (returnDetails) {
      resolved.res = res;
      resolved.usedParams = this.getUsedParamsDetails(opt);
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, opt, resolved, lastKey) {
    if (this.i18nFormat?.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...opt
      }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!opt.skipInterpolation) {
      if (opt.interpolation) this.interpolator.init({
        ...opt,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...opt.interpolation
          }
        }
      });
      const skipOnVariables = isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = opt.replace && !isString(opt.replace) ? opt.replace : opt;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) opt.nest = false;
      }
      if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
      if (opt.nest !== false) res = this.interpolator.nest(res, (...args) => {
        if (lastKey?.[0] === args[0] && !opt.context) {
          this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return this.translate(...args, key);
      }, opt);
      if (opt.interpolation) this.interpolator.reset();
    }
    const postProcess = opt.postProcess || this.options.postProcess;
    const postProcessorNames = isString(postProcess) ? [postProcess] : postProcess;
    if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: {
          ...resolved,
          usedParams: this.getUsedParamsDetails(opt)
        },
        ...opt
      } : opt, this);
    }
    return res;
  }
  resolve(keys, opt = {}) {
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (isString(keys)) keys = [keys];
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, opt);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = opt.count !== undefined && !isString(opt.count);
      const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
      const needsContextHandling = opt.context !== undefined && (isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
      const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat?.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${opt.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, opt);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key, options = {}) {
    if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  getUsedParamsDetails(options = {}) {
    const optionsKeys = ['defaultValue', 'ordinal', 'context', 'replace', 'lng', 'lngs', 'fallbackLng', 'ns', 'keySeparator', 'nsSeparator', 'returnObjects', 'returnDetails', 'joinArrays', 'postProcess', 'interpolation'];
    const useOptionsReplaceForData = options.replace && !isString(options.replace);
    let data = useOptionsReplaceForData ? options.replace : options;
    if (useOptionsReplaceForData && typeof options.count !== 'undefined') {
      data.count = options.count;
    }
    if (this.options.interpolation.defaultVariables) {
      data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
    }
    if (!useOptionsReplaceForData) {
      data = {
        ...data
      };
      for (const key of optionsKeys) {
        delete data[key];
      }
    }
    return data;
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (isString(code) && code.indexOf('-') > -1) {
      let formattedCode;
      try {
        formattedCode = Intl.getCanonicalLocales(code)[0];
      } catch (e) {}
      if (formattedCode && this.options.lowerCaseLng) {
        formattedCode = formattedCode.toLowerCase();
      }
      if (formattedCode) return formattedCode;
      if (this.options.lowerCaseLng) {
        return code.toLowerCase();
      }
      return code;
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngScOnly = this.getScriptPartFromCode(code);
        if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
          if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (isString(fallbacks)) fallbacks = [fallbacks];
    if (Array.isArray(fallbacks)) return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (isString(code)) {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
const dummyRule = {
  select: count => count === 1 ? 'one' : 'other',
  resolvedOptions: () => ({
    pluralCategories: ['one', 'other']
  })
};
class PluralResolver {
  constructor(languageUtils, options = {}) {
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.pluralRulesCache = {};
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(code, options = {}) {
    const cleanedCode = getCleanedCode(code === 'dev' ? 'en' : code);
    const type = options.ordinal ? 'ordinal' : 'cardinal';
    const cacheKey = JSON.stringify({
      cleanedCode,
      type
    });
    if (cacheKey in this.pluralRulesCache) {
      return this.pluralRulesCache[cacheKey];
    }
    let rule;
    try {
      rule = new Intl.PluralRules(cleanedCode, {
        type
      });
    } catch (err) {
      if (!Intl) {
        this.logger.error('No Intl support, please use an Intl polyfill!');
        return dummyRule;
      }
      if (!code.match(/-|_/)) return dummyRule;
      const lngPart = this.languageUtils.getLanguagePartFromCode(code);
      rule = this.getRule(lngPart, options);
    }
    this.pluralRulesCache[cacheKey] = rule;
    return rule;
  }
  needsPlural(code, options = {}) {
    let rule = this.getRule(code, options);
    if (!rule) rule = this.getRule('dev', options);
    return rule?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(code, key, options = {}) {
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code, options = {}) {
    let rule = this.getRule(code, options);
    if (!rule) rule = this.getRule('dev', options);
    if (!rule) return [];
    return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
  }
  getSuffix(code, count, options = {}) {
    const rule = this.getRule(code, options);
    if (rule) {
      return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return this.getSuffix('dev', count, options);
  }
}

const deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true) => {
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && isString(key)) {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
};
const regexSafe = val => val.replace(/\$/g, '$$$$');
class Interpolator {
  constructor(options = {}) {
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options?.interpolation?.format || (value => value);
    this.init(options);
  }
  init(options = {}) {
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const {
      escape: escape$1,
      escapeValue,
      useRawValueToEscape,
      prefix,
      prefixEscaped,
      suffix,
      suffixEscaped,
      formatSeparator,
      unescapeSuffix,
      unescapePrefix,
      nestingPrefix,
      nestingPrefixEscaped,
      nestingSuffix,
      nestingSuffixEscaped,
      nestingOptionsSeparator,
      maxReplaces,
      alwaysFormat
    } = options.interpolation;
    this.escape = escape$1 !== undefined ? escape$1 : escape;
    this.escapeValue = escapeValue !== undefined ? escapeValue : true;
    this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
    this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || '{{';
    this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || '}}';
    this.formatSeparator = formatSeparator || ',';
    this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
    this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
    this.maxReplaces = maxReplaces || 1000;
    this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const getOrResetRegExp = (existingRegExp, pattern) => {
      if (existingRegExp?.source === pattern) {
        existingRegExp.lastIndex = 0;
        return existingRegExp;
      }
      return new RegExp(pattern, 'g');
    };
    this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
    this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
    this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = isString(temp) ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (!isString(value) && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc, options = {}) {
    let match;
    let value;
    let clonedOptions;
    const handleHasOptions = (key, inheritedOptions) => {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
      return key;
    };
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
      if (keyEndIndex !== -1) {
        formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map(elem => elem.trim()).filter(Boolean);
        match[1] = match[1].slice(0, keyEndIndex);
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && !isString(value)) return value;
      if (!isString(value)) value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (formatters.length) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

const parseFormatStr = formatStr => {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (opt) {
          const [key, ...rest] = opt.split(':');
          const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
          const trimmedKey = key.trim();
          if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
          if (val === 'false') formatOptions[trimmedKey] = false;
          if (val === 'true') formatOptions[trimmedKey] = true;
          if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
        }
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
};
const createCachedFormatter = fn => {
  const cache = {};
  return (v, l, o) => {
    let optForCache = o;
    if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) {
      optForCache = {
        ...optForCache,
        [o.interpolationkey]: undefined
      };
    }
    const key = l + JSON.stringify(optForCache);
    let frm = cache[key];
    if (!frm) {
      frm = fn(getCleanedCode(l), o);
      cache[key] = frm;
    }
    return frm(v);
  };
};
const createNonCachedFormatter = fn => (v, l, o) => fn(getCleanedCode(l), o)(v);
class Formatter {
  constructor(options = {}) {
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.init(options);
  }
  init(services, options = {
    interpolation: {}
  }) {
    this.formatSeparator = options.interpolation.formatSeparator || ',';
    const cf = options.cacheInBuiltFormats ? createCachedFormatter : createNonCachedFormatter;
    this.formats = {
      number: cf((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: cf((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: cf((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: cf((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: cf((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng, options = {}) {
    const formats = format.split(this.formatSeparator);
    if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find(f => f.indexOf(')') > -1)) {
      const lastIndex = formats.findIndex(f => f.indexOf(')') > -1);
      formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
    }
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options?.formatParams?.[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

const removePending = (q, name) => {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
};
class Connector extends EventEmitter {
  constructor(backend, store, services, options = {}) {
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    this.backend?.init?.(services, options.backend, options);
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (!err && data) {
      this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
        skipCopy: true
      });
    }
    this.state[name] = err ? -1 : 2;
    if (err && data) this.state[name] = 0;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces, options = {}, callback) {
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
    if (isString(namespaces)) namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name, prefix = '') {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = () => {}) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend?.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

const get = () => ({
  debug: false,
  initAsync: true,
  ns: ['translation'],
  defaultNS: ['translation'],
  fallbackLng: ['dev'],
  fallbackNS: false,
  supportedLngs: false,
  nonExplicitSupportedLngs: false,
  load: 'all',
  preload: false,
  simplifyPluralSuffix: true,
  keySeparator: '.',
  nsSeparator: ':',
  pluralSeparator: '_',
  contextSeparator: '_',
  partialBundledLanguages: false,
  saveMissing: false,
  updateMissing: false,
  saveMissingTo: 'fallback',
  saveMissingPlurals: true,
  missingKeyHandler: false,
  missingInterpolationHandler: false,
  postProcess: false,
  postProcessPassResolved: false,
  returnNull: false,
  returnEmptyString: true,
  returnObjects: false,
  joinArrays: false,
  returnedObjectHandler: false,
  parseMissingKeyHandler: false,
  appendNamespaceToMissingKey: false,
  appendNamespaceToCIMode: false,
  overloadTranslationOptionHandler: args => {
    let ret = {};
    if (typeof args[1] === 'object') ret = args[1];
    if (isString(args[1])) ret.defaultValue = args[1];
    if (isString(args[2])) ret.tDescription = args[2];
    if (typeof args[2] === 'object' || typeof args[3] === 'object') {
      const options = args[3] || args[2];
      Object.keys(options).forEach(key => {
        ret[key] = options[key];
      });
    }
    return ret;
  },
  interpolation: {
    escapeValue: true,
    format: value => value,
    prefix: '{{',
    suffix: '}}',
    formatSeparator: ',',
    unescapePrefix: '-',
    nestingPrefix: '$t(',
    nestingSuffix: ')',
    nestingOptionsSeparator: ',',
    maxReplaces: 1000,
    skipOnVariables: true
  },
  cacheInBuiltFormats: true
});
const transformOptions = options => {
  if (isString(options.ns)) options.ns = [options.ns];
  if (isString(options.fallbackLng)) options.fallbackLng = [options.fallbackLng];
  if (isString(options.fallbackNS)) options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs?.indexOf?.('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
  return options;
};

const noop = () => {};
const bindMemberFunctions = inst => {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
};
class I18n extends EventEmitter {
  constructor(options = {}, callback) {
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initAsync) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init(options = {}, callback) {
    this.isInitializing = true;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (options.defaultNS == null && options.ns) {
      if (isString(options.ns)) {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    this.options.interpolation = {
      ...defOpts.interpolation,
      ...this.options.interpolation
    };
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    const createClassOnDemand = ClassOrObject => {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    };
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
      if (usingLegacyFormatFunction) {
        this.logger.warn(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
      }
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        if (s.formatter.init) s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', (event, ...args) => {
        this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', (event, ...args) => {
        this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = (...args) => this.store[fcName](...args);
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = (...args) => {
        this.store[fcName](...args);
        return this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        this.isInitializing = false;
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initAsync) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language, callback = noop) {
    let usedCallback = callback;
    const usedLng = isString(language) ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        if (lng === 'cimode') return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (l === 'cimode') return;
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      this.options.preload?.forEach?.(l => append(l));
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (typeof lngs === 'function') {
      callback = lngs;
      lngs = undefined;
    }
    if (typeof ns === 'function') {
      callback = ns;
      ns = undefined;
    }
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
    if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
      this.resolvedLanguage = l;
      this.languages.unshift(l);
    }
  }
  changeLanguage(lng, callback) {
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        if (this.isLanguageChangingTo === lng) {
          setLngProps(l);
          this.translator.changeLanguage(l);
          this.isLanguageChangingTo = undefined;
          this.emit('languageChanged', l);
          this.logger.log('languageChanged', l);
        }
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve((...args) => this.t(...args));
      if (callback) callback(err, (...args) => this.t(...args));
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const fl = isString(lngs) ? lngs : lngs && lngs[0];
      const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes(isString(lngs) ? [lngs] : lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        this.services.languageDetector?.cacheUserLanguage?.(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    const fixedT = (key, opts, ...rest) => {
      let o;
      if (typeof opts !== 'object') {
        o = this.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        o = {
          ...opts
        };
      }
      o.lng = o.lng || fixedT.lng;
      o.lngs = o.lngs || fixedT.lngs;
      o.ns = o.ns || fixedT.ns;
      if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = this.options.keySeparator || '.';
      let resultKey;
      if (o.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => `${o.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
      }
      return this.t(resultKey, o);
    };
    if (isString(lng)) {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t(...args) {
    return this.translator?.translate(...args);
  }
  exists(...args) {
    return this.translator?.exists(...args);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns, options = {}) {
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 0 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (isString(ns)) ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (isString(lngs)) lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    if (Intl.Locale) {
      const l = new Intl.Locale(lng);
      if (l && l.getTextInfo) {
        const ti = l.getTextInfo();
        if (ti && ti.direction) return ti.direction;
      }
    }
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services?.languageUtils || new LanguageUtil(get());
    if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance(options = {}, callback) {
    return new I18n(options, callback);
  }
  cloneInstance(options = {}, callback = noop) {
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      const clonedData = Object.keys(this.store.data).reduce((prev, l) => {
        prev[l] = {
          ...this.store.data[l]
        };
        prev[l] = Object.keys(prev[l]).reduce((acc, n) => {
          acc[n] = {
            ...prev[l][n]
          };
          return acc;
        }, prev[l]);
        return prev;
      }, {});
      clone.store = new ResourceStore(clonedData, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', (event, ...args) => {
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
const t = instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

function getCalendarFormat(_a) {
    var date = _a.date, unixDate = _a.unixDate, _b = _a.showTime, showTime = _b === void 0 ? true : _b, _c = _a.atTxt, atTxt = _c === void 0 ? "at" : _c, _d = _a.calendarFormat, calendarFormat = _d === void 0 ? false : _d;
    var calDate;
    if (unixDate) {
        calDate = moment$1(moment$1.unix(unixDate).isValid() ? moment$1.unix(unixDate) : date);
    }
    else {
        calDate = moment$1(date);
    }
    var momentLocale = moment$1.locale();
    var frCA = momentLocale === "fr-ca";
    var frfr = momentLocale === "fr";
    var en = ["en", "en-us"];
    var timeFormat = undefined;
    var format = showTime ? "lll" : "ll";
    var currentYear = moment$1().year();
    var isThisYear = calDate.year() === currentYear;
    if (frfr) {
        timeFormat = showTime ? "[".concat(atTxt || t("general-at-txt"), "] HH:mm") : undefined;
        format = "D MMM".concat(isThisYear ? "" : " YYYY", " ");
    }
    else if (frCA) {
        timeFormat = showTime ? "HH [h] mm" : undefined;
        format = "D MMM".concat(isThisYear ? "" : " YYYY", " ");
    }
    else if (en.includes(momentLocale)) {
        timeFormat = showTime ? "h:mm a" : undefined;
        format = "MMM. D".concat(isThisYear ? "" : ", YYYY".concat(timeFormat ? "," : ""), " ");
    }
    if (timeFormat) {
        format = "".concat(format).concat(timeFormat);
    }
    var formatedDate;
    if (calendarFormat) {
        formatedDate = calDate.calendar(moment$1.now(), {
            nextWeek: format,
            lastWeek: format,
            sameElse: format
        });
    }
    else {
        formatedDate = calDate.format(format);
    }
    return formatedDate;
}

function hasDecimal(number) {
    return number % 1 !== 0;
}
function formatNumber(number, locale, IntlOptions) {
    var uNumber = Number(number);
    if (isNaN(uNumber))
        return number;
    try {
        var uLocale = locale === null || locale === void 0 ? void 0 : locale.replace("_", "-");
        return new Intl.NumberFormat(uLocale || "en-US", IntlOptions).format(uNumber);
    }
    catch (e) {
        return number;
    }
}

var EEvents;
(function (EEvents) {
    EEvents["PAGE"] = "Page";
    EEvents["IDENTIFY"] = "Identify";
    EEvents["GROUP"] = "Group";
    EEvents["SIGN_IN"] = "User.Loggedin";
    EEvents["IMPERSONATE"] = "User.Impersonated";
    EEvents["IMPERSONATE_ACCOUNT"] = "Account.Impersonated";
    EEvents["SIGN_OUT"] = "User.Loggedout";
    EEvents["USER_CREATED"] = "User.Created";
    EEvents["USER_UPDATED"] = "User.Updated";
    EEvents["USER_DELETED"] = "User.Deleted";
    EEvents["USER_CONFIRMED"] = "User.Confirmed";
    EEvents["USER_CONFIRMATION_SENT"] = "User.Confirmation.Sent";
    EEvents["USER_PASSWORD_RESET"] = "User.Password.Reset";
    EEvents["USER_PASSWORD_CONFIRM"] = "User.Password.Confirm";
    EEvents["ACCOUNT_CREATED"] = "Account.Created";
    EEvents["ACCOUNT_CONFIRMED"] = "Account.Confirmed";
    EEvents["ACCOUNT_UPDATED"] = "Account.Updated";
    EEvents["ACCOUNT_SETUP"] = "Account.Setup";
    EEvents["ACCOUNT_SUSPENDED"] = "Account.Suspended";
    EEvents["ACCOUNT_CONVERTED_ORGANIZATION"] = "Account.Converted.Organization";
    EEvents["ACCOUNT_CONVERT_PARTNER_REQUESTED"] = "Account.Convert.Partner.Requested";
    EEvents["ACCOUNT_SETUP_FORM"] = "Account.Setup.Form";
    EEvents["ACCOUNT_DELETED"] = "Account.Deleted";
    EEvents["ACCOUNT_UNSUSPENDED"] = "Account.Unsuspended";
    EEvents["ONBOARDING_COMPLETED"] = "Onboarding.Completed";
    EEvents["PLAN_DOWNGRADE_INITIATED"] = "Plan.Downgrade.Initiated";
    EEvents["PLAN_DOWNGRADE_CANCELLED"] = "Plan.Downgrade.Cancelled";
    EEvents["PLAN_DOWNGRADED"] = "Plan.Downgraded";
    EEvents["PLAN_DOWNGRADE_REQUESTED"] = "Plan.Downgrade.Requested";
    EEvents["PLAN_DOWNGRADE_SCHEDULED"] = "Plan.Downgrade.Scheduled";
    EEvents["PLAN_UPGRADE_INITIATED"] = "Plan.Upgrade.Initiated";
    EEvents["PLAN_UPGRADE_CANCELLED"] = "Plan.Upgrade.Cancelled";
    EEvents["PLAN_UPGRADE"] = "Plan.Upgraded";
    EEvents["CAMPAIGN_CREATED"] = "Campaign.Created";
    EEvents["CAMPAIGN_UPDATED"] = "Campaign.Updated";
    EEvents["CAMPAIGN_SCHEDULED"] = "Campaign.Scheduled";
    EEvents["CAMPAIGN_RESCHEDULED"] = "Campaign.ReScheduled";
    EEvents["CAMPAIGN_UNSCHEDULED"] = "Campaign.Unscheduled";
    EEvents["CAMPAIGN_DELETED"] = "Campaign.Deleted";
    EEvents["CAMPAIGN_DUPLICATED"] = "Campaign.Duplicated";
    EEvents["CAMPAIGN_PAUSED"] = "Campaign.Paused";
    EEvents["CAMPAIGN_CANCELED"] = "Campaign.Canceled";
    EEvents["CAMPAIGN_RESUMED"] = "Campaign.Resumed";
    EEvents["CAMPAIGN_SUSPENDED"] = "Campaign.Suspended";
    EEvents["CAMPAIGN_ARCHIVED"] = "Campaign.Archived";
    EEvents["CAMPAIGN_UNARCHIVED"] = "Campaign.UnArchived";
    EEvents["TEST_EMAIL_SENT"] = "Campaign.Test.Sent";
    EEvents["TEST_EMAIL_SENT_AUTOMATION"] = "Automation.Test.Sent";
    EEvents["CAMPAIGN_LOG_EXPORT"] = "CampaignLog.Export";
    EEvents["CAMPAIGN_LOG_DOWNLOAD"] = "CampaignLog.Export.Download";
    EEvents["CAMPAIGNS_REPORTS_EXPORT"] = "CampaignsReports.Export";
    EEvents["CAMPAIGNS_REPORTS_EXPORT_DOWNLOAD"] = "CampaignsReports.Download";
    EEvents["TRANSACTIONAL_EMAIL_CREATED"] = "TransactionalEmail.Created";
    EEvents["TRANSACTIONAL_EMAIL_UPDATED"] = "TransactionalEmail.Updated";
    EEvents["TRANSACTIONAL_EMAIL_DELETED"] = "TransactionalEmail.Deleted";
    EEvents["TRANSACTIONAL_EMAIL_DUPLICATED"] = "TransactionalEmail.Duplicated";
    EEvents["TRANSACTIONAL_TEST_EMAIL_SENT"] = "TransactionalEmail.Test.Sent";
    EEvents["CONTACT_CREATED"] = "Contact.Created";
    EEvents["CONTACT_UPDATED"] = "Contact.Updated";
    EEvents["CONTACT_DELETED"] = "Contact.Deleted";
    EEvents["CONTACT_UNSUBSCRIBED"] = "Contact.Unsubscribed";
    EEvents["CONTACT_SUPPRESSED"] = "Contact.Suppressed";
    EEvents["CONTACT_UNSUPPRESSED"] = "Contact.Unsuppressed";
    EEvents["CONTACT_IMPORTED"] = "Contact.Imported";
    EEvents["CONTACT_EXPORT"] = "Contact.Export";
    EEvents["CONTACT_EXPORT_DOWNLOAD"] = "Contact.Export.Download";
    EEvents["CONTACT_TAGGED"] = "Contact.Tagged";
    EEvents["CONTACT_UNTAGGED"] = "Contact.Untagged";
    EEvents["CONTACT_INTERESTED"] = "Contact.Interested";
    EEvents["CONTACT_UNINTERESTED"] = "Contact.Uninterested";
    EEvents["SUPPRESSED_EMAIL_EXPORT_CREATED"] = "SuppressedEmail.Export.Created";
    EEvents["SUPPRESSED_EMAIL_EXPORT_DOWNLOAD"] = "SuppressedEmail.Export.Download";
    EEvents["SUPPRESSED_EMAIL_DELETED"] = "SuppressedEmail.Deleted";
    EEvents["SUPPRESSED_EMAIL_ADDED"] = "SuppressedEmail.Added";
    EEvents["LIST_CREATED"] = "List.Created";
    EEvents["LIST_UPDATED"] = "List.Updated";
    EEvents["LIST_DELETED"] = "List.Deleted";
    EEvents["LIST_LOGS_EXPORT_CREATED"] = "ListLogsExport.Created";
    EEvents["LIST_LOGS_EXPORT_DOWNLOAD"] = "ListLogsExport.Download";
    EEvents["SENDER_CREATED"] = "Sender.Created";
    EEvents["SENDER_UPDATED"] = "Sender.Updated";
    EEvents["SENDER_DELETED"] = "Sender.Deleted";
    EEvents["SENDER_CONFIRMED"] = "Sender.Confirmed";
    EEvents["SENDER_CONFIRMATION_SENT"] = "Sender.Confirmation.Sent";
    EEvents["TEMPLATE_CREATED"] = "Template.Created";
    EEvents["TEMPLATE_UPDATED"] = "Template.Updated";
    EEvents["TEMPLATE_DELETED"] = "Template.Deleted";
    EEvents["TEMPLATE_DUPLICATED"] = "Template.Duplicated";
    EEvents["TEMPLATE_SHARED"] = "Template.Shared";
    EEvents["TEMPLATE_UNSCHARED"] = "Template.Unshared";
    EEvents["SYSTEM_EMAILS_UPDATED"] = "SystemEmails.Updated";
    EEvents["FORM_CREATED"] = "Form.Created";
    EEvents["FORM_UPDATED"] = "Form.Updated";
    EEvents["FORM_DELETED"] = "Form.Deleted";
    EEvents["FORM_ENABLED"] = "Form.Enabled";
    EEvents["FORM_DISABLED"] = "Form.Disabled";
    EEvents["FORM_PUBLISHED"] = "Form.Published";
    EEvents["FORM_RENDERED"] = "Form.Rendered";
    EEvents["FORM_RENDERED_PUBLISHED"] = "Form.Rendered.Published";
    EEvents["AUTOMATION_CREATED"] = "Automation.Created";
    EEvents["AUTOMATION_UPDATED"] = "Automation.Updated";
    EEvents["AUTOMATION_DELETED"] = "Automation.Deleted";
    EEvents["AUTOMATION_ACTIVATED"] = "Automation.Activated";
    EEvents["AUTOMATION_DEACTIVATED"] = "Automation.Deactivated";
    EEvents["AUTOMATION_TRIGGER_ADDED"] = "Automation.Trigger.Added";
    EEvents["AUTOMATION_TRIGGER_DELETED"] = "Automation.Trigger.Deleted";
    EEvents["AUTOMATION_ACTION_ADDED"] = "Automation.Action.Added";
    EEvents["AUTOMATION_ACTION_DELETED"] = "Automation.Action.Deleted";
    EEvents["AUTOMATION_CONDITION_ADDED"] = "Automation.Condition.Added";
    EEvents["AUTOMATION_CONDITION_DELETED"] = "Automation.Action.Deleted";
    EEvents["AUTOMATION_UPGRADE_CLICKED"] = "Automation.Upgrade.Clicked";
    EEvents["AUTOMATION_MANUAL_TRIGGER_CLICKED"] = "Automation.Trigger.Manual.Clicked";
    EEvents["AUTOMATION_MANUAL_ADD_CONTACTS_CLICKED"] = "Automation.Manual.AddContacts.Clicked";
    EEvents["AUTOMATION_ACTION_CREATED"] = "Automation.Action.Created";
    EEvents["AUTOMATION_ACTION_UPDATED"] = "Automation.Action.Updated";
    EEvents["AUTOMATION_INTERACTION_OVERVIEW"] = "Automation.Interaction.Overview.Viewed";
    EEvents["AUTOMATION_INTERACTION_CAMPAIGN_REPORT"] = "Automation.Interaction.Report.Viewed";
    EEvents["SEGMENT_CREATED"] = "Segment.Created";
    EEvents["SEGMENT_UPDATED"] = "Segment.Updated";
    EEvents["SEGMENT_DELETED"] = "Segment.Deleted";
    EEvents["ACTION_BLOCKED"] = "Action.Blocked";
    EEvents["BRAND_UPDATED"] = "Brand.Updated";
    EEvents["BRAND_CREATED"] = "Brand.Created";
    EEvents["BRAND_EMAIL_ENRICHED"] = "Brand.Email.Enriched";
    EEvents["BRAND_ORGANIZATION_ENRICHED"] = "Brand.Organization.Enriched";
    EEvents["BRAND_ENRICHED"] = "Brand.Enriched";
    EEvents["BRAND_REPO"] = "BrandRepo.Redirection";
    EEvents["BRAND_REPO_CANCELLED"] = "BrandRepo.Dialog.Cancelled";
    EEvents["SUPPORT_REQUESTED"] = "Support.Requested";
    EEvents["SUPPORT_SIGNED_IN"] = "Support.Signed.In";
    EEvents["TAG_CREATED"] = "Tag.Created";
    EEvents["TAG_UPDATED"] = "Tag.Updated";
    EEvents["TAG_DELETED"] = "Tag.Deleted";
    EEvents["INTEREST_CREATED"] = "Interest.Created";
    EEvents["INTEREST_UPDATED"] = "Interest.Updated";
    EEvents["INTEREST_DELETED"] = "Interest.Deleted";
    EEvents["PREFERENCE_CENTER_CREATED"] = "PreferenceCenter.Created";
    EEvents["PREFERENCE_CENTER_UPDATED"] = "PreferenceCenter.Updated";
    EEvents["AI_SUBJECT_GENERATED"] = "Ai.Subject.Generated";
    EEvents["BUTTON_CLICKED"] = "Button.Clicked";
    EEvents["LINK_CLICKED"] = "Link.Clicked";
    EEvents["DROPDOWN_CLICKED"] = "Dropdown.Clicked";
    EEvents["DROPDOWN_OPTION_SELECTED"] = "Dropdown.Option.Clicked";
    EEvents["MFA_ACTIVATION_FLOW"] = "MFA.Activation.Flow.Started";
    EEvents["MFA_DISABLE_FLOW"] = "MFA.Disable.Flow.Started";
    EEvents["MFA_ENABLED"] = "MFA.Enabled";
    EEvents["MFA_DISABLED"] = "MFA.Disabled";
    EEvents["POPUP_CREATED"] = "Popup.Created";
    EEvents["POPUP_UPDATED"] = "Popup.Updated";
    EEvents["POPUP_DELETED"] = "Popup.Deleted";
    EEvents["POPUP_ENABLED"] = "Popup.Enabled";
    EEvents["POPUP_DISABLED"] = "Popup.Disabled";
    EEvents["POPUP_PUBLISHED"] = "Popup.Published";
    EEvents["PAGE_CREATED"] = "Page.Created";
    EEvents["PAGE_UPDATED"] = "Page.Updated";
    EEvents["PAGE_DELETED"] = "Page.Deleted";
    EEvents["PAGE_ENABLED"] = "Page.Enabled";
    EEvents["PAGE_DISABLED"] = "Page.Disabled";
    EEvents["PAGE_PUBLISHED"] = "Page.Published";
})(EEvents || (EEvents = {}));
function eventCondition(type, disabledEvents) {
    if (disabledEvents === void 0) { disabledEvents = []; }
    if (!(disabledEvents === null || disabledEvents === void 0 ? void 0 : disabledEvents.includes(type)) && (posthog === null || posthog === void 0 ? void 0 : posthog.__loaded)) {
        return true;
    }
    return false;
}
function trackEvent(type, data, dataParser, disabledEvents) {
    if (eventCondition(type, disabledEvents) && (posthog === null || posthog === void 0 ? void 0 : posthog.__loaded)) {
        posthog.capture(type, eventPayloads(type, data || {}, dataParser));
    }
}
function eventIdentify(id, data, dataParser) {
    if (eventCondition(EEvents.IDENTIFY)) {
        posthog.identify(cleanPostHogId(id), eventPayloads(EEvents.IDENTIFY, data || {}, dataParser));
    }
}
function eventLogout() {
    if (posthog === null || posthog === void 0 ? void 0 : posthog.__loaded) {
        posthog.reset();
    }
}
function eventPayloads(event, data, dataParser) {
    var payload = {};
    if (![
        EEvents.IDENTIFY,
        EEvents.GROUP,
        EEvents.PAGE,
    ].includes(event)) {
        payload.url = window.location.href;
        payload.hostname = window.location.hostname;
        payload.user_agent = navigator.userAgent;
        payload["$user-agent"] = navigator.userAgent;
        payload.$useragent = navigator.userAgent;
        var utms = getUtmCookies();
        if (utms.utm_campaign) {
            payload.utm_campaign = utms.utm_campaign;
        }
        if (utms.utm_content) {
            payload.utm_content = utms.utm_content;
        }
        if (utms.utm_medium) {
            payload.utm_medium = utms.utm_medium;
        }
        if (utms.utm_source) {
            payload.utm_source = utms.utm_source;
        }
    }
    if (dataParser) {
        payload = __assign(__assign({}, dataParser(event, data)), payload);
    }
    else {
        payload = __assign(__assign({}, data), payload);
    }
    return flattenObject(payload);
}
function flattenObject(obj, parentKey, result) {
    if (parentKey === void 0) { parentKey = ""; }
    if (result === void 0) { result = {}; }
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            var newKey = parentKey ? "".concat(parentKey, "_").concat(key) : key;
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
                flattenObject(obj[key], newKey, result);
            }
            else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}
function initPostHog(_a) {
    var id = _a.id, _b = _a.enabled, enabled = _b === void 0 ? true : _b, server = _a.server, uiHost = _a.uiHost, onLoaded = _a.onLoaded, eventsPerSecond = _a.eventsPerSecond, eventsBurstLimit = _a.eventsBurstLimit;
    if (id &&
        enabled &&
        !navigator.userAgent.includes("Prerender") &&
        !(posthog === null || posthog === void 0 ? void 0 : posthog.__loaded) &&
        !amIImpersonating()) {
        var phId = getUrlQueryParam("phId");
        var bootstrapData = {};
        if (phId && eventCondition(EEvents.IDENTIFY)) {
            bootstrapData.distinctID = decodeURIComponent(phId);
        }
        posthog.init(id, {
            api_host: server || process.env.POSTHOG_SERVER || "https://e.cakemail.com",
            ui_host: uiHost || process.env.POSTHOG_UI_HOST || "https://us.posthog.com",
            loaded: function (posthog) {
                onLoaded && onLoaded(posthog);
            },
            opt_in_site_apps: true,
            bootstrap: bootstrapData,
            capture_pageview: false,
            rate_limiting: {
                events_per_second: eventsPerSecond || 50,
                events_burst_limit: eventsBurstLimit || 200,
            }
        });
    }
}
function cleanPostHogId(id) {
    var formatedId = id || "";
    /*const split = formatedId.split("@");
    if(split.length > 1){
        formatedId += "@" + split[1].toLowerCase();
    }
    return formatedId;*/
    return formatedId.toLowerCase();
}

function startPromisePool(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        function callSetter(result, index, skip) {
            if (index === void 0) { index = 0; }
            if (skip === void 0) { skip = false; }
            if (skip === false && index % setterBatched === 0) {
                var res = __assign({}, result);
                if (storageKeyName) {
                    setStorage({ key: storageKeyName, data: res, type: EStorageType.session });
                }
                setter && setter(res);
            }
        }
        var storageKeyName, partialData;
        var data = _b.data, setter = _b.setter, _c = _b.concurrency, concurrency = _c === void 0 ? 5 : _c, _d = _b.setterBatched, setterBatched = _d === void 0 ? 5 : _d, poolRef = _b.poolRef, storageKey = _b.storageKey, _e = _b.dataIdPath, dataIdPath = _e === void 0 ? "id" : _e, processor = _b.processor, finalSetOnly = _b.finalSetOnly;
        return __generator(this, function (_f) {
            storageKeyName = storageKey !== null && storageKey !== void 0 ? storageKey : undefined;
            partialData = {};
            if (storageKeyName) {
                partialData = getStorage({ key: storageKeyName, type: EStorageType.session }) || {};
            }
            PromisePool.withConcurrency(concurrency)
                .for(data)
                .process(function (item, index, pool) {
                var id = typeof item === "string" ? item : getNestedProperty(item, dataIdPath) || findNestedProperty(item, dataIdPath);
                if (poolRef && !poolRef.current)
                    poolRef.current = pool;
                if (storageKeyName && (partialData === null || partialData === void 0 ? void 0 : partialData[id])) {
                    callSetter(partialData, index, finalSetOnly);
                    return partialData[id];
                }
                else {
                    if (processor) {
                        return processor({
                            processSetter: function (processedData) {
                                if (storageKeyName) {
                                    partialData[id] = processedData;
                                }
                                callSetter(partialData, index, finalSetOnly);
                            },
                            item: item
                        });
                    }
                    else {
                        if (storageKeyName && (partialData === null || partialData === void 0 ? void 0 : partialData[id])) {
                            if (storageKeyName) {
                                partialData[id] = item;
                            }
                            callSetter(partialData, index, finalSetOnly);
                            return partialData[id];
                        }
                        else {
                            return item;
                        }
                    }
                }
            })
                .then(function (_a) {
                var results = _a.results; _a.errors;
                if (poolRef)
                    poolRef.current = undefined;
                callSetter(storageKeyName ? partialData : results, 0);
            });
            return [2 /*return*/];
        });
    });
}
function addPartialInformation(_a) {
    var partialPoolStorageKey = _a.partialPoolStorageKey, data = _a.data;
    var partialInfo = getStorage({ key: partialPoolStorageKey, type: EStorageType.session }) || {};
    partialInfo = __assign(__assign({}, partialInfo), data);
    setStorage({ key: partialPoolStorageKey, data: partialInfo, type: EStorageType.session });
}
function deletePartialInformation(_a) {
    var partialPoolStorageKey = _a.partialPoolStorageKey, itemKeys = _a.itemKeys;
    if (itemKeys === "all") {
        deleteStorageItem({ key: partialPoolStorageKey, type: EStorageType.session });
    }
    else {
        var partialInfo_1 = getStorage({ key: partialPoolStorageKey, type: EStorageType.session }) || {};
        if (Array.isArray(itemKeys)) {
            itemKeys.forEach(function (key) {
                delete (partialInfo_1[key]);
            });
        }
        else {
            delete (partialInfo_1[itemKeys]);
        }
        setStorage({ key: partialPoolStorageKey, data: partialInfo_1, type: EStorageType.session });
    }
}

var originalBrand = {
    client_config: {
        brand_repo: {
            url: "",
            accountId: "",
            brandId: ""
        },
        support: {
            email: "",
            phone: ""
        },
        segment_config: {
            disabled_event: [],
            enabled: false,
            id: "",
            server: ""
        },
        zendesk_config: {
            enabled: false,
            return_to: ""
        },
        recaptcha: {
            enabled: false,
            key: ""
        },
        verisoul: {
            enabled: false,
            dryrun: true
        },
        yaplaCms: {
            calendarEventsEnabled: false
        },
        indiegrafIntegration: {
            enabled: false
        }
    },
    page_customization: {
        filters: {
            templatetags: []
        },
        sign_in: {
            sign_up_link_disabled: false,
            sign_up_link_redirection: "",
        },
        sign_up: {
            disabled: false,
            sign_in_link_disabled: false,
            sign_in_link_redirection: "",
        },
        forms: {
            disabled: false
        },
        general: {
            reset_password_disabled: false
        },
        users: {
            create_disabled: false,
            delete_disabled: false
        },
        campaigns: {
            createGoesToOverview: true,
            disabledMenu: []
        },
        templateBrowser: {
            disabledMenu: []
        }
    },
    images: {
        "ill-empty-automations": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-automations.png",
        "ill-empty-ab-test-drafts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-ab-test-drafts.png",
        "ill-empty-ab-test-outbox": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-ab-test-outbox.png",
        "ill-empty-ab-test-complete": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-ab-test-complete.png",
        favicon: "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-empty-forms": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-forms.png",
        "ill-empty-campaigns-drafts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-drafts.png",
        "favicon-mstile": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-add-contacts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-add-contacts.png",
        "favicon-32": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "favicon-android-chrome-512": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-create-email": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-create-email.png",
        "ill-empty-campaigns-outbox": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-outbox.png",
        "ill-empty-contacts": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-contacts.png",
        "favicon-16": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        logo: "https://app-brand-assets.s3.amazonaws.com/default/default-logo.svg",
        injected_logo: "https://app-brand-assets.s3.amazonaws.com/default/default-logo.svg",
        "favicon-android-chrome-192": "https://app-brand-assets.s3.amazonaws.com/default/favicon.svg",
        "ill-empty-campaigns-sent": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-sent.png",
        "favicon-apple-touch": "https://app-brand-assets.s3.amazonaws.com/cakemail/favicon/apple-touch-icon.png",
        "ill-empty-campaigns-templates": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-campaigns-templates.png",
        "ill-empty-listing": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-empty-listing.png",
        "ill-workflow": "https://app-brand-assets.s3.amazonaws.com/cakemail/illustrations/ill-workflow.png"
    },
    theme: {
        base: {
            "background-color-2": "#F8F8F8",
            "body-font-color": "#4A4A4A",
            "error-brand-color": "#FF4835",
            "heading-font": "aller, Lucida Grande,Lucida Sans Unicode,Lucida Sans,Geneva,Verdana,sans-serif",
            "primary-brand-color": "#69006E",
            "text-font": "proxima-nova, Lucida Grande,Lucida Sans Unicode,Lucida Sans,Geneva,Verdana,sans-serif",
            "body-font-color-2": "#9B9B9B",
            "warning-brand-color": "#FF9E0E",
            "success-brand-color": "#0ABDAE",
            "secondary-brand-color": "#0ABDAE",
            "background-color-1": "#FFFFFF"
        },
        advance: {
            Spinner: {
                "spinner-stroke-outer": "#1E7FFF"
            }
        }
    },
    url: {
        privacy_url: {
            en: ""
        },
        email_designer_help: {
            en: ""
        },
        schedule_help_url: {
            en: ""
        },
        anti_spam_url: {
            en: ""
        },
        protect_account_kb_url: {
            en: ""
        },
        unusubcribe_mergetag_kb_url: {
            en: ""
        },
        kb_boost_1: {
            en: ""
        },
        kb_boost_segment: {
            en: ""
        },
        kb_choose_sender_email: {
            en: ""
        },
        terms_url: {
            en: ""
        },
        address_mergetag_kb_url: {
            en: ""
        },
        help_url: {
            en: ""
        }
    },
    list_redirection: {
        logo: {
            id: null,
            width: null,
            type: ""
        },
        styles: {
            "title-color": "#444444",
            "text-color": "#444444",
            "background-color": "#F8F8F8",
            "background-ele-color": "#ffffff"
        }
    },
    name: "",
    config: {}
};

function getMuiAvatar(theme) {
    return {
        variants: [
            {
                props: { variant: "circular" },
                style: {
                    borderRadius: "100px",
                },
            },
            {
                props: { variant: "rounded" },
                style: {
                    borderRadius: "12px",
                },
            },
            {
                props: { variant: "square" },
                style: {
                    borderRadius: "8px",
                },
            }
        ],
        styleOverrides: {
            root: __assign(__assign({}, theme.typography.h3S), { 
                //padding: theme.spacing(1),
                whiteSpace: "nowrap", boxSizing: "border-box", background: "none", border: "1px solid " + theme.palette.pebble.main, textTransform: "uppercase", fontSize: "1rem", color: theme.palette.primary.main, wordSpacing: "-4px" }),
        },
        defaultProps: {},
    };
}

function getMuiBadge(theme) {
    return {
        variants: [],
        styleOverrides: {
            root: function (_a) {
                var ownerState = _a.ownerState, theme = _a.theme;
                return {
                    '& .MuiBadge-badge': {
                        color: theme.palette[ownerState.color].main,
                        boxShadow: "0 0 0 2px ".concat(theme.palette.background.paper),
                        '&::after': {
                            position: 'absolute',
                            top: -1,
                            left: -1,
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            animation: 'ripple 1.2s infinite ease-in-out',
                            border: '1px solid currentColor',
                            content: '""',
                        },
                    },
                    '@keyframes ripple': {
                        '0%': {
                            transform: 'scale(.8)',
                            opacity: 1,
                        },
                        '100%': {
                            transform: 'scale(1.5)',
                            opacity: 0,
                        },
                    },
                };
            }
        },
        defaultProps: {},
    };
}

function getMuiButton(theme, brandContextTheme) {
    return {
        variants: [
            {
                props: { size: "small" },
                style: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    var padding = theme.spacing(2, 3);
                    if (ownerState.className && ownerState.className.includes("iconOnly")) {
                        padding = theme.spacing(2);
                    }
                    return {
                        padding: padding,
                        fontSize: theme.typography.body1S.fontSize,
                        lineHeight: theme.typography.body1S.lineHeight,
                        fontWeight: 600,
                    };
                },
            },
            {
                props: { size: "medium" },
                style: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    var padding = theme.spacing(3, 4);
                    if (ownerState.className && ownerState.className.includes("iconOnly")) {
                        padding = theme.spacing(3);
                    }
                    return {
                        padding: padding,
                        fontSize: theme.typography.body1.fontSize,
                        lineHeight: theme.typography.body1.lineHeight,
                    };
                },
            },
            {
                props: { size: "large" },
                style: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    var padding = theme.spacing(5, 8);
                    if (ownerState.className && ownerState.className.includes("iconOnly")) {
                        padding = theme.spacing(5);
                    }
                    return {
                        padding: padding,
                        fontSize: theme.typography.body1L.fontSize,
                        lineHeight: theme.typography.body1L.lineHeight,
                    };
                },
            },
            {
                props: {
                    disabled: true
                },
                style: {
                    opacity: 1,
                    pointerEvent: "none",
                    color: "blue"
                },
            },
        ],
        styleOverrides: {
            //full override
            root: function (_a) {
                var ownerState = _a.ownerState, theme = _a.theme;
                var styles = {};
                var fullColor = ["primary", "secondary", "warning", "error", "success", "darkMatter", "boulder"];
                if (ownerState.variant === 'contained') {
                    if (fullColor.includes(ownerState.color)) {
                        styles["color"] = theme.palette.common.white;
                        styles[".MuiSvgIcon-root"] = {
                            color: theme.palette.common.white
                        };
                        styles["&:active"] = {
                            background: "".concat(theme.palette[ownerState.color].main, " !important"),
                            color: "".concat(theme.palette.common.white, " !important"),
                            ".MuiSvgIcon-root": {
                                color: "".concat(theme.palette.common.white, " !important"),
                            }
                        };
                        styles["&.Mui-disabled"] = {
                            background: theme.palette[ownerState.color].main,
                            color: theme.palette.common.white,
                            "&:not(.MuiLoadingButton-loading)": {
                                opacity: "0.65"
                            }
                        };
                        styles["&.MuiLoadingButton-loading svg circle"] = {
                            stroke: theme.palette.common.white
                        };
                    }
                    else {
                        styles["color"] = theme.palette.text.primary;
                        styles["&:active"] = {
                            background: "".concat(theme.palette[ownerState.color].main, "!important"),
                            color: "".concat(theme.palette.text.primary, "!important"),
                            ".MuiSvgIcon-root": {
                                color: "".concat(theme.palette.text.primary, " !important"),
                            }
                        };
                        styles["&.MuiLoadingButton-loading svg circle"] = {
                            stroke: theme.palette.text.primary
                        };
                    }
                    var hoverColor = theme.palette.wildSand.main;
                    var hoverTextColor = theme.palette.text.primary;
                    if (ownerState.color === "primary" && (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.btnPrimaryContainedHoverBg)) {
                        hoverColor = brandContextTheme.btnPrimaryContainedHoverBg;
                        if (!isColorLight(brandContextTheme.btnPrimaryContainedHoverBg))
                            hoverTextColor = theme.palette.common.white;
                    }
                    else if (ownerState.color === "secondary" && (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.btnSecondaryContainedHoverBg)) {
                        hoverColor = brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.btnSecondaryContainedHoverBg;
                        if (!isColorLight(brandContextTheme.btnPrimaryContainedHoverBg))
                            hoverTextColor = theme.palette.common.white;
                    }
                    styles["&:hover,&.hover"] = {
                        background: hoverColor,
                        color: hoverTextColor,
                        ".MuiSvgIcon-root": {
                            color: hoverTextColor,
                        }
                    };
                }
                else if (ownerState.variant === 'outlined') {
                    styles["color"] = theme.palette[ownerState.color].main;
                    styles["outline"] = "1px solid ".concat(theme.palette.wildSand.main);
                    styles["background"] = theme.palette.common.white;
                    styles[".MuiSvgIcon-root"] = {
                        color: theme.palette[ownerState.color].main
                    };
                    styles["&:active"] = {
                        background: "".concat(theme.palette.common.white, " !important"),
                        color: "".concat(theme.palette[ownerState.color].main, " !important"),
                        outline: "1px solid ".concat(theme.palette.wildSand.main, " !important"),
                        ".MuiSvgIcon-root": {
                            color: "".concat(theme.palette[ownerState.color].main, " !important"),
                        }
                    };
                    styles["&.Mui-disabled"] = {
                        //background: "none",
                        color: theme.palette[ownerState.color].main,
                        "&:not(.MuiLoadingButton-loading)": {
                            opacity: "0.65"
                        }
                    };
                    styles["&.MuiLoadingButton-loading svg circle"] = {
                        stroke: theme.palette[ownerState.color].main
                    };
                    styles["&:hover,&.hover"] = {
                        outline: "1px solid ".concat(theme.palette.wildSand.main),
                        background: theme.palette.wildSand.main,
                        color: theme.palette.text.primary,
                        ".MuiSvgIcon-root": {
                            color: theme.palette.text.primary,
                        }
                    };
                }
                else if (ownerState.variant === 'text') {
                    styles["&:hover,&.hover"] = {
                        background: theme.palette.wildSand.main,
                    };
                }
                styles["border"] = "none!important";
                styles["borderRadius"] = "8px";
                styles["textAlign"] = "center";
                styles["textTransform"] = "none";
                styles["minWidth"] = "32px";
                styles["&.isIconText .MuiSvgIcon-root"] = {
                    marginLeft: theme.spacing(2)
                };
                styles["&.MuiLoadingButton-loading .MuiLoadingButton-loadingIndicatorStart"] = {
                    position: "unset",
                    marginRight: theme.spacing(4)
                };
                styles["&.MuiLoadingButton-loading .MuiLoadingButton-loadingIndicatorEnd"] = {
                    position: "unset",
                    marginLeft: theme.spacing(4)
                };
                styles["transitionDuration"] = "150ms !important";
                return styles;
            },
        },
        defaultProps: {
            variant: "contained",
            color: "primary",
            size: "medium",
            disableRipple: true,
            disableElevation: true
        },
    };
}

function getMuiCheckbox(theme) {
    return {
        variants: [
            {
                props: { size: "medium" },
                style: {
                    width: theme.spacing(6),
                    height: theme.spacing(6),
                    ".MuiSvgIcon-root": {
                        fontSize: "0.625rem",
                    }
                },
            },
            {
                props: { size: "small" },
                style: {
                    width: theme.spacing(4),
                    height: theme.spacing(4),
                    ".MuiSvgIcon-root": {
                        fontSize: theme.spacing(2),
                    }
                },
            },
        ],
        styleOverrides: {
            root: function (_a) {
                var ownerState = _a.ownerState, theme = _a.theme;
                var styles = {
                    border: "1px solid ".concat(theme.palette.silver.main),
                    background: theme.palette.common.white,
                    "&.Mui-disabled": {
                        opacity: "0.65",
                    },
                    "&.Mui-checked": {
                        border: "2px solid ".concat(theme.palette[ownerState.color].main),
                        ".MuiSvgIcon-root": {
                            display: "block"
                        }
                    },
                    ".MuiSvgIcon-root": {
                        display: "none"
                    },
                    "&:hover.Mui-checked": {
                        border: "2px solid ".concat(theme.palette.wildSand.main),
                        background: theme.palette.wildSand.main,
                        color: theme.palette.text.primary,
                        ".MuiSvgIcon-root": {
                            display: "block",
                            color: theme.palette.body1.main,
                        }
                    },
                    "&:hover:not(.Mui-checked)": {
                        border: "2px solid ".concat(theme.palette.wildSand.main),
                        background: theme.palette.wildSand.main,
                        color: theme.palette.text.primary,
                        ".MuiSvgIcon-root": {
                            display: "block",
                            color: theme.palette.silver.main,
                        }
                    }
                };
                return styles;
            },
        },
        defaultProps: {
            disableRipple: true,
        },
    };
}

function getMuiChip(theme) {
    return {
        variants: [
            {
                props: { size: "small" },
                style: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    var classes = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className;
                    var conditionalStyles = {};
                    if ((classes === null || classes === void 0 ? void 0 : classes.includes("lowerCased")) && (classes === null || classes === void 0 ? void 0 : classes.includes("squared"))) {
                        conditionalStyles.padding = theme.spacing(1.5);
                    }
                    else {
                        conditionalStyles.padding = theme.spacing(1, 2);
                    }
                    return __assign(__assign(__assign({}, theme.typography.body2S), { lineHeight: "0.875rem", color: theme.palette.common.white, fontWeight: 700, borderRadius: "4px", ".MuiChip-deleteIcon": {
                            fontSize: 14
                        } }), conditionalStyles);
                },
            },
            {
                props: { size: "medium" },
                style: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    var classes = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className;
                    var conditionalStyles = {};
                    if ((classes === null || classes === void 0 ? void 0 : classes.includes("lowerCased")) && (classes === null || classes === void 0 ? void 0 : classes.includes("squared"))) {
                        conditionalStyles["padding"] = theme.spacing(2);
                    }
                    else {
                        conditionalStyles["padding"] = theme.spacing(1.5, 2.5);
                    }
                    return __assign(__assign(__assign({}, theme.typography.body2S), conditionalStyles), { lineHeight: "0.875rem", color: theme.palette.common.white, fontWeight: 700, ".MuiChip-deleteIcon": {
                            fontSize: 16
                        } });
                },
            },
            {
                props: { variant: "filled" },
                style: {},
            },
            {
                props: { variant: "outlined" },
                style: {},
            },
        ],
        styleOverrides: {
            root: function (_a) {
                var _b, _c, _d, _e;
                var ownerState = _a.ownerState, theme = _a.theme;
                var styles = {};
                var fullColor = ["primary", "secondary", "warning", "error", "success", "darkMatter", "boulder", "body1", "body2", "silver"];
                if (ownerState.variant === 'outlined') {
                    styles["color"] = "".concat(theme.palette[ownerState.color].main, "!important");
                }
                if (!fullColor.includes(ownerState.color)) {
                    styles["color"] = "".concat(theme.palette.text.primary, "!important");
                    if ((_b = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _b === void 0 ? void 0 : _b.includes("tinted")) {
                        styles["background"] = "".concat(lighten(String(theme.palette.text.primary), 0.9), "!important");
                    }
                }
                else {
                    if ((_c = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _c === void 0 ? void 0 : _c.includes("tinted")) {
                        styles["color"] = "".concat(theme.palette[ownerState.color].main, "!important");
                        styles["background"] = "".concat(lighten(String(theme.palette[ownerState.color].main), 0.9), "!important");
                    }
                }
                if ((_d = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _d === void 0 ? void 0 : _d.includes("squared")) {
                    styles["borderRadius"] = "8px";
                }
                else {
                    styles["borderRadius"] = "100px";
                }
                if ((_e = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _e === void 0 ? void 0 : _e.includes("lowerCased")) {
                    styles["span"] = {
                        padding: "0 2px"
                    };
                    styles[".MuiSvgIcon-root"] = {
                        margin: 0,
                        paddingRight: theme.spacing(1.5)
                    };
                }
                else {
                    styles["textTransform"] = "uppercase";
                    styles[".MuiChip-label"] = {
                        position: "relative",
                        top: "1px"
                    };
                    styles[".MuiSvgIcon-root"] = {
                        margin: 0,
                        paddingRight: theme.spacing(2)
                    };
                }
                styles["height"] = "unset";
                styles[".MuiChip-deleteIcon"] = {
                    paddingRight: 0,
                    paddingLeft: theme.spacing(2),
                    color: "inherit",
                };
                return styles;
            },
            label: {
                padding: 0
            }
        },
        defaultProps: {
            variant: "filled",
            size: "medium",
            color: "secondary"
        },
    };
}

function getMuiDrawer(theme) {
    return {
        styleOverrides: {
            root: {},
        },
        defaultProps: {},
    };
}

function getMuiLinearProgress(theme) {
    return {
        styleOverrides: {
            root: {
                width: "100%",
                height: theme.spacing(1.5),
                border: "1px solid " + theme.palette.cloud.main,
                borderRadius: 16,
                background: theme.palette.cloud.main,
                "&.small": {
                //height: theme.spacing(1)
                },
                "&.medium": {
                    height: theme.spacing(3.5)
                },
                "&.large": {
                    height: theme.spacing(4)
                }
            }
        },
        defaultProps: {
            variant: "indeterminate"
        },
    };
}

function getMuiLink(theme) {
    return {
        variants: [
            {
                props: { color: "secondary.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.secondary.dark,
                    }
                },
            },
            {
                props: { color: "primary.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.primary.dark,
                    }
                },
            },
            {
                props: { color: "body1.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.body1.dark,
                    }
                },
            },
            {
                props: { color: "body2.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.body2.dark,
                    }
                },
            },
            {
                props: { color: "darkMatter.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.darkMatter.dark,
                    }
                },
            },
            {
                props: { color: "silver.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.silver.dark,
                    }
                },
            },
            {
                props: { color: "wildSand.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.wildSand.dark,
                    }
                },
            },
            {
                props: { color: "cloud.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.cloud.dark,
                    }
                },
            },
            {
                props: { color: "boulder.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.boulder.dark,
                    }
                },
            },
            {
                props: { color: "pebble.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.pebble.dark,
                    }
                },
            },
            {
                props: { color: "white.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.white.dark,
                    }
                },
            },
            {
                props: { color: "shade1000.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade1000.dark,
                    }
                },
            },
            {
                props: { color: "shade950.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade950.dark,
                    }
                },
            },
            {
                props: { color: "shade900.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade900.dark,
                    }
                },
            },
            {
                props: { color: "shade850.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade850.dark,
                    }
                },
            },
            {
                props: { color: "shade800.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade800.dark,
                    }
                },
            },
            {
                props: { color: "shade750.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade750.dark,
                    }
                },
            },
            {
                props: { color: "shade700.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade700.dark,
                    }
                },
            },
            {
                props: { color: "shade650.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade650.dark,
                    }
                },
            },
            {
                props: { color: "shade600.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade600.dark,
                    }
                },
            },
            {
                props: { color: "shade550.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade550.dark,
                    }
                },
            },
            {
                props: { color: "shade500.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade500.dark,
                    }
                },
            },
            {
                props: { color: "shade450.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade450.dark,
                    }
                },
            },
            {
                props: { color: "shade400.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade400.dark,
                    }
                },
            },
            {
                props: { color: "shade350.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade350.dark,
                    }
                },
            },
            {
                props: { color: "shade300.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade300.dark,
                    }
                },
            },
            {
                props: { color: "shade250.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade250.dark,
                    }
                },
            },
            {
                props: { color: "shade200.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade200.dark,
                    }
                },
            },
            {
                props: { color: "shade150.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade150.dark,
                    }
                },
            },
            {
                props: { color: "shade100.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade100.dark,
                    }
                },
            },
            {
                props: { color: "shade50.main" },
                style: {
                    "&:hover": {
                        color: theme.palette.shade50.dark,
                    }
                },
            },
        ],
        styleOverrides: {
            root: {
                cursor: "pointer",
                "&:hover": {
                    color: theme.palette.primary.dark,
                }
            },
        },
        defaultProps: {
            color: "secondary.main",
            variant: "link"
        },
    };
}

function getMuiMenu(theme) {
    return {
        styleOverrides: {
            root: {
                zIndex: "10000",
                "&.hasStickyActions, &.hasSearch": {
                    ".MuiPaper-root": {
                        maxHeight: "40vh",
                    }
                },
                "&.hasStickyActions.hasSearch .MuiPaper-root": {
                    maxHeight: "45vh",
                },
                ".MuiPaper-root": {
                    overflowY: "auto",
                    marginTop: "0.75rem",
                    maxHeight: "35vh",
                    width: " max-content",
                    boxShadow: "0px 0px 15px 0px #00000026",
                    padding: theme.spacing(3),
                    borderRadius: 16,
                    minWidth: 300,
                    background: theme.palette.background.default,
                    boxSizing: "border-box",
                    "&::-webkit-scrollbar": {
                        background: "none",
                        borderTopRightRadius: "16px",
                        borderBottomRightRadius: "16px",
                        width: 8,
                    },
                    "&::-webkit-scrollbar-track": {},
                    "&::-webkit-scrollbar-thumb": {
                        background: theme.palette.body2.main,
                        borderRadius: "16px",
                    },
                    "::-webkit-scrollbar-track": {},
                    ".search-component-v2": {
                        marginBottom: theme.spacing(3),
                        ".inputContainer": {
                            padding: theme.spacing(3),
                            boxShadow: "none",
                            border: "1px solid " + theme.palette.wildSand.main,
                            "input": {
                                marginLeft: theme.spacing(3),
                            }
                        }
                    },
                    ".stickyActions": {
                        marginTop: theme.spacing(3),
                        background: theme.palette.background.default,
                        position: "sticky",
                        bottom: 0
                    }
                }
            },
            list: {
                padding: 0
            }
        },
        defaultProps: {},
    };
}

function getMuiMenuItem(theme) {
    return {
        styleOverrides: {
            root: __assign(__assign({}, theme.typography.body1L), { lineHeight: "unset", padding: theme.spacing(3), borderRadius: 8, ":hover,&.Mui-selected": {
                    background: theme.palette.cloud.main + "!important",
                }, "&.isAction:not(:hover)": {
                    background: 'none !important',
                    ".selectedCheckmark": {
                        display: "none !important"
                    }
                }, "&.isAction.Mui-selected .selectedCheckmark": {
                    display: "none !important"
                }, "&.isTitle": {
                    pointerEvents: "none",
                    paddingTop: 0,
                    paddingBottom: 0
                }, ".MuiListItemIcon-root": {
                    marginRight: theme.spacing(3),
                    minWidth: "max-content"
                }, "&.showDivider": {
                    minHeight: 1,
                    padding: theme.spacing(3, 0),
                    background: "none!important",
                    pointerEvents: "none !important"
                }, ".MuiDivider-root": {
                    width: "100%"
                }, ".selectedCheckmark": {
                    display: "none"
                }, "&.Mui-selected .selectedCheckmark": {
                    marginRight: 0,
                    display: "block"
                }, "&.disabled": {
                    pointerEvents: "none",
                    opacity: "0.65"
                } })
        },
        defaultProps: {
            disableRipple: true,
        },
    };
}

function getMuiPopover(theme) {
    return getMuiMenu(theme);
}

function getMuiPopper(theme) {
    return {};
}

function getMuiRadio(theme) {
    return {
        variants: [
            {
                props: { size: "medium" },
                style: {
                    width: theme.spacing(6),
                    height: theme.spacing(6),
                    ".MuiSvgIcon-root": {
                        fontSize: theme.spacing(5),
                    }
                },
            },
            {
                props: { size: "small" },
                style: {
                    width: theme.spacing(4.5),
                    height: theme.spacing(4.5),
                    padding: "7px",
                    ".MuiSvgIcon-root": {
                        fontSize: theme.spacing(4),
                    }
                },
            },
        ],
        styleOverrides: {
            root: function (_a) {
                var ownerState = _a.ownerState, theme = _a.theme;
                var styles = {
                    border: "1px solid ".concat(theme.palette.silver.main),
                    background: theme.palette.common.white,
                    "&.Mui-disabled": {
                        opacity: "0.65",
                    },
                    "&.Mui-checked": {
                        border: "2px solid ".concat(theme.palette[ownerState.color].main),
                    },
                    "&:hover.Mui-checked": {
                        border: "2px solid ".concat(theme.palette.wildSand.main),
                        background: theme.palette.wildSand.main,
                        color: theme.palette.text.primary,
                        ".MuiSvgIcon-root": {
                            color: theme.palette.body1.main,
                        }
                    },
                    "&:hover:not(.Mui-checked)": {
                        border: "2px solid ".concat(theme.palette.wildSand.main),
                        background: theme.palette.wildSand.main,
                        color: theme.palette.text.primary,
                        ".MuiSvgIcon-root": {
                            color: theme.palette.silver.main,
                        }
                    },
                    "span > svg:first-child": {
                        opacity: 0,
                    },
                    "span > svg:last-child": {
                        color: theme.palette[ownerState.color].main
                    },
                };
                return styles;
            },
        },
        defaultProps: {
            disableRipple: true,
            size: "medium"
        },
    };
}

function getMuiSelect(theme) {
    return {
        variants: [
            {
                props: { variant: "standard" },
                style: {
                    ":before,:after": {
                        border: "none !important"
                    }
                },
            },
        ],
        styleOverrides: {
            //full override
            root: function (_a) {
                var _b, _c, _d, _e, _f, _g, _h;
                var ownerState = _a.ownerState, theme = _a.theme;
                var styles = {};
                var fullColor = ["primary", "secondary", "warning", "error", "success", "darkMatter", "boulder"];
                var colorMatches = getTColor(((_b = ownerState === null || ownerState === void 0 ? void 0 : ownerState.SelectDisplayProps) === null || _b === void 0 ? void 0 : _b.color) || "primary");
                /*
                CUSTOM SIZE STYLES
                */
                if (ownerState.variant !== 'standard') {
                    if ((_c = ownerState.className) === null || _c === void 0 ? void 0 : _c.includes("small")) {
                        styles = {
                            ".MuiSelect-select": {
                                padding: ownerState.className.includes("iconOnly") ? theme.spacing(2) + "!important" : theme.spacing(2, 3.5) + "!important",
                                ".MuiTypography-root": {
                                    fontSize: theme.typography.body1S.fontSize,
                                    lineHeight: theme.typography.body1S.lineHeight,
                                    fontWeight: 600,
                                }
                            }
                        };
                    }
                    else if ((_d = ownerState.className) === null || _d === void 0 ? void 0 : _d.includes("medium")) {
                        styles = {
                            ".MuiSelect-select": {
                                padding: ownerState.className.includes("iconOnly") ? theme.spacing(3) + "!important" : theme.spacing(3, 3.5) + "!important",
                                ".MuiTypography-root": {
                                    fontSize: theme.typography.body1.fontSize,
                                    lineHeight: theme.typography.body1.lineHeight,
                                }
                            }
                        };
                    }
                    else if ((_e = ownerState.className) === null || _e === void 0 ? void 0 : _e.includes("large")) {
                        styles = {
                            ".MuiSelect-select": {
                                padding: ownerState.className.includes("iconOnly") ? theme.spacing(5) + "!important" : theme.spacing(4, 3.5) + "!important",
                                ".MuiTypography-root": {
                                    fontWeight: 600,
                                    fontSize: theme.typography.body1L.fontSize,
                                    lineHeight: theme.typography.body1L.lineHeight,
                                }
                            }
                        };
                    }
                }
                /*
                CUSTOM COLOR STYLES BASED ON VARIANT
                */
                if (ownerState.variant === 'filled') {
                    if (fullColor.includes(colorMatches)) {
                        styles = __assign(__assign({}, styles), { color: theme.palette.common.white, background: theme.palette[colorMatches].main, ".MuiSvgIcon-root": {
                                color: theme.palette.common.white
                            }, "&:active": {
                                background: "".concat(theme.palette[colorMatches].main, " !important"),
                                color: "".concat(theme.palette.common.white, " !important"),
                                ".MuiSvgIcon-root": {
                                    color: "".concat(theme.palette.common.white, " !important"),
                                }
                            }, "&.Mui-disabled": {
                                pointerEvents: "none !important",
                                background: theme.palette[colorMatches].main,
                                color: theme.palette.common.white,
                                opacity: "0.65"
                            } });
                    }
                    else {
                        styles = __assign(__assign({}, styles), { color: theme.palette.text.primary, "&:active": {
                                background: "".concat(theme.palette[colorMatches].main, "!important"),
                                color: "".concat(theme.palette.text.primary, "!important"),
                                ".MuiSvgIcon-root": {
                                    color: theme.palette.text.primary,
                                }
                            } });
                    }
                    styles = __assign(__assign({}, styles), { "&:hover:not(.Mui-disabled),&.open,&.Mui-focused": {
                            border: "none",
                            background: theme.palette.pebble.main,
                            color: theme.palette.text.primary,
                            ".MuiSvgIcon-root": {
                                color: theme.palette.text.primary,
                            }
                        }, ":before,:after": {
                            display: "none!important"
                        } });
                }
                else if (ownerState.variant === 'outlined') {
                    styles = __assign(__assign({}, styles), { color: theme.palette[colorMatches].main, outline: ((_f = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _f === void 0 ? void 0 : _f.includes("noLabel")) ? "1px solid ".concat(theme.palette.wildSand.main) : "none", "fieldset": {
                            borderColor: theme.palette.wildSand.main + "!important",
                            borderWidth: ((_g = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _g === void 0 ? void 0 : _g.includes("noLabel")) ? "0px!important" : "1px !important"
                        }, background: theme.palette.common.white, ".MuiSvgIcon-root": {
                            color: theme.palette[colorMatches].main
                        }, "&.Mui-disabled,.Mui-disabled": {
                            pointerEvents: "none !important",
                            background: theme.palette.common.white,
                            color: theme.palette[colorMatches].main + "!important",
                            opacity: "0.65",
                            ".MuiSvgIcon-root": {
                                color: theme.palette[colorMatches].main + "!important",
                            }
                        }, "&:hover:not(.Mui-disabled),&.open": {
                            outline: ((_h = ownerState === null || ownerState === void 0 ? void 0 : ownerState.className) === null || _h === void 0 ? void 0 : _h.includes("noLabel")) ? "1px solid ".concat(theme.palette.pebble.main) : "none",
                            background: theme.palette.pebble.main,
                            color: theme.palette.text.primary,
                            ".MuiSvgIcon-root": {
                                color: theme.palette.text.primary,
                            },
                            "fieldset": {
                                borderColor: theme.palette.pebble.main + "!important "
                            },
                        } });
                }
                else if (ownerState.variant === 'standard') {
                    styles = __assign(__assign({}, styles), { color: theme.palette[colorMatches].main, ".MuiSvgIcon-root": {
                            color: theme.palette[colorMatches].main
                        }, "&.Mui-disabled,.Mui-disabled": {
                            pointerEvents: "none !important",
                            color: theme.palette[colorMatches].main + "!important",
                            opacity: "0.65",
                            ".MuiSvgIcon-root": {
                                color: theme.palette[colorMatches].main + "!important",
                            }
                        }, "&:hover:not(.Mui-disabled),&.open": {
                            color: theme.palette[colorMatches].main,
                            ".MuiSvgIcon-root": {
                                color: theme.palette[colorMatches].main,
                            }
                        } });
                }
                return __assign(__assign({}, styles), { ".MuiInputLabel-root": __assign(__assign({}, theme.typography.body2), { color: theme.palette.body1.main + "!important", transform: "translate(14px, -9px) !important", ">div": {
                            display: "flex",
                            alignItems: "center",
                            ".MuiSvgIcon-root": {
                                marginLeft: theme.spacing(1)
                            },
                        } }), cursor: "pointer", borderRadius: "8px", ">.MuiSvgIcon-root": {
                        display: "none",
                    } });
            },
            select: function (_a) {
                _a.ownerState; var theme = _a.theme;
                var styles = {};
                return __assign(__assign({}, styles), { display: "flex", alignItems: "center", justifyContent: "space-between", lineHeight: "0", minHeight: "unset", background: "none", "-webkit-text-fill-color": "unset!important", ".MuiTypography-root": {
                        textTransform: "none",
                        fontSize: "unset",
                        marginRight: theme.spacing(2),
                    } });
            },
        },
        defaultProps: {},
    };
}

function getMuiSvgIcon(theme) {
    return {
        variants: [
            {
                props: { fontSize: "10" },
                style: {
                    fontSize: "0.625rem!important",
                },
            },
            {
                props: { fontSize: "14" },
                style: {
                    fontSize: "0.75rem!important",
                },
            },
            {
                props: { fontSize: "18" },
                style: {
                    fontSize: "1.125rem!important",
                },
            },
            {
                props: { fontSize: "24" },
                style: {
                    fontSize: "1.5rem!important",
                },
            },
            {
                props: { fontSize: "32" },
                style: {
                    fontSize: "2rem!important",
                },
            },
            {
                props: { fontSize: "44" },
                style: {
                    fontSize: "2.75rem!important",
                },
            },
        ],
        styleOverrides: {
            root: {
                ".noFill": {
                    fill: "none!important",
                    stroke: "currentColor"
                }
            },
        },
        defaultProps: {
            color: "body1",
            fontSize: "inherit",
        },
    };
}

function getMuiTable(theme) {
    return {
        styleOverrides: {
            root: {
                borderCollapse: "collapse",
                "&.noRowClick.noRowSelect": {
                    ".MuiTableBody-root tr": {
                        cursor: "default !important",
                        "&:not(.Mui-selected)": {
                            "&:not(:first-child)": {
                                borderTop: "1px solid ".concat(theme.palette.wildSand.main, "!important")
                            },
                            "&:hover td, &:hover td:first-child::before, &:hover td:last-child::before": {
                                background: "white!important"
                            }
                        },
                        "&.Mui-selected": {}
                    }
                },
            },
        },
        defaultProps: {},
    };
}

function getMuiTableBody(theme) {
    return {
        styleOverrides: {
            root: {},
        },
        defaultProps: {},
    };
}

function getMuiTableCell(theme) {
    return {
        styleOverrides: {
            root: {
                "&:not(.seperator)": {
                    boxSizing: "border-box",
                    marginBottom: theme.spacing(5),
                    border: "none",
                    maxWidth: "25rem !important",
                    "&:not(th)": {
                        overflow: "hidden",
                    },
                    ".cellContainer .MuiTypography-root, .cellContainer p": {
                        maxWidth: "23rem !important",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    },
                    verticalAlign: "center",
                    "&:nth-child(2)": {
                        paddingLeft: theme.spacing(5) + "!important",
                    },
                    "&:not(.MuiTableCell-head)": __assign(__assign({}, theme.typography.body1L), { padding: theme.spacing(4) }),
                    "&.MuiTableCell-head": {
                        padding: theme.spacing(3, 4),
                    },
                    ".MuiCollapse-wrapperInner": {
                        padding: theme.spacing(12)
                    },
                    "&.stickyFirstCol,&.stickyLastCol, &.stickyEffect": {
                        whiteSpace: "nowrap",
                        position: "sticky",
                        backgroundColor: theme.palette.background.default,
                    },
                    "&.stickyEffect": {
                        padding: 0,
                        width: "0px",
                        minWidth: "0px",
                        maxWidth: "0px",
                        zIndex: 105,
                        "&::before": {
                            position: "absolute",
                            top: 0,
                            width: "16px",
                            height: "100%",
                            zIndex: 101,
                        },
                        "&::after": {
                            top: 0,
                            width: "16px",
                            position: "absolute",
                            height: "100%",
                            zIndex: 100,
                        }
                    },
                    "&.leftStickyEffect": {
                        "&::before": {
                            left: 0,
                            borderTopLeftRadius: "16px",
                            borderBottomLeftRadius: "16px",
                        },
                    },
                    "&.rightStickyEffect": {
                        "&::before": {
                            right: 0,
                            borderTopRightRadius: "16px",
                            borderBottomRightRadius: "16px",
                        },
                    },
                    "&.stickyFirstCol,&.stickyLastCol": {
                        zIndex: 100
                    },
                    "&.stickyFirstCol": {
                        left: 0,
                        "&::after": {
                            background: "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
                            right: "-19px",
                        }
                    },
                    "&.stickyLastCol": {
                        right: 0,
                        "&::before": {
                            background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
                            left: "-19px",
                        }
                    },
                    "&.MuiTableCell-head&.stickyFirstCol": {
                        "&::after": {
                            background: "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, ".concat(theme.palette.cloud.main, " 100%) !important"),
                            right: "-19px",
                        }
                    },
                    "&.MuiTableCell-head&.stickyLastCol": {
                        "&::before": {
                            background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, ".concat(theme.palette.cloud.main, " 100%) !important"),
                            left: "-19px",
                        }
                    },
                    "&.MuiTableCell-stickyHeader": {}
                },
            },
        },
        defaultProps: {},
    };
}

function getMuiTableContainer(theme) {
    return {
        styleOverrides: {
            root: {},
        },
        defaultProps: {},
    };
}

function getMuiTableHead(theme) {
    return {
        styleOverrides: {
            root: {
                "tr th:not(.MuiTableCell-paddingCheckbox) *:not(svg):(button),tr th:not(.MuiTableCell-paddingCheckbox)": __assign(__assign({}, theme.typography.body1), { color: theme.palette.text.primary }),
                "tr th": {
                    fontWeight: "600 !important"
                },
                ".MuiTableCell-stickyHeader": {
                    zIndex: "110!important",
                    "&.stickyFirstCol, &.stickyLastCol": {
                        zIndex: "115!important",
                    },
                    "&.stickyEffect": {
                        zIndex: "120!important",
                    },
                    ".MuiButtonBase-root": {
                        padding: 0
                    },
                },
            }
        },
        defaultProps: {},
    };
}

function getMuiTablePagination(theme) {
    return {
        styleOverrides: {
            root: {
                position: "absolute",
                bottom: 0,
                width: "-webkit-fill-available",
                ".MuiToolbar-root": {
                    justifyContent: "space-between",
                    padding: 0,
                },
                ".MuiInputBase-root,.MuiTablePagination-spacer,.MuiTablePagination-selectLabel": {
                    display: "none"
                },
                ".MuiTablePagination-displayedRows": __assign(__assign({}, theme.typography.body1L), { color: theme.palette.body1.main, fontWeight: 400 }),
                ".MuiTablePagination-actions": {
                    "button": {
                        "border": "1px solid " + theme.palette.wildSand.main,
                        borderRadius: "8px",
                        padding: theme.spacing(3),
                        "&:not(:last-child)": {
                            marginRight: theme.spacing(3)
                        },
                        "&.Mui-disabled": {
                            opacity: 0.65
                        }
                    }
                }
            },
        },
        defaultProps: {},
    };
}

function getMuiTableRow(theme) {
    return {
        styleOverrides: {
            root: {
                background: "none",
                backgroundColor: "transparent!important",
                "&:not(.seperator)": {
                    //Border styles
                    "&:not(:first-child):not(.collapsibleContent)": {
                        borderTop: "1px solid ".concat(theme.palette.wildSand.main),
                    },
                    //## default case
                    "&:hover, &:hover + tr, &.Mui-selected, &.Mui-selected + tr": {
                        borderTopColor: theme.palette.background.default + "!important",
                        ".MuiLinearProgress-root": {
                            backgroundColor: theme.palette.common.white
                        },
                    },
                    //##special case
                    "&:hover.collapsible:not(.collapsibleOpen) + tr + tr, &.Mui-selected.collapsible:not(.collapsibleOpen) + tr + tr": {
                        borderTopColor: theme.palette.background.default + "!important"
                    },
                    //Background styles
                    "th:not(.stickyEffect)": {
                        backgroundColor: theme.palette.cloud.main,
                    },
                    "&:hover:not(.collapsibleContentOpened):not(th):not(.collapsibleContent)": {
                        "td:not(.stickyEffect),.stickyFirstCol,.stickyLastCol, .stickyEffect::before": {
                            backgroundColor: theme.palette.cloud.main
                        },
                    },
                    "&.Mui-selected": {
                        "td:not(.stickyEffect),.stickyFirstCol,.stickyLastCol, .stickyEffect::before": {
                            backgroundColor: lighten$1(theme.palette.secondary.main, 0.9),
                        }
                    },
                    //Collapsible content styles
                    "&.collapsibleOpen": {
                        "&.Mui-selected": {
                            "td:not(.stickyEffect),.stickyFirstCol,.stickyLastCol,.stickyEffect::before": {
                                backgroundColor: lighten$1(theme.palette.secondary.main, 0.9),
                            },
                        },
                        "&:not(.Mui-selected)": {
                            "td:not(.stickyEffect),.stickyFirstCol,.stickyLastCol,.stickyEffect::before": {
                                backgroundColor: theme.palette.cloud.main,
                            },
                        },
                        td: {
                            "&:not(.stickyEffect):not(:first-child):not(:last-child)": {
                                borderTop: "2px solid " + theme.palette.secondary.main,
                            },
                            "&.stickyEffect::before": {
                                borderBottomLeftRadius: "0",
                                borderBottomRightRadius: "0",
                                height: "calc(100% + 2px)",
                                top: "-2px",
                                boxSizing: "border-box"
                            },
                            "&.leftStickyEffect::before": {
                                borderLeft: "2px solid " + theme.palette.secondary.main,
                                borderTop: "2px solid " + theme.palette.secondary.main,
                            },
                            "&.rightStickyEffect::before": {
                                borderRight: "2px solid " + theme.palette.secondary.main,
                                borderTop: "2px solid " + theme.palette.secondary.main,
                            },
                            "&.stickyEffect::after": {
                                top: "-2px"
                            }
                        },
                    },
                    "&.collapsibleContentOpened": {
                        td: {
                            ".MuiCollapse-wrapperInner": {
                                padding: theme.spacing(12),
                            },
                            "&:not(.stickyEffect)": {
                                borderBottom: "2px solid " + theme.palette.secondary.main,
                            },
                            "&.stickyEffect::before": {
                                borderTopLeftRadius: "0",
                                borderTopRightRadius: "0",
                                height: "calc(100% + 2px)",
                                top: "-1px",
                                boxSizing: "border-box"
                            },
                            "&.leftStickyEffect::before": {
                                borderBottomLeftRadius: "16px",
                                borderLeft: "2px solid " + theme.palette.secondary.main,
                                borderBottom: "2px solid " + theme.palette.secondary.main,
                            },
                            "&.rightStickyEffect::before": {
                                borderBottomRightRadius: "16px",
                                borderRight: "2px solid " + theme.palette.secondary.main,
                                borderBottom: "2px solid " + theme.palette.secondary.main,
                            },
                            "&.stickyEffect::after": {
                                top: "1px"
                            }
                        },
                    },
                },
            },
        },
        defaultProps: {},
    };
}

function getMuiTextField(theme) {
    return {
        styleOverrides: {
            root: {
                ".MuiInputLabel-root": __assign(__assign({}, theme.typography.body2), { color: theme.palette.body1.main, transform: "translate(14px, -9px)", ">div": {
                        display: "flex",
                        alignItems: "center",
                        ".MuiSvgIcon-root": {
                            marginLeft: theme.spacing(1)
                        },
                    } }),
                ".MuiFormLabel-filled ~ .MuiInputBase-root": {
                    "fieldset": {
                        transform: "none !important",
                        borderColor: theme.palette.secondary.main,
                    }
                },
                ".MuiInputBase-root": {
                    "&.MuiOutlinedInput-root": {},
                    "&.MuiFilledInput-root": {},
                    "&.MuiInput-root": {},
                    "input, textarea": __assign(__assign({ height: "unset" }, theme.typography.body1L), { fontWeight: 600, borderRadius: 8, backgroundColor: theme.palette.common.white, "&:not(:placeholder-shown)": {
                            color: theme.palette.primary.main
                        } }),
                    "input": {
                        padding: theme.spacing(4, 3.5),
                    },
                    "fieldset": {
                        borderRadius: 8,
                        borderColor: theme.palette.wildSand.main,
                        "legend": __assign({}, theme.typography.body2)
                    },
                    "&:hover": {
                        "fieldset": {
                            borderColor: theme.palette.secondary.main,
                        }
                    }
                },
                ".MuiFormHelperText-root": __assign({}, theme.typography.body2S),
                ".Mui-error": {
                    color: theme.palette.error.main,
                    "fieldset": {
                        borderColor: theme.palette.error.main + "!important",
                    },
                    "svg path": {
                        fill: theme.palette.error.main,
                    }
                }
            }
        },
        defaultProps: {
            autoComplete: "off",
            fullWidth: true,
            InputLabelProps: {
                shrink: true,
            },
            color: "secondary"
        },
    };
}

function getMuiTooltip(theme) {
    //TODO  <TooltipContentComplex> component to extend tooltip to match more complex design
    //https://www.figma.com/file/B5SHR91AjSAO6ZLUiFP3Kl/UI-KIT?type=design&node-id=111-54&mode=design&t=qSzS6XpqXZUpw7bZ-0
    return {
        styleOverrides: {
            popper: {
                zIndex: 10001
            },
            tooltip: __assign(__assign({ 
                //TODO border radius 8px, find a way to reposition arrow to fix whitespace
                background: theme.palette.text.primary }, theme.typography.body1), { color: theme.palette.common.white, padding: theme.spacing(2, 3), borderRadius: "4px", maxWidth: "324px" }),
            arrow: function (_a) {
                var ownerState = _a.ownerState, theme = _a.theme;
                var styles = {};
                if (ownerState.placement.includes("top") || ownerState.placement.includes("bottom")) ;
                else if (ownerState.placement.includes("left") || ownerState.placement.includes("right")) ;
                styles["&:hover"] = {
                    border: "none",
                    background: theme.palette.pebble.main,
                    color: theme.palette.text.primary,
                };
                styles["&:before"] = {
                    color: theme.palette.text.primary
                };
                return styles;
            }
        },
        defaultProps: {
            arrow: true,
            placement: "bottom-start",
            enterDelay: 500,
        },
    };
}

function getTypography(theme, _a) {
    var bodyFont = _a.bodyFont, headerFont = _a.headerFont, primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, body1 = _a.body1, body2 = _a.body2;
    var h1Def = {
        fontFamily: headerFont,
        fontWeight: 400,
        fontSize: "1.75rem",
        lineHeight: "2.125rem",
        color: primaryColor,
        letterSpacing: "-1.5px",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "font-smooth": "never"
    };
    var h2Def = {
        fontFamily: bodyFont,
        fontWeight: 600,
        fontSize: "1.375rem",
        lineHeight: "1.75rem",
        color: body1,
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "font-smooth": "never"
    };
    var h3Def = {
        fontFamily: bodyFont,
        fontWeight: 600,
        fontSize: "1.375rem",
        lineHeight: "1.75rem",
        color: body1,
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "font-smooth": "never"
    };
    var bodyDef = {
        fontFamily: bodyFont,
        fontWeight: 400,
        fontSize: "0.875rem",
        lineHeight: "1.125rem",
        maxWidth: "52rem",
        color: body1,
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "font-smooth": "never"
    };
    var body2Def = {
        fontFamily: bodyFont,
        fontWeight: 700,
        fontSize: "0.875rem",
        lineHeight: "1.125rem",
        maxWidth: "52rem",
        color: body2,
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "font-smooth": "never"
    };
    return {
        fontFamily: bodyFont,
        h1: h1Def,
        h1L: __assign(__assign({}, h1Def), { fontSize: "2rem", lineHeight: "2.375rem" }),
        h1S: __assign(__assign({}, h1Def), { fontSize: "1.5rem", lineHeight: "1.875rem" }),
        displayL: __assign(__assign({}, h1Def), { fontSize: "2rem", lineHeight: "2.375rem" }),
        display: h1Def,
        displayS: __assign(__assign({}, h1Def), { fontSize: "1.5rem", lineHeight: "1.875rem" }),
        h2: h2Def,
        h2L: __assign(__assign({}, h2Def), { fontSize: "1.625rem", lineHeight: "1.75rem" }),
        h2S: __assign(__assign({}, h2Def), { fontSize: "1.125rem", lineHeight: "1.375rem" }),
        headlineL: __assign(__assign({}, h2Def), { fontSize: "1.625rem", lineHeight: "1.75rem" }),
        headline: h2Def,
        headlineS: __assign(__assign({}, h2Def), { fontSize: "1.125rem", lineHeight: "1.375rem" }),
        h3: h3Def,
        h3L: __assign(__assign({}, h3Def), { fontSize: "1.625rem", lineHeight: "1.75rem" }),
        h3S: __assign(__assign({}, h3Def), { fontSize: "1.125rem", lineHeight: "1.375rem" }),
        titleL: __assign(__assign({}, h3Def), { fontSize: "1.625rem", lineHeight: "1.75rem" }),
        title: h3Def,
        titleS: __assign(__assign({}, h3Def), { fontSize: "1.125rem", lineHeight: "1.375rem" }),
        h4: {},
        h5: {},
        h6: {},
        subtitle1: {},
        subtitle2: {},
        body1: bodyDef,
        body1L: __assign(__assign({}, bodyDef), { fontSize: "1rem", lineHeight: "1.25rem" }),
        body1S: __assign(__assign({}, bodyDef), { fontSize: "0.75rem", lineHeight: "1rem" }),
        link: __assign(__assign({}, bodyDef), { color: secondaryColor, textDecoration: "underline" }),
        linkS: __assign(__assign({}, bodyDef), { fontSize: "0.75rem", lineHeight: "1rem", color: secondaryColor, textDecoration: "underline" }),
        linkL: __assign(__assign({}, bodyDef), { fontSize: "1rem", lineHeight: "1.25rem", color: secondaryColor, textDecoration: "underline" }),
        body2: body2Def,
        body2L: __assign(__assign({}, body2Def), { fontSize: "1rem", fontWeight: 600, lineHeight: "1rem" }),
        body2S: __assign(__assign({}, body2Def), { fontWeight: 600, fontSize: "0.75rem", lineHeight: "1.125rem" }),
        button: {
            fontFamily: bodyFont,
            cursor: "pointer",
            fontWeight: 700,
        },
        caption: {},
        overline: {}
    };
}

function buildMUITheme(_a) {
    var _b, _c;
    var brand = _a.brand, _d = _a.context, context = _d === void 0 ? "" : _d, _e = _a.styleOverride, styleOverride = _e === void 0 ? {} : _e;
    var brandTheme = (_b = brand === null || brand === void 0 ? void 0 : brand.theme) === null || _b === void 0 ? void 0 : _b.base;
    var brandContextTheme = (context && (brand === null || brand === void 0 ? void 0 : brand[context]) && ((_c = brand === null || brand === void 0 ? void 0 : brand[context]) === null || _c === void 0 ? void 0 : _c.styles)) ? brand[context].styles : undefined;
    var headerFont = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.headingFont) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.headingFont) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.headingFont) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["heading-font"]) || originalBrand.theme.base["heading-font"];
    var bodyFont = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.textFont) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.textFont) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.textFont) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["text-font"]) || originalBrand.theme.base["text-font"];
    var primaryColor = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.primaryBrandColor) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.primaryBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.primaryBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["primary-brand-color"]) || originalBrand.theme.base["primary-brand-color"];
    var secondaryColor = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.secondaryBrandColor) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.secondaryBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.secondaryBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["secondary-brand-color"]) || originalBrand.theme.base["secondary-brand-color"];
    var body1 = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.bodyFontColor) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.bodyFontColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.bodyFontColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["body-font-color"]) || originalBrand.theme.base["body-font-color"];
    var body2 = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.bodyFontColor2) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.bodyFontColor2) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.bodyFontColor2) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["body-font-color-2"]) || originalBrand.theme.base["body-font-color-2"];
    var errorColor = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.errorBrandColor) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.errorBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.errorBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["error-brand-color"]) || originalBrand.theme.base["error-brand-color"];
    var warningColor = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.warningBrandColor) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.warningBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.warningBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["warning-brand-color"]) || originalBrand.theme.base["warning-brand-color"];
    var successColor = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.successBrandColor) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.successBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.successBrandColor) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["success-brand-color"]) || originalBrand.theme.base["secondary-brand-color"];
    var bg1Color = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.backgroundColor1) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.backgroundColor1) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.backgroundColor1) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["background-color-1"]) || originalBrand.theme.base["background-color-1"];
    var bg2Color = (styleOverride === null || styleOverride === void 0 ? void 0 : styleOverride.backgroundColor2) || (brandContextTheme === null || brandContextTheme === void 0 ? void 0 : brandContextTheme.backgroundColor2) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme.backgroundColor2) || (brandTheme === null || brandTheme === void 0 ? void 0 : brandTheme["background-color-2"]) || originalBrand.theme.base["background-color-2"];
    var getObj = {
        bodyFont: bodyFont,
        headerFont: headerFont,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        body1: body1,
        body2: body2};
    var theme = createTheme$1({
        spacing: function (factor) { return "".concat(0.25 * factor, "rem"); },
        breakpoints: {
            values: {
                mobile: 0,
                tablet: 600,
                xs: 1024,
                sm: 1336,
                md: 1440,
                lg: 1920,
                xl: 2560,
            },
        },
        typography: getTypography(null, getObj),
    });
    //console.log(primaryColor, lighten(primaryColor, 0.7), darken(primaryColor, 0.7))
    theme = createTheme$1(theme, {
        palette: {
            contrastThreshold: 4.5,
            common: {
                black: "#000000",
                white: "#FFFFFF"
            },
            text: {
                primary: body1,
                secondary: body2,
            },
            background: {
                default: bg1Color,
                paper: bg2Color,
            },
            primary: theme.palette.augmentColor({
                color: {
                    main: primaryColor,
                }
            }),
            secondary: theme.palette.augmentColor({
                color: {
                    main: secondaryColor,
                }
            }),
            error: theme.palette.augmentColor({
                color: {
                    main: errorColor,
                }
            }),
            warning: theme.palette.augmentColor({
                color: {
                    main: warningColor,
                }
            }),
            success: theme.palette.augmentColor({
                color: {
                    main: successColor,
                }
            }),
            body1: theme.palette.augmentColor({
                color: {
                    main: body1,
                }
            }),
            body2: theme.palette.augmentColor({
                color: {
                    main: body2,
                }
            }),
            darkMatter: theme.palette.augmentColor({
                color: {
                    main: "#2B2B2B",
                },
                name: "darkMatter",
            }),
            silver: theme.palette.augmentColor({
                color: {
                    main: "#9B9B9B",
                },
                name: "silver",
            }),
            wildSand: theme.palette.augmentColor({
                color: {
                    main: "#dddddd",
                },
                name: "wildSand",
            }),
            cloud: theme.palette.augmentColor({
                color: {
                    main: "#F4F4F4",
                },
                name: "cloud",
            }),
            boulder: theme.palette.augmentColor({
                color: {
                    main: "#4A4A4A",
                },
                name: "boulder",
            }),
            pebble: theme.palette.augmentColor({
                color: {
                    main: "#EAEAEA",
                },
                name: "pebble",
            }),
            white: theme.palette.augmentColor({
                color: {
                    main: "#ffffff",
                },
                name: "white",
            }),
            shade1000: theme.palette.augmentColor({
                color: {
                    main: "#1B1A1A",
                },
                name: "shade1000",
            }),
            shade950: theme.palette.augmentColor({
                color: {
                    main: "#272626",
                },
                name: "shade950",
            }),
            shade900: theme.palette.augmentColor({
                color: {
                    main: "#333232",
                },
                name: "shade900",
            }),
            shade850: theme.palette.augmentColor({
                color: {
                    main: "#3F3E3E",
                },
                name: "shade850",
            }),
            shade800: theme.palette.augmentColor({
                color: {
                    main: "#4B4A4A",
                },
                name: "shade800",
            }),
            shade750: theme.palette.augmentColor({
                color: {
                    main: "#575656",
                },
                name: "shade750",
            }),
            shade700: theme.palette.augmentColor({
                color: {
                    main: "#636262",
                },
                name: "shade700",
            }),
            shade650: theme.palette.augmentColor({
                color: {
                    main: "#6F6E6E",
                },
                name: "shade650",
            }),
            shade600: theme.palette.augmentColor({
                color: {
                    main: "#7B7A7A",
                },
                name: "shade600",
            }),
            shade550: theme.palette.augmentColor({
                color: {
                    main: "#878686",
                },
                name: "shade550",
            }),
            shade500: theme.palette.augmentColor({
                color: {
                    main: "#939292",
                },
                name: "shade500",
            }),
            shade450: theme.palette.augmentColor({
                color: {
                    main: "#9E9E9D",
                },
                name: "shade450",
            }),
            shade400: theme.palette.augmentColor({
                color: {
                    main: "#AAAAA9",
                },
                name: "shade400",
            }),
            shade350: theme.palette.augmentColor({
                color: {
                    main: "#B7B6B6",
                },
                name: "shade350",
            }),
            shade300: theme.palette.augmentColor({
                color: {
                    main: "#C3C2C2",
                },
                name: "shade300",
            }),
            shade250: theme.palette.augmentColor({
                color: {
                    main: "#CFCECE",
                },
                name: "shade250",
            }),
            shade200: theme.palette.augmentColor({
                color: {
                    main: "#DBDADA",
                },
                name: "shade200",
            }),
            shade150: theme.palette.augmentColor({
                color: {
                    main: "#E7E6E6",
                },
                name: "shade150",
            }),
            shade100: theme.palette.augmentColor({
                color: {
                    main: "#F3F2F2",
                },
                name: "shade100",
            }),
            shade50: theme.palette.augmentColor({
                color: {
                    main: "#FFFFFF",
                },
                name: "shade50",
            }),
        },
    });
    return createTheme$1(theme, {
        components: {
            MuiButton: getMuiButton(theme, brandContextTheme),
            MuiDrawer: getMuiDrawer(),
            MuiSvgIcon: getMuiSvgIcon(),
            MuiTooltip: getMuiTooltip(theme),
            MuiChip: getMuiChip(),
            MuiMenu: getMuiMenu(theme),
            MuiMenuItem: getMuiMenuItem(theme),
            MuiPopper: getMuiPopper(),
            MuiPopover: getMuiPopover(theme),
            MuiSelect: getMuiSelect(),
            MuiLinearProgress: getMuiLinearProgress(theme),
            MuiTableContainer: getMuiTableContainer(),
            MuiTable: getMuiTable(theme),
            MuiTableHead: getMuiTableHead(theme),
            MuiTableBody: getMuiTableBody(),
            MuiTableRow: getMuiTableRow(theme),
            MuiTableCell: getMuiTableCell(theme),
            MuiTablePagination: getMuiTablePagination(theme),
            MuiCheckbox: getMuiCheckbox(theme),
            MuiRadio: getMuiRadio(theme),
            MuiAvatar: getMuiAvatar(theme),
            MuiBadge: getMuiBadge(),
            MuiTableFooter: {},
            MuiGrid: {},
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        backgroundColor: theme.palette.common.white,
                    },
                }
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        "&:not(.noPadding)": {
                            padding: theme.spacing(2, 0, 8, 0)
                        },
                        "&.noPadding > *:not(.dialogTitle).not(.MuiDialogActions-root)": {
                            padding: theme.spacing(2, 0, 8, 0)
                        }
                    },
                }
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: {
                        padding: 0,
                        "button": {
                            marginLeft: "0 !important",
                            "&:not(:last-child)": {
                                marginRight: theme.spacing(4)
                            }
                        }
                    },
                }
            },
            MuiTableSortLabel: {
                styleOverrides: {
                    root: {
                        ".MuiSvgIcon-root": {
                            marginLeft: theme.spacing(3)
                        }
                    },
                }
            },
            MuiFilledInput: {},
            MuiFormControl: {},
            MuiFormHelperText: {},
            MuiIconButton: {},
            MuiInputBase: {},
            MuiInputLabel: {},
            MuiOutlinedInput: {},
            MuiFab: {},
            MuiTextField: getMuiTextField(theme),
            MuiToolbar: {},
            MuiLink: getMuiLink(theme),
            MuiTypography: {
                defaultProps: {
                    variantMapping: {
                        h1: "h1",
                        h2: "h2",
                        h3: "h3",
                        h4: "h4",
                        h5: "h5",
                        h6: "h6",
                        subtitle1: "h2",
                        subtitle2: "h2",
                        body1: "p",
                        body2: "p",
                    },
                },
            },
            MuiList: {
                styleOverrides: {
                    root: {
                        ".MuiList-root": {
                            maxHeight: "35vh",
                            overflow: "overlay",
                            overflowX: "hidden",
                            minWidth: "max-content",
                            width: " 100%",
                            backgroundColor: theme.palette.common.white,
                            boxShadow: "0 4px 10px rgb(0 0 0 / 30%)",
                            padding: theme.spacing(4, 0)
                        },
                    },
                },
            },
            MuiListItem: {
            /*styleOverrides: {
            root: {
    
                fontFamily: bodyFont,
                fontWeight: 400,
                fontSize: theme.spacing(4),
                color: theme.palette.text.secondary,
                lineHeight: "150%",
                padding: theme.spacing(2, 4, 2, 4),
    
                ":hover": {
                    color: theme.palette.primary.main
                },
                ":before": {
                    display: "none"
                }
            }
        }*/
            },
            MuiListItemText: {
            /*styleOverrides: {
                root: {
                    fontFamily: bodyFont,
                    fontWeight: 400,
                    fontSize: theme.spacing(4),
                    color: theme.palette.text.secondary,
                    lineHeight: "150%",
                }
            }*/
            },
        }
    });
}

function initFieldValidation(name, initialValue) {
    var _a;
    if (initialValue === void 0) { initialValue = {}; }
    return _a = {},
        _a[name] = {
            error: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.error) || false,
            message: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.message) || "",
            value: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.value) || ""
        },
        _a;
}
function validateEmail(email, validateEmptyOnly) {
    if (validateEmptyOnly === void 0) { validateEmptyOnly = false; }
    var error = false;
    var isEmpty = true;
    var isValid = false;
    if (email) {
        isEmpty = email.length === 0;
        isValid = isValidEmail(email);
    }
    var message = "input-validation-good";
    if (isEmpty) {
        message = "input-validation-email-empty";
    }
    else if (!validateEmptyOnly && !isValid) {
        message = "input-validation-email-error";
        error = true;
    }
    return {
        message: message,
        error: error,
        value: email,
    };
}
function validateUrl(url) {
    var error = false;
    var message = "input-validation-good";
    if (url) {
        url = url.trim();
        if (url.match(/http[s]{0,1}:\/\//) === null) {
            error = true;
            message = "input-validation-url-error-scheme-missing";
        }
        else if (!isValidUrl(url)) {
            error = true;
            message = "input-validation-url-error";
        }
    }
    return {
        message: message,
        error: error,
        value: url,
    };
}
function validateGenericInput(value) {
    var error = false;
    var message = "input-validation-good";
    if (!isValidString(value)) {
        message = "input-validation-input-error";
        error = true;
    }
    return {
        message: message,
        error: error,
        value: value,
    };
}
function validateColor(color) {
    var error = false;
    var message = "input-validation-good";
    if (!color || !color.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
        message = "input-validation-color-error";
        error = true;
    }
    return {
        message: message,
        error: error,
        value: color,
    };
}

function Typography(_a) {
    var variant = _a.variant, color = _a.color, children = _a.children, className = _a.className, bold = _a.bold, semiBold = _a.semiBold, props = __rest(_a, ["variant", "color", "children", "className", "bold", "semiBold"]);
    var classes = classNames(className, {
        "bold": bold,
        "semiBold": semiBold,
    });
    return React__default.createElement(Typography$1, __assign({}, props, { variant: variant, color: color, className: classes }), children);
}

function DialogActions(_a) {
    var children = _a.children, primaryBtnText = _a.primaryBtnText, primaryBtnOnClick = _a.primaryBtnOnClick, secondaryBtnText = _a.secondaryBtnText, secondaryBtnOnClick = _a.secondaryBtnOnClick, primaryBtnDisabled = _a.primaryBtnDisabled;
    function handleOnPrimaryClick(e, btnRef) {
        if (primaryBtnOnClick) {
            primaryBtnOnClick(e, btnRef);
        }
        else {
            DialogHandler.hide();
        }
    }
    function handleOnSecondaryClick() {
        if (secondaryBtnOnClick) {
            secondaryBtnOnClick();
        }
        else {
            DialogHandler.hide();
        }
    }
    return React__default.createElement(MuiDialogActions, null,
        children,
        secondaryBtnText &&
            React__default.createElement(Button, { variant: "outlined", color: "body1", onClick: handleOnSecondaryClick }, secondaryBtnText),
        primaryBtnText &&
            React__default.createElement(Button, { variant: "contained", color: "secondary", onClick: handleOnPrimaryClick, disabled: primaryBtnDisabled, animated: true }, primaryBtnText));
}

function DialogTitle(_a) {
    var children = _a.children, type = _a.type, _b = _a.variant, variant = _b === void 0 ? "h2" : _b, className = _a.className;
    return React__default.createElement(Stack$1, { className: "dialogTitle ".concat(type), direction: "row", alignItems: "center" },
        type &&
            React__default.createElement(Icon, { name: type === "success" ? "Success24" : "Warning24", className: type }),
        React__default.createElement(Typography, { className: className, variant: variant }, children));
}

var css_248z$t = ".dialog-component-v2 {\n  box-sizing: border-box;\n  z-index: 9000 !important;\n}\n.dialog-component-v2.alert {\n  pointer-events: none;\n}\n.dialog-component-v2.alert .MuiBackdrop-root {\n  display: none;\n}\n.dialog-component-v2.alert > .MuiDialog-container > .MuiPaper-root {\n  border-radius: 8px;\n  pointer-events: all;\n  width: -moz-max-content;\n  width: max-content;\n  padding: 1rem;\n}\n.dialog-component-v2.alert > .MuiDialog-container > .MuiPaper-root .MuiDialogContent-root {\n  text-align: left;\n  padding: 0.25rem 0 0;\n}\n.dialog-component-v2:not(.alert) > .MuiDialog-container > .MuiPaper-root {\n  border-radius: 16px;\n  max-width: 500px;\n  width: 100%;\n  max-height: calc(100vh - 2rem);\n  padding: 2rem;\n}\n.dialog-component-v2:not(.alert) > .MuiDialog-container > .MuiPaper-root::-webkit-scrollbar {\n  display: block;\n}\n.dialog-component-v2:not(.alert) > .MuiDialog-container > .MuiPaper-root::-webkit-scrollbar-track:horizontal {\n  position: absolute;\n  bottom: -20px;\n}\n.dialog-component-v2:not(.alert) > .MuiDialog-container > .MuiPaper-root::-webkit-scrollbar-track:vertical {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n.dialog-component-v2:not(.alert) > .MuiDialog-container > .MuiPaper-root::-webkit-scrollbar-track {\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 2rem;\n  background-clip: content-box;\n  border-bottom-left-radius: 8px;\n}\n.dialog-component-v2:not(.alert) > .MuiDialog-container > .MuiPaper-root::-webkit-scrollbar-thumb {\n  background: var(--body-font-color-2, var(--silver, #9B9B9B));\n  border-radius: 24px;\n  border-top: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-bottom: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-right: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-left: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n}\n.dialog-component-v2 .dialogTitle .MuiSvgIcon-root {\n  margin-right: 0.75rem;\n}\n.dialog-component-v2 .dialogTitle.warning .MuiSvgIcon-root path {\n  fill: var(--warning-brand-color, var(--orange, #FF9E0E));\n}\n.dialog-component-v2 .dialogTitle.error .MuiSvgIcon-root path {\n  fill: var(--error-brand-color, var(--rad-red, #FF4835));\n}\n.dialog-component-v2 .dialogTitle.success .MuiSvgIcon-root path {\n  fill: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}";
styleInject(css_248z$t);

var Dialog = forwardRef(function (props, ref) {
    var refState = useRef({ open: false });
    var _a = useState(props), state = _a[0], setNewState = _a[1];
    var hideTimeout = useRef(undefined);
    useEffect(function () {
        refState.current = { open: state.open || false };
    }, [state.open]);
    //Controlled Component
    useEffect(function () {
        if (!areAllPropertiesEmpty(props)) {
            setNewState(setStateFromProps(props));
        }
    }, [props]);
    useLayoutEffect(function () {
        if (state.open) {
            adjustDialogPosition();
        }
    });
    function isShowing() {
        return refState.current.open;
    }
    function show(cState) {
        clearTimeout(hideTimeout.current);
        var newState = setStateFromProps(__assign(__assign({}, cState), { open: true }));
        setNewState(newState);
        if ((!newState.primaryBtnText || !newState.secondaryBtnText) && newState.managedByContent === false) {
            hideTimeout.current = setTimeout(DialogHandler.hide, newState.hideAfter);
        }
    }
    function hide() {
        setNewState(setStateFromProps({ open: false }));
    }
    function setStateFromProps(cState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var nextState = cState || {};
        var newState = {
            title: (_a = nextState.title) !== null && _a !== void 0 ? _a : undefined,
            content: (_b = nextState.content) !== null && _b !== void 0 ? _b : undefined,
            managedByContent: (_c = nextState.managedByContent) !== null && _c !== void 0 ? _c : false,
            primaryBtnText: (_d = nextState.primaryBtnText) !== null && _d !== void 0 ? _d : undefined,
            primaryBtnOnClick: (_e = nextState.primaryBtnOnClick) !== null && _e !== void 0 ? _e : undefined,
            secondaryBtnText: (_f = nextState.secondaryBtnText) !== null && _f !== void 0 ? _f : undefined,
            secondaryBtnOnClick: (_g = nextState.secondaryBtnOnClick) !== null && _g !== void 0 ? _g : undefined,
            className: (_h = nextState.className) !== null && _h !== void 0 ? _h : "",
            type: (_j = nextState.type) !== null && _j !== void 0 ? _j : undefined,
            hideAfter: (_k = nextState.hideAfter) !== null && _k !== void 0 ? _k : 2600,
            showAfter: (_l = nextState.showAfter) !== null && _l !== void 0 ? _l : 0,
            open: (_m = nextState.open) !== null && _m !== void 0 ? _m : false,
            adjustedPosition: cState === null || cState === void 0 ? void 0 : cState.adjustedPosition
        };
        return newState;
    }
    function adjustDialogPosition(_a) {
        var _b = {} ; _b.x; _b.y;
        var overlayRect = document.querySelector(".dialog-component-v2 .MuiBackdrop-root");
        var dialogRect = document.querySelector(".dialog-component-v2 .MuiPaper-root");
        if (overlayRect && dialogRect && state.adjustedPosition) {
            overlayRect.getBoundingClientRect();
            dialogRect.getBoundingClientRect();
            if (state.adjustedPosition.x) {
                dialogRect.style.left = state.adjustedPosition.x + "px";
            }
            if (state.adjustedPosition.y) {
                dialogRect.style.top = state.adjustedPosition.y + "px";
            }
        }
    }
    useImperativeHandle(ref, function () { return ({
        isShowing: isShowing,
        show: show,
        hide: hide
    }); });
    var isAlert = (!state.primaryBtnText || !state.secondaryBtnText) && state.managedByContent === false;
    var mainClasses = classNames("dialog-component-v2", state.className, state.type, {
        "alert": isAlert,
        "managedByContent": state.managedByContent
    });
    return React__default.createElement(Dialog$1, { open: !!state.open, className: mainClasses, sx: props.sx },
        state.managedByContent &&
            React__default.createElement("div", { className: state.title ? "" : "noPadding" },
                state.title &&
                    React__default.createElement(DialogTitle, { variant: "h2", type: state.type }, state.title),
                state.content,
                props.children),
        !state.managedByContent && React__default.createElement(React__default.Fragment, null,
            React__default.createElement(DialogTitle, { className: isAlert ? "semiBold" : "", variant: isAlert ? "body1L" : "h2", type: state.type }, state.title),
            state.content &&
                React__default.createElement(DialogContent, null, typeof state.content === "string" ? React__default.createElement(Typography, { variant: "body1L" }, state.content) : state.content),
            (state.primaryBtnText || state.secondaryBtnText) &&
                React__default.createElement(DialogActions, { primaryBtnText: state.primaryBtnText, primaryBtnOnClick: state.primaryBtnOnClick, secondaryBtnText: state.secondaryBtnText, secondaryBtnOnClick: state.secondaryBtnOnClick })),
        !state.managedByContent && props.children);
});

var css_248z$s = "";
styleInject(css_248z$s);

var Drawer = forwardRef(function (props, ref) {
    var _a = useState(props.open || false), isOpen = _a[0], setIsOpen = _a[1];
    var refState = useRef({ open: false });
    var _b = useState(props), state = _b[0], setNewState = _b[1];
    useImperativeHandle(ref, function () { return ({
        show: show,
        hide: hide,
        isShowing: isShowing
    }); });
    useEffect(function () {
        refState.current = { open: state.open || false };
    }, [state.open]);
    useEffect(function () {
        if (!areAllPropertiesEmpty(props)) {
            setNewState(setStateFromProps(props));
        }
    }, [props]);
    function isShowing() {
        return refState.current.open;
    }
    function show(cState) {
        setNewState(setStateFromProps(__assign(__assign({}, cState), { open: true })));
        setIsOpen(true);
    }
    function hide() {
        setNewState(setStateFromProps({ open: false }));
        setIsOpen(false);
    }
    function setStateFromProps(cState) {
        var _a, _b, _c, _d, _e, _f;
        var nextState = cState || {};
        var newState = {
            children: nextState.children || nextState.content,
            className: (_a = nextState.className) !== null && _a !== void 0 ? _a : "",
            open: (_b = nextState.open) !== null && _b !== void 0 ? _b : false,
            position: (_c = nextState.position) !== null && _c !== void 0 ? _c : "left",
            onClose: (_d = nextState.onClose) !== null && _d !== void 0 ? _d : undefined,
            transitionDuration: (_e = nextState.transitionDuration) !== null && _e !== void 0 ? _e : 100,
            variant: (_f = nextState.variant) !== null && _f !== void 0 ? _f : "temporary"
        };
        return newState;
    }
    function handleClose(event, reason) {
        state.onClose && state.onClose(event, reason);
        setIsOpen(!isOpen);
    }
    return React__default.createElement(MuiDrawer, { open: isOpen, variant: state.variant, onClose: handleClose, className: "drawer-component-v2 ".concat(state.className), anchor: state.position, transitionDuration: state.transitionDuration }, props.children || state.children);
});

var css_248z$r = ".contentSectionContainer {\n  padding: 2rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: auto;\n}\n.contentSectionContainer > *:not(:first-child) {\n  margin-top: 2rem;\n}\n.contentSectionContainer > *:not(:last-child) {\n  flex: 0;\n}\n.contentSectionContainer > *:last-child {\n  flex: 1;\n}";
styleInject(css_248z$r);

function ContentSectionContainer(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    return React__default.createElement(Box, { className: "contentSectionContainer ".concat(className) }, children);
}

var css_248z$q = ".fullBar-component-v2 {\n  position: relative;\n  flex-wrap: wrap;\n}\n.fullBar-component-v2 > div {\n  position: unset;\n}\n.fullBar-component-v2 .left > *:nth-child(n+2),\n.fullBar-component-v2 .center > *:nth-child(n+2),\n.fullBar-component-v2 .right > *:nth-child(n+2) {\n  margin-left: 0.75rem;\n}";
styleInject(css_248z$q);

function FullBar(props) {
    if (props === void 0) { props = {}; }
    var _a = props.stackProps, stackProps = _a === void 0 ? {} : _a, className = props.className, left = props.left, center = props.center, right = props.right, leftSX = props.leftSX, centerSX = props.centerSX, rightSX = props.rightSX, leftProps = props.leftProps, centerProps = props.centerProps, rightProps = props.rightProps;
    var sx = (stackProps === null || stackProps === void 0 ? void 0 : stackProps.sx) || {};
    if (stackProps === null || stackProps === void 0 ? void 0 : stackProps.sx)
        delete stackProps.sx;
    return React__default.createElement(Stack$1, __assign({ direction: "row", sx: __assign({ justifyContent: "space-between" }, sx), className: "fullBar-component-v2 " + className }, stackProps),
        React__default.createElement(Stack$1, __assign({ direction: "row" }, leftProps, { sx: __assign({ alignItems: "center", justifyContent: "left", fex: 1 }, leftSX), className: "left" }), left),
        React__default.createElement(Stack$1, __assign({ direction: "row" }, centerProps, { sx: __assign({ alignItems: "center", justifyContent: "center", fex: 1 }, centerSX), className: "center" }), center),
        React__default.createElement(Stack$1, __assign({ direction: "row" }, rightProps, { sx: __assign({ alignItems: "center", justifyContent: "right", fex: 1 }, rightSX), className: "right" }), right));
}

var css_248z$p = ".logo-component-v2 {\n  line-height: 0;\n}";
styleInject(css_248z$p);

function Logo(_a) {
    var url = _a.url, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.imgProps, imgProps = _c === void 0 ? {} : _c;
    var classes = classNames("logo-component-v2", className);
    var styles = (imgProps === null || imgProps === void 0 ? void 0 : imgProps.styles) || {};
    return React__default.createElement(Box$1, { className: classes },
        React__default.createElement("img", __assign({ src: url, style: __assign({ maxHeight: "45px", maxWidth: "200px" }, styles) }, imgProps)));
}

var css_248z$o = ".modal-component-v2 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: var(--white, #FFFFFF);\n  z-index: 8500;\n  flex-direction: column;\n}\n.modal-component-v2.spacedHeader .fullBar-component-v2 {\n  padding: 2rem 2rem 0 2rem;\n}\n.modal-component-v2.open {\n  display: flex;\n}\n.modal-component-v2:not(.open) {\n  display: none;\n}\n.modal-component-v2 .vSeperator {\n  width: 1px;\n  height: 50%;\n  background: var(--wild-sand, #dddddd);\n}\n.modal-component-v2:not(.spacedHeader) > .fullBar-component-v2 {\n  background: var(--shade100, #F3F2F2);\n}\n.modal-component-v2 > .fullBar-component-v2 {\n  flex: 0;\n  padding: 0.75rem 1.5rem;\n}\n.modal-component-v2 > .fullBar-component-v2 .subNav-component-v2 button {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.modal-component-v2 > .fullBar-component-v2 .left > *:nth-child(n+2) {\n  margin-left: 1rem;\n}\n.modal-component-v2 > div:not(.fullBar-component-v2) {\n  flex: 1;\n}\n.modal-component-v2 .contentSectionContainer {\n  display: flex;\n  align-items: center;\n  overflow-y: auto;\n}";
styleInject(css_248z$o);

function ModalHeading(props) {
    if (props === void 0) { props = {}; }
    var logoUrl = props.logoUrl, leftContent = props.leftContent, rightContent = props.rightContent, onClose = props.onClose, closeBtnText = props.closeBtnText;
    var verticalLine = React__default.createElement("div", { key: "modal-heading-line", className: "vSeperator" });
    var lContent = [];
    if (logoUrl) {
        lContent.push(React__default.createElement(Logo, { key: "modal-heading-logo", url: logoUrl }));
    }
    if (Array.isArray(leftContent)) {
        lContent.push(verticalLine);
        lContent = lContent.concat(leftContent);
    }
    else if (leftContent) {
        lContent.push(verticalLine);
        lContent.push(leftContent);
    }
    var rContent = [];
    if (Array.isArray(rightContent)) {
        rContent = rContent.concat(rightContent);
    }
    else {
        rContent.push(rightContent);
    }
    if (onClose && closeBtnText)
        rContent.push(React__default.createElement(Button, { key: "modal-close-btn", color: "shade150", size: "medium", onClick: onClose }, closeBtnText));
    return React__default.createElement(FullBar, { left: lContent, right: rContent });
}

var Modal = forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var refState = useRef({ open: false });
    var _k = useState(props), state = _k[0], setNewState = _k[1];
    useRef(undefined);
    useEffect(function () {
        refState.current = { open: state.open || false };
    }, [state.open]);
    useEffect(function () {
        if (!areAllPropertiesEmpty(props)) {
            setNewState(setStateFromProps(props));
        }
    }, [props]);
    function isShowing() {
        return refState.current.open;
    }
    function show(cState) {
        setNewState(setStateFromProps(__assign(__assign({}, cState), { open: true })));
    }
    function hide() {
        var _a;
        setNewState(setStateFromProps({ open: false }));
        ((_a = props.heading) === null || _a === void 0 ? void 0 : _a.closeBtnOnClick) && props.heading.closeBtnOnClick();
    }
    function setStateFromProps(cState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var nextState = cState || {};
        var newState = {
            content: (_a = nextState.content) !== null && _a !== void 0 ? _a : undefined,
            managedByContent: (_b = nextState.managedByContent) !== null && _b !== void 0 ? _b : false,
            variant: (_c = nextState.variant) !== null && _c !== void 0 ? _c : "default",
            className: (_d = nextState.className) !== null && _d !== void 0 ? _d : "",
            open: (_e = nextState.open) !== null && _e !== void 0 ? _e : false,
            heading: {
                logoUrl: (_g = (_f = nextState.heading) === null || _f === void 0 ? void 0 : _f.logoUrl) !== null && _g !== void 0 ? _g : undefined,
                titleContent: (_j = (_h = nextState.heading) === null || _h === void 0 ? void 0 : _h.titleContent) !== null && _j !== void 0 ? _j : undefined,
                actions: (_l = (_k = nextState.heading) === null || _k === void 0 ? void 0 : _k.actions) !== null && _l !== void 0 ? _l : undefined,
                closeBtnText: (_o = (_m = nextState.heading) === null || _m === void 0 ? void 0 : _m.closeBtnText) !== null && _o !== void 0 ? _o : undefined,
                closeBtnOnClick: (_q = (_p = nextState.heading) === null || _p === void 0 ? void 0 : _p.closeBtnOnClick) !== null && _q !== void 0 ? _q : undefined,
            }
        };
        return newState;
    }
    useImperativeHandle(ref, function () { return ({
        show: show,
        hide: hide,
        isShowing: isShowing
    }); });
    var mainClasses = classNames("modal-component-v2", state.variant, state.className, {
        "managedByContent": state.managedByContent,
        "open": state.open
    });
    return React__default.createElement(React__default.Fragment, null, state.open &&
        React__default.createElement(Box, { className: mainClasses },
            state.managedByContent &&
                React__default.createElement(React__default.Fragment, null,
                    ((_a = state.heading) === null || _a === void 0 ? void 0 : _a.titleContent) &&
                        React__default.createElement(ModalHeading, { onClose: hide, leftContent: (_b = state.heading) === null || _b === void 0 ? void 0 : _b.titleContent, rightContent: (_c = state.heading) === null || _c === void 0 ? void 0 : _c.actions, closeBtnText: (_d = state.heading) === null || _d === void 0 ? void 0 : _d.closeBtnText, logoUrl: (_e = state.heading) === null || _e === void 0 ? void 0 : _e.logoUrl }),
                    state.content),
            !state.managedByContent && React__default.createElement(React__default.Fragment, null,
                React__default.createElement(ModalHeading, { onClose: hide, leftContent: (_f = state.heading) === null || _f === void 0 ? void 0 : _f.titleContent, rightContent: (_g = state.heading) === null || _g === void 0 ? void 0 : _g.actions, closeBtnText: (_h = state.heading) === null || _h === void 0 ? void 0 : _h.closeBtnText, logoUrl: (_j = state.heading) === null || _j === void 0 ? void 0 : _j.logoUrl }),
                React__default.createElement(ContentSectionContainer, null, state.content))));
});

var css_248z$n = ".overlay-component-v2 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 9000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.overlay-component-v2 .container {\n  background: var(--white, #FFFFFF);\n  border-radius: 16px;\n  width: 80%;\n  height: 80%;\n}\n.overlay-component-v2 .container .contentSectionContainer > div {\n  width: 100%;\n}\n.overlay-component-v2 .container .vSeperator {\n  width: 1px;\n  height: 50%;\n  background: var(--wild-sand, #dddddd);\n}\n.overlay-component-v2 .container > .fullBar-component-v2 {\n  flex: 0;\n  padding: 0.75rem 0.75rem;\n  border-bottom: 1px solid var(--wild-sand, #dddddd);\n}\n.overlay-component-v2 .container > .fullBar-component-v2 .subNav-component-v2 button {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.overlay-component-v2 .container > .fullBar-component-v2 .left > *:nth-child(n+2) {\n  margin-left: 1rem;\n}\n.overlay-component-v2 .container > div:not(.fullBar-component-v2) {\n  flex: 1;\n}\n.overlay-component-v2 .container .contentSectionContainer {\n  display: flex;\n  align-items: center;\n  overflow-y: auto;\n}\n.overlay-component-v2.open {\n  display: flex;\n}\n.overlay-component-v2:not(.open) {\n  display: none;\n}";
styleInject(css_248z$n);

function OverlayHeading(props) {
    if (props === void 0) { props = {}; }
    var logoUrl = props.logoUrl, leftContent = props.leftContent, rightContent = props.rightContent, onClose = props.onClose, closeBtnText = props.closeBtnText;
    var verticalLine = React__default.createElement("div", { key: "overlay-heading-line", className: "vSeperator" });
    var lContent = [];
    if (logoUrl) {
        lContent.push(React__default.createElement(Logo, { key: "overlay-heading-logo", url: logoUrl }));
        lContent.push(verticalLine);
    }
    if (Array.isArray(leftContent)) {
        lContent = lContent.concat(leftContent);
    }
    else {
        lContent.push(leftContent);
    }
    var rContent = [];
    if (Array.isArray(rightContent)) {
        rContent = rContent.concat(rightContent);
    }
    else {
        rContent.push(rightContent);
    }
    if (onClose && closeBtnText)
        rContent.push(React__default.createElement(Button, { key: "modal-close-btn", color: "cloud", size: "medium", onClick: onClose }, closeBtnText));
    return React__default.createElement(FullBar, { left: lContent, right: rContent });
}

var Overlay = forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var refState = useRef({ open: false });
    var _k = useState(props), state = _k[0], setNewState = _k[1];
    useRef(undefined);
    useEffect(function () {
        refState.current = { open: state.open || false };
    }, [state.open]);
    useEffect(function () {
        if (!areAllPropertiesEmpty(props)) {
            setNewState(setStateFromProps(props));
        }
    }, [props]);
    function isShowing() {
        return refState.current.open;
    }
    function show(cState) {
        setNewState(setStateFromProps(__assign(__assign({}, cState), { open: true })));
    }
    function hide() {
        var _a;
        setNewState(setStateFromProps({ open: false }));
        ((_a = props.heading) === null || _a === void 0 ? void 0 : _a.closeBtnOnClick) && props.heading.closeBtnOnClick();
    }
    function setStateFromProps(cState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var nextState = cState || {};
        var newState = {
            content: (_a = nextState.content) !== null && _a !== void 0 ? _a : undefined,
            managedByContent: (_b = nextState.managedByContent) !== null && _b !== void 0 ? _b : false,
            className: (_c = nextState.className) !== null && _c !== void 0 ? _c : "",
            open: (_d = nextState.open) !== null && _d !== void 0 ? _d : false,
            heading: {
                logoUrl: (_f = (_e = nextState.heading) === null || _e === void 0 ? void 0 : _e.logoUrl) !== null && _f !== void 0 ? _f : undefined,
                titleContent: (_h = (_g = nextState.heading) === null || _g === void 0 ? void 0 : _g.titleContent) !== null && _h !== void 0 ? _h : undefined,
                actions: (_k = (_j = nextState.heading) === null || _j === void 0 ? void 0 : _j.actions) !== null && _k !== void 0 ? _k : undefined,
                closeBtnText: (_m = (_l = nextState.heading) === null || _l === void 0 ? void 0 : _l.closeBtnText) !== null && _m !== void 0 ? _m : undefined,
                closeBtnOnClick: (_p = (_o = nextState.heading) === null || _o === void 0 ? void 0 : _o.closeBtnOnClick) !== null && _p !== void 0 ? _p : undefined,
            }
        };
        return newState;
    }
    useImperativeHandle(ref, function () { return ({
        show: show,
        hide: hide,
        isShowing: isShowing
    }); });
    var mainClasses = classNames("overlay-component-v2", state.className, {
        "managedByContent": state.managedByContent,
        "open": state.open
    });
    return React__default.createElement(React__default.Fragment, null, state.open &&
        React__default.createElement(Box, { className: mainClasses },
            React__default.createElement(Stack$1, { className: "container" },
                state.managedByContent &&
                    React__default.createElement(React__default.Fragment, null,
                        ((_a = state.heading) === null || _a === void 0 ? void 0 : _a.titleContent) &&
                            React__default.createElement(OverlayHeading, { onClose: hide, leftContent: (_b = state.heading) === null || _b === void 0 ? void 0 : _b.titleContent, rightContent: (_c = state.heading) === null || _c === void 0 ? void 0 : _c.actions, closeBtnText: (_d = state.heading) === null || _d === void 0 ? void 0 : _d.closeBtnText, logoUrl: (_e = state.heading) === null || _e === void 0 ? void 0 : _e.logoUrl }),
                        state.content),
                !state.managedByContent && React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(OverlayHeading, { onClose: hide, leftContent: (_f = state.heading) === null || _f === void 0 ? void 0 : _f.titleContent, rightContent: (_g = state.heading) === null || _g === void 0 ? void 0 : _g.actions, closeBtnText: (_h = state.heading) === null || _h === void 0 ? void 0 : _h.closeBtnText, logoUrl: (_j = state.heading) === null || _j === void 0 ? void 0 : _j.logoUrl }),
                    React__default.createElement(ContentSectionContainer, null, state.content)))));
});

var css_248z$m = ".ui-kit-v2-wrapper {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}";
styleInject(css_248z$m);

function BrandWrapper(_a) {
    _a.onInit; var _b = _a.onBrandSuccess, onBrandSuccess = _b === void 0 ? function () { } : _b, _c = _a.onBrandError, onBrandError = _c === void 0 ? function () { } : _c, MUITheme = _a.MUITheme, brandId = _a.brandId, brandHost = _a.brandHost, children = _a.children, _d = _a.noFetch, noFetch = _d === void 0 ? false : _d, _e = _a.setPageHead, setPageHead = _e === void 0 ? true : _e, _f = _a.includeHandlers, includeHandlers = _f === void 0 ? true : _f, brandThemeContext = _a.brandThemeContext, styleOverride = _a.styleOverride;
    var fBrandPath = "/brands/".concat(brandId ? brandId + "/" : "", "compiledBrand.json");
    var fBrandHost = brandHost || uiKitConfig.GATEWAY_PROXY || "https://us-central1-brand-prod.cloudfunctions.net";
    var dialogRef = useRef(undefined);
    var actionsBarContainerRef = useRef(undefined);
    var overlayRef = useRef(undefined);
    var modalRef = useRef(undefined);
    var drawerRef = useRef(undefined);
    useEffect(getBrand, [brandId, brandHost]);
    useEffect(initHandlers, [MUITheme]);
    function initHandlers() {
        if (MUITheme && includeHandlers) {
            //@ts-ignore
            DialogHandler.register(dialogRef.current);
            //@ts-ignore
            ActionBarContainerHandler.register(actionsBarContainerRef.current);
            //@ts-ignore
            OverlayHandler.register(overlayRef.current);
            //@ts-ignore
            ModalHandler.register(modalRef.current);
            //@ts-ignore
            DrawerHandler.register(drawerRef.current);
        }
    }
    function getBrand() {
        if (noFetch)
            return;
        getBrandService({ url: fBrandHost + fBrandPath }).then(function (brand) {
            if (setPageHead) {
                setBrandHeadElements(brand);
            }
            onBrandSuccess(brand, buildMUITheme({ brand: brand, context: brandThemeContext, styleOverride: styleOverride }));
        }).catch(function (error) {
            onBrandError(error, buildMUITheme({ brand: whiteLabelBrand, context: brandThemeContext, styleOverride: styleOverride }));
        });
    }
    return React__default.createElement("div", { className: "ui-kit-v2-wrapper" }, MUITheme && React__default.createElement(ThemeProvider, { theme: MUITheme },
        includeHandlers && React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Dialog, { ref: dialogRef }),
            React__default.createElement(ActionBarContainer, { ref: actionsBarContainerRef }),
            React__default.createElement(Overlay, { ref: overlayRef }),
            React__default.createElement(Modal, { ref: modalRef }),
            React__default.createElement(Drawer, { ref: drawerRef })),
        children));
}

function Checkbox(_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return React__default.createElement(Checkbox$1, __assign({}, props, { color: color, checkedIcon: React__default.createElement(Icon, { name: "Checkmark10", color: color }), icon: React__default.createElement(Icon, { name: "Checkmark10", color: color }) }));
}

function MenuOption(_a) {
    var preContent = _a.preContent, text = _a.text, postContent = _a.postContent, desc = _a.desc, onClick = _a.onClick, onMouseDown = _a.onMouseDown, divider = _a.divider, value = _a.value, disabled = _a.disabled, isAction = _a.isAction, isMultiSelect = _a.isMultiSelect, selected = _a.selected, isTitle = _a.isTitle, parentProps = __rest(_a, ["preContent", "text", "postContent", "desc", "onClick", "onMouseDown", "divider", "value", "disabled", "isAction", "isMultiSelect", "selected", "isTitle"]);
    var menuItemClasses = classNames("menuOption-component-v2", {
        "showPreContent": !!preContent,
        "showDivider": divider,
        "disabled": disabled,
        "isAction": isAction,
        "isTitle": isTitle
    });
    //@ts-ignore
    return React__default.createElement(MenuItem, __assign({ onClick: onClick, onMouseDown: onMouseDown, className: menuItemClasses, value: value, sx: {
            alignItems: "flex-start"
        } }, parentProps), divider ?
        React__default.createElement(Divider$1, { variant: "fullWidth" })
        :
            React__default.createElement(React__default.Fragment, null,
                preContent &&
                    React__default.createElement(ListItemIcon, { sx: { justifyContent: "left" } }, preContent),
                React__default.createElement(ListItemText, null, desc ?
                    React__default.createElement(Stack$2, null, isTitle ?
                        React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Typography$2, { variant: "body1S", className: "uppercase bold" }, text),
                            React__default.createElement(Typography$2, { variant: "body2" },
                                " ",
                                desc))
                        :
                            React__default.createElement(React__default.Fragment, null,
                                React__default.createElement(Typography$2, { variant: "body1L", className: "semiBold" }, text),
                                React__default.createElement(Typography$2, null,
                                    " ",
                                    desc)))
                    :
                        React__default.createElement(React__default.Fragment, null, isTitle ?
                            React__default.createElement(Typography$2, { variant: "body1S", className: "uppercase bold" }, text)
                            :
                                React__default.createElement(Typography$2, { variant: "body1L", className: "semiBold" },
                                    " ",
                                    text))),
                postContent &&
                    React__default.createElement(ListItemIcon, { sx: { justifyContent: "right" } }, postContent),
                React__default.createElement(ListItemIcon, { className: isMultiSelect ? "multiSelect" : "selectedCheckmark", sx: { justifyContent: "right" } }, isMultiSelect ?
                    React__default.createElement(Checkbox, { checked: selected })
                    :
                        React__default.createElement(Icon, { name: "Checkmark10" }))));
}

var css_248z$l = ".dropMenu-component-v2.inlineMenu {\n  position: relative;\n  overflow-y: auto;\n  margin-top: 0.75rem;\n  max-height: 35vh;\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1490196078);\n  padding: 0.75rem;\n  border-radius: 16px;\n  min-width: 300;\n  background: var(--background-color-1, var(--white, #FFFFFF));\n  box-sizing: border-box;\n}\n.dropMenu-component-v2.inlineMenu::-webkit-scrollbar {\n  display: block;\n}\n.dropMenu-component-v2.inlineMenu::-webkit-scrollbar-track:horizontal {\n  position: absolute;\n  bottom: -20px;\n}\n.dropMenu-component-v2.inlineMenu::-webkit-scrollbar-track:vertical {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n.dropMenu-component-v2.inlineMenu::-webkit-scrollbar-track {\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 2rem;\n  background-clip: content-box;\n  border-bottom-left-radius: 8px;\n}\n.dropMenu-component-v2.inlineMenu::-webkit-scrollbar-thumb {\n  background: var(--body-font-color-2, var(--silver, #9B9B9B));\n  border-radius: 24px;\n  border-top: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-bottom: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-right: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-left: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n}";
styleInject(css_248z$l);

function DropMenu(_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.popoverProps, popoverProps = _c === void 0 ? {
        open: true
    } : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.inlineMenu, inlineMenu = _e === void 0 ? false : _e;
    var args = __assign({ className: "dropMenu-component-v2 " + className }, popoverProps);
    if (inlineMenu) {
        args.className = args.className + " inlineMenu";
        return React__default.createElement(Paper, __assign({}, args), options === null || options === void 0 ? void 0 : options.map(function (args, index) { return (React__default.createElement(MenuOption, __assign({ key: "DropMenu-MenuOption-".concat(index) }, args))); }));
    }
    else {
        args.anchorOrigin = {
            vertical: 'bottom',
            horizontal: 'right',
        };
        args.transformOrigin = {
            vertical: 'top',
            horizontal: 'right',
        };
        //@ts-ignore
        return React__default.createElement(Popover, __assign({}, args), options === null || options === void 0 ? void 0 : options.map(function (args, index) { return (React__default.createElement(MenuOption, __assign({ key: "DropMenu-MenuOption-".concat(index) }, args))); }));
    }
}

var css_248z$k = ".buttonMenu-component-v2.MuiButton-sizeSmall {\n  min-height: 2rem;\n}\n.buttonMenu-component-v2.MuiButton-sizeMedium {\n  min-height: 3.125rem;\n}\n.buttonMenu-component-v2.MuiButton-sizeLarge {\n  min-height: 3.75rem;\n}";
styleInject(css_248z$k);

function ButtonMenu(_a) {
    var children = _a.children, _b = _a.buttonProps, buttonProps = _b === void 0 ? {
        variant: "outlined"
    } : _b, _c = _a.options, options = _c === void 0 ? [] : _c, _d = _a.iconProps, iconProps = _d === void 0 ? 'default' : _d;
    var _e = useState(undefined), anchor = _e[0], setAnchor = _e[1];
    function handleClick(event) {
        event.preventDefault();
        setAnchor(event.currentTarget);
    }
    function handleClose() {
        setAnchor(undefined);
    }
    var upIconProps = iconProps === "default" ? { name: "Chevron10" } : iconProps;
    var btnClass = classNames("buttonMenu-component-v2", buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, {
        "isIconText": !!iconProps && children
    });
    var iconClass = classNames(upIconProps === null || upIconProps === void 0 ? void 0 : upIconProps.className, {
        "rotate-180": !!anchor
    });
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button$1, __assign({}, buttonProps, { className: btnClass, onClick: handleClick }),
            children,
            iconProps &&
                React__default.createElement(Icon, __assign({}, upIconProps, { className: iconClass }))),
        React__default.createElement(DropMenu, { popoverProps: {
                anchorEl: anchor,
                open: !!anchor,
                onClose: handleClose
            }, options: options }));
}

function Chip(_a) {
    var color = _a.color, className = _a.className, tinted = _a.tinted, squared = _a.squared, lowerCased = _a.lowerCased, props = __rest(_a, ["color", "className", "tinted", "squared", "lowerCased"]);
    var classes = classNames("chip-component-v2", className, {
        "tinted": tinted,
        "squared": squared,
        "lowerCased": lowerCased
    });
    return React__default.createElement(Chip$1, __assign({}, props, { className: classes, color: color }));
}

var css_248z$j = ".codeInput-component > div {\n  justify-content: center;\n  align-items: center;\n}\n.codeInput-component > div input {\n  box-sizing: border-box;\n  width: 48px;\n  height: 48px;\n  padding: 1rem;\n  border-radius: 8px;\n  outline: none;\n  color: var(--primary-brand-color, var(--grape, #69006E));\n  font-size: 1rem;\n  line-height: 1.25rem;\n  text-align: center;\n  margin: 0 0.5rem;\n}\n.codeInput-component > div input[type=number]::-webkit-inner-spin-button, .codeInput-component > div input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.codeInput-component > div input:-moz-placeholder {\n  border: 1px solid var(--wild-sand, #dddddd);\n  color: var(--body-font-color-2, var(--silver, #9B9B9B));\n}\n.codeInput-component > div input:placeholder-shown {\n  border: 1px solid var(--wild-sand, #dddddd);\n  color: var(--body-font-color-2, var(--silver, #9B9B9B));\n}\n.codeInput-component > div input:not(:-moz-placeholder) {\n  border: 1px solid var(--secondary-brand-color, var(--teal, #0ABDAE));\n}\n.codeInput-component > div input:not(:placeholder-shown) {\n  border: 1px solid var(--secondary-brand-color, var(--teal, #0ABDAE));\n}\n.codeInput-component > div input:first-child {\n  margin-left: 0;\n}\n.codeInput-component > div input:last-child {\n  margin-right: 0;\n}";
styleInject(css_248z$j);

function CodeInput(_a) {
    var className = _a.className, initValue = _a.initValue, value = _a.value, _b = _a.numInputs, numInputs = _b === void 0 ? 6 : _b, _c = _a.shouldAutoFocus, shouldAutoFocus = _c === void 0 ? true : _c, placeholder = _a.placeholder, renderSeparator = _a.renderSeparator, _d = _a.inputType, inputType = _d === void 0 ? "text" : _d, onChange = _a.onChange, onPaste = _a.onPaste;
    var _e = useState(initValue), iValue = _e[0], setIValue = _e[1];
    function handleOnChange(newValue) {
        if (value === undefined) {
            setIValue(newValue);
        }
        onChange(newValue);
    }
    function handleOnPaste(event) {
        var clipboardData = event.clipboardData || window.clipboardData;
        var pastedText = clipboardData.getData('text');
        if (onPaste) {
            onPaste(pastedText);
        }
        handleOnChange(pastedText);
    }
    var cValue = value !== undefined ? value : iValue;
    return React__default.createElement("div", { className: "codeInput-component ".concat(className) },
        React__default.createElement(OTPInput, { value: cValue, onChange: handleOnChange, onPaste: handleOnPaste, renderInput: function (props) { return React__default.createElement("input", __assign({}, props)); }, inputType: inputType, numInputs: numInputs, skipDefaultStyles: true, shouldAutoFocus: shouldAutoFocus, placeholder: placeholder, renderSeparator: renderSeparator }));
}

function CustomPaginationActions(_a) {
    var count = _a.count, page = _a.page, rowsPerPage = _a.rowsPerPage, onPageChange = _a.onPageChange, showFirstButton = _a.showFirstButton, showLastButton = _a.showLastButton;
    var handleFirstPageButtonClick = function (event) {
        onPageChange(event, 0);
    };
    var handleBackButtonClick = function (event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (React__default.createElement(Stack$1, { direction: "row", gap: 3 },
        showFirstButton &&
            React__default.createElement(Button, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page", variant: "outlined", color: "body1" }),
        React__default.createElement(Button, { onClick: handleBackButtonClick, disabled: page === 0, iconOnly: true, variant: "outlined", color: "body1" },
            React__default.createElement(Icon, { name: "Chevron10", sx: {
                    transform: "rotate(90deg)"
                } })),
        React__default.createElement(Button, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, iconOnly: true, variant: "outlined", color: "body1" },
            React__default.createElement(Icon, { name: "Chevron10", sx: {
                    transform: "rotate(-90deg)"
                } })),
        showLastButton &&
            React__default.createElement(Button, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page", variant: "outlined", color: "body1" }, "Last")));
}

var css_248z$i = ".dataTable-component-v2 {\n  position: relative;\n  height: 100%;\n}\n.dataTable-component-v2 .MuiTableContainer-root {\n  margin-bottom: 5rem;\n}\n.dataTable-component-v2 .MuiTableContainer-root::-webkit-scrollbar {\n  display: block;\n}\n.dataTable-component-v2 .MuiTableContainer-root::-webkit-scrollbar-track:horizontal {\n  position: absolute;\n  bottom: -20px;\n}\n.dataTable-component-v2 .MuiTableContainer-root::-webkit-scrollbar-track:vertical {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n.dataTable-component-v2 .MuiTableContainer-root::-webkit-scrollbar-track {\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 2rem;\n  background-clip: content-box;\n  border-bottom-left-radius: 8px;\n}\n.dataTable-component-v2 .MuiTableContainer-root::-webkit-scrollbar-thumb {\n  background: var(--body-font-color-2, var(--silver, #9B9B9B));\n  border-radius: 24px;\n  border-top: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-bottom: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-right: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-left: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n}\n.dataTable-component-v2 .MuiTableContainer-root > table thead {\n  border-bottom: 1px solid transparent;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th {\n  vertical-align: middle;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.sortable {\n  cursor: pointer;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.sortable .MuiTableSortLabel-root .MuiTableSortLabel-icon path {\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.sortable:hover .MuiTableSortLabel-root .MuiTableSortLabel-icon {\n  opacity: 0.5;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th,\n.dataTable-component-v2 .MuiTableContainer-root > table td {\n  white-space: nowrap;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th > .cellContainer,\n.dataTable-component-v2 .MuiTableContainer-root > table td > .cellContainer {\n  width: -moz-max-content;\n  width: max-content;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.stickyLastCol::before,\n.dataTable-component-v2 .MuiTableContainer-root > table td.stickyLastCol::before {\n  content: \"\";\n  width: 19px;\n  height: -webkit-fill-available;\n  display: block;\n  position: absolute;\n  top: 0;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.stickyFirstCol::after,\n.dataTable-component-v2 .MuiTableContainer-root > table td.stickyFirstCol::after {\n  content: \"\";\n  width: 19px;\n  height: -webkit-fill-available;\n  display: block;\n  position: absolute;\n  top: 0;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.leftStickyEffect::before, .dataTable-component-v2 .MuiTableContainer-root > table th.rightStickyEffect::before,\n.dataTable-component-v2 .MuiTableContainer-root > table td.leftStickyEffect::before,\n.dataTable-component-v2 .MuiTableContainer-root > table td.rightStickyEffect::before {\n  content: \"\";\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.leftStickyEffect::after, .dataTable-component-v2 .MuiTableContainer-root > table th.rightStickyEffect::after,\n.dataTable-component-v2 .MuiTableContainer-root > table td.leftStickyEffect::after,\n.dataTable-component-v2 .MuiTableContainer-root > table td.rightStickyEffect::after {\n  content: \"\";\n  background-size: 16px 16px, 16px 16px;\n  background-repeat: no-repeat, no-repeat;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.leftStickyEffect,\n.dataTable-component-v2 .MuiTableContainer-root > table td.leftStickyEffect {\n  left: 0;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.leftStickyEffect::after,\n.dataTable-component-v2 .MuiTableContainer-root > table td.leftStickyEffect::after {\n  background-position: top left, bottom left;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.rightStickyEffect,\n.dataTable-component-v2 .MuiTableContainer-root > table td.rightStickyEffect {\n  right: 0;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table th.rightStickyEffect::after,\n.dataTable-component-v2 .MuiTableContainer-root > table td.rightStickyEffect::after {\n  right: 0;\n  background-position: top right, bottom right;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table tr {\n  position: relative;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table tr td .cellContainer {\n  display: flex;\n  justify-content: left;\n  width: -moz-max-content;\n  width: max-content;\n  min-width: 100%;\n}\n.dataTable-component-v2 .MuiTableContainer-root > table tr td.centered .cellContainer {\n  justify-content: center;\n}\n.dataTable-component-v2 .MuiTablePagination-root .MuiTablePagination-selectLabel,\n.dataTable-component-v2 .MuiTablePagination-root .MuiInputBase-root {\n  display: none;\n}\n\n.colManagerMenu .MuiListItemText-root .MuiCheckbox-root {\n  margin-right: 0.75rem;\n}";
styleInject(css_248z$i);

var bottomLeftCorner = "data:image/svg+xml,%3Csvg%20width%3D%228%22%20height%3D%228%22%20viewBox%3D%220%200%208%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fillRule%3D%22evenodd%22%20clipRule%3D%22evenodd%22%20d%3D%22M8%208C3.58172%208%20-1.56562e-07%204.41828%20-3.49691e-07%200L0%208L8%208Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var bottomRightCorner = "data:image/svg+xml,%3Csvg%20width%3D%228%22%20height%3D%228%22%20viewBox%3D%220%200%208%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fillRule%3D%22evenodd%22%20clipRule%3D%22evenodd%22%20d%3D%22M8%200C8%204.41828%204.41828%208%200%208L8%208L8%200Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var topLeftCorner = "data:image/svg+xml,%3Csvg%20width%3D%228%22%20height%3D%228%22%20viewBox%3D%220%200%208%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fillRule%3D%22evenodd%22%20clipRule%3D%22evenodd%22%20d%3D%22M0%208C0%203.58173%203.58203%200%208%200H0V8Z%22%20fill%3D%22%23ffffff%22%2F%3E%3C%2Fsvg%3E";

var topRightCorner = "data:image/svg+xml,%3Csvg%20width%3D%228%22%20height%3D%228%22%20viewBox%3D%220%200%208%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fillRule%3D%22evenodd%22%20clipRule%3D%22evenodd%22%20d%3D%22M0%20-3.49691e-07C4.41828%20-1.56562e-07%208%203.58172%208%208L8%200L0%20-3.49691e-07Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

function DataTableHead(_a) {
    var onSelectAllClick = _a.onSelectAllClick, order = _a.order, orderBy = _a.orderBy, numSelected = _a.numSelected, rowCount = _a.rowCount, onRequestSort = _a.onRequestSort, columnsData = _a.columnsData, showRowSelection = _a.showRowSelection, stickyFirstCol = _a.stickyFirstCol, stickyLastCol = _a.stickyLastCol, showCollapsibleContent = _a.showCollapsibleContent;
    var createSortHandler = function (property) { return function (event) {
        onRequestSort(event, property);
    }; };
    return (React__default.createElement(TableHead, null,
        React__default.createElement(TableRow, null,
            React__default.createElement(TableCell, { className: "leftStickyEffect stickyEffect", sx: {
                    '&:after': {
                        backgroundImage: "url('".concat(topLeftCorner, "'), url('").concat(bottomLeftCorner, "')")
                    }
                } }),
            showRowSelection &&
                React__default.createElement(TableCell, { padding: "checkbox", className: stickyFirstCol ? "stickyFirstCol" : "" },
                    React__default.createElement(Checkbox, { color: "secondary", indeterminate: numSelected > 0 && numSelected < rowCount, checked: rowCount > 0 && numSelected === rowCount, onChange: onSelectAllClick })),
            showCollapsibleContent && React__default.createElement(TableCell, { className: "collapsibleCell", style: { minWidth: 42, maxWidth: 42, width: 42 }, padding: "checkbox" }),
            columnsData.map(function (columnData, index) {
                var cellClass = columnData.className || "";
                if (stickyFirstCol) {
                    if (!showRowSelection) {
                        cellClass += " stickyFirstCol";
                    }
                }
                if (stickyLastCol && columnsData.length - 1 === index) {
                    cellClass += " stickyLastCol";
                }
                if (columnData === null || columnData === void 0 ? void 0 : columnData.sortable) {
                    cellClass += " sortable";
                }
                var baseColumnWidth = 50;
                if (columnData.width)
                    baseColumnWidth = columnData.width;
                else if (columnsData.length - 1 === index && !cellClass.includes("stickyLastCol"))
                    baseColumnWidth = undefined;
                else if (columnsData.length - 2 === index && stickyLastCol)
                    baseColumnWidth = undefined;
                return React__default.createElement(TableCell, { key: columnData.id, className: cellClass, align: columnData.numeric ? 'right' : 'left', padding: columnData.disablePadding ? 'none' : 'normal', sortDirection: orderBy === columnData.id ? order : false, style: {
                        width: baseColumnWidth,
                        minWidth: baseColumnWidth
                    }, onClick: (columnData === null || columnData === void 0 ? void 0 : columnData.sortable) ? createSortHandler(columnData.id) : undefined }, (columnData === null || columnData === void 0 ? void 0 : columnData.sortable) ?
                    React__default.createElement(TableSortLabel, { active: orderBy === columnData.id, direction: orderBy === columnData.id ? order : 'asc', className: "cellContainer" }, columnData.label)
                    :
                        React__default.createElement("span", { className: "cellContainer" }, columnData.label));
            }),
            React__default.createElement(TableCell, { className: "rightStickyEffect stickyEffect", sx: {
                    '&:after': {
                        backgroundImage: "url('".concat(topRightCorner, "'), url('").concat(bottomRightCorner, "')")
                    }
                } }))));
}

function DataTablePaginationNoCount(_a) {
    var page = _a.page, setPage = _a.setPage, onPaginationChange = _a.onPaginationChange, hasMore = _a.hasMore, rowsPerPage = _a.rowsPerPage;
    function handleChangePage(changePage) {
        setPage(page + changePage);
        onPaginationChange && onPaginationChange(page + changePage, rowsPerPage);
    }
    return (React__default.createElement(Stack$1, { direction: "row", className: "pagination-buttons" },
        React__default.createElement(Button, { color: "body1", variant: "outlined", size: "medium", disabled: page < 2, onClick: function () { return handleChangePage(-1); } },
            React__default.createElement(Icon, { name: "Chevron10", sx: {
                    transform: "rotate(90deg)"
                } })),
        React__default.createElement(Button, { color: "body1", variant: "outlined", size: "medium", disabled: !hasMore, onClick: function () { return handleChangePage(1); } },
            React__default.createElement(Icon, { name: "Chevron10", sx: {
                    transform: "rotate(-90deg)"
                } }))));
}

function DataTableRow(_a) {
    var row = _a.row, columnsData = _a.columnsData, handleRowClick = _a.handleRowClick, handleRowSelect = _a.handleRowSelect, isItemSelected = _a.isItemSelected, index = _a.index, rowIdMap = _a.rowIdMap, showRowSelection = _a.showRowSelection, stickyFirstCol = _a.stickyFirstCol, stickyLastCol = _a.stickyLastCol, showCollapsibleContent = _a.showCollapsibleContent, colCount = _a.colCount;
    var _b = React__default.useState((row === null || row === void 0 ? void 0 : row.initCollapsedOpen) || false), open = _b[0], setOpen = _b[1];
    function handleOpen(event) {
        event.stopPropagation();
        setOpen(!open);
    }
    function flattenRowToIds(row) {
        var formatedRow = {};
        Object.entries(row).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var stringValue = value;
            if (!isSimpleType(value)) {
                if (value === null || value === void 0 ? void 0 : value.id) {
                    stringValue = value.id;
                }
            }
            formatedRow[key] = stringValue;
        });
        return formatedRow;
    }
    var rowKey = "row-".concat(row[rowIdMap] || index);
    var tableRowClasses = classNames({
        "collapsible": row === null || row === void 0 ? void 0 : row.collapsedContent,
        "collapsibleOpen": open
    });
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TableRow, { key: rowKey, hover: true, onClick: function (event) {
                if (handleRowClick)
                    handleRowClick(event, flattenRowToIds(row));
                else if (showRowSelection && handleRowSelect) {
                    handleRowSelect(event, row[rowIdMap]);
                }
            }, role: "checkbox", "aria-checked": isItemSelected, tabIndex: -1, selected: isItemSelected, sx: { cursor: 'pointer' }, className: tableRowClasses },
            React__default.createElement(TableCell, { className: "leftStickyEffect stickyEffect", sx: {
                    '&:after': {
                        backgroundImage: "url('".concat(topLeftCorner, "'), url('").concat(bottomLeftCorner, "')")
                    }
                } }),
            showRowSelection &&
                React__default.createElement(TableCell, { key: "".concat(rowKey, "-cell-0"), padding: "checkbox", onClick: function (event) { return handleRowSelect && handleRowSelect(event, row[rowIdMap]); }, className: stickyFirstCol ? "stickyFirstCol" : "" },
                    React__default.createElement(Checkbox, { color: "secondary", checked: isItemSelected })),
            showCollapsibleContent &&
                React__default.createElement(TableCell, { onClick: (row === null || row === void 0 ? void 0 : row.collapsedContent) && handleOpen, style: { minWidth: 42, maxWidth: 42 }, padding: "checkbox", className: "collapsibleCell ".concat(open ? "openedCollapsibleCell" : "") }, (row === null || row === void 0 ? void 0 : row.collapsedContent) &&
                    React__default.createElement(Icon, { name: "Chevron10", sx: {
                            transform: open ? "rotate(0deg)" : "rotate(-90deg)"
                        } })),
            columnsData.map(function (column, index) {
                var _a, _b;
                var cellClass = column.className || "";
                var cellContainerSX = {};
                if (stickyFirstCol) {
                    if (!showRowSelection) {
                        cellClass += " stickyFirstCol";
                    }
                }
                if (stickyLastCol && columnsData.length - 1 === index) {
                    cellClass += " stickyLastCol";
                }
                if (column.ellipsis && column.width) {
                    cellContainerSX = { width: column.width, minWidth: column.width };
                }
                return React__default.createElement(TableCell, { key: "".concat(rowKey, "-cell-").concat(column.id || index + 1), className: cellClass + (((_a = row[column.id]) === null || _a === void 0 ? void 0 : _a.className) || ""), align: column.numeric || false ? 'right' : 'left' },
                    React__default.createElement("div", { className: "cellContainer ".concat(column.ellipsis && column.width ? "ellipsis" : ""), style: cellContainerSX }, ((_b = row[column.id]) === null || _b === void 0 ? void 0 : _b.content) ? row[column.id].content : row[column.id]));
            }),
            React__default.createElement(TableCell, { className: "rightStickyEffect stickyEffect", sx: {
                    '&:after': {
                        backgroundImage: "url('".concat(topRightCorner, "'), url('").concat(bottomRightCorner, "')")
                    }
                } })),
        (row === null || row === void 0 ? void 0 : row.collapsedContent) &&
            React__default.createElement(TableRow, { sx: { '& > *': { borderBottom: 'unset' } }, className: "collapsibleContent ".concat(open ? "collapsibleContentOpened" : "") },
                React__default.createElement(TableCell, { className: "leftStickyEffect stickyEffect" }),
                React__default.createElement(TableCell, { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: colCount - 2 },
                    React__default.createElement(Collapse, { in: Boolean(open), timeout: "auto", unmountOnExit: true }, row.collapsedContent)),
                React__default.createElement(TableCell, { className: "rightStickyEffect stickyEffect" })));
}

var css_248z$h = ".search-component-v2 {\n  width: 100%;\n}\n.search-component-v2 .inputContainer {\n  width: 100%;\n  padding: 1.25rem 1.5rem;\n  background-color: var(--background-color-1, var(--white, #FFFFFF));\n  border-radius: 16px;\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);\n  box-sizing: border-box;\n}\n.search-component-v2 .inputContainer > *:not(:first-child) {\n  margin-left: 1rem;\n}\n.search-component-v2 .inputContainer input {\n  flex: 1;\n  font-family: proxima-nova, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Geneva, Verdana, sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.25rem;\n  border: none;\n  outline: none;\n  color: var(--primary-brand-color, var(--grape, #69006E));\n  background: none;\n}\n.search-component-v2 .inputContainer input::-moz-placeholder {\n  color: var(--silver, #9B9B9B);\n}\n.search-component-v2 .inputContainer input::placeholder {\n  color: var(--silver, #9B9B9B);\n}";
styleInject(css_248z$h);

function Search(_a) {
    var _b = _a.initValue, initValue = _b === void 0 ? "" : _b, name = _a.name, onChange = _a.onChange, _c = _a.intervalTime, intervalTime = _c === void 0 ? 800 : _c, placeholder = _a.placeholder, onClose = _a.onClose, _d = _a.className, className = _d === void 0 ? "" : _d, useClickAway = _a.useClickAway, onEnter = _a.onEnter, _e = _a.useKeyDownForChange, useKeyDownForChange = _e === void 0 ? false : _e;
    var timeoutRef = useRef(undefined);
    var _f = useState(initValue), value = _f[0], setValue = _f[1];
    function handleKeyDown(event) {
        if (event.key === 'Escape') {
            setValue("");
            changeTimer("");
        }
        else if (event.key === "Enter") {
            if (onEnter) {
                onEnter(value);
            }
            else if (onChange) {
                onChange(value);
            }
            clearTimeout(timeoutRef.current);
        }
        else if (useKeyDownForChange) {
            // To Prevent Material UI Dropdown Auto-Selection by typing
            handleOnKeyDownChange(event);
        }
    }
    function handleOnKeyDownChange(event) {
        var target = event.target;
        target.name;
        var currentValue = target.value;
        if (event.key.length === 1) {
            if (target.selectionStart !== target.selectionEnd) {
                // Replace selected text with typed character
                var start = target.selectionStart || 0;
                var end = target.selectionEnd || 0;
                currentValue = currentValue.substring(0, start) + event.key + currentValue.substring(end);
            }
            else {
                // Single character keys (letters, numbers, symbols)
                currentValue = currentValue + event.key;
            }
            event.stopPropagation();
            event.preventDefault();
            setValue(currentValue);
            changeTimer(currentValue);
        }
    }
    function handleOnChange(event) {
        var _a = event === null || event === void 0 ? void 0 : event.currentTarget; _a.name; var value = _a.value;
        setValue(value);
        changeTimer(value);
    }
    function changeTimer(search) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(function () {
            if (onChange) {
                onChange(search);
            }
            setValue(search);
        }, intervalTime);
    }
    //on open, focus
    return React__default.createElement(ClickAwayListener, { onClickAway: function () {
            if (!value && useClickAway && onClose)
                onClose();
        } },
        React__default.createElement(Stack$1, { className: "search-component-v2 ".concat(className) },
            React__default.createElement(Stack$1, { className: "inputContainer", direction: "row", alignItems: "center" },
                React__default.createElement(Icon, { name: "Search18" }),
                React__default.createElement("input", { autoComplete: "off", className: "searchInput", value: value, name: name, onChange: handleOnChange, placeholder: placeholder, onKeyDown: handleKeyDown }),
                onClose &&
                    React__default.createElement(Icon, { actionIcon: true, className: "close", name: "X18", onClick: onClose }))));
}

var css_248z$g = ".dropdown-component-v2 .prefixIcon {\n  margin-right: 0.5rem;\n}\n.dropdown-component-v2 .MuiFormLabel-root,\n.dropdown-component-v2 .MuiFormLabel-root.Mui-focused {\n  font-family: proxima-nova, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Geneva, Verdana, sans-serif;\n  font-weight: 700;\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  max-width: 52rem;\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n  transform: translate(14px, -9px) !important;\n}\n.dropdown-component-v2 .MuiFormLabel-root > div,\n.dropdown-component-v2 .MuiFormLabel-root.Mui-focused > div {\n  display: flex;\n  align-items: \"center\";\n}\n.dropdown-component-v2 .MuiFormLabel-root > div .MuiSvgIcon-root,\n.dropdown-component-v2 .MuiFormLabel-root.Mui-focused > div .MuiSvgIcon-root {\n  margin-left: 0.5rem;\n}\n.dropdown-component-v2 .filled fieldset {\n  border-color: var(--secondary-brand-color, var(--teal, #0ABDAE)) !important;\n}\n.dropdown-component-v2 fieldset legend span {\n  font-weight: 700;\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  max-width: 52rem;\n}";
styleInject(css_248z$g);

function Dropdown(_a) {
    var placeholder = _a.placeholder, label = _a.label, keepOpenOnClick = _a.keepOpenOnClick, name = _a.name, _b = _a.className, className = _b === void 0 ? "" : _b, extraSelectProps = _a.extraSelectProps, variant = _a.variant, labelIconColor = _a.labelIconColor, onChange = _a.onChange, defaultValue = _a.defaultValue, _c = _a.menuPlacement, menuPlacement = _c === void 0 ? "bottom-right" : _c, _d = _a.iconOnly, iconOnly = _d === void 0 ? false : _d, chevronIconOverride = _a.chevronIconOverride, renderValue = _a.renderValue, _e = _a.options, options = _e === void 0 ? [] : _e, _f = _a.typographyVariant, typographyVariant = _f === void 0 ? "button" : _f, _g = _a.size, size = _g === void 0 ? "medium" : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h, _j = _a.color, color = _j === void 0 ? "primary" : _j, _k = _a.value, value = _k === void 0 ? undefined : _k, _l = _a.multiSelect, multiSelect = _l === void 0 ? false : _l, searchProps = _a.searchProps, stickyActions = _a.stickyActions, prefixIcon = _a.prefixIcon, onOpen = _a.onOpen, onClose = _a.onClose;
    var _m = useState(false), open = _m[0], setOpen = _m[1];
    var _o = useState(!!(value || defaultValue)), hasValue = _o[0], setHasValue = _o[1];
    var theme = useTheme$2();
    var id = useRef("dropdown-".concat(Math.floor(Math.random() * 100000000)));
    function handleOnChange(e, child) {
        setHasValue(true);
        //@ts-ignore
        onChange && onChange(e, child, value);
    }
    function toggleOpen(event) {
        event.stopPropagation();
        var menuOptionParent = event.currentTarget.closest('.menuOption-component-v2');
        if (keepOpenOnClick && open && menuOptionParent) {
            return;
        }
        if (open && onClose) {
            onClose();
        }
        else if (!open && onOpen) {
            onOpen();
        }
        setOpen(!open);
    }
    var selectClass = classNames(className, extraSelectProps === null || extraSelectProps === void 0 ? void 0 : extraSelectProps.className, size, "c-".concat(color), {
        "open": open,
        "iconOnly": iconOnly,
        "noLabel": !label
    });
    var iconFontSize = "10";
    if (typographyVariant === null || typographyVariant === void 0 ? void 0 : typographyVariant.includes("h")) {
        iconFontSize = "18";
    }
    var placement = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }
    };
    switch (menuPlacement) {
        case "bottom":
            placement.anchorOrigin.horizontal = "center";
            placement.transformOrigin.horizontal = "center";
            break;
        case "bottom-left":
            placement.anchorOrigin.horizontal = "left";
            placement.transformOrigin.horizontal = "left";
            break;
    }
    var dropMenuClasses = classNames("dropdown-menu-list", className ? className + "-menu-list" : undefined, {
        hasStickyActions: !!stickyActions,
        hasSearch: !!searchProps
    });
    var isMultiSelect = typeof multiSelect === "boolean" ? multiSelect : !!multiSelect;
    return React__default.createElement(FormControl, { className: "dropdown-component-v2" },
        label &&
            React__default.createElement(InputLabel, { id: "DD-label" + label }, label),
        React__default.createElement(Select, __assign({ id: "DD-label" + label, labelId: "DD-label" + label, autoWidth: true, displayEmpty: true, placeholder: placeholder, label: label }, extraSelectProps, { disabled: disabled, onOpen: toggleOpen, onClose: toggleOpen, open: open, 
            //@ts-ignore
            defaultValue: defaultValue, 
            //@ts-ignore
            value: value, onChange: handleOnChange, name: name, variant: variant, multiple: isMultiSelect, 
            //@ts-ignore
            MenuProps: __assign(__assign({}, placement), { className: dropMenuClasses }), renderValue: renderValue ? renderValue : function (value) {
                var text = options === null || options === void 0 ? void 0 : options.find(function (option) { return ((option === null || option === void 0 ? void 0 : option.value) === value); });
                //TODO multiselect override
                return (React__default.createElement(React__default.Fragment, null,
                    !iconOnly && React__default.createElement(React__default.Fragment, null,
                        prefixIcon && React__default.createElement(Icon, { className: "prefixIcon", name: "Filter14" }),
                        labelIconColor && (React__default.createElement(Box$1, { sx: {
                                display: "inline-block",
                                width: "1.2em",
                                height: "1.2em",
                                backgroundColor: theme.palette[labelIconColor].main,
                                marginRight: "0.5em",
                            } })),
                        React__default.createElement(Typography$1, { variant: typographyVariant }, !text ? placeholder || "" : String((text === null || text === void 0 ? void 0 : text.renderedText) || (text === null || text === void 0 ? void 0 : text.text) || value))),
                    React__default.createElement(Icon, { name: chevronIconOverride || ("Chevron" + iconFontSize), className: chevronIconOverride ? "" : open ? "rotate-180" : "" })));
            }, SelectDisplayProps: {
                color: color
            }, className: "".concat(selectClass, " ").concat(hasValue ? "filled" : "") }),
            searchProps && React__default.createElement(Search, __assign({ useKeyDownForChange: true }, searchProps)), options === null || options === void 0 ? void 0 :
            options.map(function (args, index) {
                return React__default.createElement(MenuOption, __assign({ key: "".concat(id, "-").concat(index), isMultiSelect: isMultiSelect, selected: isMultiSelect ? value === null || value === void 0 ? void 0 : value.includes(args.value || "") : undefined }, args));
            }),
            stickyActions && React__default.createElement(Stack$1, { className: "stickyActions", direction: "column", justifyContent: "center", alignContent: "center" }, stickyActions)));
}

function ColManager(_a) {
    var columns = _a.columns, removedColumns = _a.removedColumns, onVisibilityChange = _a.onVisibilityChange;
    function handleColVisibility(event) {
        var _a = event.target; _a.name; var value = _a.value;
        var updatedCols = [];
        if (removedColumns.includes(value)) {
            updatedCols = removedColumns.filter(function (id) { return id !== value; });
        }
        else {
            updatedCols = __spreadArray(__spreadArray([], removedColumns, true), [value], false);
        }
        onVisibilityChange(updatedCols);
    }
    return React__default.createElement(Box, { className: "colManager" },
        React__default.createElement(Dropdown, { className: "colManagerMenu", keepOpenOnClick: true, onChange: handleColVisibility, size: "small", iconOnly: true, value: "", options: columns === null || columns === void 0 ? void 0 : columns.map(function (col) {
                return {
                    value: col.id,
                    text: React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(Checkbox, { color: "secondary", value: "id", checked: !removedColumns.includes(String(col.id)) }),
                        " ",
                        col.label)
                };
            }) }));
}

function DataTable(_a) {
    var rows = _a.rows, columnsData = _a.columnsData, className = _a.className, onRowClick = _a.onRowClick, onRowSelect = _a.onRowSelect, onPaginationChange = _a.onPaginationChange, onSortChange = _a.onSortChange, _b = _a.showHead, showHead = _b === void 0 ? true : _b, _c = _a.showRowSelection, showRowSelection = _c === void 0 ? false : _c, _d = _a.rowIdMap, rowIdMap = _d === void 0 ? "id" : _d, _e = _a.rowsPerPageOptions, rowsPerPageOptions = _e === void 0 ? [25, 50, 100] : _e, totalCount = _a.totalCount, controlledState = _a.controlledState, initState = _a.initState, _f = _a.stickyHeader, stickyHeader = _f === void 0 ? false : _f, tableContainerSX = _a.tableContainerSX, sx = _a.sx, stickyFirstCol = _a.stickyFirstCol, stickyLastCol = _a.stickyLastCol, _g = _a.showCollapsibleContent, showCollapsibleContent = _g === void 0 ? false : _g, _h = _a.showPagination, showPagination = _h === void 0 ? true : _h, hasMore = _a.hasMore; _a.showLineSeparator; var _k = _a.useSortMemo, useSortMemo = _k === void 0 ? false : _k;
    var _l = useState((controlledState === null || controlledState === void 0 ? void 0 : controlledState.order) || (initState === null || initState === void 0 ? void 0 : initState.order) || "asc"), order = _l[0], setOrder = _l[1];
    var _m = useState((controlledState === null || controlledState === void 0 ? void 0 : controlledState.orderBy) || (initState === null || initState === void 0 ? void 0 : initState.orderBy) || ""), orderBy = _m[0], setOrderBy = _m[1];
    var _o = useState((controlledState === null || controlledState === void 0 ? void 0 : controlledState.selected) || (initState === null || initState === void 0 ? void 0 : initState.selected) || []), selected = _o[0], setSelected = _o[1];
    var _p = useState((controlledState === null || controlledState === void 0 ? void 0 : controlledState.page) || (initState === null || initState === void 0 ? void 0 : initState.page) || 0), page = _p[0], setPage = _p[1];
    var _q = useState((controlledState === null || controlledState === void 0 ? void 0 : controlledState.rowsPerPage) || (initState === null || initState === void 0 ? void 0 : initState.rowsPerPage) || 50), rowsPerPage = _q[0], setRowsPerPage = _q[1];
    //TODO controlled state
    //TODO showLineSeparator false
    useEffect(function () {
        if (controlledState) {
            controlledState.order && setOrder(controlledState.order);
            controlledState.orderBy && setOrderBy(controlledState.orderBy);
            controlledState.selected && setSelected(controlledState.selected);
            controlledState.page && setPage(controlledState.page);
            controlledState.rowsPerPage && setRowsPerPage(controlledState.rowsPerPage);
        }
    }, [controlledState]);
    function handleRequestSort(event, property) {
        var isAsc = orderBy === property && order === 'asc';
        var cOrder = isAsc ? 'desc' : 'asc';
        setOrder(cOrder);
        setOrderBy(property);
        onSortChange && onSortChange(cOrder, property);
    }
    function handleSelectAllClick(event) {
        if (event.target.checked) {
            var newSelected = rows.map(function (n) {
                var _a;
                if (isSimpleType(n[rowIdMap])) {
                    return n[rowIdMap];
                }
                return (_a = n[rowIdMap]) === null || _a === void 0 ? void 0 : _a.value;
            });
            setSelected(newSelected);
            onRowSelect && onRowSelect(event, undefined, newSelected);
            return;
        }
        setSelected([]);
        onRowSelect && onRowSelect(event, undefined, []);
    }
    function handleRowSelect(event, id) {
        event.stopPropagation();
        var selectedIndex = selected.indexOf(id);
        var newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
        onRowSelect && onRowSelect(event, id, newSelected);
    }
    function handleChangePage(event, newPage) {
        setPage(newPage);
        onPaginationChange && onPaginationChange(newPage + 1, rowsPerPage);
    }
    function handleChangeRowsPerPage(event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        onPaginationChange && onPaginationChange(1, parseInt(event.target.value, 10));
    }
    function isSelected(id) {
        return selected.indexOf(id) !== -1;
    }
    var visibleRows = rows;
    if (!onSortChange && orderBy) {
        if (useSortMemo) {
            visibleRows = React__default.useMemo(function () {
                return stableSort(rows, order, orderBy).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
            }, [order, orderBy, page, rowsPerPage]);
        }
        else {
            visibleRows = stableSort(rows, order, orderBy).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        }
    }
    var classes = classNames("dataTable-component-v2", className);
    var tableClasses = classNames({
        "noRowClick": !!!onRowClick,
        "noRowSelect": !showRowSelection
    });
    var colCount = columnsData.length + 3 + (showRowSelection ? 1 : 0);
    return React__default.createElement(Box$1, { className: classes, sx: sx },
        React__default.createElement(TableContainer, { sx: tableContainerSX },
            React__default.createElement(Table, { stickyHeader: stickyHeader, sx: { minWidth: "100%" }, "aria-labelledby": "tableTitle", className: tableClasses },
                showHead &&
                    React__default.createElement(DataTableHead, { numSelected: selected.length, order: order, orderBy: orderBy, onSelectAllClick: handleSelectAllClick, onRequestSort: handleRequestSort, rowCount: rows.length, columnsData: columnsData, showRowSelection: showRowSelection, stickyFirstCol: stickyFirstCol, stickyLastCol: stickyLastCol, showCollapsibleContent: showCollapsibleContent }),
                React__default.createElement(TableBody, null, visibleRows.map(function (row, index) {
                    var isItemSelected = isSelected(row[rowIdMap]) || !!(row === null || row === void 0 ? void 0 : row.isSelected);
                    return React__default.createElement(DataTableRow, { key: "mainrow-" + index, handleRowClick: onRowClick, handleRowSelect: handleRowSelect, isItemSelected: isItemSelected, columnsData: columnsData, row: row, index: index, rowIdMap: rowIdMap, showRowSelection: showRowSelection, stickyFirstCol: stickyFirstCol, stickyLastCol: stickyLastCol, showCollapsibleContent: showCollapsibleContent, colCount: colCount });
                })))),
        showPagination && (hasMore !== undefined ? (React__default.createElement(DataTablePaginationNoCount, { page: page, setPage: setPage, onPaginationChange: onPaginationChange, rowsPerPage: rowsPerPage, hasMore: hasMore })) : (React__default.createElement(TablePagination, { rowsPerPageOptions: rowsPerPageOptions, component: "div", count: totalCount !== undefined ? totalCount : rows.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage, 
            //@ts-ignore
            ActionsComponent: CustomPaginationActions }))));
}

var css_248z$f = ".dateTimeSelector.dateTimeCalendar {\n  background: var(--white, #FFFFFF);\n}\n.dateTimeSelector .MuiMultiSectionDigitalClock-root,\n.dateTimeSelector .MuiMultiSectionDigitalClockSection-root {\n  flex: 1;\n}\n.dateTimeSelector .MuiMultiSectionDigitalClock-root .MuiMultiSectionDigitalClockSection-item.Mui-selected,\n.dateTimeSelector .MuiMultiSectionDigitalClockSection-root .MuiMultiSectionDigitalClockSection-item.Mui-selected {\n  background-color: var(--primary-brand-color, var(--grape, #69006E)) !important;\n}";
styleInject(css_248z$f);

function DatePicker(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = classNames("inputDateTimePicker", "datePicker", className);
    return React__default.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
        React__default.createElement(DatePicker$1, __assign({ className: classes }, props)));
}
function TimePicker(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = classNames("inputDateTimePicker", "timePicker", className);
    return React__default.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
        React__default.createElement(TimePicker$1, __assign({ className: classes }, props)));
}
function DateTimePicker(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = classNames("inputDateTimePicker", "dateTimePicker", className);
    return React__default.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
        React__default.createElement(DateTimePicker$1, __assign({ className: classes }, props)));
}
function TimeSelector(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = classNames("dateTimeSelector", "timeSelector", className);
    return React__default.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
        React__default.createElement(MultiSectionDigitalClock, __assign({ className: classes }, props)));
}
function DateCalendar(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classes = classNames("dateTimeSelector", "dateCalendar", className);
    return React__default.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
        React__default.createElement(DateCalendar$1, __assign({ className: classes }, props)));
}
function DateTimeCalendar(_a) {
    _a.showToolbar; var className = _a.className, props = __rest(_a, ["showToolbar", "className"]);
    var _b = React__default.useState("day"), currentView = _b[0], setCurrentView = _b[1];
    var classes = classNames("dateTimeSelector", "dateTimeCalendar", className);
    return React__default.createElement(LocalizationProvider, { dateAdapter: AdapterMoment },
        React__default.createElement(StaticDateTimePicker, __assign({}, props, { view: currentView, 
            //Preview default auto switch fix
            onViewChange: function (newView) {
                if (currentView !== "hours" && (newView === "year" || currentView === "year")) {
                    setCurrentView(newView);
                }
            }, className: classes, viewRenderers: {
                hours: function (props) {
                    return React__default.createElement(MultiSectionDigitalClock, { ampm: props.ampm, minTime: props.minTime, maxTime: props.maxTime, onChange: props.onChange, value: props.value, defaultValue: props.defaultValue, disableFuture: props.disableFuture, disablePast: props.disablePast, timezone: props.timezone });
                },
                minutes: function () { return React__default.createElement(MultiSectionDigitalClock, null); },
            }, slotProps: {
                toolbar: { hidden: true }, actionBar: { actions: [] },
                tabs: {
                    //@ts-ignore
                    onViewChange: function (view) {
                        console.log("view", view);
                        setCurrentView(view);
                    }
                }
            } })));
}

var css_248z$e = ".divider-component-v2 {\n  width: 100%;\n}";
styleInject(css_248z$e);

function Divider(_a) {
    var _b = _a.height, height = _b === void 0 ? 1 : _b, _c = _a.color, color = _c === void 0 ? "wildSand" : _c;
    var theme = useTheme$2();
    return React__default.createElement(Box, { className: "divider-component-v2", sx: {
            height: height + "px",
            backgroundColor: theme.palette[color].main,
        } });
}

function CountryDropdown(_a) {
    var useCodesForValue = _a.useCodesForValue, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, args = __rest(_a, ["useCodesForValue", "value", "defaultValue", "onChange"]);
    value = (value === null || value === void 0 ? void 0 : value.length) === 2 ? value === null || value === void 0 ? void 0 : value.toUpperCase() : value === null || value === void 0 ? void 0 : value.toLocaleLowerCase();
    defaultValue = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) === 2 ? defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toUpperCase() : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toLocaleLowerCase();
    var shoudUseCodesForValue = value ? (value === null || value === void 0 ? void 0 : value.length) === 2 : (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) === 2;
    if (useCodesForValue !== undefined)
        shoudUseCodesForValue = useCodesForValue;
    var options = Object.entries(getNameList()).map(function (c) {
        return {
            text: capitalizeFirstLetter(c[0]),
            value: shoudUseCodesForValue ? c[1] : c[0]
        };
    });
    return React__default.createElement(Dropdown, __assign({}, args, { value: value, defaultValue: defaultValue, options: options, onChange: onChange }));
}

var css_248z$d = ".emptyContent-component-v2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  padding: 2rem;\n  box-sizing: border-box;\n  background: var(--cloud, #F4F4F4);\n  align-self: stretch;\n  justify-self: stretch;\n  border-radius: 32px;\n}\n.emptyContent-component-v2 > .MuiStack-root {\n  width: 32rem;\n  text-align: center;\n}\n.emptyContent-component-v2 > .MuiStack-root .MuiTypography-h3 {\n  margin-top: 1rem;\n}\n.emptyContent-component-v2 > .MuiStack-root .MuiTypography-body1L {\n  display: block;\n  margin-top: 0.5rem;\n}\n.emptyContent-component-v2 > .MuiStack-root button {\n  margin-top: 1rem;\n}";
styleInject(css_248z$d);

function EmptyContent(_a) {
    var title = _a.title, desc = _a.desc, _b = _a.iconName, iconName = _b === void 0 ? "EmptyFolder44" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, button = _a.button;
    return React__default.createElement(Box, { className: "emptyContent-component-v2 ".concat(className) },
        React__default.createElement(Stack$1, { alignItems: "center" },
            React__default.createElement(Icon, { name: iconName }),
            title &&
                React__default.createElement(Typography, { variant: "h3" }, title),
            desc &&
                React__default.createElement(Typography, { variant: "body1L" }, desc),
            button && button));
}

var css_248z$c = ".fileUpload-component-v2 {\n  position: relative;\n  width: 100%;\n}\n.fileUpload-component-v2 > .fileUploadContainer {\n  box-sizing: border-box;\n  text-align: center;\n  cursor: pointer;\n  width: 100%;\n  padding: 3rem 2rem;\n  display: flex;\n  position: relative;\n}\n.fileUpload-component-v2 > .fileUploadContainer fieldset {\n  position: absolute;\n  margin: 0;\n  padding: 0 0 0 1rem !important;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  border: 1px dashed var(--pebble, #EAEAEA);\n  text-align: left;\n  position: absolute;\n  padding-inline: 0.75em;\n  margin-inline: unset;\n}\n.fileUpload-component-v2 > .fileUploadContainer img {\n  max-width: 100%;\n}\n.fileUpload-component-v2 > .fileUploadContainer.hasDropdown fieldset {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.fileUpload-component-v2 .dropdown-component-v2 {\n  flex: 1;\n  margin-top: 0;\n  position: relative;\n  left: 1px;\n  width: calc(100% - 2px);\n}\n.fileUpload-component-v2 .dropdown-component-v2 > .MuiInputBase-root {\n  max-width: unset;\n  border-top-right-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n.fileUpload-component-v2 .dropdown-component-v2 > .MuiInputBase-root:not(:focus):not(:hover):not(:active) {\n  outline-color: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}";
styleInject(css_248z$c);

function FileUpload(_a) {
    var label = _a.label, onChange = _a.onChange, _b = _a.defaultIconName, defaultIconName = _b === void 0 ? "Upload44" : _b, placeholder = _a.placeholder, support = _a.support, dropdown = _a.dropdown;
    var theme = useTheme$2();
    var _c = useState(null), file = _c[0], setFile = _c[1];
    var _d = useState(false), dragging = _d[0], setDragging = _d[1];
    var _e = useState(null), preview = _e[0], setPreview = _e[1];
    var fileInputRef = useRef(null);
    var handleFileChange = useCallback(function (selectedFile) {
        if (selectedFile) {
            setFile(selectedFile);
            if (selectedFile.type.startsWith("image/")) {
                var reader_1 = new FileReader();
                reader_1.onloadend = function () {
                    setPreview(reader_1.result);
                };
                reader_1.readAsDataURL(selectedFile);
            }
            else {
                setPreview(null);
            }
            if (onChange) {
                onChange(selectedFile);
            }
        }
        else {
            setFile(null);
            setPreview(null);
            if (onChange) {
                onChange(null);
            }
        }
    }, [onChange]);
    var handleDrop = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        setDragging(false);
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            handleFileChange(event.dataTransfer.files[0]);
            event.dataTransfer.clearData();
        }
    }, [handleFileChange]);
    function handleDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
        setDragging(true);
    }
    function handleDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        setDragging(false);
    }
    function handleClick() {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    function onFileInputChange(event) {
        var files = event.target.files;
        if (files && files.length > 0) {
            handleFileChange(files[0]);
        }
    }
    return React__default.createElement(Stack$1, { className: "fileUpload-component-v2" },
        React__default.createElement(Stack$1, { className: "fileUploadContainer ".concat(dropdown ? "hasDropdown" : ""), onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, onClick: handleClick, alignItems: "center", justifyContent: "center" },
            React__default.createElement("fieldset", { "aria-hidden": "true", style: {
                    borderColor: (dropdown === null || dropdown === void 0 ? void 0 : dropdown.value) ? theme.palette.secondary.main : theme.palette.shade450.main,
                    borderWidth: dragging ? "2px" : "1px",
                    borderStyle: (dropdown === null || dropdown === void 0 ? void 0 : dropdown.value) ? "solid" : "dashed",
                } },
                React__default.createElement("legend", null,
                    React__default.createElement(Typography$1, { variant: "body2", color: "text.primary" }, label))),
            React__default.createElement("input", { type: "file", ref: fileInputRef, onChange: onFileInputChange, style: { display: "none" }, accept: "image/*" }),
            ((dropdown === null || dropdown === void 0 ? void 0 : dropdown.value) || preview) ? React__default.createElement(React__default.Fragment, null,
                React__default.createElement("img", { src: ((dropdown === null || dropdown === void 0 ? void 0 : dropdown.value) || preview), alt: "Preview" })) : file ? (React__default.createElement(Stack$1, { alignItems: "center", spacing: 1 },
                React__default.createElement(Icon, { name: defaultIconName }),
                React__default.createElement(Typography$1, { variant: "body1" }, file.name),
                React__default.createElement(Typography$1, { variant: "caption" }, "File selected"))) : (React__default.createElement(Stack$1, { alignItems: "center", spacing: 1 },
                React__default.createElement(Icon, { name: defaultIconName }),
                React__default.createElement(Typography$1, { variant: "body1L" }, placeholder),
                React__default.createElement(Typography$1, { variant: "body2" }, support)))),
        dropdown && React__default.createElement(Dropdown, { size: "large", placeholder: dropdown.placeholder || "", onChange: dropdown.onChange, className: "fileUploadDropdown ".concat(dropdown.className ? dropdown.className : ""), options: dropdown.options.concat({
                text: dropdown.uploadText || "Upload",
                value: "upload",
                isAction: true,
                onClick: function (e) {
                    if (fileInputRef.current) {
                        fileInputRef.current.click();
                    }
                }
            }), value: dropdown.value }));
}

function Link(_a) {
    var variant = _a.variant, color = _a.color, children = _a.children, className = _a.className, bold = _a.bold, semiBold = _a.semiBold, props = __rest(_a, ["variant", "color", "children", "className", "bold", "semiBold"]);
    var classes = classNames(className, {
        "bold": bold,
        "semiBold": semiBold,
    });
    return React__default.createElement(Link$1, __assign({}, props, { variant: variant, color: color, className: classes }), children);
}

var css_248z$b = ".subNav-component-v2 {\n  flex-wrap: wrap;\n}\n.subNav-component-v2.dir-row button:not(:last-child) {\n  margin-right: 2px;\n}\n.subNav-component-v2.dir-column button:not(:first-child) {\n  margin-top: 1.25rem;\n}\n.subNav-component-v2 button.default, .subNav-component-v2 button.text {\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n  outline: none;\n}\n.subNav-component-v2 button.default span, .subNav-component-v2 button.text span {\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}\n.subNav-component-v2 button.default:not(:hover), .subNav-component-v2 button.text:not(:hover) {\n  background: none;\n}\n.subNav-component-v2 button.default:hover, .subNav-component-v2 button.text:hover {\n  outline: none;\n}\n.subNav-component-v2 button.default:active, .subNav-component-v2 button.text:active {\n  outline: none !important;\n}\n.subNav-component-v2 button.default {\n  text-transform: none;\n}\n.subNav-component-v2 button.default span {\n  text-transform: none;\n}\n.subNav-component-v2 button.default.selected {\n  background-color: var(--cloud, #F4F4F4);\n}\n.subNav-component-v2 button.text span {\n  color: var(--silver, #9B9B9B);\n}\n.subNav-component-v2 button.text:hover, .subNav-component-v2 button.text.selected {\n  background: none;\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}\n.subNav-component-v2 button.text:hover span, .subNav-component-v2 button.text.selected span {\n  color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}";
styleInject(css_248z$b);

function SubNav(_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.direction, direction = _c === void 0 ? "row" : _c, initialSelected = _a.initialSelected, selected = _a.selected, onClick = _a.onClick, className = _a.className, _d = _a.menuVariant, menuVariant = _d === void 0 ? "default" : _d, btnOverride = _a.btnOverride;
    var _e = useState(initialSelected), stateSelected = _e[0], setSelected = _e[1];
    var curSelection = selected || stateSelected;
    function handleOnClick(event, item) {
        if (!selected) {
            setSelected(event.currentTarget.name);
        }
        if (item === null || item === void 0 ? void 0 : item.onClick) {
            item === null || item === void 0 ? void 0 : item.onClick(event, item);
        }
        else {
            onClick && onClick(event, item);
        }
    }
    var classes = classNames("subNav-component-v2", className, "dir-" + direction);
    return React__default.createElement(Stack$1, { className: classes, direction: direction }, items.map(function (i, index) {
        var classes = classNames(menuVariant, {
            "selected": (i.name && i.name === curSelection) || (!initialSelected && !curSelection && 0 === index)
        });
        return React__default.createElement(Button, { key: "subNav-".concat(i.name, "-").concat(index), color: (btnOverride === null || btnOverride === void 0 ? void 0 : btnOverride.color) || "body1", variant: (btnOverride === null || btnOverride === void 0 ? void 0 : btnOverride.variant) || "outlined", className: classes, name: i.name, onClick: function (e) { handleOnClick(e, i); }, disabled: i.disabled, iconOnly: i.iconOnly },
            i.iconName && React__default.createElement(Icon, { name: i.iconName }),
            i.text &&
                React__default.createElement(React__default.Fragment, null, menuVariant === "text" ?
                    React__default.createElement(Typography, { variant: "title" }, i.text)
                    :
                        i.text));
    }));
}

var css_248z$a = ".filter-bar-component-v2 {\n  background: var(--cloud, #F4F4F4);\n  width: 100%;\n  box-sizing: border-box;\n}\n.filter-bar-component-v2 .DDItem {\n  padding-left: 2rem;\n}\n.filter-bar-component-v2 .DDItem .MuiInputBase-input {\n  padding-right: 0 !important;\n}\n.filter-bar-component-v2 .addFilterBox {\n  padding: 0 1.5rem;\n  position: relative;\n  cursor: pointer;\n}\n.filter-bar-component-v2 .addFilterBox .MuiLink-root {\n  text-decoration: none;\n}\n.filter-bar-component-v2 .addFilterBox .search-component-v2 .inputContainer {\n  padding: 0;\n  background: unset;\n  box-shadow: none;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer {\n  position: absolute;\n  top: 4rem;\n  width: -moz-max-content;\n  width: max-content;\n  min-width: 100%;\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1490196078);\n  border-radius: 16px;\n  min-width: 300;\n  background: var(--background-color-1, var(--white, #FFFFFF));\n  box-sizing: border-box;\n  z-index: 1000;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 {\n  justify-content: space-between;\n  margin: 0;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 button {\n  flex: 1;\n  border-radius: 0;\n  background: var(--cloud, #F4F4F4);\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 button.selected {\n  background: var(--white, #FFFFFF);\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 button:first-child, .filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 button:first-child:hover {\n  border-top-left-radius: 4px;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 button:last-child, .filter-bar-component-v2 .addFilterBox .dropMenuContainer .subNav-component-v2 button:last-child:hover {\n  border-top-right-radius: 4px;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .dropMenu-component-v2 {\n  box-shadow: none;\n  margin-top: 0;\n  padding: 1.5rem;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .dropMenu-component-v2 .MuiMenuItem-root {\n  padding: 0.5rem;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .dropMenu-component-v2 .MuiMenuItem-root.isTitle {\n  padding-top: 0;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer .dropMenu-component-v2 .MuiTypography-body1L {\n  font-size: 0.875rem;\n}\n.filter-bar-component-v2 .addFilterBox .dropMenuContainer > button {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  padding: 0.75rem;\n}\n.filter-bar-component-v2 .pillContainer {\n  padding: 0.75rem;\n  min-height: 2rem;\n  overflow-x: auto;\n}\n.filter-bar-component-v2 .pillContainer .MuiSvgIcon-root {\n  padding-right: 0;\n  padding-left: 0.5rem;\n}\n.filter-bar-component-v2 .pillContainer .MuiChip-root {\n  flex-direction: row-reverse;\n}\n.filter-bar-component-v2 .pillContainer .MuiChip-root.disabled {\n  pointer-events: all !important;\n}\n.filter-bar-component-v2 .pillContainer .MuiChip-root .MuiChip-label {\n  display: flex;\n  align-items: center;\n}\n.filter-bar-component-v2 .pillContainer .MuiChip-root .MuiChip-label .MuiSvgIcon-root {\n  margin-right: 0.5rem;\n}\n.filter-bar-component-v2 .pillContainer .MuiChip-root .MuiChip-label .MuiSvgIcon-root path {\n  fill: var(--white, #FFFFFF);\n}\n.filter-bar-component-v2 .pillContainer:not(.empty) {\n  border-left: 1px solid var(--wild-sand, #dddddd);\n}\n.filter-bar-component-v2 .actionContainer {\n  border-left: 1px solid var(--wild-sand, #dddddd);\n  padding: 0 2rem;\n  padding-left: 2rem;\n}\n.filter-bar-component-v2 .actionContainer .MuiTypography-root {\n  cursor: pointer;\n}";
styleInject(css_248z$a);

function FilterBar(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var operatorOptions = _a.operatorOptions, initOperatorValue = _a.initOperatorValue, operatorValue = _a.operatorValue, onSave = _a.onSave, saveTxt = _a.saveTxt, onClear = _a.onClear, clearTxt = _a.clearTxt, onUpdate = _a.onUpdate, onSearchUpdate = _a.onSearchUpdate, loading = _a.loading, addFilterTxt = _a.addFilterTxt, filterTerms = _a.filterTerms, initFilterTerms = _a.initFilterTerms, dropMenuOptions = _a.dropMenuOptions, dropMenuProps = _a.dropMenuProps, replacePartial = _a.replacePartial;
    var _k = useState(false), showSearch = _k[0], setShowSearch = _k[1];
    var _l = useState(""), search = _l[0], setSearch = _l[1];
    var _m = useState((_c = (_b = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.tabs) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name), selectedTab = _m[0], setSelectedTab = _m[1];
    var _o = useState(filterTerms !== undefined ? filterTerms : initFilterTerms !== undefined ? initFilterTerms : []), filterTermState = _o[0], setFilterTermState = _o[1];
    var _p = useState(operatorValue !== undefined ? operatorValue : initOperatorValue !== undefined ? initOperatorValue : EOperatorTypes.and), operatorState = _p[0], setOperatorState = _p[1];
    var cFilterTerms = filterTerms !== undefined ? filterTerms : filterTermState;
    var cOperatorValue = operatorValue !== undefined ? operatorValue : operatorState;
    useEffect(handleSearchFocus, [showSearch]);
    function handleDropMenuClick(value) {
        handleAddFilterTerms({ value: value || "", tab: selectedTab });
    }
    function handleSearchFocus() {
        if (!showSearch)
            return;
        var el = document.querySelector(".filter-bar-component-v2 .search-component-v2 input");
        if (el)
            el.focus();
    }
    function handleOnSearch(search) {
        setSearch(search);
        if (search === "") {
            handleShowSearch();
        }
        onSearchUpdate && onSearchUpdate({ value: search || "", tab: selectedTab || "" });
    }
    function handleRemoveTerm(termValue) {
        var updatedTerms = cFilterTerms.filter(function (t) { return t.value !== termValue; });
        setFilterTermState(updatedTerms);
        onUpdate && onUpdate({ filterTerms: updatedTerms, operator: cOperatorValue });
    }
    function handleAddFilterTerms(term) {
        var updatedTerms = __spreadArray([], cFilterTerms, true);
        updatedTerms.push(term);
        setFilterTermState(updatedTerms);
        handleUpdate(updatedTerms);
    }
    function handleOnSearchEnter(value) {
        if (replacePartial) {
            var updatedTerms = cFilterTerms.filter(function (t) { return t.tab !== "partial"; });
            updatedTerms.push({ value: value, tab: "partial" });
            setFilterTermState(updatedTerms);
            onUpdate && onUpdate({ filterTerms: updatedTerms, operator: cOperatorValue });
        }
        else {
            handleAddFilterTerms({ value: value, tab: "partial" });
        }
        handleShowSearch();
    }
    function handleOnSave(event) {
        onSave && onSave({ filterTerms: cFilterTerms, operator: cOperatorValue });
    }
    function handleOnClear() {
        setShowSearch(false);
        setFilterTermState([]);
        handleUpdate([], cOperatorValue);
        onClear && onClear();
    }
    function handleOnClose() {
        handleOnSearch("");
    }
    function handleUpdate(terms, operator) {
        onUpdate && onUpdate({ filterTerms: terms || cFilterTerms, operator: operator || cOperatorValue });
    }
    function handleShowSearch() {
        setShowSearch(!showSearch);
    }
    function handleOperatorDD(event, child, previousValue) {
        var _a = event.target; _a.name; var value = _a.value;
        setOperatorState(value);
        handleUpdate(cFilterTerms, value);
    }
    function handleFilterSets(event, item) {
        setSelectedTab(item.name);
    }
    //Filter current set
    dropMenuOptions = dropMenuOptions === null || dropMenuOptions === void 0 ? void 0 : dropMenuOptions.filter(function (i) {
        return i.tab === selectedTab;
    });
    // Filter out current pills & search
    dropMenuOptions = dropMenuOptions === null || dropMenuOptions === void 0 ? void 0 : dropMenuOptions.filter(function (i) {
        var _a, _b, _c, _d;
        if ((_b = (_a = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.options) === null || _a === void 0 ? void 0 : _a[i.tab || ""]) === null || _b === void 0 ? void 0 : _b.disableLocalSearch) {
            return true;
        }
        var item = (_c = cFilterTerms.find(function (cF) { return i.value === cF.value; })) === null || _c === void 0 ? void 0 : _c.value;
        return (i.value !== item || i.value == null) && ((_d = i.value) === null || _d === void 0 ? void 0 : _d.includes(search));
    });
    //set onClick
    dropMenuOptions = dropMenuOptions === null || dropMenuOptions === void 0 ? void 0 : dropMenuOptions.map(function (i) {
        var _a;
        return __assign(__assign({}, i), { disabled: (_a = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.disabledTabs) === null || _a === void 0 ? void 0 : _a.includes(i.tab), onClick: function () { handleDropMenuClick(i === null || i === void 0 ? void 0 : i.value); } });
    });
    if (dropMenuOptions && (dropMenuOptions === null || dropMenuOptions === void 0 ? void 0 : dropMenuOptions.length) > 0) {
        var foundTitle = (_e = (_d = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.options) === null || _d === void 0 ? void 0 : _d[selectedTab || ""]) === null || _e === void 0 ? void 0 : _e.title;
        if (foundTitle) {
            dropMenuOptions.unshift({
                tab: selectedTab || "partial",
                isTitle: true,
                text: foundTitle.text,
                desc: foundTitle.desc
            });
        }
    }
    if (dropMenuOptions && (dropMenuOptions === null || dropMenuOptions === void 0 ? void 0 : dropMenuOptions.length) === 0) {
        var foundEmptyText = (_g = (_f = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.options) === null || _f === void 0 ? void 0 : _f[selectedTab || ""]) === null || _g === void 0 ? void 0 : _g.emptyText;
        if (foundEmptyText) {
            dropMenuOptions.push({
                tab: selectedTab || "partial",
                isTitle: true,
                text: foundEmptyText.text,
                desc: foundEmptyText.desc
            });
        }
    }
    var currentAction = (_j = (_h = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.options) === null || _h === void 0 ? void 0 : _h[selectedTab || ""]) === null || _j === void 0 ? void 0 : _j.action;
    if (dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.tabs) {
        dropMenuProps.tabs = dropMenuProps.tabs.map(function (t) {
            var _a;
            return __assign(__assign({}, t), { disabled: (_a = dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.disabledTabs) === null || _a === void 0 ? void 0 : _a.includes(t.name) });
        });
    }
    return React__default.createElement(Stack$1, { className: "filter-bar-component-v2 ".concat(loading ? "loading" : ""), direction: "row" },
        React__default.createElement(Stack$1, { direction: "row", className: "DDItem", alignItems: "center", justifyContent: "center" },
            React__default.createElement(Dropdown, { menuPlacement: "bottom-left", value: cOperatorValue, prefixIcon: "Filter14", variant: "standard", options: operatorOptions, color: "body1", onChange: handleOperatorDD })),
        React__default.createElement(Stack$1, { className: "addFilterBox", alignItems: "center", justifyContent: "center" },
            showSearch &&
                React__default.createElement(ClickAwayListener, { onClickAway: handleOnClose },
                    React__default.createElement(Box, null,
                        React__default.createElement(Search, { initValue: search, onChange: handleOnSearch, onEnter: handleOnSearchEnter, placeholder: addFilterTxt, onClose: handleOnClose }),
                        dropMenuOptions &&
                            React__default.createElement(Stack$1, { className: "dropMenuContainer" },
                                (dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.tabs) && dropMenuProps.tabs.length > 1 && React__default.createElement(SubNav, { initialSelected: selectedTab, items: dropMenuProps.tabs, onClick: handleFilterSets }),
                                React__default.createElement(DropMenu, { inlineMenu: true, options: dropMenuOptions }),
                                currentAction && React__default.createElement(Button, { color: "cloud", onClick: currentAction.onClick }, currentAction.text)))),
            !showSearch &&
                React__default.createElement(Link, { color: "secondary.main", onClick: handleShowSearch, alignItems: "center", justifyContent: "center", display: "flex", gap: 3 },
                    React__default.createElement(Icon, { name: "Add18", color: "secondary" }),
                    " ",
                    addFilterTxt)),
        React__default.createElement(Stack$1, { direction: "row", className: "pillContainer ".concat(cFilterTerms.length === 0 ? "empty" : ""), alignItems: "center", justifyContent: "flex-start", flex: 1, gap: 2 }, cFilterTerms.map(function (term) {
            var isDisabled = Object.keys((dropMenuProps === null || dropMenuProps === void 0 ? void 0 : dropMenuProps.options) || {}).includes(String(term.tab));
            var isPartial = term.tab === "partial";
            return React__default.createElement(Chip, { className: isDisabled ? "disabled" : "", label: isPartial ? React__default.createElement(React__default.Fragment, null,
                    " ",
                    React__default.createElement(Icon, { name: "Search10" }),
                    " ",
                    term.value) : term.value, color: isPartial ? "wildSand" : "secondary", squared: true, icon: React__default.createElement(Icon, { name: "X14" }), onClick: function () { handleRemoveTerm(term.value); } });
        }).reverse()),
        cFilterTerms.length > 0 &&
            React__default.createElement(Stack$1, { direction: "row", className: "actionContainer", alignItems: "center", justifyContent: "center", gap: 3 },
                onSave && React__default.createElement(Link, { onClick: handleOnSave, variant: "body2" }, saveTxt),
                React__default.createElement(Link, { onClick: handleOnClear, variant: "body2" }, clearTxt)));
}

var emptyAccountLimits = {
    starts_on: 0,
    per_campaign: 0,
    per_month: 0,
    remaining: 0,
    maximum_contacts: 0,
    lists: 0,
    users: 0,
    campaign_blueprints: 0,
    automation_conditions: 0,
    use_campaign_blueprints: false,
    use_ab_split: false,
    use_automation_conditions: false,
    use_automation_customwebhooks: false,
    use_html_editor: false,
    use_contact_export: false,
    use_custom_merge_tags: false,
    use_list_redirection: false,
    use_behavioral_segmentation: false,
    use_smart_email_resource: false,
    use_smart_blueprint: false,
    use_brand: false,
    use_tags_in_automation: false,
    use_tags: false,
    use_email_api: false,
    insert_reseller_logo: true,
};
var emptyAccountAddress = {
    address1: "",
    address2: "",
    city: "",
    country: "",
    postal_code: "",
    province: "",
};

var CustomerModel = /** @class */ (function () {
    function CustomerModel(_a) {
        var id = _a.id, language = _a.language, profile = _a.profile, subscriptions = _a.subscriptions;
        this.id = id;
        this.language = language;
        this.profile = profile;
        this.subscriptions = subscriptions;
    }
    CustomerModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    CustomerModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    return CustomerModel;
}());

function getCustomerProfile(_a) {
    var id = _a.id, _b = _a.useImpersonationTree, useImpersonationTree = _b === void 0 ? false : _b;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/billing/customer/profile",
        query: { account_id: id },
        useImpersonationTree: useImpersonationTree,
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function searchCustomerProfiles(_a) {
    var query = _a.query;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/billing/customer/searchProfiles",
        query: { query: query },
        fetchOptions: {
            method: EMethods.get
        }
    });
}

var BillingFactory = /** @class */ (function () {
    function BillingFactory() {
    }
    BillingFactory.search = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var query = _b.query;
            return __generator(this, function (_c) {
                return [2 /*return*/, searchCustomerProfiles({ query: query }).then(function (data) {
                        data.data = data.data.map(function (c) { return new CustomerModel(c); });
                        return data;
                    })];
            });
        });
    };
    BillingFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id, _c = _b.useImpersonationTree, useImpersonationTree = _c === void 0 ? false : _c;
            return __generator(this, function (_d) {
                return [2 /*return*/, getCustomerProfile({ id: id, useImpersonationTree: useImpersonationTree }).then(function (data) {
                        return new CustomerModel(data);
                    })];
            });
        });
    };
    return BillingFactory;
}());

function whoAmi() {
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/whoami",
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getAccountReport(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/accounts/" + options.accountId,
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
    });
}
function createAccount(_a) {
    var partnerId = _a.partnerId, account = _a.account;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts",
        query: {
            partner_account_id: partnerId
        },
        fetchOptions: {
            body: account,
            method: EMethods.post
        }
    });
}
function updateAccount(_a) {
    var account = _a.account;
    if (!account.id)
        throw "Missing Account ID";
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts/" + account.id,
        fetchOptions: {
            body: account,
            method: EMethods.patch
        }
    });
}
function listAccounts(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getAccount(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts/" + id,
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function impersonateService(_a) {
    var id = _a.id, _b = _a.byContext, byContext = _b === void 0 ? true : _b;
    if (byContext) {
        return new Promise(function (resolve) {
            addToImpersonificationTree(id);
            resolve({ loggedIn: true });
        });
    }
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/impersonate",
        fetchOptions: {
            body: { accountId: id },
            method: EMethods.post
        }
    });
}
function logOutService() {
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logout",
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteAccount(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts/" + id,
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function suspendAccount(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts/" + id + "/suspend",
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function unSuspendAccount(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/accounts/" + id + "/unsuspend",
        fetchOptions: {
            method: EMethods.post
        }
    });
}

function getDomainsService(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/default/domains/default",
        query: { account_id: id },
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function isDomainValidService(_a) {
    var domain = _a.domain, useImpersonationTree = _a.useImpersonationTree, query = _a.query;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/domains/" + domain + "/isVerified",
        query: query,
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}

var AccountModel = /** @class */ (function () {
    function AccountModel(params) {
        this.id = params.id || 0;
        this.lineage = params.lineage || "";
        this.status = params.status || "";
        this.name = params.name || "";
        this.address = params.address || emptyAccountAddress;
        this.fax = params.fax || "";
        this.phone = params.phone || "";
        this.website = params.website || "";
        this.logo = params.logo || "";
        this.usage_limits = params.usage_limits || emptyAccountLimits;
        this.last_activity_on = params.last_activity_on || 0;
        this.created_on = params.created_on || 0;
        this.partner = params.partner || false;
        this.organization = params.organization || false;
        this.overrides = params.overrides || {};
        this.stripe_customer_id = params.stripe_customer_id || "";
        this.metadata = params.metadata || {};
        this.usage = params.usage || undefined;
        this.account_owner = params.account_owner || { user_id: 0 };
        if (params.isMainAccount) {
            this.getUsageReport();
        }
    }
    AccountModel.prototype.toJson = function () {
        return modelToJson(this, ["usage"]);
    };
    AccountModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    AccountModel.prototype.getUsageReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (["1", "131010", "133315"].includes(this.id.toString())) {
                    return [2 /*return*/, {}];
                }
                return [2 /*return*/, this.getReport({}).then(function (report) {
                        _this.usage = report;
                        return report;
                    })];
            });
        });
    };
    AccountModel.prototype.getReport = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                return [2 /*return*/, getAccountReport(__assign(__assign({}, options), { accountId: this.id })).then(function (result) {
                        return result.data;
                    })];
            });
        });
    };
    AccountModel.prototype.impersonate = function () {
        return __awaiter(this, arguments, void 0, function (byContext) {
            if (byContext === void 0) { byContext = true; }
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                return [2 /*return*/, impersonateService({ id: this.id, byContext: byContext })];
            });
        });
    };
    AccountModel.prototype.getDomains = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                return [2 /*return*/, getDomainsService({ id: this.id }).then(function (data) { return data.data; })];
            });
        });
    };
    AccountModel.prototype.getCustomer = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                return [2 /*return*/, BillingFactory.get({ id: this.id })];
            });
        });
    };
    AccountModel.prototype.update = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                trackEvent(EEvents.ACCOUNT_UPDATED, {
                    id: account === null || account === void 0 ? void 0 : account.id,
                    address: account === null || account === void 0 ? void 0 : account.address,
                    created_at: account === null || account === void 0 ? void 0 : account.created_on,
                    name: account === null || account === void 0 ? void 0 : account.name,
                    phone: account === null || account === void 0 ? void 0 : account.phone,
                    website: account === null || account === void 0 ? void 0 : account.website,
                    lineage: account === null || account === void 0 ? void 0 : account.lineage,
                    partner: account === null || account === void 0 ? void 0 : account.partner
                });
                return [2 /*return*/, updateAccount({ account: account }).then(function (data) {
                        return {
                            data: new AccountModel(data.data),
                            warning: data.warnings
                        };
                    })];
            });
        });
    };
    AccountModel.prototype.logOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, logOutService()];
            });
        });
    };
    AccountModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                trackEvent(EEvents.ACCOUNT_DELETED, { id: this.id, lineage: this.lineage, name: this.name });
                return [2 /*return*/, deleteAccount({ id: this.id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    AccountModel.prototype.suspend = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                trackEvent(EEvents.ACCOUNT_SUSPENDED, { id: this.id, lineage: this.lineage, name: this.name });
                return [2 /*return*/, suspendAccount({ id: this.id }).then(function (data) {
                        return new AccountModel(data.data);
                    })];
            });
        });
    };
    AccountModel.prototype.unsuspend = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Account was not initialized");
                }
                trackEvent(EEvents.ACCOUNT_UNSUSPENDED, { id: this.id, lineage: this.lineage, name: this.name });
                return [2 /*return*/, unSuspendAccount({ id: this.id }).then(function (data) {
                        return new AccountModel(data.data);
                    })];
            });
        });
    };
    AccountModel.prototype.isPartnerOrOrganization = function () {
        return this.partner || this.organization;
    };
    AccountModel.prototype.hasAccessTo = function (_a) {
        var feature = _a.feature, partnerBrand = _a.partnerBrand, userCount = _a.userCount;
        var featureValue = this.usage_limits[feature];
        if (featureValue === undefined) {
            return false;
        }
        var brandDisabledLimitsFeatures = getNestedProperty(partnerBrand, "config.disabledLimitsFeatures") || [];
        if (brandDisabledLimitsFeatures.includes(feature))
            return true;
        if (typeof featureValue === "boolean" || Number.isNaN(featureValue)) {
            //Some feature flags are inverted
            if (feature === "insert_reseller_logo") {
                return !featureValue;
            }
            else {
                return Boolean(featureValue);
            }
        }
        else {
            if (this.usage) {
                if (feature === "lists") {
                    return this.usage.current_lists <= featureValue;
                }
                else if (feature === "users" && userCount !== undefined) {
                    return userCount <= featureValue;
                }
                else if (feature === "per_month") {
                    return this.usage.emails_usage <= 100;
                }
                else if (feature === "maximum_contacts") {
                    return this.usage.active_contacts <= featureValue;
                }
                throw new Error("Requested Feature does not exist in account usage");
            }
            else {
                throw new Error("Usage not fetched, please call getUsageReport() before calling hasAccessTo() with usage-based features");
            }
        }
    };
    return AccountModel;
}());

function listUsers(_a) {
    var useImpersonationTree = _a.useImpersonationTree, options = __rest(_a, ["useImpersonationTree"]);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/users",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}
function getUser(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/users/" + id,
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function updateUser(_a) {
    var id = _a.id, data = _a.data;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/users/" + id,
        fetchOptions: {
            method: EMethods.patch,
            body: data
        }
    });
}
function deleteUser(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/users/" + id,
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function resendVerificationEmail(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/users/" + id + "/resend-verification-email",
        fetchOptions: {
            method: EMethods.post
        }
    });
}

var UserModel = /** @class */ (function () {
    function UserModel(_a) {
        var id = _a.id, email = _a.email, status = _a.status, created_on = _a.created_on, last_activity_on = _a.last_activity_on, expires_on = _a.expires_on, first_name = _a.first_name, last_name = _a.last_name, title = _a.title, language = _a.language, timezone = _a.timezone, office_phone = _a.office_phone, mobile_phone = _a.mobile_phone;
        this.id = id || 0;
        this.email = email || "";
        this.status = status || "";
        this.created_on = created_on || 0;
        this.last_activity_on = last_activity_on || 0;
        this.expires_on = expires_on || 0;
        this.first_name = first_name || "";
        this.last_name = last_name || "";
        this.title = title || "";
        this.language = language || "en_US";
        this.timezone = timezone || "";
        this.office_phone = office_phone || "";
        this.mobile_phone = mobile_phone || "";
    }
    UserModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    UserModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    UserModel.prototype.update = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, updateUser({ id: this.id, data: user || this.toJson() }).then(function (data) {
                        trackEvent(EEvents.USER_UPDATED);
                        return new UserModel(data.data);
                    })];
            });
        });
    };
    UserModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, deleteUser({ id: this.id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    UserModel.prototype.resendVerificationEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, resendVerificationEmail({ id: this.id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    return UserModel;
}());

function amILoggedInService() {
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/amiloggedin",
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function loginService(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/login",
        fetchOptions: {
            method: EMethods.post,
            body: camelCase(options)
        }
    });
}

function getAllAutomationStats(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations/generalStats/" + options.accountId,
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function listAutomations(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function listWorkflows(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/workflows",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getAutomation(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteAutomation(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations/".concat(id),
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function getAutomationExecutionsCount(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations/".concat(id, "/actionExecutionsCount"),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function updateAutomation(_a) {
    var id = _a.id, data = _a.data;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations/".concat(id),
        fetchOptions: {
            method: EMethods.put,
            body: data
        }
    });
}
function deleteWorkflow(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/workflows/".concat(id),
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function updateWorkflow(_a) {
    var id = _a.id, data = _a.data;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/workflows/".concat(id),
        fetchOptions: {
            method: EMethods.patch,
            body: data
        }
    });
}
// implement
function getAutomationStats(_a) {
    var id = _a.id, path = _a.path;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/automations/".concat(id, "/steps/").concat(path, "/stats"),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getAutomationEmailContent(_a) {
    var contentId = _a.contentId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/content/".concat(contentId),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteAnyAutomation(_a) {
    var id = _a.id, v1 = _a.v1;
    if (v1) {
        return deleteWorkflow({ id: id });
    }
    return deleteAutomation({ id: id });
}
function updateAnyAutomation(_a) {
    var id = _a.id, data = _a.data, v1 = _a.v1;
    if (v1) {
        return updateWorkflow({ id: id, data: data });
    }
    return updateAutomation({ id: id, data: data });
}

function getBrand(_a) {
    var id = _a.id, _b = _a.compiled, compiled = _b === void 0 ? true : _b;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/".concat(id, "/").concat(compiled ? "compiledBrand.json" : "brand.json"),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function createBrand(_a) {
    var id = _a.id, _b = _a.brand, brand = _b === void 0 ? {} : _b, _c = _a.query, query = _c === void 0 ? {} : _c;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/".concat(id, "/brand.json"),
        fetchOptions: {
            method: EMethods.post,
            body: brand
        },
        query: query
    });
}
function enrichProfile(_a) {
    var email = _a.email;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/enrich/email",
        fetchOptions: {
            method: EMethods.post,
            body: {
                email: email
            }
        }
    });
}
function enrichOrganization(_a) {
    var domain = _a.domain;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/enrich/organization",
        fetchOptions: {
            method: EMethods.get
        },
        query: {
            domain: domain
        }
    });
}
function enrichBrand(_a) {
    var domain = _a.domain;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/enrich/brand",
        fetchOptions: {
            method: EMethods.get
        },
        query: {
            domain: domain
        }
    });
}

function listCampaigns(_a) {
    var useImpersonationTree = _a.useImpersonationTree, options = __rest(_a, ["useImpersonationTree"]);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}
function createCampaign(_a) {
    var campaign = _a.campaign;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns",
        fetchOptions: {
            method: EMethods.post,
            body: campaign
        }
    });
}
function getCampaign(_a) {
    var id = _a.id, revisionId = _a.revisionId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id),
        query: {
            revision_id: revisionId
        },
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id),
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function updateCampaign(_a) {
    var id = _a.id, campaign = _a.campaign;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id),
        fetchOptions: {
            method: EMethods.patch,
            body: campaign
        }
    });
}
function renderCampaign(_a) {
    var id = _a.id, contactId = _a.contactId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/render"),
        query: {
            contact_id: contactId,
        },
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function sendCampaignTest(_a) {
    var id = _a.id, email = _a.email, type = _a.type;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/send-test"),
        fetchOptions: {
            method: EMethods.post,
            body: {
                email: email,
                type: type
            }
        }
    });
}
function scheduleCampaign(_a) {
    var id = _a.id, date = _a.date, htmlEmpty = _a.htmlEmpty;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/schedule"),
        fetchOptions: {
            method: EMethods.post,
            body: {
                date: date,
                html_empty: htmlEmpty
            }
        }
    });
}
function unScheduleCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/unschedule"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function reScheduleCampaign(_a) {
    var id = _a.id, date = _a.date, htmlEmpty = _a.htmlEmpty;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/reschedule"),
        fetchOptions: {
            method: EMethods.post,
            body: {
                date: date,
                html_empty: htmlEmpty
            }
        }
    });
}
function suspendCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/suspend"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function resumeCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/resume"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function cancelCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/cancel"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function archiveCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/archive"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function unArchiveCampaign(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/unarchive"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function getCampaignRevisions(_a) {
    var id = _a.id, options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/revisions"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getCampaignLinks(_a) {
    var id = _a.id, options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/campaigns/".concat(id, "/links"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getCampaignLogs(_a) {
    var id = _a.id, options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/campaigns/".concat(id),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getCampaignLogsExports(_a) {
    var id = _a.id, options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/campaigns/".concat(id, "/exports"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function createCampaignLogsExports(_a) {
    var id = _a.id, description = _a.description, filter = _a.filter;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/campaigns/".concat(id, "/exports"),
        fetchOptions: {
            method: EMethods.post,
            body: {
                description: description,
                filter: filter
            }
        }
    });
}
function downloadCampaignLogExport(_a) {
    var campaignId = _a.campaignId, exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/campaigns/".concat(campaignId, "/exports/").concat(exportId, "/download"),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getCampaignReport(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getCampaignLinksReport(_a) {
    var id = _a.id, options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns/".concat(id, "/links"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function listCampaignsReportsExports(_a) {
    var options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns-exports",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getCampaignsReportsExport(_a) {
    var exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns-exports/".concat(exportId),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteCampaignsReportsExport(_a) {
    var exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns-exports/".concat(exportId),
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function createCampaignsReportsExport(_a) {
    var description = _a.description;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns-exports",
        fetchOptions: {
            method: EMethods.post,
            body: {
                description: description
            }
        }
    });
}
function downloadCampaignsReportsExport(_a) {
    var exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/campaigns-exports/".concat(exportId, "/download"),
        fetchOptions: {
            method: EMethods.get
        }
    });
}

function listContacts(_a) {
    var listId = _a.listId, useImpersonationTree = _a.useImpersonationTree, options = __rest(_a, ["listId", "useImpersonationTree"]);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(listId, "/contacts"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}

var EEmailLogTypeParam;
(function (EEmailLogTypeParam) {
    EEmailLogTypeParam["all"] = "all";
    EEmailLogTypeParam["submitted"] = "submitted";
    EEmailLogTypeParam["rejected"] = "rejected";
    EEmailLogTypeParam["error"] = "error";
    EEmailLogTypeParam["queued"] = "queued";
    EEmailLogTypeParam["delivered"] = "delivered";
    EEmailLogTypeParam["open"] = "open";
    EEmailLogTypeParam["click"] = "click";
    EEmailLogTypeParam["bounce"] = "bounce";
    EEmailLogTypeParam["unsubscribe"] = "unsubscribe";
    EEmailLogTypeParam["global_unsubscribe"] = "global_unsubscribe";
    EEmailLogTypeParam["spam"] = "spam";
})(EEmailLogTypeParam || (EEmailLogTypeParam = {}));
var EEmailSummaryEngagement;
(function (EEmailSummaryEngagement) {
    EEmailSummaryEngagement["click"] = "click";
    EEmailSummaryEngagement["open"] = "open";
    EEmailSummaryEngagement["none"] = "none";
    EEmailSummaryEngagement["open_not_click"] = "open_not_click";
})(EEmailSummaryEngagement || (EEmailSummaryEngagement = {}));
var EEMailSummaryStatuses;
(function (EEMailSummaryStatuses) {
    EEMailSummaryStatuses["submitted"] = "submitted";
    EEMailSummaryStatuses["delivered"] = "delivered";
    EEMailSummaryStatuses["queued"] = "queued";
    EEMailSummaryStatuses["rejected"] = "rejected";
    EEMailSummaryStatuses["error"] = "error";
    EEMailSummaryStatuses["bounced"] = "bounced";
    EEMailSummaryStatuses["spam"] = "spam";
    EEMailSummaryStatuses["unsubscribed"] = "unsubscribed";
    EEMailSummaryStatuses["global_unsubscribed"] = "global_unsubscribed";
    EEMailSummaryStatuses["other"] = "other";
})(EEMailSummaryStatuses || (EEMailSummaryStatuses = {}));
var EEmailProviders;
(function (EEmailProviders) {
    EEmailProviders["outlook"] = "Outlook";
    EEmailProviders["gmail"] = "Gmail";
    EEmailProviders["proton"] = "Proton";
    EEmailProviders["aol"] = "AOL";
    EEmailProviders["yahoo"] = "Yahoo";
    EEmailProviders["icloud"] = "iCloud";
    EEmailProviders["videotron"] = "Videotron";
    EEmailProviders["rogers"] = "Rogers";
    EEmailProviders["bell"] = "Bell Canada";
    EEmailProviders["comcast"] = "Comcast";
    EEmailProviders["other"] = "Other";
    EEmailProviders["unknown"] = "unknown";
})(EEmailProviders || (EEmailProviders = {}));

function lisTEmailTags(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/email-tags",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function listEmailLogs(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/v2/logs/emails",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getEmailReport(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/v2/reports/emails",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getEmailActivitySummary(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/emails-summary",
        query: __assign({}, camelCase(options)),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getEmail(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/v2/emails/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function renderEmail(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/v2/emails/".concat(id, "/render"),
        fetchOptions: {
            method: EMethods.get
        }
    });
}

function createForm(_a) {
    var form = _a.form, type = _a.type;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms",
        fetchOptions: {
            body: __assign(__assign({}, form), { type: type }),
            method: EMethods.post
        }
    });
}
function listForms(_a) {
    var useImpersonationTree = _a.useImpersonationTree, options = __rest(_a, ["useImpersonationTree"]);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}
function patchForm(_a) {
    var id = _a.id, data = _a.data;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id,
        fetchOptions: {
            method: EMethods.patch,
            body: data
        }
    });
}
function getForm(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id,
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteForm(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id,
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function enableForm(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id + "/enable",
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function disableForm(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id + "/disable",
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function publishForm(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id + "/publish",
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function renderForm(_a) {
    var id = _a.id, published = _a.published;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + id + "/render",
        query: camelCase({ published: published }),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function renderPublicHtmlForm(_a) {
    var token = _a.token;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/forms/" + token + "/render-html",
        fetchOptions: {
            method: EMethods.get
        }
    });
}

var EEditorType;
(function (EEditorType) {
    EEditorType["emailDesigner"] = "email_designer";
    EEditorType["formDesigner"] = "form_designer";
    EEditorType["popUpDesigner"] = "pop_up_designer";
    EEditorType["pageDesigner"] = "page_designer";
    EEditorType["fileManager"] = "file_manager";
})(EEditorType || (EEditorType = {}));

function requestSupportService(_a) {
    var requestOptions = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/requests",
        fetchOptions: {
            method: EMethods.post,
            body: __assign({}, requestOptions)
        }
    });
}
function connectToZendeskSupportService() {
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/zendesk",
        fetchOptions: {
            method: EMethods.post,
        }
    });
}
function getBeeTokenService(_a) {
    var _b = _a.editorType, editorType = _b === void 0 ? EEditorType.emailDesigner : _b;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/bee/token",
        fetchOptions: {
            method: EMethods.post,
            body: {
                type: editorType,
            },
        }
    });
}

function listList(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getList(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteList(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(id),
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function saveList(_a) {
    var id = _a.id, list = _a.list;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(id),
        fetchOptions: {
            method: EMethods.patch,
            body: list
        },
    });
}
function getListReport(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/lists/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function getListLogs(_a) {
    var id = _a.id, options = _a.options;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/lists/".concat(id),
        fetchOptions: {
            method: EMethods.get,
        },
        query: camelCase(options)
    });
}
function acceptListPolicy(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(id, "/accept-policy"),
        fetchOptions: {
            method: EMethods.post,
        },
    });
}
function listListAttributes(_a) {
    var id = _a.id, options = __rest(_a, ["id"]);
    if (!(options === null || options === void 0 ? void 0 : options.perPage)) {
        options.perPage = 200;
    }
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(id, "/custom-attributes"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get,
        },
    });
}
function listListInterests(_a) {
    var id = _a.id, options = __rest(_a, ["id"]);
    if (!(options === null || options === void 0 ? void 0 : options.perPage)) {
        options.perPage = 200;
    }
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(id, "/interests"),
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get,
        },
    });
}
function downloadContactsExport(_a) {
    var listId = _a.listId, exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/lists/".concat(listId, "/exports/").concat(exportId, "/download"),
        fetchOptions: {
            method: EMethods.get,
        },
    });
}
function downloadListLogExport(_a) {
    var listId = _a.listId, exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/logs/lists/".concat(listId, "/exports/").concat(exportId, "/download"),
        fetchOptions: {
            method: EMethods.get,
        },
    });
}

function listPages(_a) {
    return __awaiter(this, void 0, void 0, function () {
        var options = __rest(_a, []);
        return __generator(this, function (_b) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages",
                    query: camelCase(options),
                    fetchOptions: {
                        method: EMethods.get
                    }
                })];
        });
    });
}
function createPage(_a) {
    return __awaiter(this, void 0, void 0, function () {
        var page = __rest(_a, []);
        return __generator(this, function (_b) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages",
                    fetchOptions: {
                        body: page,
                        method: EMethods.post
                    }
                })];
        });
    });
}
function getPage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id),
                    fetchOptions: {
                        method: EMethods.get
                    }
                })];
        });
    });
}
function deletePage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id),
                    fetchOptions: {
                        method: EMethods.delete
                    }
                })];
        });
    });
}
function updatePage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id, page = _b.page;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id),
                    fetchOptions: {
                        method: EMethods.patch,
                        body: page
                    }
                })];
        });
    });
}
function enablePage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id, "/enable"),
                    fetchOptions: {
                        method: EMethods.post,
                    }
                })];
        });
    });
}
function disablePage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id, "/disable"),
                    fetchOptions: {
                        method: EMethods.post,
                    }
                })];
        });
    });
}
function publishPage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id, "/publish"),
                    fetchOptions: {
                        method: EMethods.post,
                    }
                })];
        });
    });
}
function renderPage(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/pages/".concat(id, "/render"),
                    fetchOptions: {
                        method: EMethods.get,
                    }
                })];
        });
    });
}

function listPopups(_a) {
    return __awaiter(this, void 0, void 0, function () {
        var options = __rest(_a, []);
        return __generator(this, function (_b) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups",
                    query: camelCase(options),
                    fetchOptions: {
                        method: EMethods.get
                    }
                })];
        });
    });
}
function createPopup(_a) {
    return __awaiter(this, void 0, void 0, function () {
        var popup = __rest(_a, []);
        return __generator(this, function (_b) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups",
                    fetchOptions: {
                        body: popup,
                        method: EMethods.post
                    }
                })];
        });
    });
}
function getPopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id),
                    fetchOptions: {
                        method: EMethods.get
                    }
                })];
        });
    });
}
function deletePopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id),
                    fetchOptions: {
                        method: EMethods.delete
                    }
                })];
        });
    });
}
function updatePopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id, popup = _b.popup;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id),
                    fetchOptions: {
                        method: EMethods.patch,
                        body: popup
                    }
                })];
        });
    });
}
function enablePopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id, "/enable"),
                    fetchOptions: {
                        method: EMethods.post,
                    }
                })];
        });
    });
}
function disablePopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id, "/disable"),
                    fetchOptions: {
                        method: EMethods.post,
                    }
                })];
        });
    });
}
function publishPopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id, "/publish"),
                    fetchOptions: {
                        method: EMethods.post,
                    }
                })];
        });
    });
}
function renderPopup(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var id = _b.id;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/popups/".concat(id, "/render"),
                    fetchOptions: {
                        method: EMethods.get,
                    }
                })];
        });
    });
}

function listSenders(_a) {
    var useImpersonationTree = _a.useImpersonationTree, options = __rest(_a, ["useImpersonationTree"]);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/default/senders",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}
function getSender(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/default/senders/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}

function addSuppressedEmail(_a) {
    var email = _a.email;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/suppressed-emails",
        fetchOptions: {
            method: EMethods.post,
            body: { email: email }
        }
    });
}
function listSuppressedEmails(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/suppressed-emails",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get,
        }
    });
}
function deleteSuppressedEmail(_a) {
    var email = _a.email;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/suppressed-emails/" + email,
        fetchOptions: {
            method: EMethods.delete,
        }
    });
}
function createSuppressedEmailExport() {
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/suppressed-emails-exports",
        fetchOptions: {
            method: EMethods.post
        }
    });
}
function getSuppressedEmailExport(_a) {
    var exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/suppressed-emails-exports/" + exportId,
        fetchOptions: {
            method: EMethods.get,
        }
    });
}
function downloadSuppressedEmailExport(_a) {
    var exportId = _a.exportId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/reports/suppressed-emails-exports/".concat(exportId, "/download"),
        fetchOptions: {
            method: EMethods.get,
        }
    });
}

function listSystemEmails(_a) {
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/default/system-emails",
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function updateSystemEmails(_a) {
    var systemEmails = _a.systemEmails;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/brands/default/system-emails",
        fetchOptions: {
            method: EMethods.patch,
            body: systemEmails
        }
    });
}

function getTaskService(_a) {
    var taskId = _a.taskId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/tasks/" + taskId,
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function listTasksService(_a) {
    var options = __rest(_a, []);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/tasks/",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function deleteTaskService(_a) {
    var taskId = _a.taskId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/tasks/" + taskId,
        fetchOptions: {
            method: EMethods.delete
        }
    });
}

function listTemplates(_a) {
    var useImpersonationTree = _a.useImpersonationTree, options = __rest(_a, ["useImpersonationTree"]);
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates",
        query: camelCase(options),
        fetchOptions: {
            method: EMethods.get
        },
        useImpersonationTree: useImpersonationTree
    });
}
function getTemplate(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates/".concat(id),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function createTemplate(_a) {
    var template = _a.template;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates",
        fetchOptions: {
            body: template,
            method: EMethods.post
        }
    });
}
function updateTemplate(_a) {
    var id = _a.id, template = _a.template;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates/".concat(id),
        fetchOptions: {
            body: template,
            method: EMethods.patch
        }
    });
}
function deleteTemplate(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates/".concat(id),
        fetchOptions: {
            method: EMethods.delete
        }
    });
}
function renderTemplate(_a) {
    var id = _a.id, brandAccountId = _a.brandAccountId;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates/".concat(id, "/render"),
        query: camelCase({ brandAccountId: brandAccountId }),
        fetchOptions: {
            method: EMethods.get
        }
    });
}
function shareTemplate(_a) {
    var id = _a.id, accounts = _a.accounts, everyone = _a.everyone, automatic = _a.automatic;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates/".concat(id, "/share"),
        fetchOptions: {
            body: {
                accounts: accounts,
                everyone: everyone,
                automatic: automatic
            },
            method: EMethods.post
        }
    });
}
function unshareTemplate(_a) {
    var id = _a.id;
    return callApi({
        url: uiKitConfig.GATEWAY_PROXY + "/templates/".concat(id, "/unshare"),
        fetchOptions: {
            method: EMethods.post
        }
    });
}

var GenericWrapperContext = createContext({
    partnerBrand: {},
    userBrand: undefined,
    account: {},
    user: {}
});

function GenericWrapper(_a) {
    var children = _a.children, brandObj = _a.brandObj, userBrandObj = _a.userBrandObj, brandId = _a.brandId, brandHost = _a.brandHost, account = _a.account, user = _a.user, _b = _a.setPageHead, setPageHead = _b === void 0 ? true : _b, _c = _a.setPostHog, setPostHog = _c === void 0 ? true : _c, LocizeInitializer = _a.LocizeInitializer, brandThemeContext = _a.brandThemeContext, proxyUrl = _a.proxyUrl, _d = _a.styleOverride, styleOverride = _d === void 0 ? {} : _d, _e = _a.includeHandlers, includeHandlers = _e === void 0 ? true : _e;
    var _f = useState(brandObj ? buildMUITheme({ brand: brandObj }) : undefined), mUITheme = _f[0], setMUITheme = _f[1];
    var _g = useState(brandObj), partnerBrand = _g[0], setPartnerBrand = _g[1];
    var _h = useState(userBrandObj), userBrand = _h[0], setUserBrand = _h[1];
    var _j = useTranslation(); _j.t; _j.i18n;
    var dialogRef = useRef(undefined);
    var actionsBarContainerRef = useRef(undefined);
    var overlayRef = useRef(undefined);
    var modalRef = useRef(undefined);
    var drawerRef = useRef(undefined);
    if (proxyUrl) {
        uiKitConfig.GATEWAY_PROXY = proxyUrl;
    }
    useEffect(function () {
        var _a, _b;
        if (user) {
            //@ts-ignore
            var locale = getBestLocalMatch((_a = user === null || user === void 0 ? void 0 : user.language) === null || _a === void 0 ? void 0 : _a.replace("_", "-"), (_b = partnerBrand === null || partnerBrand === void 0 ? void 0 : partnerBrand.client_config) === null || _b === void 0 ? void 0 : _b.languages);
            if (LocizeInitializer) {
                LocizeInitializer.changeLanguage(locale);
            }
            moment$1.locale(locale);
            getBrand({ id: user.id, compiled: false }).then(function (res) {
                setUserBrand(res);
            });
        }
    }, [user]);
    useEffect(initPH, []);
    useEffect(initHandlers, [mUITheme]);
    function initHandlers() {
        if (!includeHandlers || !mUITheme)
            return;
        //@ts-ignore
        DialogHandler.register(dialogRef.current);
        //@ts-ignore
        ActionBarContainerHandler.register(actionsBarContainerRef.current);
        //@ts-ignore
        OverlayHandler.register(overlayRef.current);
        //@ts-ignore
        ModalHandler.register(modalRef.current);
        //@ts-ignore
        DrawerHandler.register(drawerRef.current);
    }
    function initPH(brand) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (setPostHog) {
            var cBrand = brand || brandObj;
            if (!cBrand)
                return;
            initPostHog({
                enabled: (_b = (_a = cBrand.client_config) === null || _a === void 0 ? void 0 : _a.segment_config) === null || _b === void 0 ? void 0 : _b.enabled,
                id: ((_d = (_c = cBrand.client_config) === null || _c === void 0 ? void 0 : _c.segment_config) === null || _d === void 0 ? void 0 : _d.phId) || "",
                server: (_f = (_e = cBrand.client_config) === null || _e === void 0 ? void 0 : _e.segment_config) === null || _f === void 0 ? void 0 : _f.phServer,
                uiHost: (_h = (_g = cBrand.client_config) === null || _g === void 0 ? void 0 : _g.segment_config) === null || _h === void 0 ? void 0 : _h.phUiHost,
                eventsPerSecond: (_k = (_j = cBrand.client_config) === null || _j === void 0 ? void 0 : _j.segment_config) === null || _k === void 0 ? void 0 : _k.eventsPerSecond,
                eventsBurstLimit: (_m = (_l = cBrand.client_config) === null || _l === void 0 ? void 0 : _l.segment_config) === null || _m === void 0 ? void 0 : _m.eventsBurstLimit
            });
        }
    }
    var content = React__default.createElement(BrandWrapper, { MUITheme: mUITheme, brandId: brandId, styleOverride: styleOverride, brandHost: brandHost, onBrandSuccess: function (compiledBrand, theme) {
            initPH(compiledBrand);
            setPartnerBrand(compiledBrand);
            setMUITheme(theme);
        }, onBrandError: function () {
            setMUITheme(buildMUITheme({ brand: whiteLabelBrand }));
        }, noFetch: !!brandObj, setPageHead: setPageHead, brandThemeContext: brandThemeContext, includeHandlers: false }, partnerBrand &&
        React__default.createElement(GenericWrapperContext.Provider, { value: {
                partnerBrand: partnerBrand,
                userBrand: userBrand,
                account: account ? new AccountModel(account) : new AccountModel({}),
                user: user ? new UserModel(user) : new UserModel({})
            } },
            includeHandlers && React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Dialog, { ref: dialogRef }),
                React__default.createElement(ActionBarContainer, { ref: actionsBarContainerRef }),
                React__default.createElement(Overlay, { ref: overlayRef }),
                React__default.createElement(Modal, { ref: modalRef }),
                React__default.createElement(Drawer, { ref: drawerRef })),
            children));
    return React__default.createElement(React__default.Fragment, null,
        setPostHog &&
            React__default.createElement(PostHogProvider, { client: posthog }, content),
        !setPostHog &&
            content);
}

var css_248z$9 = ".groupedActions-component {\n  display: flex;\n}\n.groupedActions-component > *:first-child, .groupedActions-component > *:first-child.dropdown-component-v2 .MuiInputBase-root {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.groupedActions-component > *:last-child, .groupedActions-component > *:last-child.dropdown-component-v2 .MuiInputBase-root {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.groupedActions-component > *:nth-child(n+2):not(:last-child), .groupedActions-component > *:nth-child(n+2):not(:last-child).dropdown-component-v2 .MuiInputBase-root {\n  border-radius: 0;\n}\n.groupedActions-component.contained > *:nth-child(n+2):not(:last-child) {\n  margin-left: 1px;\n}\n.groupedActions-component.contained > *:last-child {\n  margin-left: 1px;\n}\n.groupedActions-component.outlined > *:nth-child(n+2):not(:last-child), .groupedActions-component.outlined > *:nth-child(n+2):not(:last-child).dropdown-component-v2 .MuiInputBase-root, .groupedActions-component.outlined > *:not(:first-child):active, .groupedActions-component.outlined > *:not(:first-child):active.dropdown-component-v2 .MuiInputBase-root, .groupedActions-component.outlined > *:last-child, .groupedActions-component.outlined > *:last-child.dropdown-component-v2 .MuiInputBase-root {\n  border-left: none !important;\n}";
styleInject(css_248z$9);

function GroupedActions(_a) {
    var _b = _a.components, components = _b === void 0 ? [] : _b, classNames$1 = _a.classNames, _c = _a.variant, variant = _c === void 0 ? "contained" : _c;
    var classes = classNames("groupedActions-component", classNames$1, variant);
    //TODO check why this doesnt work, it should, it would minimize the dev work when switching variants (1 place instead of all components)
    /*
    {components.map((Component) => {
            return <Component variant={variant} />
        })}
    */
    return React__default.createElement(Box$1, { className: classes }, components);
}

var css_248z$8 = ".header-component-v2 {\n  max-width: 31rem;\n  width: 100%;\n}\n.header-component-v2 > * {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.header-component-v2 .header .headerText,\n.header-component-v2 .header .headerText span,\n.header-component-v2 .desc span,\n.header-component-v2 .support span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 31rem;\n  display: block;\n  text-wrap: nowrap;\n  width: 100%;\n}\n.header-component-v2 .header,\n.header-component-v2 .desc,\n.header-component-v2 .support {\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.header-component-v2 .header {\n  flex: 1;\n  margin-top: 0;\n}\n.header-component-v2 .header .postHeader,\n.header-component-v2 .header .preHeader {\n  display: inline-block;\n  width: -moz-fit-content;\n  width: fit-content;\n  text-wrap: nowrap;\n}\n.header-component-v2 .header .preHeader {\n  margin-right: 1rem;\n}\n.header-component-v2 .header .postHeader {\n  margin-left: 1.5rem;\n}\n.header-component-v2 .support {\n  flex: 1;\n  line-height: 0.75rem;\n  display: block;\n  margin-bottom: 1px;\n}\n.header-component-v2 .desc {\n  flex: 1;\n  margin-top: 1rem;\n  border-color: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}";
styleInject(css_248z$8);

//TODO when bottom line is secondary color, it means it is in a editable state, clicking it would transform it into a text field with check and x
//https://www.figma.com/proto/OQkvkOI4CMyrcPbuza16e3/Analytics?type=design&node-id=232-14879&t=kNKIjcU4MImW1jef-0&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=232%3A14512&show-proto-sidebar=1 
function Header(_a) {
    var heading = _a.heading, preHeading = _a.preHeading, postHeading = _a.postHeading, headingTooltip = _a.headingTooltip, support = _a.support, supportTooltip = _a.supportTooltip, desc = _a.desc, descTooltip = _a.descTooltip, tooltipPosition = _a.tooltipPosition, _b = _a.headingVariant, headingVariant = _b === void 0 ? "h2" : _b, headingColor = _a.headingColor;
    //TODO DESC PART NOT COMPLETE HAS DESIGN : https://www.figma.com/file/B5SHR91AjSAO6ZLUiFP3Kl/UI-KIT?type=design&node-id=276-258&mode=design&t=r59eS7O2F0i19Fki-0
    var classes = classNames("header-component-v2");
    return React__default.createElement(Stack$2, { className: classes, spacing: 2 },
        support &&
            React__default.createElement(Tooltip$1, { arrow: true, placement: tooltipPosition, title: supportTooltip },
                React__default.createElement(Typography$2, { variant: "body2S", className: "support uppercase ".concat(supportTooltip ? "showTooltip" : "") }, support)),
        React__default.createElement(Stack$2, { direction: "row", className: "header", alignItems: "center" },
            preHeading &&
                React__default.createElement(Box$1, { className: "preHeader" }, preHeading),
            React__default.createElement(Tooltip$1, { arrow: true, placement: tooltipPosition, title: headingTooltip, className: "headerText" },
                React__default.createElement(Typography$2, { variant: headingVariant, color: headingColor, className: headingTooltip ? "showTooltip" : "" }, heading)),
            postHeading &&
                React__default.createElement(Box$1, { className: "postHeader" }, postHeading)),
        desc &&
            React__default.createElement(Tooltip$1, { arrow: true, placement: tooltipPosition, title: descTooltip },
                React__default.createElement(Typography$2, { variant: "body1L", className: "desc ".concat(descTooltip ? "showTooltip" : "") }, desc)));
}

var css_248z$7 = ".iconPill-component-v2 {\n  position: relative;\n}\n.iconPill-component-v2 span {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: var(--background-color-1, var(--white, #FFFFFF));\n  border: 1px solid var(--wild-sand, #dddddd);\n  font-size: 0.625rem;\n  border-radius: 20px;\n  font-weight: bold;\n  top: -0.625rem;\n  right: -0.625rem;\n  width: 1.25rem;\n  height: 1.25rem;\n}\n.iconPill-component-v2.s10 span {\n  top: -0.25rem;\n  right: -0.75rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  font-size: 0.5rem;\n}\n.iconPill-component-v2.s14 span {\n  top: -0.3rem;\n  right: -0.7rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  font-size: 0.5rem;\n}\n.iconPill-component-v2.s18 span {\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 1rem;\n  height: 1rem;\n}\n.iconPill-component-v2.s32 span {\n  top: -0.75rem;\n  right: -0.75rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  font-size: 0.85rem;\n}\n.iconPill-component-v2.s44 span {\n  top: -0.75rem;\n  right: -0.75rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  font-size: 1rem;\n}";
styleInject(css_248z$7);

var IconPill = forwardRef(function (_a, ref) {
    var _b = _a.count, count = _b === void 0 ? 0 : _b, _c = _a.iconName, iconName = _c === void 0 ? "Domainauthenticated24" : _c, color = _a.color;
    var defaultColor = color || "success";
    if (!color) {
        if (iconName.includes("Domainunauthenticated"))
            defaultColor = "warning";
        else if (iconName.includes("Domainblocked"))
            defaultColor = "error";
    }
    var size = Number(iconName.slice(-2));
    if (isNaN(size)) {
        size = 24;
    }
    var classes = classNames("iconPill-component-v2", "s" + size);
    return React__default.createElement(Box, { className: classes, ref: ref },
        React__default.createElement("span", null, count),
        React__default.createElement(Icon, { name: iconName, color: defaultColor }));
});

var css_248z$6 = ".informationGroup-component-v2 {\n  display: flex;\n}\n.informationGroup-component-v2:first-child {\n  padding-bottom: 2rem;\n}\n.informationGroup-component-v2:last-child {\n  padding-top: 2rem;\n}\n.informationGroup-component-v2:not(:first-child):not(:last-child) {\n  padding: 2rem 0;\n}\n.informationGroup-component-v2:not(:last-child) {\n  border-bottom: 1px solid var(--wild-sand, #dddddd);\n}\n.informationGroup-component-v2 > div {\n  max-width: 31.25rem;\n  width: 100%;\n}\n.informationGroup-component-v2 > div:first-child {\n  margin-right: 3rem;\n}\n.informationGroup-component-v2 > div:last-child {\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n}\n.informationGroup-component-v2 > div:last-child > div:not(:first-child) {\n  margin-top: 2.5rem;\n}\n.informationGroup-component-v2 > div:last-child .dropdown-component-v2 .MuiInputBase-root,\n.informationGroup-component-v2 > div:last-child .dropdown-component-v2 {\n  width: 100%;\n}\n.informationGroup-component-v2 > div:last-child .autocomplete-dropdown-container {\n  z-index: 10000000;\n}";
styleInject(css_248z$6);

function InformationGroup(_a) {
    var title = _a.title, desc = _a.desc, rightContent = _a.rightContent, children = _a.children;
    return React__default.createElement(Box, { className: "informationGroup-component-v2" },
        React__default.createElement(Box, null,
            React__default.createElement(Typography, { variant: "body1L", semiBold: true }, title),
            desc && React__default.createElement(Typography, null, desc)),
        React__default.createElement(Box, null,
            rightContent,
            children));
}

var css_248z$5 = ".inlineTextEdit-component-v2 {\n  border-bottom: var(--secondary-brand-color, var(--teal, #0ABDAE));\n  border-bottom-style: dashed;\n  position: relative;\n}\n.inlineTextEdit-component-v2 .hasPlaceholder {\n  opacity: 0.5;\n}\n.inlineTextEdit-component-v2.editing .actions {\n  position: absolute;\n  right: -4.875rem;\n  top: -2px;\n}\n.inlineTextEdit-component-v2.editing .actions .confirm {\n  margin-right: 0.25rem;\n}\n.inlineTextEdit-component-v2.editing .actions .cancel svg {\n  width: 10px;\n}\n.inlineTextEdit-component-v2 input,\n.inlineTextEdit-component-v2 textarea,\n.inlineTextEdit-component-v2 .MuiInputBase-root {\n  width: 100%;\n  border: none;\n  padding: 0 !important;\n  outline: none;\n}\n.inlineTextEdit-component-v2 input:active, .inlineTextEdit-component-v2 input:focus,\n.inlineTextEdit-component-v2 textarea:active,\n.inlineTextEdit-component-v2 textarea:focus,\n.inlineTextEdit-component-v2 .MuiInputBase-root:active,\n.inlineTextEdit-component-v2 .MuiInputBase-root:focus {\n  border: none;\n}\n.inlineTextEdit-component-v2 > span,\n.inlineTextEdit-component-v2 input,\n.inlineTextEdit-component-v2 textarea,\n.inlineTextEdit-component-v2 .MuiBox-root,\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2,\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root,\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root .MuiInputBase-root,\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root .MuiInputBase-root input {\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root .MuiInputBase-root::before {\n  content: unset;\n}\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root .MuiInputBase-root::after {\n  content: unset !important;\n}\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root .MuiInputBase-root input,\n.inlineTextEdit-component-v2 .MuiBox-root .textfield-component-v2 .MuiTextField-root .MuiInputBase-root textarea {\n  border: none;\n  padding-top: 0;\n  height: unset;\n}";
styleInject(css_248z$5);

function InlineTextEdit(_a) {
    var _b, _c;
    var disabled = _a.disabled, tooltipTitle = _a.tooltipTitle, tooltipPlacement = _a.tooltipPlacement, defaultValue = _a.defaultValue, name = _a.name, onConfirm = _a.onConfirm, onCancel = _a.onCancel, placeholder = _a.placeholder, showActionButtons = _a.showActionButtons, maxRows = _a.maxRows, maxLength = _a.maxLength;
    var _d = useState(false), editing = _d[0], setEditing = _d[1];
    var id = useRef(Math.floor(Math.random() * 1000000000));
    var spanRef = useRef(null);
    var _e = useState(defaultValue), value = _e[0], setValue = _e[1];
    maxRows = maxRows || 1;
    var multiline = maxRows > 1;
    useLayoutEffect(function () {
        if (editing) {
            var input = document.querySelectorAll("#inlineTextEdit-id-".concat(id.current, ".inlineTextEdit-component-v2.editing ").concat(multiline ? "textarea" : "input"))[0];
            if (input)
                input.focus();
        }
    }, [editing]);
    function handleClick() {
        setEditing(!editing);
    }
    function handleClose() {
        handleClick();
        setValue(defaultValue);
        onCancel && onCancel({ name: name, value: value });
    }
    function handleConfirm() {
        handleClick();
        onConfirm && onConfirm({ name: name, value: value });
    }
    function handleOnClickAway() {
        if (!showActionButtons && editing)
            handleConfirm();
    }
    function handleOnChange(e) {
        setValue(e.target.value);
    }
    tooltipPlacement = tooltipPlacement || "right";
    var offsetWidthOfSpan = ((_b = spanRef === null || spanRef === void 0 ? void 0 : spanRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 150;
    if (offsetWidthOfSpan < 150) {
        offsetWidthOfSpan = 150;
    }
    var offsetHeightOfSpan = ((_c = spanRef === null || spanRef === void 0 ? void 0 : spanRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) || 20;
    var classes = classNames("inlineTextEdit-component-v2", {
        "editing": editing,
        "disabled": disabled
    });
    return React__default.createElement(ClickAwayListener, { onClickAway: handleOnClickAway, disableReactTree: true },
        React__default.createElement(Box$1, { id: "inlineTextEdit-id-" + id.current, className: classes },
            !editing &&
                React__default.createElement(Tooltip$1, { title: tooltipTitle, arrow: true, placement: tooltipPlacement },
                    React__default.createElement(Box$1, { component: "span", className: "".concat(!value && placeholder ? "hasPlaceholder" : "", " pointer"), onClick: handleClick, style: { maxHeight: offsetHeightOfSpan * maxRows } }, value || placeholder)),
            React__default.createElement(Box$1, { className: editing ? "" : "hidden" },
                React__default.createElement(TextField, { disabled: disabled, inputProps: { maxLength: maxLength || 256 }, maxRows: maxRows, multiline: multiline, placeholder: placeholder, variant: "standard", name: name, style: { width: "".concat(offsetWidthOfSpan, "px") }, value: value, onChange: handleOnChange }),
                showActionButtons &&
                    React__default.createElement(Stack$1, { className: "actions", direction: "row", justifyContent: "center", alignContent: "center" },
                        React__default.createElement(Button, { onClick: handleConfirm, className: "confirm", color: "body1", size: "small" },
                            React__default.createElement(Icon, { name: "Checkmark10", color: "white" })),
                        React__default.createElement(Button, { onClick: handleClose, className: "cancel", color: "body1", size: "small" },
                            React__default.createElement(Icon, { name: "X18", color: "white" })))),
            React__default.createElement("span", { ref: spanRef, style: {
                    visibility: 'hidden',
                    whiteSpace: multiline ? 'pre-wrap' : 'pre', // For multiline, allow wrapping
                    position: 'absolute',
                    top: '-9999px', // Move completely off-screen
                    left: '-9999px',
                    padding: '0', // Remove padding to match input exactly
                    margin: '0',
                    border: 'none',
                    outline: 'none',
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                    fontWeight: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit',
                    wordSpacing: 'inherit',
                    textTransform: 'inherit',
                    fontVariant: 'inherit',
                    fontStretch: 'inherit',
                    fontStyle: 'inherit',
                    textDecoration: 'inherit',
                    textAlign: 'inherit',
                    textIndent: 'inherit',
                    textShadow: 'inherit',
                    textOverflow: 'inherit',
                    textRendering: 'inherit',
                    unicodeBidi: 'inherit',
                    writingMode: 'inherit',
                    direction: 'inherit',
                    // Ensure the span behaves like an input field
                    display: 'inline-block',
                    minWidth: '1px',
                    width: 'auto', // Use available width for multiline
                } }, value || ' ')));
}

/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */
function formatMuiErrorMessage(code, ...args) {
  const url = new URL(`https://mui.com/production-error/?code=${code}`);
  args.forEach(arg => url.searchParams.append('args[]', arg));
  return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  {
    return asString;
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var isBrowser = typeof document !== 'undefined';

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  return memoize$1(function () {
    return {};
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (!getServerStylisCache) {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var EmotionCacheContext = /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

EmotionCacheContext.Provider;

var ThemeContext = /* #__PURE__ */React.createContext({});

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$1.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$1.exports = requireReactIs_production_min();
	} else {
	  reactIs$1.exports = requireReactIs_development$1();
	}
	return reactIs$1.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

/**
 * @mui/styled-engine v7.2.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$1(tag, options) {
  const stylesFactory = emStyled(tag, options);
  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';
      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_mutateStyles(tag, processor) {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
}

// Emotion only accepts an array, but we want to avoid allocations
const wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_serializeStyles(styles) {
  wrapper[0] = styles;
  return serializeStyles(wrapper);
}

var reactIs = {exports: {}};

var reactIs_production = {};

/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production;

function requireReactIs_production () {
	if (hasRequiredReactIs_production) return reactIs_production;
	hasRequiredReactIs_production = 1;
	var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
	  REACT_PORTAL_TYPE = Symbol.for("react.portal"),
	  REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
	  REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
	  REACT_PROFILER_TYPE = Symbol.for("react.profiler");
	var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
	  REACT_CONTEXT_TYPE = Symbol.for("react.context"),
	  REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
	  REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
	  REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
	  REACT_MEMO_TYPE = Symbol.for("react.memo"),
	  REACT_LAZY_TYPE = Symbol.for("react.lazy"),
	  REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
	  REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
	function typeOf(object) {
	  if ("object" === typeof object && null !== object) {
	    var $$typeof = object.$$typeof;
	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        switch (((object = object.type), object)) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	          case REACT_VIEW_TRANSITION_TYPE:
	            return object;
	          default:
	            switch (((object = object && object.$$typeof), object)) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	                return object;
	              case REACT_CONSUMER_TYPE:
	                return object;
	              default:
	                return $$typeof;
	            }
	        }
	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }
	}
	reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
	reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
	reactIs_production.Element = REACT_ELEMENT_TYPE;
	reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
	reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
	reactIs_production.Lazy = REACT_LAZY_TYPE;
	reactIs_production.Memo = REACT_MEMO_TYPE;
	reactIs_production.Portal = REACT_PORTAL_TYPE;
	reactIs_production.Profiler = REACT_PROFILER_TYPE;
	reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
	reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
	reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	reactIs_production.isContextConsumer = function (object) {
	  return typeOf(object) === REACT_CONSUMER_TYPE;
	};
	reactIs_production.isContextProvider = function (object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	};
	reactIs_production.isElement = function (object) {
	  return (
	    "object" === typeof object &&
	    null !== object &&
	    object.$$typeof === REACT_ELEMENT_TYPE
	  );
	};
	reactIs_production.isForwardRef = function (object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	};
	reactIs_production.isFragment = function (object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	};
	reactIs_production.isLazy = function (object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	};
	reactIs_production.isMemo = function (object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	};
	reactIs_production.isPortal = function (object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	};
	reactIs_production.isProfiler = function (object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	};
	reactIs_production.isStrictMode = function (object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	};
	reactIs_production.isSuspense = function (object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	};
	reactIs_production.isSuspenseList = function (object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	};
	reactIs_production.isValidElementType = function (type) {
	  return "string" === typeof type ||
	    "function" === typeof type ||
	    type === REACT_FRAGMENT_TYPE ||
	    type === REACT_PROFILER_TYPE ||
	    type === REACT_STRICT_MODE_TYPE ||
	    type === REACT_SUSPENSE_TYPE ||
	    type === REACT_SUSPENSE_LIST_TYPE ||
	    ("object" === typeof type &&
	      null !== type &&
	      (type.$$typeof === REACT_LAZY_TYPE ||
	        type.$$typeof === REACT_MEMO_TYPE ||
	        type.$$typeof === REACT_CONTEXT_TYPE ||
	        type.$$typeof === REACT_CONSUMER_TYPE ||
	        type.$$typeof === REACT_FORWARD_REF_TYPE ||
	        type.$$typeof === REACT_CLIENT_REFERENCE ||
	        void 0 !== type.getModuleId))
	    ? true
	    : false;
	};
	reactIs_production.typeOf = typeOf;
	return reactIs_production;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;
	"production" !== process.env.NODE_ENV &&
	  (function () {
	    function typeOf(object) {
	      if ("object" === typeof object && null !== object) {
	        var $$typeof = object.$$typeof;
	        switch ($$typeof) {
	          case REACT_ELEMENT_TYPE:
	            switch (((object = object.type), object)) {
	              case REACT_FRAGMENT_TYPE:
	              case REACT_PROFILER_TYPE:
	              case REACT_STRICT_MODE_TYPE:
	              case REACT_SUSPENSE_TYPE:
	              case REACT_SUSPENSE_LIST_TYPE:
	              case REACT_VIEW_TRANSITION_TYPE:
	                return object;
	              default:
	                switch (((object = object && object.$$typeof), object)) {
	                  case REACT_CONTEXT_TYPE:
	                  case REACT_FORWARD_REF_TYPE:
	                  case REACT_LAZY_TYPE:
	                  case REACT_MEMO_TYPE:
	                    return object;
	                  case REACT_CONSUMER_TYPE:
	                    return object;
	                  default:
	                    return $$typeof;
	                }
	            }
	          case REACT_PORTAL_TYPE:
	            return $$typeof;
	        }
	      }
	    }
	    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
	      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
	      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
	      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
	      REACT_PROFILER_TYPE = Symbol.for("react.profiler");
	    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
	      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
	      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
	      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
	      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
	      REACT_MEMO_TYPE = Symbol.for("react.memo"),
	      REACT_LAZY_TYPE = Symbol.for("react.lazy"),
	      REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
	      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
	    reactIs_development.ContextConsumer = REACT_CONSUMER_TYPE;
	    reactIs_development.ContextProvider = REACT_CONTEXT_TYPE;
	    reactIs_development.Element = REACT_ELEMENT_TYPE;
	    reactIs_development.ForwardRef = REACT_FORWARD_REF_TYPE;
	    reactIs_development.Fragment = REACT_FRAGMENT_TYPE;
	    reactIs_development.Lazy = REACT_LAZY_TYPE;
	    reactIs_development.Memo = REACT_MEMO_TYPE;
	    reactIs_development.Portal = REACT_PORTAL_TYPE;
	    reactIs_development.Profiler = REACT_PROFILER_TYPE;
	    reactIs_development.StrictMode = REACT_STRICT_MODE_TYPE;
	    reactIs_development.Suspense = REACT_SUSPENSE_TYPE;
	    reactIs_development.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	    reactIs_development.isContextConsumer = function (object) {
	      return typeOf(object) === REACT_CONSUMER_TYPE;
	    };
	    reactIs_development.isContextProvider = function (object) {
	      return typeOf(object) === REACT_CONTEXT_TYPE;
	    };
	    reactIs_development.isElement = function (object) {
	      return (
	        "object" === typeof object &&
	        null !== object &&
	        object.$$typeof === REACT_ELEMENT_TYPE
	      );
	    };
	    reactIs_development.isForwardRef = function (object) {
	      return typeOf(object) === REACT_FORWARD_REF_TYPE;
	    };
	    reactIs_development.isFragment = function (object) {
	      return typeOf(object) === REACT_FRAGMENT_TYPE;
	    };
	    reactIs_development.isLazy = function (object) {
	      return typeOf(object) === REACT_LAZY_TYPE;
	    };
	    reactIs_development.isMemo = function (object) {
	      return typeOf(object) === REACT_MEMO_TYPE;
	    };
	    reactIs_development.isPortal = function (object) {
	      return typeOf(object) === REACT_PORTAL_TYPE;
	    };
	    reactIs_development.isProfiler = function (object) {
	      return typeOf(object) === REACT_PROFILER_TYPE;
	    };
	    reactIs_development.isStrictMode = function (object) {
	      return typeOf(object) === REACT_STRICT_MODE_TYPE;
	    };
	    reactIs_development.isSuspense = function (object) {
	      return typeOf(object) === REACT_SUSPENSE_TYPE;
	    };
	    reactIs_development.isSuspenseList = function (object) {
	      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	    };
	    reactIs_development.isValidElementType = function (type) {
	      return "string" === typeof type ||
	        "function" === typeof type ||
	        type === REACT_FRAGMENT_TYPE ||
	        type === REACT_PROFILER_TYPE ||
	        type === REACT_STRICT_MODE_TYPE ||
	        type === REACT_SUSPENSE_TYPE ||
	        type === REACT_SUSPENSE_LIST_TYPE ||
	        ("object" === typeof type &&
	          null !== type &&
	          (type.$$typeof === REACT_LAZY_TYPE ||
	            type.$$typeof === REACT_MEMO_TYPE ||
	            type.$$typeof === REACT_CONTEXT_TYPE ||
	            type.$$typeof === REACT_CONSUMER_TYPE ||
	            type.$$typeof === REACT_FORWARD_REF_TYPE ||
	            type.$$typeof === REACT_CLIENT_REFERENCE ||
	            void 0 !== type.getModuleId))
	        ? true
	        : false;
	    };
	    reactIs_development.typeOf = typeOf;
	  })();
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = requireReactIs_production();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;

// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
  if (typeof item !== 'object' || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (/*#__PURE__*/React.isValidElement(source) || reactIsExports.isValidElementType(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}

/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? {
    ...target
  } : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      if (/*#__PURE__*/React.isValidElement(source[key]) || reactIsExports.isValidElementType(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject(source[key]) &&
      // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return {
      ...acc,
      [obj.key]: obj.val
    };
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screen
    },
    unit = 'px',
    step = 5,
    ...other
  } = breakpoints;
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return {
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit,
    ...other
  };
}

/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */
function sortContainerQueries(theme, css) {
  if (!theme.containerQueries) {
    return css;
  }
  const sorted = Object.keys(css).filter(key => key.startsWith('@container')).sort((a, b) => {
    const regex = /min-width:\s*([0-9.]+)/;
    return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
  });
  if (!sorted.length) {
    return css;
  }
  return sorted.reduce((acc, key) => {
    const value = css[key];
    delete acc[key];
    acc[key] = value;
    return acc;
  }, {
    ...css
  });
}
function isCqShorthand(breakpointKeys, value) {
  return value === '@' || value.startsWith('@') && (breakpointKeys.some(key => value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function getContainerQuery(theme, shorthand) {
  const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
  if (!matches) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${shorthand})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.\n` + 'For example, `@sm` or `@600` or `@40rem/sidebar`.' : formatMuiErrorMessage(18, `(${shorthand})`));
    }
    return null;
  }
  const [, containerQuery, containerName] = matches;
  const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
  return theme.containerQueries(containerName).up(value);
}
function cssContainerQueries(themeInput) {
  const toContainerQuery = (mediaQuery, name) => mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
  function attachCq(node, name) {
    node.up = (...args) => toContainerQuery(themeInput.breakpoints.up(...args), name);
    node.down = (...args) => toContainerQuery(themeInput.breakpoints.down(...args), name);
    node.between = (...args) => toContainerQuery(themeInput.breakpoints.between(...args), name);
    node.only = (...args) => toContainerQuery(themeInput.breakpoints.only(...args), name);
    node.not = (...args) => {
      const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
      if (result.includes('not all and')) {
        // `@container` does not work with `not all and`, so need to invert the logic
        return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
      }
      return result;
    };
  }
  const node = {};
  const containerQueries = name => {
    attachCq(node, name);
    return node;
  };
  attachCq(containerQueries);
  return {
    ...themeInput,
    containerQueries
  };
}

const shape = {
  borderRadius: 4
};

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
const defaultContainerQueries = {
  containerQueries: containerName => ({
    up: key => {
      let result = typeof key === 'number' ? key : values[key] || key;
      if (typeof result === 'number') {
        result = `${result}px`;
      }
      return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
    }
  })
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (isCqShorthand(themeBreakpoints.keys, breakpoint)) {
        const containerKey = getContainerQuery(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
        if (containerKey) {
          acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
        }
      }
      // key is breakpoint
      else if (Object.keys(themeBreakpoints.values || values).includes(breakpoint)) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => deepmerge(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI: `capitalize(string)` expects a string argument.' : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$2(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType
  } : {};
  fn.filterProps = [prop];
  return fn;
}

function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  const themeSpacing = getPath(theme, themeKey, true) ?? defaultValue;
  if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') {
    return val => {
      if (typeof val === 'string') {
        return val;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (typeof val !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${val}.`);
        }
      }
      if (typeof themeSpacing === 'string') {
        if (themeSpacing.startsWith('var(') && val === 0) {
          return 0;
        }
        if (themeSpacing.startsWith('var(') && val === 1) {
          return themeSpacing;
        }
        return `calc(${val} * ${themeSpacing})`;
      }
      return themeSpacing * val;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return val => {
      if (typeof val === 'string') {
        return val;
      }
      const abs = Math.abs(val);
      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }
      const transformed = themeSpacing[abs];
      if (val >= 0) {
        return transformed;
      }
      if (typeof transformed === 'number') {
        return -transformed;
      }
      if (typeof transformed === 'string' && transformed.startsWith('var(')) {
        return `calc(-1 * ${transformed})`;
      }
      return `-${transformed}`;
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  return transformer(propValue);
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (!keys.includes(prop)) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style$1(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style$1(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style$1(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};

// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing(spacingInput = 8,
// Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = createUnarySpacing({
  spacing: spacingInput
})) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return style$2({
    prop,
    themeKey: 'borders',
    transform
  });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ['borderRadius'];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);

// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType
} : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$2({
  prop: 'gridColumn'
});
const gridRow = style$2({
  prop: 'gridRow'
});
const gridAutoFlow = style$2({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$2({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$2({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$2({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$2({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$2({
  prop: 'gridTemplateAreas'
});
const gridArea = style$2({
  prop: 'gridArea'
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = style$2({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = style$2({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = style$2({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);

function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$2({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      const breakpoint = props.theme?.breakpoints?.values?.[propValue] || values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (props.theme?.breakpoints?.unit !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$2({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = style$2({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = style$2({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = style$2({
  prop: 'minHeight',
  transform: sizingTransform
});
style$2({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
style$2({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = style$2({
  prop: 'boxSizing'
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: 'font'
  },
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    const {
      sx,
      theme = {},
      nested
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    const config = theme.unstable_sxConfig ?? defaultSxConfig;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme,
                  nested: true
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      if (!nested && theme.modularCssLayers) {
        return {
          '@layer sx': sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css))
        };
      }
      return sortContainerQueries(theme, removeUnusedBreakpoints(breakpointsKeys, css));
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];

/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles(key, styles) {
  // @ts-expect-error this is 'any' type
  const theme = this;
  if (theme.vars) {
    if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') {
      return {};
    }
    // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
    let selector = theme.getColorSchemeSelector(key);
    if (selector === '&') {
      return styles;
    }
    if (selector.includes('data-') || selector.includes('.')) {
      // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
      selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
    }
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

function createTheme(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {},
    ...other
  } = options;
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: {
      mode: 'light',
      ...paletteInput
    },
    spacing,
    shape: {
      ...shape,
      ...shapeInput
    }
  }, other);
  muiTheme = cssContainerQueries(muiTheme);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => deepmerge(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = {
    ...defaultSxConfig,
    ...other?.unstable_sxConfig
  };
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

function isObjectEmpty$1(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$1(defaultTheme = null) {
  const contextTheme = React.useContext(ThemeContext);
  return !contextTheme || isObjectEmpty$1(contextTheme) ? defaultTheme : contextTheme;
}

const systemDefaultTheme$1 = createTheme();
function useTheme(defaultTheme = systemDefaultTheme$1) {
  return useTheme$1(defaultTheme);
}

const splitProps = props => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = props?.theme?.unstable_sxConfig ?? defaultSxConfig;
  Object.keys(props).forEach(prop => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
    sx: inSx,
    ...other
  } = props;
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject(result)) {
        return systemProps;
      }
      return {
        ...systemProps,
        ...result
      };
    };
  } else {
    finalSx = {
      ...systemProps,
      ...inSx
    };
  }
  return {
    ...otherProps,
    sx: finalSx
  };
}

const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

const globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}

function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}

/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */
function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case reactIsExports.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

function preprocessStyles(input) {
  const {
    variants,
    ...style
  } = input;
  const result = {
    variants,
    style: internal_serializeStyles(style),
    isProcessed: true
  };

  // Not supported on styled-components
  if (result.style === style) {
    return result;
  }
  if (variants) {
    variants.forEach(variant => {
      if (typeof variant.style !== 'function') {
        variant.style = internal_serializeStyles(variant.style);
      }
    });
  }
  return result;
}

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-labels */
/* eslint-disable no-lone-blocks */

const systemDefaultTheme = createTheme();

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function shallowLayer(serialized, layerName) {
  if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
  ) {
    serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
  }
  return serialized;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (_props, styles) => styles[slot];
}
function attachTheme(props, themeId, defaultTheme) {
  props.theme = isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function processStyle(props, style, layerName) {
  /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */

  const resolvedStyle = typeof style === 'function' ? style(props) : style;
  if (Array.isArray(resolvedStyle)) {
    return resolvedStyle.flatMap(subStyle => processStyle(props, subStyle, layerName));
  }
  if (Array.isArray(resolvedStyle?.variants)) {
    let rootStyle;
    if (resolvedStyle.isProcessed) {
      rootStyle = layerName ? shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
    } else {
      const {
        variants,
        ...otherStyles
      } = resolvedStyle;
      rootStyle = layerName ? shallowLayer(internal_serializeStyles(otherStyles), layerName) : otherStyles;
    }
    return processStyleVariants(props, resolvedStyle.variants, [rootStyle], layerName);
  }
  if (resolvedStyle?.isProcessed) {
    return layerName ? shallowLayer(internal_serializeStyles(resolvedStyle.style), layerName) : resolvedStyle.style;
  }
  return layerName ? shallowLayer(internal_serializeStyles(resolvedStyle), layerName) : resolvedStyle;
}
function processStyleVariants(props, variants, results = [], layerName = undefined) {
  let mergedState; // We might not need it, initialized lazily

  variantLoop: for (let i = 0; i < variants.length; i += 1) {
    const variant = variants[i];
    if (typeof variant.props === 'function') {
      mergedState ??= {
        ...props,
        ...props.ownerState,
        ownerState: props.ownerState
      };
      if (!variant.props(mergedState)) {
        continue;
      }
    } else {
      for (const key in variant.props) {
        if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) {
          continue variantLoop;
        }
      }
    }
    if (typeof variant.style === 'function') {
      mergedState ??= {
        ...props,
        ...props.ownerState,
        ownerState: props.ownerState
      };
      results.push(layerName ? shallowLayer(internal_serializeStyles(variant.style(mergedState)), layerName) : variant.style(mergedState));
    } else {
      results.push(layerName ? shallowLayer(internal_serializeStyles(variant.style), layerName) : variant.style);
    }
  }
  return results;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  function styleAttachTheme(props) {
    attachTheme(props, themeId, defaultTheme);
  }
  const styled = (tag, inputOptions = {}) => {
    // If `tag` is already a styled component, filter out the `sx` style function
    // to prevent unnecessary styles generated by the composite components.
    internal_mutateStyles(tag, styles => styles.filter(style => style !== styleFunctionSx));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)),
      ...options
    } = inputOptions;
    const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = styled$1(tag, {
      shouldForwardProp: shouldForwardPropOption,
      label: generateStyledLabel(componentName, componentSlot),
      ...options
    });
    const transformStyle = style => {
      // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
      //   component stays as a function. This condition makes sure that we do not interpolate functions
      //   which are basically components used as a selectors.
      // - `style` could be a styled component from a babel plugin for component selectors, This condition
      //   makes sure that we do not interpolate them.
      if (style.__emotion_real === style) {
        return style;
      }
      if (typeof style === 'function') {
        return function styleFunctionProcessor(props) {
          return processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
        };
      }
      if (isPlainObject(style)) {
        const serialized = preprocessStyles(style);
        return function styleObjectProcessor(props) {
          if (!serialized.variants) {
            return props.theme.modularCssLayers ? shallowLayer(serialized.style, layerName) : serialized.style;
          }
          return processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
        };
      }
      return style;
    };
    const muiStyledResolver = (...expressionsInput) => {
      const expressionsHead = [];
      const expressionsBody = expressionsInput.map(transformStyle);
      const expressionsTail = [];

      // Preprocess `props` to set the scoped theme value.
      // This must run before any other expression.
      expressionsHead.push(styleAttachTheme);
      if (componentName && overridesResolver) {
        expressionsTail.push(function styleThemeOverrides(props) {
          const theme = props.theme;
          const styleOverrides = theme.components?.[componentName]?.styleOverrides;
          if (!styleOverrides) {
            return null;
          }
          const resolvedStyleOverrides = {};

          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          // eslint-disable-next-line guard-for-in
          for (const slotKey in styleOverrides) {
            resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
          }
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsTail.push(function styleThemeVariants(props) {
          const theme = props.theme;
          const themeVariants = theme?.components?.[componentName]?.variants;
          if (!themeVariants) {
            return null;
          }
          return processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
        });
      }
      if (!skipSx) {
        expressionsTail.push(styleFunctionSx);
      }

      // This function can be called as a tagged template, so the first argument would contain
      // CSS `string[]` values.
      if (Array.isArray(expressionsBody[0])) {
        const inputStrings = expressionsBody.shift();

        // We need to add placeholders in the tagged template for the custom functions we have
        // possibly added (attachTheme, overrides, variants, and sx).
        const placeholdersHead = new Array(expressionsHead.length).fill('');
        const placeholdersTail = new Array(expressionsTail.length).fill('');
        let outputStrings;
        // prettier-ignore
        {
          outputStrings = [...placeholdersHead, ...inputStrings, ...placeholdersTail];
          outputStrings.raw = [...placeholdersHead, ...inputStrings.raw, ...placeholdersTail];
        }

        // The only case where we put something before `attachTheme`
        expressionsHead.unshift(outputStrings);
      }
      const expressions = [...expressionsHead, ...expressionsBody, ...expressionsTail];
      const Component = defaultStyledResolver(...expressions);
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      if (process.env.NODE_ENV !== 'production') {
        Component.displayName = generateDisplayName(componentName, componentSlot, tag);
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
  return styled;
}
function generateDisplayName(componentName, componentSlot, tag) {
  if (componentName) {
    return `${componentName}${capitalize(componentSlot || '')}`;
  }
  return `Styled(${getDisplayName(tag)})`;
}
function generateStyledLabel(componentName, componentSlot) {
  let label;
  if (process.env.NODE_ENV !== 'production') {
    if (componentName) {
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      label = `${componentName}-${lowercaseFirstLetter(componentSlot || 'Root')}`;
    }
  }
  return label;
}
function isObjectEmpty(object) {
  // eslint-disable-next-line
  for (const _ in object) {
    return false;
  }
  return true;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(string) {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
}

const styled = createStyled();

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */
function resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
  const output = {
    ...props
  };
  for (const key in defaultProps) {
    if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
      const propName = key;
      if (propName === 'components' || propName === 'slots') {
        output[propName] = {
          ...defaultProps[propName],
          ...output[propName]
        };
      } else if (propName === 'componentsProps' || propName === 'slotProps') {
        const defaultSlotProps = defaultProps[propName];
        const slotProps = props[propName];
        if (!slotProps) {
          output[propName] = defaultSlotProps || {};
        } else if (!defaultSlotProps) {
          output[propName] = slotProps;
        } else {
          output[propName] = {
            ...slotProps
          };
          for (const slotKey in defaultSlotProps) {
            if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
              const slotPropName = slotKey;
              output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
            }
          }
        }
      } else if (propName === 'className' && mergeClassNameAndStyle && props.className) {
        output.className = clsx(defaultProps?.className, props?.className);
      } else if (propName === 'style' && mergeClassNameAndStyle && props.style) {
        output.style = {
          ...defaultProps?.style,
          ...props?.style
        };
      } else if (output[propName] === undefined) {
        output[propName] = defaultProps[propName];
      }
    }
  }
  return output;
}

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

function useThemeProps({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = useTheme(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  return getThemeProps({
    theme,
    name,
    props
  });
}

/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */

/**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */
function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  for (const slotName in slots) {
    const slot = slots[slotName];
    let buffer = '';
    let start = true;
    for (let i = 0; i < slot.length; i += 1) {
      const value = slot[i];
      if (value) {
        buffer += (start === true ? '' : ' ') + getUtilityClass(value);
        start = false;
        if (classes && classes[value]) {
          buffer += ' ' + classes[value];
        }
      }
    }
    output[slotName] = buffer;
  }
  return output;
}

const defaultTheme = createTheme();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = styled('div', {
  name: 'MuiStack',
  slot: 'Root'
});
function useThemePropsDefault(props) {
  return useThemeProps({
    props,
    name: 'MuiStack',
    defaultTheme
  });
}

/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */
function joinChildren(children, separator) {
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push(/*#__PURE__*/React.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }
    return output;
  }, []);
}
const getSideFromDirection = direction => {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};
const style = ({
  ownerState,
  theme
}) => {
  let styles = {
    display: 'flex',
    flexDirection: 'column',
    ...handleBreakpoints({
      theme
    }, resolveBreakpointValues({
      values: ownerState.direction,
      breakpoints: theme.breakpoints.values
    }), propValue => ({
      flexDirection: propValue
    }))
  };
  if (ownerState.spacing) {
    const transformer = createUnarySpacing(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    const directionValues = resolveBreakpointValues({
      values: ownerState.direction,
      base
    });
    const spacingValues = resolveBreakpointValues({
      values: ownerState.spacing,
      base
    });
    if (typeof directionValues === 'object') {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];
        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    const styleFromPropValue = (propValue, breakpoint) => {
      if (ownerState.useFlexGap) {
        return {
          gap: getValue(transformer, propValue)
        };
      }
      return {
        // The useFlexGap={false} implement relies on each child to give up control of the margin.
        // We need to reset the margin to avoid double spacing.
        '& > :not(style):not(style)': {
          margin: 0
        },
        '& > :not(style) ~ :not(style)': {
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: getValue(transformer, propValue)
        }
      };
    };
    styles = deepmerge(styles, handleBreakpoints({
      theme
    }, spacingValues, styleFromPropValue));
  }
  styles = mergeBreakpointsInOrder(theme.breakpoints, styles);
  return styles;
};
function createStack(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiStack'
  } = options;
  const useUtilityClasses = () => {
    const slots = {
      root: ['root']
    };
    return composeClasses(slots, slot => generateUtilityClass(componentName, slot), {});
  };
  const StackRoot = createStyledComponent(style);
  const Stack = /*#__PURE__*/React.forwardRef(function Grid(inProps, ref) {
    const themeProps = useThemeProps(inProps);
    const props = extendSxProp(themeProps); // `color` type conflicts with html color attribute.
    const {
      component = 'div',
      direction = 'column',
      spacing = 0,
      divider,
      children,
      className,
      useFlexGap = false,
      ...other
    } = props;
    const ownerState = {
      direction,
      spacing,
      useFlexGap
    };
    const classes = useUtilityClasses();
    return /*#__PURE__*/jsx(StackRoot, {
      as: component,
      ownerState: ownerState,
      ref: ref,
      className: clsx(classes.root, className),
      ...other,
      children: divider ? joinChildren(children, divider) : children
    });
  });
  process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
    children: PropTypes.node,
    direction: PropTypes.oneOfType([PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes.arrayOf(PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes.object]),
    divider: PropTypes.node,
    spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
  } : void 0;
  return Stack;
}

/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */
const Stack = createStack();
process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), PropTypes.arrayOf(PropTypes.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), PropTypes.object]),
  /**
   * Add an element between each child.
   */
  divider: PropTypes.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the theme's default props configuration.
   * @default false
   */
  useFlexGap: PropTypes.bool
} : void 0;

var css_248z$4 = ".metricCard-component {\n  min-width: 250px;\n  width: 100%;\n  max-width: 35.25rem;\n  box-sizing: border-box;\n  box-shadow: none !important;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 2rem;\n}\n.metricCard-component.card {\n  padding: 2rem;\n  background: var(--cloud, #F4F4F4);\n}\n.metricCard-component.plain {\n  background: none !important;\n}\n.metricCard-component.withRightContent {\n  max-width: 72rem;\n}\n.metricCard-component > .rightContent {\n  flex: 1;\n  align-items: flex-end;\n}\n.metricCard-component > .rightContent img {\n  border-radius: 24px;\n  border: 1px solid var(--wild-sand, #dddddd);\n  width: 100%;\n  min-width: 150px;\n  max-width: 225px;\n  max-height: 18rem;\n}\n.metricCard-component > div:not(.rightContent) {\n  flex: 1;\n}\n.metricCard-component > div:not(.rightContent) > img + .heading,\n.metricCard-component > div:not(.rightContent) > img + .subHeading,\n.metricCard-component > div:not(.rightContent) > img + .metricRows {\n  margin-top: 2rem;\n}\n.metricCard-component > div:not(.rightContent) > .heading ~ div,\n.metricCard-component > div:not(.rightContent) .subHeading ~ div {\n  margin-top: 1.5rem;\n}\n.metricCard-component > div:not(.rightContent) > img {\n  border-radius: 48px;\n  max-width: 100%;\n  max-height: 18.75rem;\n  margin: 0 auto;\n}\n.metricCard-component > div:not(.rightContent) > .heading .MuiSvgIcon-root {\n  margin-right: 1rem;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading.withProgress {\n  margin-top: 1rem;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading > .MuiStack-root {\n  flex: 1;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading > .MuiStack-root > .desc {\n  display: grid;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading > .MuiStack-root > .progress {\n  height: calc(1rem - 2px);\n  background: var(--white, #FFFFFF);\n}\n.metricCard-component > div:not(.rightContent) > .subHeading > .MuiStack-root > .progress + .data {\n  margin-left: 1rem;\n  font-size: 4rem;\n  position: relative;\n  top: -12px;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading > .MuiStack-root > .data + .desc {\n  margin-left: 2rem;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading .MuiChip-root {\n  margin-left: 2rem;\n}\n.metricCard-component > div:not(.rightContent) > .subHeading .MuiChip-root .MuiSvgIcon-root {\n  padding-right: 0.5rem;\n}\n.metricCard-component > div:not(.rightContent) > .metricRows .MuiStack-root .MuiTypography-root:first-child {\n  margin-right: 1rem;\n}\n.metricCard-component > div:not(.rightContent) > .metricRows .MuiStack-root:not(:last-child) {\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--wild-sand, #dddddd);\n}\n.metricCard-component > div:not(.rightContent) > .metricRows .MuiStack-root:not(:first-child) {\n  margin-top: 1rem;\n}\n.metricCard-component > div:not(.rightContent) > .floatingRow {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}";
styleInject(css_248z$4);

function MetricCard(_a) {
    var _b, _c, _d, _e;
    var imgUrl = _a.imgUrl, heading = _a.heading, subHeading = _a.subHeading, _f = _a.metricRow, metricRow = _f === void 0 ? [] : _f, floatingRow = _a.floatingRow, _g = _a.variant, variant = _g === void 0 ? "card" : _g, className = _a.className, rightContent = _a.rightContent, sx = _a.sx;
    var classes = classNames("metricCard-component", variant, className, {
        "withImg": imgUrl,
        "withRightContent": !!rightContent
    });
    var subHeadingclasses = classNames("subHeading", variant, {
        "withProgress": !!(subHeading === null || subHeading === void 0 ? void 0 : subHeading.linearProgress)
    });
    return React__default.createElement(Card, { className: classes, sx: __assign({ borderRadius: variant === "plain" ? "0px" : imgUrl ? "48px" : "24px" }, sx) },
        React__default.createElement(Stack, null,
            imgUrl &&
                React__default.createElement("img", { src: imgUrl }),
            heading &&
                React__default.createElement(Stack, { direction: "row", className: "heading" },
                    (heading === null || heading === void 0 ? void 0 : heading.iconName) &&
                        React__default.createElement(Icon, { name: heading.iconName }),
                    React__default.createElement(Tooltip$1, { title: heading === null || heading === void 0 ? void 0 : heading.tooltip },
                        React__default.createElement(Typography$2, { variant: (heading === null || heading === void 0 ? void 0 : heading.variant) || "h3S", className: "".concat((heading === null || heading === void 0 ? void 0 : heading.tooltip) && "showTooltip") }, heading.name))),
            subHeading &&
                React__default.createElement(Stack, { direction: "row", className: subHeadingclasses, justifyContent: "space-between", alignItems: "center" },
                    React__default.createElement(Stack, { direction: "row", alignItems: "center" },
                        (subHeading === null || subHeading === void 0 ? void 0 : subHeading.linearProgress) &&
                            React__default.createElement(LinearProgress, { className: "progress", variant: "determinate", value: subHeading.linearProgress.value || 0, color: subHeading.linearProgress.color || "secondary" }),
                        (subHeading === null || subHeading === void 0 ? void 0 : subHeading.data) &&
                            React__default.createElement(Typography$2, { className: "data", variant: "h2L" }, subHeading.data),
                        (subHeading === null || subHeading === void 0 ? void 0 : subHeading.desc) &&
                            React__default.createElement(Box$1, { className: "desc" },
                                ((_b = subHeading.desc) === null || _b === void 0 ? void 0 : _b.name) &&
                                    React__default.createElement(Typography$2, { variant: ((_c = subHeading.desc) === null || _c === void 0 ? void 0 : _c.variant) || "body1L", className: "bold" }, subHeading.desc.name),
                                ((_d = subHeading.desc) === null || _d === void 0 ? void 0 : _d.support) &&
                                    React__default.createElement(Typography$2, { variant: ((_e = subHeading.desc) === null || _e === void 0 ? void 0 : _e.supportVariant) || "body2", noWrap: true, className: "regular" }, subHeading.desc.support))),
                    (subHeading === null || subHeading === void 0 ? void 0 : subHeading.chipComponent) && subHeading.chipComponent),
            (metricRow === null || metricRow === void 0 ? void 0 : metricRow.length) > 0 &&
                React__default.createElement(Box$1, { className: "metricRows" }, metricRow === null || metricRow === void 0 ? void 0 : metricRow.map(function (row, index) {
                    return React__default.createElement(Stack, { key: "metric-row-".concat(index), justifyContent: "space-between", sx: {
                            flexDirection: {
                                mobile: "column",
                                xs: "row"
                            }
                        } },
                        React__default.createElement(Typography$2, { variant: "body1L" }, row.name),
                        React__default.createElement(Typography$2, { variant: "body1L" }, row.data));
                })),
            floatingRow &&
                React__default.createElement(Box$1, { className: "floatingRow" }, floatingRow)),
        rightContent && React__default.createElement(Stack, { className: "rightContent" }, rightContent));
}

function Radio(_a) {
    var props = __rest(_a, []);
    return React__default.createElement(Radio$1, __assign({}, props));
}

var css_248z$3 = ".resourceEdit-component-v2 {\n  width: 100%;\n  padding-bottom: 1.5rem;\n}\n.resourceEdit-component-v2 .resource-heading {\n  flex: 1;\n  width: 100%;\n}\n.resourceEdit-component-v2 .resource-heading.editable {\n  cursor: pointer;\n}\n.resourceEdit-component-v2 .resource-heading .resource-title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.resourceEdit-component-v2 .resource-heading .statusCheckmark {\n  width: 24px;\n  height: 24px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 0.5rem;\n}\n.resourceEdit-component-v2 .resource-heading .statusCheckmark.valid {\n  background-color: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}\n.resourceEdit-component-v2 .resource-heading .statusCheckmark.warning {\n  background-color: var(--warning-brand-color, var(--orange, #FF9E0E));\n}\n.resourceEdit-component-v2 .resource-heading .statusCheckmark.error {\n  background-color: var(--error-brand-color, var(--rad-red, #FF4835));\n}\n.resourceEdit-component-v2 .resource-heading .statusCheckmark.empty {\n  background-color: var(--shade500, #939292);\n}";
styleInject(css_248z$3);

function ResourceEdit(_a) {
    var _b = _a.editable, editable = _b === void 0 ? false : _b, title = _a.title, desc = _a.desc, support = _a.support, status = _a.status, editableContent = _a.editableContent, className = _a.className, _c = _a.initOpen, initOpen = _c === void 0 ? false : _c;
    var _d = useState(initOpen), open = _d[0], setOpen = _d[1];
    function handleToggleOpen() {
        setOpen(!open);
    }
    return React__default.createElement(Stack$1, { className: "resourceEdit-component-v2 ".concat(className || ""), gap: 4 },
        React__default.createElement(Stack$1, { direction: "row", className: "resource-heading ".concat(editable ? "editable" : ""), justifyContent: "space-between", gap: 4, onClick: editable ? handleToggleOpen : undefined },
            React__default.createElement(Stack$1, { gap: 1 },
                React__default.createElement(Typography$1, { className: "resource-title", variant: "titleS" },
                    title,
                    " ",
                    status && React__default.createElement(Box, { className: "statusCheckmark ".concat(status || "") },
                        React__default.createElement(Icon, { name: status === "valid" ? "Checkmark10" : "X14", color: "white" }))),
                desc && React__default.createElement(Typography$1, { variant: "body1", color: "shade500.main" }, desc)),
            editable && React__default.createElement(Box, null,
                React__default.createElement(Button, { color: "body1", variant: 'text', iconOnly: true, onClick: handleToggleOpen },
                    React__default.createElement(Icon, { name: "Chevron18", sx: { transform: open ? "rotate(-180deg)" : "rotate(0deg)" } })))),
        React__default.createElement(Box, { className: "resource-content ".concat(open ? "open" : "hidden") }, !!editableContent && editableContent),
        React__default.createElement(Box, { className: "resource-support ".concat(!open ? "open" : "hidden") }, !!support && support));
}

var css_248z$2 = ".sideMenu-component-v2 {\n  z-index: 8000;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.sideMenu-component-v2 .sideMenu-spacer {\n  display: none;\n}\n.sideMenu-component-v2.minified:hover .sideMenu-spacer {\n  display: block;\n}\n.sideMenu-component-v2 .sideMenu-wrapper {\n  z-index: 8000;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  width: 20rem;\n  min-width: 20rem;\n  max-width: 20rem;\n  padding: 1rem;\n  background: var(--shade100, #F3F2F2);\n  position: relative;\n  box-sizing: border-box;\n}\n.sideMenu-component-v2 .sideMenu-wrapper::-webkit-scrollbar {\n  display: block;\n}\n.sideMenu-component-v2 .sideMenu-wrapper::-webkit-scrollbar-track:horizontal {\n  position: absolute;\n  bottom: -20px;\n}\n.sideMenu-component-v2 .sideMenu-wrapper::-webkit-scrollbar-track:vertical {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n.sideMenu-component-v2 .sideMenu-wrapper::-webkit-scrollbar-track {\n  height: 2.5rem;\n  width: 2.5rem;\n  padding: 2rem;\n  background-clip: content-box;\n  border-bottom-left-radius: 8px;\n}\n.sideMenu-component-v2 .sideMenu-wrapper::-webkit-scrollbar-thumb {\n  background: var(--body-font-color-2, var(--silver, #9B9B9B));\n  border-radius: 24px;\n  border-top: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-bottom: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-right: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n  border-left: 5px solid var(--background-color-1, var(--white, #FFFFFF));\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:hover {\n  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.15);\n  position: absolute !important;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) {\n  gap: 1rem;\n  max-width: 73px;\n  min-width: 73px;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .sideMenuHeader {\n  display: none;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .subNav-component-v2 button {\n  padding: 0.75rem;\n  margin-right: 0;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .subNav-component-v2 button:not(.selected) {\n  display: none;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .sideMenuContainer-component-v2 .menuItemRow .sideMenuItem-component-v2.subItem,\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .sideMenuContainer-component-v2 .menuItemRow .sideMenuItem-component-v2 .chevron {\n  display: none;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .sideMenuContainer-component-v2 .menuItemRow .sideMenuItem-component-v2 a {\n  justify-content: center;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .sideMenuContainer-component-v2 .menuItemRow .sideMenuItem-component-v2 a .MuiStack-root {\n  display: none;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .footer > .avatar-component-v2 {\n  display: block;\n}\n.sideMenu-component-v2 .sideMenu-wrapper.minified:not(:hover) .footer button {\n  display: none;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .sideMenuHeader {\n  margin-bottom: 1.5rem;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .sideMenuHeader .minifyIcon {\n  cursor: pointer;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .search-component-v2 {\n  margin-top: 1.5rem;\n  position: relative;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .search-component-v2 .inputContainer {\n  padding: 0.75rem 1rem;\n  box-shadow: unset;\n  border-radius: 8px;\n  border: 1px solid var(--shade200, #DBDADA);\n}\n.sideMenu-component-v2 .sideMenu-wrapper .search-component-v2:after {\n  position: absolute;\n  left: 0;\n  bottom: -1.5rem;\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1.5rem;\n  background: linear-gradient(var(--shade100, #F3F2F2) 0%, transparent 100%);\n}\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 {\n  width: 100%;\n  position: relative;\n  justify-content: space-between;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2:after {\n  position: absolute;\n  left: 0;\n  bottom: -1.5rem;\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1.5rem;\n  background: linear-gradient(var(--shade100, #F3F2F2) 0%, transparent 100%);\n}\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 button {\n  flex: 1;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 button:not(.selected):not(:hover) {\n  background: none;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 button:not(.selected):not(:hover) svg path:not(.noFill),\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 button:not(.selected):not(:hover) svg rect:not(.noFill) {\n  fill: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 button:not(.selected):not(:hover) svg path.noFill,\n.sideMenu-component-v2 .sideMenu-wrapper .subNav-component-v2 button:not(.selected):not(:hover) svg rect.noFill {\n  stroke: var(--secondary-brand-color, var(--teal, #0ABDAE));\n}\n.sideMenu-component-v2 .sideMenu-wrapper .sideMenuContainer-component-v2 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .footer {\n  position: relative;\n  justify-self: flex-end;\n}\n.sideMenu-component-v2 .sideMenu-wrapper .footer:before {\n  position: absolute;\n  left: 0;\n  top: -1.5rem;\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1.5rem;\n  background: linear-gradient(transparent 0, var(--shade100, #F3F2F2) 100%);\n}\n.sideMenu-component-v2 .sideMenu-wrapper .footer > .avatar-component-v2 {\n  display: none;\n}\n\n.sideMenuContainer-component-v2 {\n  flex: 1;\n  overflow-y: auto;\n}\n.sideMenuContainer-component-v2 .menuItemsContainer > .menuItemRow.withSubItems.openedSubMenu .sideMenuItem-component-v2:nth-child(2) {\n  margin-top: calc(0.5rem - 1px);\n}\n.sideMenuContainer-component-v2 .menuItemsContainer > .menuItemRow.withSubItems.openedSubMenu .sideMenuItem-component-v2:last-child {\n  margin-bottom: calc(0.5rem - 1px);\n}\n.sideMenuContainer-component-v2 .menuItemsContainer > .menuItemRow.subSection {\n  margin-top: 1rem;\n}\n.sideMenuContainer-component-v2 .menuItemsContainer > .menuItemRow:first-child {\n  margin-top: 0;\n}\n.sideMenuContainer-component-v2 .menuItemsContainer .sideMenuItem-component-v2.subItem {\n  margin-left: 2.75rem;\n}\n.sideMenuContainer-component-v2 .menuItemsContainer .sideMenuItem-component-v2.subItem a,\n.sideMenuContainer-component-v2 .menuItemsContainer .sideMenuItem-component-v2.subItem span {\n  font-size: 0.875rem;\n}\n.sideMenuContainer-component-v2 .menuItemsContainer .sideMenuItem-component-v2.rotate .chevron {\n  rotate: 180deg;\n}\n.sideMenuContainer-component-v2 .menuItemsContainer .sideMenuItem-component-v2.hasLocationSelected:hover a {\n  cursor: default;\n  background: unset !important;\n}\n\n.sideMenuItem-component-v2 {\n  box-sizing: border-box;\n}\n.sideMenuItem-component-v2:hover a, .sideMenuItem-component-v2.selected a {\n  background: var(--shade200, #DBDADA);\n}\n.sideMenuItem-component-v2.hasSubItemSelected > .MuiTypography-root .chevron {\n  rotate: -90deg;\n}\n.sideMenuItem-component-v2 .avatar-component-v2 .MuiAvatar-root {\n  border-color: var(--shade200, #DBDADA);\n  background: var(--white, #FFFFFF);\n}\n.sideMenuItem-component-v2 .chevron {\n  margin-left: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.sideMenuItem-component-v2 a {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 8px;\n  text-decoration: none !important;\n  gap: 1rem;\n}\n.sideMenuItem-component-v2 a > .MuiStack-root {\n  flex: 1;\n}\n.sideMenuItem-component-v2 a img {\n  max-width: 80px;\n}\n.sideMenuItem-component-v2.soloItem a {\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid var(--shade200, #DBDADA);\n}\n.sideMenuItem-component-v2.soloItem a:hover {\n  border-color: var(--wild-sand, #dddddd);\n}\n.sideMenuItem-component-v2.soloItem .chevron {\n  rotate: -90deg;\n}\n.sideMenuItem-component-v2.subSection {\n  padding: 0.5rem 0.75rem 0.5rem 0.75rem;\n}";
styleInject(css_248z$2);

//{ subNav, menuItems, bottomContent, className, forcedLocationPath, menuItemClick, children }: TSideMenu
function SideMenu(_a) {
    var logoUrl = _a.logoUrl, canMinify = _a.canMinify, children = _a.children, className = _a.className, onMouseLeave = _a.onMouseLeave;
    var _b = useState(false), isMinified = _b[0], setIsMinified = _b[1];
    function handleMinify() {
        setIsMinified(!isMinified);
    }
    function handleMouseLeave() {
        if (canMinify && isMinified) {
            onMouseLeave && onMouseLeave();
        }
    }
    var subClass = classNames("sideMenu-wrapper", className, {
        "minified": isMinified
    });
    return React__default.createElement(Stack$1, { className: "sideMenu-component-v2 ".concat(isMinified ? "minified" : ""), direction: "row", onMouseLeave: handleMouseLeave },
        isMinified && React__default.createElement(Box, { className: "sideMenu-spacer", sx: {
                width: 73,
                height: 73,
            } }),
        React__default.createElement(Stack$1, { className: subClass },
            (logoUrl || canMinify) &&
                React__default.createElement(Stack$1, { className: "sideMenuHeader", direction: "row", alignItems: "center", justifyContent: "space-between" },
                    logoUrl ? React__default.createElement(Logo, { url: logoUrl, className: "fullLogo" }) : React__default.createElement("div", null),
                    canMinify && React__default.createElement(Icon, { name: isMinified ? "TrayOpen18" : "TrayToggle18", className: "minifyIcon", onClick: handleMinify })),
            children));
}

function SideMenuItem(_a) {
    var item = _a.item, _b = _a.selected, selected = _b === void 0 ? false : _b, className = _a.className, menuItemClick = _a.menuItemClick, defaultItemIcon = _a.defaultItemIcon, _c = _a.variant, variant = _c === void 0 ? "" : _c;
    var mainClasses = classNames("sideMenuItem-component-v2", className, item.className, variant);
    return React__default.createElement(Tooltip, { title: item === null || item === void 0 ? void 0 : item.tooltipText, placement: "right" },
        React__default.createElement(Box$1, { className: mainClasses },
            variant === "" || variant === "soloItem" ?
                React__default.createElement(Link, { href: item.path, "data-name": item.name, onClick: menuItemClick },
                    item.prefix && React__default.cloneElement(item.prefix, { key: 'sideMenuItemPrefix' }),
                    item.icon && React__default.createElement(Icon, { name: item.icon }),
                    React__default.createElement(Stack$1, { alignItems: "flex-start", justifyContent: "center", flex: 1 },
                        React__default.createElement(Typography, { variant: "body2L", className: "title", color: "body1.main" },
                            " ",
                            item.text),
                        item.support && React__default.createElement(Typography, { variant: "body2S", className: "support", color: "body2.main" }, item.support)),
                    (defaultItemIcon !== false || selected || variant === "soloItem") && React__default.createElement(Box$1, { className: "chevron" },
                        React__default.createElement(Icon, { name: selected ? "Checkmark10" : defaultItemIcon || "Chevron10" })))
                :
                    React__default.createElement(React__default.Fragment, null, item.icon && React__default.createElement(Icon, { name: item.icon })),
            variant === "section" && React__default.createElement(Typography, { variant: "title" }, item.text),
            variant === "subSection" && React__default.createElement(Typography, { variant: "body2S", className: "uppercase" }, item.text)));
}

function SideMenuContainer(_a) {
    var menuItems = _a.menuItems, menuItemClick = _a.menuItemClick, forcedLocationPath = _a.forcedLocationPath, className = _a.className;
    var location = useLocation();
    var _b = useState([]), openedItems = _b[0], setOpenedItems = _b[1];
    function isSelected(value) {
        if (!value)
            return false;
        return (forcedLocationPath === null || forcedLocationPath === void 0 ? void 0 : forcedLocationPath.endsWith(value)) || location.hash.endsWith(value.replace("#", "")) || location.pathname.endsWith(value.replace("#", ""));
    }
    function handleMenuItemClick(event) {
        menuItemClick && menuItemClick(event);
    }
    function handleToggleSubMenu(event) {
        var itemName = event.currentTarget.getAttribute("data-name") || "";
        if (openedItems.includes(itemName)) {
            setOpenedItems(function (prev) { return prev.filter(function (i) { return i !== itemName; }); });
        }
        else {
            setOpenedItems(function (prev) { return __spreadArray(__spreadArray([], prev, true), [itemName], false); });
        }
    }
    return React__default.createElement(Stack$1, { className: classNames("sideMenuContainer-component-v2", className) },
        React__default.createElement(Stack$1, { className: "menuItemsContainer", gap: "1px" }, menuItems.map(function (i, mIndex) {
            var variant = i.variant || "";
            var selected = isSelected(i.path);
            var hasSubItemSelected = false;
            var subItems = i.subItems && i.subItems.map(function (s, sIndex) {
                var subSelected = isSelected(s.path);
                var subClasses = classNames({
                    "subItem": true,
                    "selected": subSelected,
                });
                if (subSelected) {
                    hasSubItemSelected = true;
                }
                return React__default.createElement(SideMenuItem, { item: s, defaultItemIcon: s.defaultItemIcon, menuItemClick: handleMenuItemClick, selected: subSelected, className: subClasses, key: "subItem-".concat(sIndex) });
            });
            var openedSubMenu = (hasSubItemSelected || openedItems.includes(i.name || ""));
            var classes = classNames({
                "selected": selected,
                "rotate": hasSubItemSelected || openedItems.includes(i.name || ""),
                "hasLocationSelected": hasSubItemSelected
            });
            return React__default.createElement(Stack$1, { key: "menuItemRow-".concat(mIndex), className: "menuItemRow ".concat(variant, " ").concat(!!i.subItems ? "withSubItems" : "", " ").concat(openedSubMenu ? "openedSubMenu" : ""), gap: "1px" },
                React__default.createElement(SideMenuItem, { item: i, variant: variant, defaultItemIcon: i.defaultItemIcon, menuItemClick: (subItems && (subItems === null || subItems === void 0 ? void 0 : subItems.length) > 0) ? handleToggleSubMenu : handleMenuItemClick, selected: selected, className: classes }),
                openedSubMenu && subItems);
        })));
}

function ColorTextField(_a) {
    var value = _a.value, onChange = _a.onChange, helperErrorText = _a.helperErrorText, error = _a.error, helperText = _a.helperText, _b = _a.pickerPosition, pickerPosition = _b === void 0 ? "top" : _b, args = __rest(_a, ["value", "onChange", "helperErrorText", "error", "helperText", "pickerPosition"]);
    var _c = useState(false), showPicker = _c[0], setShowPicker = _c[1];
    var _d = useState(false), sError = _d[0], setSError = _d[1];
    var colorRef = useRef("");
    function handleTxtFieldChange(e) {
        handleColorChangePicker(e.target.value, true);
    }
    function handleColorUpPicker() {
        onChange && onChange({ target: { value: colorRef.current, name: args.name }, currentTarget: { value: colorRef.current, name: args.name } });
    }
    function handleColorChangePicker(newColor, isTxtField) {
        if (isTxtField === void 0) { isTxtField = false; }
        if (newColor && !newColor.startsWith("#")) {
            newColor = "#".concat(newColor);
        }
        if (validateColor(newColor).error) {
            setSError(true);
        }
        else {
            setSError(false);
        }
        colorRef.current = newColor;
        if (onChange && isTxtField)
            onChange({ target: { value: newColor }, currentTarget: { value: newColor } });
    }
    return React__default.createElement(ClickAwayListener, { onClickAway: function () { return setShowPicker(false); } },
        React__default.createElement(Box, { className: "colorTextField-component-v2 ".concat(pickerPosition) },
            showPicker && React__default.createElement("div", { className: "colorPickerContainer" },
                React__default.createElement(HexColorPicker, { color: String(value) || "", onMouseUp: handleColorUpPicker, onChange: handleColorChangePicker })),
            React__default.createElement(Box, { className: "boxedColor", sx: { backgroundColor: value || "" } },
                " ",
                (!value || sError) && React__default.createElement(Icon, { name: "ColorWheel20" }),
                React__default.createElement(React__default.Fragment, null),
                " "),
            React__default.createElement(TextField, __assign({ error: sError || error, helperText: sError ? helperErrorText : helperText, value: value, onChange: handleTxtFieldChange, onFocus: function () { return setShowPicker(true); } }, args))));
}

function LocationTextField(_a) {
    var onChange = _a.onChange, onSelect = _a.onSelect, value = _a.value, args = __rest(_a, ["onChange", "onSelect", "value"]);
    return React__default.createElement(PlacesAutocomplete, { value: String(value), onChange: onChange, onSelect: onSelect || onChange }, function (_a) {
        var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
        var options = [
            {
                text: React__default.createElement("span", { style: { display: 'flex', justifyContent: "center" } },
                    React__default.createElement(CircularProgress, null))
            }
        ];
        if (!loading) {
            //@ts-ignore
            options = suggestions.map(function (suggestion) {
                var sugestionProps = getSuggestionItemProps(suggestion);
                return {
                    text: suggestion.description,
                    onClick: sugestionProps.onClick,
                    onMouseDown: sugestionProps.onMouseDown
                };
            });
        }
        return React__default.createElement("div", { className: 'locationTextField-component-v2' },
            React__default.createElement(TextField, __assign({}, getInputProps(), args)),
            options.length > 0 &&
                React__default.createElement("div", { className: "autocomplete-dropdown-container" },
                    React__default.createElement(DropMenu, { inlineMenu: true, className: "addressAutoCompleteMenu", options: options })));
    });
}

var PhoneTextField = function (_a) {
    var _b, _c;
    var value = _a.value, onChange = _a.onChange, _d = _a.defaultCountry, defaultCountry = _d === void 0 ? "ca" : _d, _e = _a.className, className = _e === void 0 ? "" : _e, restProps = __rest(_a, ["value", "onChange", "defaultCountry", "className"]);
    var foundCountry = (_c = (_b = Object.entries(getNameList())
        .find(function (c) { return (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.toLowerCase()) === c[0] || (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.toUpperCase()) === c[1]; })) === null || _b === void 0 ? void 0 : _b[1]) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    var _f = usePhoneInput({
        defaultCountry: foundCountry,
        value: value,
        countries: defaultCountries,
        onChange: function (data) {
            onChange(data.phone);
        },
    }), inputValue = _f.inputValue, handlePhoneValueChange = _f.handlePhoneValueChange, inputRef = _f.inputRef, country = _f.country, setCountry = _f.setCountry;
    useEffect(function () {
        setCountry(defaultCountry);
    }, [defaultCountry]);
    return (React__default.createElement(TextField, __assign({ value: inputValue, onChange: handlePhoneValueChange, type: "tel", inputRef: inputRef, className: "phoneTextField-component-v2 ".concat(className), 
        //@ts-ignore
        InputProps: {
            startAdornment: (React__default.createElement(InputAdornment, { position: "start", sx: { marginRight: 0 } },
                React__default.createElement(Select$1, { variant: 'standard', value: country.iso2, onChange: function (e) { return setCountry(e.target.value); }, renderValue: function (value) { return (React__default.createElement(FlagImage, { iso2: value, style: { display: 'flex' } })); }, MenuProps: {
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        }
                    } }, defaultCountries.map(function (c) {
                    var country = parseCountry(c);
                    return (React__default.createElement(MenuItem$1, { key: country.iso2, value: country.iso2 },
                        React__default.createElement(FlagImage, { iso2: country.iso2, style: { marginRight: '0.5rem' } }),
                        React__default.createElement(Typography$1, { marginRight: "0.5rem" }, country.name),
                        React__default.createElement(Typography$1, { color: "body2" },
                            "+",
                            country.dialCode)));
                })))),
        } }, restProps)));
};

var css_248z$1 = ".toggle-component-v2 {\n  width: 2.25rem;\n  border-radius: 100px;\n  display: flex;\n  cursor: pointer;\n}\n.toggle-component-v2:not(.small) {\n  padding: 0.5rem;\n}\n.toggle-component-v2:not(.small) .pill {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n.toggle-component-v2.small {\n  padding: 0.25rem;\n}\n.toggle-component-v2.small .pill {\n  width: 1rem;\n  height: 1rem;\n}\n.toggle-component-v2 input {\n  display: none;\n}\n.toggle-component-v2.on {\n  justify-content: flex-end;\n}\n.toggle-component-v2.on .pill {\n  background-color: var(--white, #FFFFFF);\n}\n.toggle-component-v2:not(.on) {\n  justify-content: flex-start;\n}\n.toggle-component-v2:not(.on) .pill {\n  background-color: var(--body-font-color, var(--dark-matter, #2B2B2B));\n}\n.toggle-component-v2 .pill {\n  position: relative;\n  border-radius: 100px;\n}";
styleInject(css_248z$1);

function Toggle(_a) {
    var className = _a.className, value = _a.value, initValue = _a.initValue, disabled = _a.disabled, name = _a.name, onChange = _a.onChange, color = _a.color, size = _a.size;
    var _b = useState(value !== undefined ? value : initValue !== undefined ? initValue : false), stateValue = _b[0], setStateValue = _b[1];
    var cValue = value !== undefined ? value : stateValue;
    function handleOnChange() {
        setStateValue(!cValue);
        onChange && onChange({ name: name, value: !cValue });
    }
    size = size || "medium";
    var classes = classNames("toggle-component-v2", size, className, {
        "on": cValue,
        "disabled": disabled
    });
    return React__default.createElement(Box$1, { className: classes, onClick: handleOnChange, sx: function (theme) {
            return {
                background: cValue === false ? theme.palette.shade100.main : theme.palette[color || "secondary"].main
            };
        } },
        React__default.createElement(Box$1, { className: "pill" }),
        React__default.createElement("input", { name: name, value: String(cValue) }));
}

var css_248z = ".topMenu-component-v2 {\n  border: 1px solid black;\n  padding: 0.75rem;\n  width: 100%;\n}\n.topMenu-component-v2 .menuItemsContainer .buttonMenu-component-v2 svg {\n  display: none;\n}";
styleInject(css_248z);

function TopMenu(_a) {
    var leftMenuItems = _a.leftMenuItems, rightMenuItems = _a.rightMenuItems, className = _a.className, logoUrl = _a.logoUrl;
    var location = useLocation();
    var _b = useState(undefined), anchor = _b[0], setAnchor = _b[1];
    var _c = useState(undefined), anchorName = _c[0], setAnchorName = _c[1];
    function handleAnchorClick(event, name) {
        event.preventDefault();
        setAnchorName(name);
        setAnchor(event.currentTarget);
    }
    function handleClose() {
        setAnchor(undefined);
        setAnchorName(undefined);
    }
    function fullMenuItems(items) {
        return items && (items === null || items === void 0 ? void 0 : items.filter(function (menuItem) {
            return !(menuItem === null || menuItem === void 0 ? void 0 : menuItem.hide) || false;
        }).map(function (menuItem, index) {
            var _a, _b, _c;
            if (menuItem.component === "content") {
                return menuItem.content;
            }
            var isActive = ((_a = location === null || location === void 0 ? void 0 : location.pathname) === null || _a === void 0 ? void 0 : _a.startsWith((menuItem === null || menuItem === void 0 ? void 0 : menuItem.href) || "")) || (menuItem === null || menuItem === void 0 ? void 0 : menuItem.active);
            var sx = {};
            menuItem.component = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.component) || "button";
            return React__default.createElement(React__default.Fragment, null,
                (menuItem === null || menuItem === void 0 ? void 0 : menuItem.component) === "button" &&
                    React__default.createElement("div", null,
                        React__default.createElement(Button, { key: "menu-" + index, onClick: function () { (menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick) ? menuItem === null || menuItem === void 0 ? void 0 : menuItem.onClick() : window.location.href = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.href) || "#"; }, variant: isActive ? "contained" : "text", color: isActive ? "cloud" : "primary", sx: sx, onMouseEnter: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) && ((_b = menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) === null || _b === void 0 ? void 0 : _b.length) > 0 ? function (e) { handleAnchorClick(e, menuItem === null || menuItem === void 0 ? void 0 : menuItem.name); } : undefined, className: "semiBold", startIcon: menuItem.iconName && React__default.createElement(Icon, { name: menuItem.iconName }) }, menuItem.text),
                        (menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) && ((_c = menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) === null || _c === void 0 ? void 0 : _c.length) > 0 && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.component) === "button" &&
                            React__default.createElement(DropMenu, { popoverProps: {
                                    anchorEl: anchor,
                                    open: !!anchor && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.name) === anchorName,
                                    onClose: handleClose,
                                }, options: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) || [] })),
                (menuItem === null || menuItem === void 0 ? void 0 : menuItem.component) === "dropdown" &&
                    React__default.createElement(ButtonMenu, { key: "menu-" + index, buttonProps: {
                            startIcon: menuItem.iconName && React__default.createElement(Icon, { name: menuItem.iconName }),
                            variant: "text",
                            color: "secondary",
                            name: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.name) || "",
                            sx: sx,
                            className: "semiBold",
                            //endIcon={<Icons name="micro-glyph-arrow-head" />}
                        }, options: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.items) || [] }, menuItem.text));
        }));
    }
    return React__default.createElement(Stack$2, { direction: "row", alignItems: "center", gap: 8, className: "topMenu-component-v2 ".concat(className || "") },
        React__default.createElement(Logo, { url: logoUrl }),
        React__default.createElement(Stack$2, { direction: "row", className: "menuItemsContainer" }, fullMenuItems(leftMenuItems)),
        React__default.createElement(Stack$2, { direction: "row", spacing: 2, justifySelf: "flex-end", display: "flex", flex: 1, justifyContent: "flex-end" }, fullMenuItems(rightMenuItems)));
}

var AccountsFactory = /** @class */ (function () {
    function AccountsFactory() {
    }
    AccountsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listAccounts(options).then(function (data) {
                        data.data = data.data.map(function (account) { return new AccountModel(account); });
                        return data;
                    })];
            });
        });
    };
    AccountsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getAccount({ id: id }).then(function (data) {
                        return new AccountModel(data.data);
                    })];
            });
        });
    };
    AccountsFactory.create = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var partnerId = _b.partnerId, account = _b.account;
            return __generator(this, function (_c) {
                return [2 /*return*/, createAccount({ partnerId: partnerId, account: account }).then(function (data) {
                        trackEvent(EEvents.ACCOUNT_CREATED, account);
                        return new AccountModel(data.data);
                    })];
            });
        });
    };
    AccountsFactory.whoAmi = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, whoAmi().then(function (data) {
                        return {
                            account: new AccountModel(data.data.account),
                            user: new UserModel(data.data.user)
                        };
                    })];
            });
        });
    };
    return AccountsFactory;
}());

var AutomationModel = /** @class */ (function () {
    function AutomationModel(automation) {
        this.id = automation.id || 0;
        this.name = automation.name || "";
        this.description = automation.description || "";
        this.status = automation.status || "inactive";
        this.paused = automation.paused || false;
        this.created_on = automation.created_on || 0;
        this.updated_on = automation.updated_on || 0;
        this.committed_on = automation.committed_on || null;
        this.committed_revision = automation.committed_revision || null;
        this.editor_version = automation.editor_version || "";
        this.lineage = automation.lineage || [];
        this.list_id = automation.list_id || 0;
        this.v1 = automation.v1;
        this.trigger = automation.trigger || [];
        this.main = automation.main || { steps: [] };
        this.sub_automations = automation.sub_automations || [];
    }
    AutomationModel.prototype.toJson = function () {
        return modelToJson(this, ["id"]);
    };
    AutomationModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    // note: fetch automation before saving if on a listings page
    AutomationModel.prototype.save = function (automation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, updateAnyAutomation({ id: this.id, data: automation, v1: this.v1 }).then(function (data) {
                        trackEvent(EEvents.AUTOMATION_UPDATED);
                        return new AutomationModel(data.data);
                    })];
            });
        });
    };
    AutomationModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, deleteAnyAutomation({ id: this.id, v1: this.v1 }).then(function (data) {
                        trackEvent(EEvents.AUTOMATION_DELETED);
                        return data.data;
                    })];
            });
        });
    };
    AutomationModel.prototype.getStats = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var path = _b.path;
            return __generator(this, function (_c) {
                return [2 /*return*/, getAutomationStats({ id: this.id, path: path }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    AutomationModel.getContent = function (contentId) {
        if (contentId === "scratchBee1") {
            return Promise.resolve({
                id: "scratchBee1",
                thumbnail: "/assets/images/campaigns/beeTemplate.png",
            });
        }
        return getAutomationEmailContent({ contentId: contentId }).then(function (data) {
            return data;
        });
    };
    return AutomationModel;
}());

var AutomationsFactory = /** @class */ (function () {
    function AutomationsFactory() {
    }
    AutomationsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getAutomation({ id: id }).then(function (data) {
                        return new AutomationModel(data.data);
                    })];
            });
        });
    };
    AutomationsFactory.getAutomationStats = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getAllAutomationStats(__assign({}, options))];
            });
        });
    };
    AutomationsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listAutomations(__assign({}, options)).then(function (response) { return (__assign(__assign({}, response), { data: response.data.map(function (automation) { return new AutomationModel(automation); }) })); })];
            });
        });
    };
    AutomationsFactory.listWorkflows = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listWorkflows(__assign({}, options)).then(function (response) { return (__assign(__assign({}, response), { data: response.data.map(function (automation) { return new AutomationModel(automation); }) })); })];
            });
        });
    };
    return AutomationsFactory;
}());

var BrandsFactory = /** @class */ (function () {
    function BrandsFactory() {
    }
    BrandsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id, _c = _b.compiled, compiled = _c === void 0 ? true : _c;
            return __generator(this, function (_d) {
                return [2 /*return*/, getBrand({ id: id, compiled: compiled })];
            });
        });
    };
    BrandsFactory.create = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id, _c = _b.brand, brand = _c === void 0 ? {} : _c, _d = _b.query, query = _d === void 0 ? {} : _d;
            return __generator(this, function (_e) {
                trackEvent(EEvents.BRAND_CREATED);
                return [2 /*return*/, createBrand({ id: id, brand: brand, query: query })];
            });
        });
    };
    BrandsFactory.enrichEmail = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var email = _b.email;
            return __generator(this, function (_c) {
                trackEvent(EEvents.BRAND_EMAIL_ENRICHED);
                return [2 /*return*/, enrichProfile({ email: email })];
            });
        });
    };
    BrandsFactory.enrichOrganization = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var domain = _b.domain;
            return __generator(this, function (_c) {
                trackEvent(EEvents.BRAND_ORGANIZATION_ENRICHED);
                return [2 /*return*/, enrichOrganization({ domain: domain })];
            });
        });
    };
    BrandsFactory.enrichBrand = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var domain = _b.domain;
            return __generator(this, function (_c) {
                trackEvent(EEvents.BRAND_ENRICHED);
                return [2 /*return*/, enrichBrand({ domain: domain })];
            });
        });
    };
    return BrandsFactory;
}());

var ECampaignStatuses;
(function (ECampaignStatuses) {
    ECampaignStatuses["active"] = "active";
    ECampaignStatuses["delivering"] = "delivering";
    ECampaignStatuses["delivered"] = "delivered";
    ECampaignStatuses["archived"] = "archived";
    ECampaignStatuses["deleted"] = "deleted";
    ECampaignStatuses["incomplete"] = "incomplete";
    ECampaignStatuses["scheduled"] = "scheduled";
})(ECampaignStatuses || (ECampaignStatuses = {}));

var ListCampaignModel = /** @class */ (function () {
    function ListCampaignModel(params) {
        this.id = params.id || 0;
        this.name = params.name || "";
        this.audience = params.audience || undefined;
        this.type = params.type || "standard";
        this.created_on = params.created_on || 0;
        this.scheduled_for = params.scheduled_for || 0;
        this.scheduled_on = params.scheduled_on || 0;
        this.updated_on = params.updated_on || 0;
        this.sender = params.sender || undefined;
        this.next_building_step = params.next_building_step || "";
        this.status = params.status || ECampaignStatuses.incomplete;
        this.suspended = params.suspended || false;
        this.web_email_link = params.web_email_link || "";
        this.thumbnail_url = params.thumbnail_url || "";
        this.over_limit = params.over_limit || false;
        this.under_review = params.under_review || false;
    }
    ListCampaignModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    ListCampaignModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    ListCampaignModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, deleteCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_DELETED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.save = function (campaign) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Campaign was not initialized");
                }
                if (!campaign) {
                    campaign = this.toJson();
                    campaign === null || campaign === void 0 ? true : delete campaign.sender;
                }
                return [2 /*return*/, updateCampaign({ campaign: campaign, id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_UPDATED, { id: _this.id });
                        return new CampaignModel(data.data);
                    })];
            });
        });
    };
    ListCampaignModel.prototype.render = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var contactId = _b.contactId;
            return __generator(this, function (_c) {
                return [2 /*return*/, renderCampaign({ id: this.id, contactId: contactId })];
            });
        });
    };
    ListCampaignModel.prototype.sendTest = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var _this = this;
            var email = _b.email, _c = _b.type, type = _c === void 0 ? "merged" : _c;
            return __generator(this, function (_d) {
                return [2 /*return*/, sendCampaignTest({ id: this.id, email: email, type: type }).then(function (data) {
                        trackEvent(EEvents.TEST_EMAIL_SENT, {
                            email: email,
                            campaign_id: _this.id
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.schedule = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var _this = this;
            var date = _b.date, htmlEmpty = _b.htmlEmpty;
            return __generator(this, function (_c) {
                return [2 /*return*/, scheduleCampaign({ id: this.id, date: date, htmlEmpty: htmlEmpty }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_SCHEDULED, {
                            campaign_id: _this.id,
                            scheduled_for: date
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.unSchedule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, unScheduleCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_UNSCHEDULED, {
                            campaign_id: _this.id,
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.reSchedule = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var _this = this;
            var date = _b.date, htmlEmpty = _b.htmlEmpty;
            return __generator(this, function (_c) {
                return [2 /*return*/, reScheduleCampaign({ id: this.id, date: date, htmlEmpty: htmlEmpty }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_RESCHEDULED, {
                            campaign_id: _this.id,
                            scheduled_for: date
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.suspend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, suspendCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_SUSPENDED, {
                            campaign_id: _this.id
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.resume = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, resumeCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_RESUMED, {
                            campaign_id: _this.id
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, cancelCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_CANCELED, {
                            campaign_id: _this.id
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.archive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, archiveCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_ARCHIVED, {
                            campaign_id: _this.id
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.unArchive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, unArchiveCampaign({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_UNARCHIVED, {
                            campaign_id: _this.id
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.getRevisions = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getCampaignRevisions({ id: this.id, options: options })];
            });
        });
    };
    ListCampaignModel.prototype.listLinks = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getCampaignLinks({ id: this.id, options: options })];
            });
        });
    };
    ListCampaignModel.prototype.listLogs = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getCampaignLogs({ id: this.id, options: options })];
            });
        });
    };
    ListCampaignModel.prototype.listLogExports = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getCampaignLogs({ id: this.id, options: options })];
            });
        });
    };
    ListCampaignModel.prototype.createLogExports = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var _this = this;
            var description = _b.description, filter = _b.filter;
            return __generator(this, function (_c) {
                return [2 /*return*/, createCampaignLogsExports({ id: this.id, description: description, filter: filter }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_LOG_EXPORT, {
                            campaign_id: _this.id,
                            description: description,
                            filter: filter
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.downloadLogExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var _this = this;
            var exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, downloadCampaignLogExport({ campaignId: this.id, exportId: exportId }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_LOG_DOWNLOAD, {
                            campaign_id: _this.id,
                            export_id: exportId
                        });
                        return data;
                    })];
            });
        });
    };
    ListCampaignModel.prototype.getReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getCampaignReport({ id: this.id })];
            });
        });
    };
    ListCampaignModel.prototype.getLinkReport = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getCampaignLinks({ id: this.id, options: options })];
            });
        });
    };
    return ListCampaignModel;
}());
var CampaignModel = /** @class */ (function (_super) {
    __extends(CampaignModel, _super);
    function CampaignModel(params) {
        var _this = _super.call(this, params) || this;
        _this.tracking = params.tracking || {
            additional_params: "",
            clicks_html: true,
            clicks_text: true,
            opens: true
        };
        _this.delivery_finished_on = params.delivery_finished_on || 0;
        _this.reply_to_email = params.reply_to_email || undefined;
        _this.content = params.content || {};
        _this.heatmap_link = params.heatmap_link || "";
        return _this;
    }
    return CampaignModel;
}(ListCampaignModel));

var CampaignsFactory = /** @class */ (function () {
    function CampaignsFactory() {
    }
    CampaignsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listCampaigns(options).then(function (data) {
                        data.data = data.data.map(function (campaign) { return new ListCampaignModel(campaign); });
                        return data;
                    })];
            });
        });
    };
    CampaignsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getCampaign({ id: id }).then(function (data) {
                        return new CampaignModel(data.data);
                    })];
            });
        });
    };
    CampaignsFactory.create = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var campaign = _b.campaign;
            return __generator(this, function (_c) {
                return [2 /*return*/, createCampaign({ campaign: campaign }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_CREATED, {
                            name: data.data.name
                        });
                        return new CampaignModel(data.data);
                    })];
            });
        });
    };
    CampaignsFactory.listReportsExports = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listCampaignsReportsExports({ options: options })];
            });
        });
    };
    CampaignsFactory.createReportsExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var description = _b.description;
            return __generator(this, function (_c) {
                trackEvent(EEvents.CAMPAIGNS_REPORTS_EXPORT);
                return [2 /*return*/, createCampaignsReportsExport({ description: description })];
            });
        });
    };
    CampaignsFactory.getReportExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, getCampaignsReportsExport({ exportId: exportId })];
            });
        });
    };
    CampaignsFactory.deleteReportExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, deleteCampaignsReportsExport({ exportId: exportId })];
            });
        });
    };
    CampaignsFactory.downloadReportExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, downloadCampaignsReportsExport({ exportId: exportId }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGNS_REPORTS_EXPORT_DOWNLOAD);
                        return data;
                    })];
            });
        });
    };
    CampaignsFactory.downloadCampaignLogExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var exportId = _b.exportId, campaignId = _b.campaignId;
            return __generator(this, function (_c) {
                return [2 /*return*/, downloadCampaignLogExport({ exportId: exportId, campaignId: campaignId }).then(function (data) {
                        trackEvent(EEvents.CAMPAIGN_LOG_DOWNLOAD, {
                            campaign_id: campaignId,
                            export_id: exportId
                        });
                        return data;
                    })];
            });
        });
    };
    return CampaignsFactory;
}());

var ContactModel = /** @class */ (function () {
    function ContactModel(params) {
        this.id = params.id;
        this.email = params.email;
        this.status = params.status;
        this.subscribed_on = params.subscribed_on;
        this.last_bounce_type = params.last_bounce_type;
        this.bounces_count = params.bounces_count;
        this.custom_attributes = params.custom_attributes;
        this.tags = params.tags;
        this.interests = params.interests;
    }
    ContactModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    ContactModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    return ContactModel;
}());

var ContactsFactory = /** @class */ (function () {
    function ContactsFactory() {
    }
    ContactsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listContacts(options).then(function (data) {
                        data.data = data.data.map(function (contact) { return new ContactModel(contact); });
                        return data;
                    })];
            });
        });
    };
    return ContactsFactory;
}());

var EEmailAttachementTypes;
(function (EEmailAttachementTypes) {
    EEmailAttachementTypes["csv"] = "csv";
    EEmailAttachementTypes["doc"] = "doc";
    EEmailAttachementTypes["docx"] = "docx";
    EEmailAttachementTypes["calendar"] = "calendar";
    EEmailAttachementTypes["jpeg"] = "jpeg";
    EEmailAttachementTypes["pdf"] = "pdf";
    EEmailAttachementTypes["png"] = "png";
    EEmailAttachementTypes["xls"] = "xls";
    EEmailAttachementTypes["xlsx"] = "xlsx";
})(EEmailAttachementTypes || (EEmailAttachementTypes = {}));
var EEmailStatuses;
(function (EEmailStatuses) {
    EEmailStatuses["submitted"] = "submitted";
    EEmailStatuses["delivered"] = "delivered";
    EEmailStatuses["queued"] = "queued";
    EEmailStatuses["rejected"] = "rejected";
    EEmailStatuses["error"] = "error";
    EEmailStatuses["bounced"] = "bounced";
    EEmailStatuses["spam"] = "spam";
    EEmailStatuses["unsubscribed"] = "unsubscribed";
    EEmailStatuses["global_unsubscribed"] = "global_unsubscribed";
    EEmailStatuses["other"] = "other";
})(EEmailStatuses || (EEmailStatuses = {}));

var Email = /** @class */ (function () {
    function Email(params) {
        this.email_id = params.email_id;
        this.email = params.email;
        this.status = params.status;
        this.provider = params.provider;
        this.submitted_time = params.submitted_time;
        this.unsubscribed = params.unsubscribed;
        this.global_unsubscribed = params.global_unsubscribed;
        this.soft_bounced = params.soft_bounced;
        this.hard_bounced = params.hard_bounced;
        this.reported_as_spam = params.reported_as_spam;
        this.open = params.open;
        this.click = params.click;
        this.list_id = params.list_id;
        this.sender = params.sender;
        this.content = params.content;
        this.tracking = params.tracking;
        this.additional_headers = params.additional_headers;
        this.tags = params.tags;
        this.thumbnail_url = params.thumbnail_url;
    }
    Email.prototype.toJson = function () {
        return modelToJson(this);
    };
    Email.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    Email.prototype.listLogs = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                if (options.filter) {
                    options.filter += ";email_id==" + this.email_id;
                }
                else {
                    options.filter = "email_id==" + this.email_id;
                }
                return [2 /*return*/, listEmailLogs(options)];
            });
        });
    };
    Email.prototype.getReport = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getEmailReport(options).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    Email.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, renderEmail({ id: this.email_id.toString() })];
            });
        });
    };
    return Email;
}());

var EEmailLogType;
(function (EEmailLogType) {
    EEmailLogType["submitted"] = "submitted";
    EEmailLogType["processing"] = "processing";
    EEmailLogType["click"] = "click";
    EEmailLogType["open"] = "open";
    EEmailLogType["bounce"] = "bounce";
    EEmailLogType["spam"] = "spam";
    EEmailLogType["unsubscribe"] = "unsubscribe";
    EEmailLogType["global_unsubscribe"] = "global_unsubscribe";
    EEmailLogType["global_unsubscribe_reason"] = "global_unsubscribe_reason";
    EEmailLogType["delivered"] = "delivered";
    EEmailLogType["rejected"] = "rejected";
    EEmailLogType["queued"] = "queued";
    EEmailLogType["error"] = "error";
    EEmailLogType["other"] = "other";
})(EEmailLogType || (EEmailLogType = {}));

//TODO refactor factoiry, it is not a factory if it outputs more than its job
var EmailAPIFactory = /** @class */ (function () {
    function EmailAPIFactory() {
    }
    EmailAPIFactory.listTags = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, lisTEmailTags(options)];
            });
        });
    };
    EmailAPIFactory.listLogs = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listEmailLogs(options)];
            });
        });
    };
    EmailAPIFactory.getReport = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getEmailReport(options).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    EmailAPIFactory.getEmail = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getEmail({ id: id }).then(function (data) {
                        return new Email(data);
                    })];
            });
        });
    };
    EmailAPIFactory.getEmailActivitySummary = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, getEmailActivitySummary(options)];
            });
        });
    };
    return EmailAPIFactory;
}());

var CommonFormModel = /** @class */ (function () {
    function CommonFormModel(_a) {
        var id = _a.id, name = _a.name, list_id = _a.list_id, double_opt_in = _a.double_opt_in;
        this.id = id;
        this.name = name;
        this.list_id = list_id;
        this.double_opt_in = double_opt_in;
    }
    CommonFormModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    CommonFormModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    CommonFormModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, deleteForm({ id: this.id.toString() }).then(function (data) {
                        trackEvent(EEvents.FORM_DELETED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    CommonFormModel.prototype.save = function (form) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Form was not initialized");
                }
                return [2 /*return*/, patchForm({ id: this.id.toString(), data: form || this.toJson() }).then(function (data) {
                        trackEvent(EEvents.FORM_UPDATED, { id: _this.id });
                        return data.data;
                    })];
            });
        });
    };
    return CommonFormModel;
}());
var FormModel = /** @class */ (function (_super) {
    __extends(FormModel, _super);
    function FormModel(_a) {
        var id = _a.id, name = _a.name, status = _a.status, content = _a.content, language = _a.language, created_on = _a.created_on, last_updated_on = _a.last_updated_on, url = _a.url, thumbnail_url = _a.thumbnail_url, redirections = _a.redirections, list_id = _a.list_id, double_opt_in = _a.double_opt_in;
        var _this = _super.call(this, { id: id, name: name, list_id: list_id, double_opt_in: double_opt_in }) || this;
        _this.status = status;
        _this.content = content;
        _this.language = language;
        _this.created_on = created_on;
        _this.last_updated_on = last_updated_on;
        _this.url = url;
        _this.thumbnail_url = thumbnail_url;
        _this.redirections = redirections;
        return _this;
    }
    FormModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    FormModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    return FormModel;
}(CommonFormModel));
var SummaryEnhancedFormModel = /** @class */ (function (_super) {
    __extends(SummaryEnhancedFormModel, _super);
    function SummaryEnhancedFormModel(_a) {
        var id = _a.id, list_id = _a.list_id, enabled = _a.enabled, name = _a.name, description = _a.description, tags = _a.tags, post_redirect_url = _a.post_redirect_url, double_opt_in = _a.double_opt_in, double_opt_in_redirect_url = _a.double_opt_in_redirect_url, submission_url = _a.submission_url, async_processing = _a.async_processing, branding = _a.branding, created_on = _a.created_on, updated_on = _a.updated_on, published_on = _a.published_on, edited_by = _a.edited_by, thumbnail_url = _a.thumbnail_url, recaptcha = _a.recaptcha, published_url = _a.published_url;
        var _this = _super.call(this, { id: id, name: name, list_id: list_id, double_opt_in: double_opt_in }) || this;
        _this.enabled = enabled;
        _this.description = description;
        _this.tags = tags;
        _this.post_redirect_url = post_redirect_url;
        _this.double_opt_in_redirect_url = double_opt_in_redirect_url;
        _this.submission_url = submission_url;
        _this.async_processing = async_processing;
        _this.branding = branding;
        _this.created_on = created_on;
        _this.updated_on = updated_on;
        _this.published_on = published_on;
        _this.edited_by = edited_by;
        _this.thumbnail_url = thumbnail_url;
        _this.recaptcha = recaptcha;
        _this.published_url = published_url;
        return _this;
    }
    SummaryEnhancedFormModel.prototype.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Form was not initialized");
                }
                return [2 /*return*/, enableForm({ id: this.id.toString() }).then(function (data) {
                        trackEvent(EEvents.FORM_ENABLED, { id: _this.id });
                        return data.data;
                    })];
            });
        });
    };
    SummaryEnhancedFormModel.prototype.disable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Form was not initialized");
                }
                return [2 /*return*/, disableForm({ id: this.id.toString() }).then(function (data) {
                        trackEvent(EEvents.FORM_DISABLED, { id: _this.id });
                        return data.data;
                    })];
            });
        });
    };
    SummaryEnhancedFormModel.prototype.publish = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Form was not initialized");
                }
                return [2 /*return*/, publishForm({ id: this.id.toString() }).then(function (data) {
                        trackEvent(EEvents.FORM_PUBLISHED, { id: _this.id });
                        return data.data;
                    })];
            });
        });
    };
    SummaryEnhancedFormModel.prototype.render = function () {
        return __awaiter(this, arguments, void 0, function (published) {
            var _this = this;
            if (published === void 0) { published = false; }
            return __generator(this, function (_a) {
                if (!this.id) {
                    throw new Error("Form was not initialized");
                }
                return [2 /*return*/, renderForm({ id: this.id.toString(), published: published }).then(function (data) {
                        trackEvent(published ? EEvents.FORM_RENDERED_PUBLISHED : EEvents.FORM_RENDERED, { id: _this.id });
                        return data.data;
                    })];
            });
        });
    };
    SummaryEnhancedFormModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    SummaryEnhancedFormModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    return SummaryEnhancedFormModel;
}(CommonFormModel));
var EnhancedFormModel = /** @class */ (function (_super) {
    __extends(EnhancedFormModel, _super);
    function EnhancedFormModel(_a) {
        var _this = this;
        var content = _a.content, rest = __rest(_a, ["content"]);
        _this = _super.call(this, rest) || this;
        _this.content = content;
        return _this;
    }
    EnhancedFormModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    return EnhancedFormModel;
}(SummaryEnhancedFormModel));

var EListAttributeType;
(function (EListAttributeType) {
    EListAttributeType["text"] = "text";
    EListAttributeType["mediumtext"] = "mediumtext";
    EListAttributeType["integer"] = "integer";
    EListAttributeType["timestamp"] = "timestamp";
    EListAttributeType["datetime"] = "datetime";
})(EListAttributeType || (EListAttributeType = {}));

var ListModel = /** @class */ (function () {
    function ListModel(params) {
        this.id = params.id;
        this.name = params.name;
        this.status = params.status;
        this.policy_accepted = params.policy_accepted;
        this.language = params.language;
        this.created_on = params.created_on;
        this.default_sender = params.default_sender;
        this.redirections = params.redirections;
        this.pages = params.pages;
        this.webhook = params.webhook;
    }
    ListModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    ListModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    ListModel.prototype.acceptPolicy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, acceptListPolicy({ id: this.id })];
            });
        });
    };
    ListModel.prototype.save = function (list) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, saveList({ id: this.id, list: list }).then(function (data) {
                        trackEvent(EEvents.LIST_UPDATED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    ListModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, deleteList({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.LIST_DELETED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    ListModel.prototype.getAttributes = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, listListAttributes(__assign({ id: this.id }, options))];
            });
        });
    };
    ListModel.prototype.getInterests = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, listListInterests(__assign({ id: this.id }, options))];
            });
        });
    };
    ListModel.prototype.getReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getListReport({ id: this.id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    return ListModel;
}());

var EPageBranding;
(function (EPageBranding) {
    EPageBranding["smart"] = "smart";
    EPageBranding["basic"] = "basic";
})(EPageBranding || (EPageBranding = {}));

var ListPageModel = /** @class */ (function () {
    function ListPageModel(params) {
        this.id = params.id;
        this.name = params.name;
        this.list_id = params.list_id;
        this.account_id = params.account_id;
        this.slug = params.slug;
        this.description = params.description;
        this.enabled = params.enabled;
        this.created_on = params.created_on;
        this.updated_on = params.updated_on;
        this.published_on = params.published_on;
        this.branding = params.branding;
        this.tags = params.tags;
        this.edited_by = params.edited_by;
        this.seo = params.seo;
        this.tracking = params.tracking;
        this.popups = params.popups;
        this.form_id = params.form_id;
        this.thumbnail_url = params.thumbnail_url;
        this.published_url = params.published_url;
    }
    ListPageModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    ListPageModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    ListPageModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, deletePage({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.PAGE_DELETED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    ListPageModel.prototype.save = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var dataToUpdate;
            var _this = this;
            return __generator(this, function (_a) {
                dataToUpdate = page || this.toJson();
                return [2 /*return*/, updatePage({ id: this.id, page: dataToUpdate }).then(function (data) {
                        trackEvent(EEvents.PAGE_UPDATED, {
                            id: _this.id,
                            name: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.name,
                            list_id: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.list_id,
                            form_id: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.form_id,
                            branding: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.branding,
                        });
                        return new PageModel(data.data);
                    })];
            });
        });
    };
    ListPageModel.prototype.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, enablePage({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.PAGE_ENABLED, { id: _this.id });
                        return new PageModel(data.data);
                    })];
            });
        });
    };
    ListPageModel.prototype.disable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, disablePage({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.PAGE_DISABLED, { id: _this.id });
                        return new PageModel(data.data);
                    })];
            });
        });
    };
    ListPageModel.prototype.publish = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, publishPage({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.PAGE_PUBLISHED, { id: _this.id });
                        return new PageModel(data.data);
                    })];
            });
        });
    };
    ListPageModel.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, renderPage({ id: this.id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    return ListPageModel;
}());
var PageModel = /** @class */ (function (_super) {
    __extends(PageModel, _super);
    function PageModel(params) {
        var _this = _super.call(this, params) || this;
        _this.content = params.content;
        return _this;
    }
    PageModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    return PageModel;
}(ListPageModel));

var EPopupTriggerType;
(function (EPopupTriggerType) {
    EPopupTriggerType["on_page_load"] = "on_page_load";
    EPopupTriggerType["on_exit_intent"] = "on_exit_intent";
    EPopupTriggerType["on_scroll"] = "on_scroll";
    EPopupTriggerType["on_time_delay"] = "on_time_delay";
    EPopupTriggerType["on_click"] = "on_click";
})(EPopupTriggerType || (EPopupTriggerType = {}));
var EPopupDisplayFrequency;
(function (EPopupDisplayFrequency) {
    EPopupDisplayFrequency["once_per_session"] = "once_per_session";
    EPopupDisplayFrequency["once_per_day"] = "once_per_day";
    EPopupDisplayFrequency["once_per_week"] = "once_per_week";
    EPopupDisplayFrequency["always"] = "always";
    EPopupDisplayFrequency["once"] = "once";
})(EPopupDisplayFrequency || (EPopupDisplayFrequency = {}));
var EPopupDeviceType;
(function (EPopupDeviceType) {
    EPopupDeviceType["desktop"] = "desktop";
    EPopupDeviceType["mobile"] = "mobile";
    EPopupDeviceType["tablet"] = "tablet";
})(EPopupDeviceType || (EPopupDeviceType = {}));
var EPopupBrowserType;
(function (EPopupBrowserType) {
    EPopupBrowserType["chrome"] = "chrome";
    EPopupBrowserType["firefox"] = "firefox";
    EPopupBrowserType["safari"] = "safari";
    EPopupBrowserType["edge"] = "edge";
    EPopupBrowserType["opera"] = "opera";
    EPopupBrowserType["other"] = "other";
})(EPopupBrowserType || (EPopupBrowserType = {}));
var EPopupPosition;
(function (EPopupPosition) {
    EPopupPosition["center"] = "classic-center";
    EPopupPosition["top_right"] = "classic-top-right";
    EPopupPosition["top_left"] = "classic-top-left";
    EPopupPosition["bottom_left"] = "classic-bottom-left";
    EPopupPosition["bottom_right"] = "classic-bottom-right";
    EPopupPosition["drawer_left"] = "drawer-left";
    EPopupPosition["drawer_right"] = "drawer-right";
    EPopupPosition["drawer_top"] = "bar-top";
    EPopupPosition["drawer_bottom"] = "bar-bottom";
})(EPopupPosition || (EPopupPosition = {}));
var EPopupCloseButtonPosition;
(function (EPopupCloseButtonPosition) {
    EPopupCloseButtonPosition["top_right"] = "top-right";
    EPopupCloseButtonPosition["top_left"] = "top-left";
    EPopupCloseButtonPosition["bottom_right"] = "bottom-right";
    EPopupCloseButtonPosition["bottom_left"] = "bottom-left";
})(EPopupCloseButtonPosition || (EPopupCloseButtonPosition = {}));
var EPopupBranding;
(function (EPopupBranding) {
    EPopupBranding["smart"] = "smart";
    EPopupBranding["basic"] = "basic";
})(EPopupBranding || (EPopupBranding = {}));

var ListPopupModel = /** @class */ (function () {
    function ListPopupModel(params) {
        this.id = params.id;
        this.list_id = params.list_id;
        this.form_id = params.form_id;
        this.account_id = params.account_id;
        this.name = params.name;
        this.description = params.description;
        this.enabled = params.enabled;
        this.created_on = params.created_on;
        this.updated_on = params.updated_on;
        this.published_on = params.published_on;
        this.branding = params.branding;
        this.tags = params.tags;
        this.edited_by = params.edited_by;
        this.content = params.content;
        this.trigger = params.trigger;
        this.targeting = params.targeting;
        this.display_frequency = params.display_frequency;
        this.thumbnail_url = params.thumbnail_url;
        this.overlay = params.overlay;
        this.closeButton = params.closeButton;
    }
    ListPopupModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    ListPopupModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    ListPopupModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, deletePopup({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.POPUP_DELETED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    ListPopupModel.prototype.save = function (popup) {
        return __awaiter(this, void 0, void 0, function () {
            var dataToUpdate;
            var _this = this;
            return __generator(this, function (_a) {
                dataToUpdate = popup || this.toJson();
                return [2 /*return*/, updatePopup({ id: this.id, popup: dataToUpdate }).then(function (data) {
                        trackEvent(EEvents.POPUP_UPDATED, {
                            id: _this.id,
                            name: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.name,
                            list_id: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.list_id,
                            form_id: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.form_id,
                            branding: dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.branding,
                        });
                        return new PopupModel(data.data);
                    })];
            });
        });
    };
    ListPopupModel.prototype.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, enablePopup({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.POPUP_ENABLED, { id: _this.id });
                        return new PopupModel(data.data);
                    })];
            });
        });
    };
    ListPopupModel.prototype.disable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, disablePopup({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.POPUP_DISABLED, { id: _this.id });
                        return new PopupModel(data.data);
                    })];
            });
        });
    };
    ListPopupModel.prototype.publish = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, publishPopup({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.POPUP_PUBLISHED, { id: _this.id });
                        return new PopupModel(data.data);
                    })];
            });
        });
    };
    ListPopupModel.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, renderPopup({ id: this.id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    return ListPopupModel;
}());
var PopupModel = /** @class */ (function (_super) {
    __extends(PopupModel, _super);
    function PopupModel(params) {
        var _this = _super.call(this, params) || this;
        _this.content = params.content;
        return _this;
    }
    PopupModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    return PopupModel;
}(ListPopupModel));

var SenderModel = /** @class */ (function () {
    function SenderModel(_a) {
        var id = _a.id, name = _a.name, email = _a.email, confirmed = _a.confirmed, confirmed_on = _a.confirmed_on, language = _a.language, last_confirmation_sent_on = _a.last_confirmation_sent_on;
        this.id = id;
        this.name = name;
        this.email = email;
        this.confirmed = confirmed;
        this.confirmed_on = confirmed_on;
        this.language = language;
        this.last_confirmation_sent_on = last_confirmation_sent_on;
    }
    SenderModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    SenderModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    return SenderModel;
}());

var SystemEmailsModel = /** @class */ (function () {
    function SystemEmailsModel(_a) {
        var account_confirm = _a.account_confirm, user_confirm = _a.user_confirm, sender_confirm = _a.sender_confirm, password_reset = _a.password_reset, contact_double_opt_in = _a.contact_double_opt_in;
        this.account_confirm = account_confirm;
        this.user_confirm = user_confirm;
        this.sender_confirm = sender_confirm;
        this.password_reset = password_reset;
        this.contact_double_opt_in = contact_double_opt_in;
    }
    SystemEmailsModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    SystemEmailsModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    return SystemEmailsModel;
}());

var ETaskType;
(function (ETaskType) {
    ETaskType["contacts_export"] = "contactsexport";
    ETaskType["campaign_logs_export"] = "campaignlogexport";
    ETaskType["campaigns_reports_export"] = "campaignsreportsexport";
    ETaskType["suppressed_emails_export"] = "suppressedemailsexport";
    ETaskType["list_logs_export"] = "listlogsexport";
})(ETaskType || (ETaskType = {}));

var ListTemplateModel = /** @class */ (function () {
    function ListTemplateModel(params) {
        var _a;
        this.id = (params === null || params === void 0 ? void 0 : params.id) || 0;
        this.name = (params === null || params === void 0 ? void 0 : params.name) || "";
        this.created_on = (params === null || params === void 0 ? void 0 : params.created_on) || 0;
        this.updated_on = (params === null || params === void 0 ? void 0 : params.updated_on) || 0;
        this.tags = (params === null || params === void 0 ? void 0 : params.tags) || [];
        this.sharing = (params === null || params === void 0 ? void 0 : params.sharing) ? {
            shared: ((_a = params === null || params === void 0 ? void 0 : params.sharing) === null || _a === void 0 ? void 0 : _a.shared) || false,
        } : undefined;
        this.thumbnail_url = (params === null || params === void 0 ? void 0 : params.thumbnail_url) || "";
        this.description = (params === null || params === void 0 ? void 0 : params.description) || "";
        this.is_owner = typeof (params === null || params === void 0 ? void 0 : params.is_owner) === "boolean" ? params === null || params === void 0 ? void 0 : params.is_owner : false;
    }
    ListTemplateModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    ListTemplateModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    ListTemplateModel.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getTemplate({ id: this.id }).then(function (data) {
                        return new TemplateModel(data.data);
                    })];
            });
        });
    };
    ListTemplateModel.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, deleteTemplate({ id: this.id }).then(function (data) {
                        trackEvent(EEvents.TEMPLATE_DELETED, { id: _this.id });
                        return data;
                    })];
            });
        });
    };
    ListTemplateModel.prototype.render = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var brandAccountId = _b.brandAccountId;
            return __generator(this, function (_c) {
                return [2 /*return*/, renderTemplate({ id: this.id, brandAccountId: brandAccountId })];
            });
        });
    };
    ListTemplateModel.prototype.share = function () {
        return __awaiter(this, arguments, void 0, function (_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, accounts = _b.accounts, everyone = _b.everyone, automatic = _b.automatic;
            return __generator(this, function (_c) {
                return [2 /*return*/, shareTemplate({ id: this.id, accounts: accounts, everyone: everyone, automatic: automatic }).then(function () {
                        trackEvent(EEvents.TEMPLATE_SHARED, { id: _this.id });
                        return;
                    })];
            });
        });
    };
    ListTemplateModel.prototype.unshare = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, unshareTemplate({ id: this.id }).then(function () {
                        trackEvent(EEvents.TEMPLATE_UNSCHARED, { id: _this.id });
                        return;
                    })];
            });
        });
    };
    return ListTemplateModel;
}());
var TemplateModel = /** @class */ (function (_super) {
    __extends(TemplateModel, _super);
    function TemplateModel(params) {
        var _this = _super.call(this, params) || this;
        _this.content = (params === null || params === void 0 ? void 0 : params.content) || {
            type: "text",
            subject: "",
            html: undefined,
            text: "",
            json: undefined
        };
        _this.sharing = (params === null || params === void 0 ? void 0 : params.sharing) || { accounts: [], shared: false, automatic: true };
        return _this;
    }
    TemplateModel.prototype.toJson = function () {
        return modelToJson(this);
    };
    TemplateModel.prototype.set = function (property, value) {
        modelSet(this, property, value);
    };
    TemplateModel.prototype.update = function (template) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                trackEvent(EEvents.TEMPLATE_UPDATED, {
                    id: template === null || template === void 0 ? void 0 : template.id,
                    name: template === null || template === void 0 ? void 0 : template.name,
                    created_on: template === null || template === void 0 ? void 0 : template.created_on,
                    updated_on: template === null || template === void 0 ? void 0 : template.updated_on,
                    tags: template === null || template === void 0 ? void 0 : template.tags,
                    sharing: template === null || template === void 0 ? void 0 : template.sharing,
                });
                return [2 /*return*/, updateTemplate({ id: this.id, template: template }).then(function (data) {
                        var _a;
                        var partial = (_a = {},
                            _a[_this.id] = {
                                "name": data.data.name,
                                "thumbnail_url": data.data.thumbnail_url,
                                "description": data.data.description
                            },
                            _a);
                        addPartialInformation({
                            data: partial,
                            partialPoolStorageKey: EPartialInfoPool.partialTemplates
                        });
                        return {
                            data: new TemplateModel(data.data)
                        };
                    })];
            });
        });
    };
    return TemplateModel;
}(ListTemplateModel));

var FormsFactory = /** @class */ (function () {
    function FormsFactory() {
    }
    FormsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getForm({ id: id }).then(function (data) {
                        if ("enabled" in data.data) {
                            return new EnhancedFormModel(data.data);
                        }
                        return new FormModel(data.data);
                    })];
            });
        });
    };
    FormsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listForms(options).then(function (data) {
                        data.data = data.data.map(function (form) {
                            if ("enabled" in form) {
                                return new SummaryEnhancedFormModel(form);
                            }
                            return new FormModel(form);
                        });
                        return data;
                    })];
            });
        });
    };
    FormsFactory.create = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var form = _b.form, type = _b.type;
            return __generator(this, function (_c) {
                return [2 /*return*/, createForm({ form: form, type: type }).then(function (data) {
                        trackEvent(EEvents.FORM_CREATED, {
                            type: type,
                            name: data.data.name,
                            list_id: data.data.list_id
                        });
                        if ("enabled" in data.data) {
                            return new EnhancedFormModel(data.data);
                        }
                        return new FormModel(data.data);
                    })];
            });
        });
    };
    FormsFactory.renderPublic = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var token = _b.token;
            return __generator(this, function (_c) {
                return [2 /*return*/, renderPublicHtmlForm({ token: token }).then(function (data) {
                        trackEvent(EEvents.FORM_RENDERED_PUBLISHED);
                        return data;
                    })];
            });
        });
    };
    return FormsFactory;
}());

var ListsFactory = /** @class */ (function () {
    function ListsFactory() {
    }
    ListsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listList(options).then(function (data) {
                        var partial = {};
                        data.data = data.data.map(function (list) {
                            partial[list.id] = {
                                "name": list.name,
                                "id": list.id,
                                "status": list.status
                            };
                            return new ListModel(list);
                        });
                        addPartialInformation({
                            data: partial,
                            partialPoolStorageKey: EPartialInfoPool.partialLists
                        });
                        return data;
                    })];
            });
        });
    };
    ListsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getList({ id: id }).then(function (data) {
                        return new ListModel(data.data);
                    })];
            });
        });
    };
    ListsFactory.getReport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var listId = _b.listId;
            return __generator(this, function (_c) {
                return [2 /*return*/, getListReport({ id: listId }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    ListsFactory.getLogs = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var listId = _a.listId, options = __rest(_a, ["listId"]);
            return __generator(this, function (_b) {
                return [2 /*return*/, getListLogs({ id: listId, options: options })];
            });
        });
    };
    ListsFactory.downloadContactsExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var listId = _b.listId, exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, downloadContactsExport({ listId: listId, exportId: exportId }).then(function (data) {
                        trackEvent(EEvents.CONTACT_EXPORT_DOWNLOAD, {
                            list_id: listId,
                            export_id: exportId
                        });
                        return data;
                    })];
            });
        });
    };
    ListsFactory.downloadListLogExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var listId = _b.listId, exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, downloadListLogExport({ listId: listId, exportId: exportId }).then(function (data) {
                        trackEvent(EEvents.LIST_LOGS_EXPORT_DOWNLOAD, {
                            list_id: listId,
                            export_id: exportId
                        });
                        return data;
                    })];
            });
        });
    };
    return ListsFactory;
}());

var PagesFactory = /** @class */ (function () {
    function PagesFactory() {
    }
    PagesFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var params = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listPages(params).then(function (data) {
                        return __assign(__assign({}, data), { data: data.data.map(function (page) { return new ListPageModel(page); }) });
                    })];
            });
        });
    };
    PagesFactory.create = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var page = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, createPage(page).then(function (data) {
                        trackEvent(EEvents.PAGE_CREATED, {
                            name: data.data.name,
                            list_id: data.data.list_id,
                            form_id: data.data.form_id,
                            branding: data.data.branding,
                        });
                        return new PageModel(data.data);
                    })];
            });
        });
    };
    PagesFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getPage({ id: id }).then(function (data) {
                        return new PageModel(data.data);
                    })];
            });
        });
    };
    return PagesFactory;
}());

var PopupsFactory = /** @class */ (function () {
    function PopupsFactory() {
    }
    PopupsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var params = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listPopups(params).then(function (data) {
                        return __assign(__assign({}, data), { data: data.data.map(function (popup) { return new ListPopupModel(popup); }) });
                    })];
            });
        });
    };
    PopupsFactory.create = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var popup = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, createPopup(popup).then(function (data) {
                        trackEvent(EEvents.POPUP_CREATED, {
                            name: data.data.name,
                            list_id: data.data.list_id,
                            form_id: data.data.form_id,
                            branding: data.data.branding,
                        });
                        return new PopupModel(data.data);
                    })];
            });
        });
    };
    PopupsFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getPopup({ id: id }).then(function (data) {
                        return new PopupModel(data.data);
                    })];
            });
        });
    };
    return PopupsFactory;
}());

var SendersFactory = /** @class */ (function () {
    function SendersFactory() {
    }
    SendersFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listSenders(options).then(function (data) {
                        var partial = {};
                        data.data = data.data.map(function (sender) {
                            partial[sender.id] = {
                                "name": sender.name,
                                "email": sender.email,
                                "confirmed": sender.confirmed
                            };
                            return new SenderModel(sender);
                        });
                        addPartialInformation({
                            data: partial,
                            partialPoolStorageKey: EPartialInfoPool.partialSenders
                        });
                        return data;
                    })];
            });
        });
    };
    SendersFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getSender({ id: id }).then(function (data) {
                        return new SenderModel(data.data);
                    })];
            });
        });
    };
    return SendersFactory;
}());

var SupportFactory = /** @class */ (function () {
    function SupportFactory() {
    }
    SupportFactory.connectToZendesk = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var isSupport = _b.isSupport, email = _b.email, returnTo = _b.returnTo, helpUrl = _b.helpUrl;
            return __generator(this, function (_c) {
                return [2 /*return*/, connectToZendeskSupportService()
                        .then(function (data) {
                        var _a;
                        if (isSupport) {
                            if (email) {
                                eventIdentify(email);
                            }
                            trackEvent(EEvents.SUPPORT_SIGNED_IN);
                            var url = (_a = data === null || data === void 0 ? void 0 : data.body) === null || _a === void 0 ? void 0 : _a.url;
                            if (returnTo) {
                                url += "&return_to=" + encodeURIComponent(returnTo);
                            }
                            window.open(url, "_blank");
                        }
                        return;
                    }).catch(function () {
                        if (helpUrl) {
                            window.open(helpUrl, "_blank");
                        }
                        else {
                            throw new Error("Missing helpUrl");
                        }
                    })];
            });
        });
    };
    return SupportFactory;
}());

var SuppressedEmailsFactory = /** @class */ (function () {
    function SuppressedEmailsFactory() {
    }
    SuppressedEmailsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listSuppressedEmails(__assign({}, options))];
            });
        });
    };
    SuppressedEmailsFactory.add = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var email = _b.email;
            return __generator(this, function (_c) {
                return [2 /*return*/, addSuppressedEmail({ email: email }).then(function (data) {
                        trackEvent(EEvents.SUPPRESSED_EMAIL_ADDED, { email: email });
                        return data;
                    })];
            });
        });
    };
    SuppressedEmailsFactory.delete = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var email = _b.email;
            return __generator(this, function (_c) {
                return [2 /*return*/, deleteSuppressedEmail({ email: email }).then(function (data) {
                        trackEvent(EEvents.SUPPRESSED_EMAIL_DELETED, { email: email });
                        return data;
                    })];
            });
        });
    };
    SuppressedEmailsFactory.createExport = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, createSuppressedEmailExport().then(function (data) {
                        trackEvent(EEvents.SUPPRESSED_EMAIL_EXPORT_CREATED);
                        return data;
                    })];
            });
        });
    };
    SuppressedEmailsFactory.getExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, getSuppressedEmailExport({ exportId: exportId })];
            });
        });
    };
    SuppressedEmailsFactory.downloadExport = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var exportId = _b.exportId;
            return __generator(this, function (_c) {
                return [2 /*return*/, downloadSuppressedEmailExport({ exportId: exportId }).then(function (data) {
                        trackEvent(EEvents.SUPPRESSED_EMAIL_EXPORT_DOWNLOAD, { exportId: exportId });
                        return data;
                    })];
            });
        });
    };
    return SuppressedEmailsFactory;
}());

var SystemEmailsFactory = /** @class */ (function () {
    function SystemEmailsFactory() {
    }
    SystemEmailsFactory.list = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, listSystemEmails().then(function (data) {
                        return new SystemEmailsModel(data.data);
                    })];
            });
        });
    };
    SystemEmailsFactory.update = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var systemEmails = _b.systemEmails;
            return __generator(this, function (_c) {
                return [2 /*return*/, updateSystemEmails({ systemEmails: systemEmails }).then(function (data) {
                        trackEvent(EEvents.SYSTEM_EMAILS_UPDATED, {});
                        return new SystemEmailsModel(data.data);
                    })];
            });
        });
    };
    return SystemEmailsFactory;
}());

function listTags(options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/tags",
                    query: camelCase(options),
                    fetchOptions: {
                        method: EMethods.get,
                    }
                })];
        });
    });
}
function CreateTag(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var tag = _b.tag;
        return __generator(this, function (_c) {
            return [2 /*return*/, callApi({
                    url: uiKitConfig.GATEWAY_PROXY + "/tags",
                    fetchOptions: {
                        method: EMethods.post,
                        body: {
                            tag: tag
                        }
                    }
                })];
        });
    });
}

var TagsFactory = /** @class */ (function () {
    function TagsFactory() {
    }
    TagsFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listTags(options)];
            });
        });
    };
    TagsFactory.create = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var tag = _b.tag;
            return __generator(this, function (_c) {
                return [2 /*return*/, CreateTag({ tag: tag }).then(function (data) {
                        trackEvent(EEvents.TAG_CREATED, { tag: tag });
                        return data.data;
                    })];
            });
        });
    };
    return TagsFactory;
}());

var TasksFactory = /** @class */ (function () {
    function TasksFactory() {
    }
    TasksFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listTasksService(options)];
            });
        });
    };
    TasksFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getTaskService({ taskId: id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    TasksFactory.delete = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, deleteTaskService({ taskId: id }).then(function (data) {
                        return data.data;
                    })];
            });
        });
    };
    return TasksFactory;
}());

var TemplatesFactory = /** @class */ (function () {
    function TemplatesFactory() {
    }
    TemplatesFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listTemplates(options).then(function (data) {
                        var partial = {};
                        data.data = data.data.map(function (template) {
                            partial[template.id] = {
                                "name": template.name,
                                "thumbnail_url": template.thumbnail_url,
                                "description": template.description
                            };
                            return new ListTemplateModel(template);
                        });
                        addPartialInformation({
                            data: partial,
                            partialPoolStorageKey: EPartialInfoPool.partialTemplates
                        });
                        return data;
                    })];
            });
        });
    };
    TemplatesFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getTemplate({ id: id }).then(function (data) {
                        return new TemplateModel(data.data);
                    })];
            });
        });
    };
    TemplatesFactory.create = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var template = _b.template;
            return __generator(this, function (_c) {
                return [2 /*return*/, createTemplate({ template: template }).then(function (data) {
                        trackEvent(EEvents.TEMPLATE_CREATED, template);
                        return TemplatesFactory.get({ id: data.id });
                    })];
            });
        });
    };
    TemplatesFactory.delete = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, deleteTemplate({ id: id }).then(function (data) {
                        trackEvent(EEvents.TEMPLATE_DELETED, { id: id });
                        return data;
                    })];
            });
        });
    };
    TemplatesFactory.render = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, renderTemplate({ id: id })];
            });
        });
    };
    return TemplatesFactory;
}());

var UsersFactory = /** @class */ (function () {
    function UsersFactory() {
    }
    UsersFactory.get = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, getUser({ id: id }).then(function (data) {
                        return new UserModel(data.data);
                    })];
            });
        });
    };
    UsersFactory.list = function (_a) {
        return __awaiter(this, void 0, void 0, function () {
            var options = __rest(_a, []);
            return __generator(this, function (_b) {
                return [2 /*return*/, listUsers(options).then(function (data) {
                        var partial = {};
                        data.data = data.data.map(function (user) {
                            partial[user.id] = {
                                email: user.email,
                                first_name: user.first_name,
                                id: user.id,
                                language: user.language,
                                last_activity_on: user.last_activity_on,
                                last_name: user.last_name,
                                status: user.status,
                                timezone: user.timezone
                            };
                            return new UserModel(user);
                        });
                        addPartialInformation({
                            data: partial,
                            partialPoolStorageKey: EPartialInfoPool.partialUsers
                        });
                        return data;
                    })];
            });
        });
    };
    return UsersFactory;
}());

export { AccountModel, AccountsFactory, ActionBarContainer, ActionBarContainerHandler, AssetManager, AutomationModel, AutomationsFactory, Avatar, BillingFactory, BrandWrapper, BrandsFactory, Button, ButtonMenu, CampaignModel, CampaignsFactory, Checkbox, Chip, CircularProgress, CodeInput, ColManager, ColorTextField, CommonFormModel, ContactModel, ContactsFactory, ContentSectionContainer, CountryDropdown, CustomerModel, DataTable, DataTableHead, DataTableRow, DateCalendar, DatePicker, DateTimeCalendar, DateTimePicker, Dialog, DialogActions, DialogHandler, DialogTitle, Divider, Drawer, DrawerHandler, DropMenu, Dropdown, EApiLanguages, EAssetManagerMatchType, ECampaignStatuses, EEMailSummaryStatuses, EEditorType, EEmailAttachementTypes, EEmailLogType, EEmailLogTypeParam, EEmailProviders, EEmailStatuses, EEmailSummaryEngagement, EEvents, EListAttributeType, EMethods, EOperatorTypes, EPageBranding, EPartialInfoPool, EPopupBranding, EPopupBrowserType, EPopupCloseButtonPosition, EPopupDeviceType, EPopupDisplayFrequency, EPopupPosition, EPopupTriggerType, EStorageType, ETaskType, ElementContains, Email, EmailAPIFactory, EmptyContent, EnhancedFormModel, FileUpload, FilterBar, FormModel, FormsFactory, FullBar, GenericWrapper, GenericWrapperContext, GroupedActions, Header, Icon, IconPill, InformationGroup, InlineTextEdit, LinearProgress, Link, ListCampaignModel, ListModel, ListPageModel, ListPopupModel, ListTemplateModel, ListsFactory, LoadingContainer, LocationTextField, Logo, MD5, MetricCard, Modal, ModalHandler, ModalHeading, Overlay, OverlayHandler, OverlayHeading, PageModel, PagesFactory, PhoneTextField, PopupModel, PopupsFactory, Radio, ResourceEdit, Search, SenderModel, SendersFactory, SideMenu, SideMenuContainer, SideMenuItem, SubNav, SummaryEnhancedFormModel, SupportFactory, SuppressedEmailsFactory, SystemEmailsFactory, SystemEmailsModel, TagsFactory, TasksFactory, TemplateModel, TemplatesFactory, TextField, TimePicker, TimeSelector, Toggle, TopMenu, Typography, UserModel, UsersFactory, acceptListPolicy, addPartialInformation, addSuppressedEmail, addToImpersonificationTree, amIImpersonating, amILoggedInService, archiveCampaign, areAllPropertiesEmpty, buildMUITheme, callApi, camelCase, camelToSnakeCase, cancelCampaign, capitalizeFirstLetter, cleanPostHogId, clearImpersonificationTree, clearStorage, connectToZendeskSupportService, copyToClipboard, createAccount, createBrand, createCampaign, createCampaignLogsExports, createCampaignsReportsExport, createForm, createPage, createPopup, createSuppressedEmailExport, createTemplate, deepMergeObject, deleteAccount, deleteAnyAutomation, deleteAutomation, deleteCampaign, deleteCampaignsReportsExport, deleteForm, deleteList, deletePage, deletePartialInformation, deletePopup, deleteStorageItem, deleteSuppressedEmail, deleteTaskService, deleteTemplate, deleteUser, deleteWorkflow, descendingComparator, disableForm, disablePage, disablePopup, downloadCampaignLogExport, downloadCampaignsReportsExport, downloadContactsExport, downloadListLogExport, downloadSuppressedEmailExport, emptyAccountAddress, emptyAccountLimits, enableForm, enablePage, enablePopup, enrichBrand, enrichOrganization, enrichProfile, eventCondition, eventIdentify, eventLogout, fetchRetry, fetchRoute, findNestedProperty, formatNumber, getAccount, getAccountReport, getAdjustedBillingCycle, getAllAutomationStats, getAutomation, getAutomationEmailContent, getAutomationExecutionsCount, getAutomationStats, getBeeTokenService, getBestLocalMatch, getBrand, getBrandService, getBrandUrl, getCalendarFormat, getCampaign, getCampaignLinks, getCampaignLinksReport, getCampaignLogs, getCampaignLogsExports, getCampaignReport, getCampaignRevisions, getCampaignsReportsExport, getComparator, getCustomerProfile, getDate, getDomainFromEmail, getDomainsFromEmails, getDomainsService, getEmail, getEmailActivitySummary, getEmailReport, getEndOfDate, getForm, getHashQueryWithoutHistory, getIconSize, getList, getListLogs, getListReport, getNestedProperty, getPage, getPopup, getPropertyValue, getSender, getStartOfDate, getStorage, getSuppressedEmailExport, getTColor, getTaskService, getTemplate, getUnixTime, getUrlQueryParam, getUser, getUtmCookies, googlePlacesMapper, hasDecimal, impersonateService, initFieldValidation, initPostHog, isColorLight, isDomainValidService, isSimpleType, isValidEmail, isValidString, isValidUrl, lisTEmailTags, listAccounts, listAutomations, listCampaigns, listCampaignsReportsExports, listContacts, listEmailLogs, listForms, listList, listListAttributes, listListInterests, listPages, listPopups, listSenders, listSuppressedEmails, listSystemEmails, listTasksService, listTemplates, listUsers, listWorkflows, logOutService, loginService, miliToSecond, modelSet, modelToJson, originalBrand, patchForm, popImpersonificationTree, postMessage, publishForm, publishPage, publishPopup, reScheduleCampaign, removeEmptyProperties, removeQueryParams, removeTrailingChar, renderCampaign, renderEmail, renderForm, renderPage, renderPopup, renderPublicHtmlForm, renderTemplate, requestSupportService, resendVerificationEmail, resumeCampaign, saveList, scheduleCampaign, searchCustomerProfiles, sendCampaignTest, setBrandHeadElements, setStorage, shareTemplate, splitArray, splitObject, stableSort, startPromisePool, suspendAccount, suspendCampaign, trackEvent, truncateEmail, truncateText, uiKitConfig, unArchiveCampaign, unScheduleCampaign, unSuspendAccount, unshareTemplate, updateAccount, updateAndClearUrlParams, updateAnyAutomation, updateAutomation, updateCampaign, updatePage, updatePopup, updateSystemEmails, updateTemplate, updateUser, updateWorkflow, validateColor, validateEmail, validateGenericInput, validateUrl, wait, whiteLabelBrand, whoAmi };
